// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3E%3Cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3E%3Ccircle r=%273%27 fill=%27%23fff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--blue: #007bff;
	--indigo: #6610f2;
	--purple: #6f42c1;
	--pink: #e83e8c;
	--red: #dc3545;
	--orange: #fd7e14;
	--yellow: #ffc107;
	--green: #28a745;
	--teal: #20c997;
	--cyan: #17a2b8;
	--white: #fff;
	--gray: #6c757d;
	--gray-dark: #343a40;
	--primary: #007bff;
	--secondary: #6c757d;
	--success: #28a745;
	--info: #17a2b8;
	--warning: #ffc107;
	--danger: #dc3545;
	--light: #f8f9fa;
	--dark: #343a40;
	--breakpoint-xs: 0;
	--breakpoint-sm: 576px;
	--breakpoint-md: 768px;
	--breakpoint-lg: 992px;
	--breakpoint-xl: 1200px;
	--font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	--font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace
}

*,
::after,
::before {
	box-sizing: border-box
}

html {
	font-family: sans-serif;
	line-height: 1.15;
	-webkit-text-size-adjust: 100%;
	-ms-text-size-adjust: 100%;
	-ms-overflow-style: scrollbar;
	-webkit-tap-highlight-color: transparent
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
	display: block
}

body {
	margin: 0;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #212529;
	text-align: left;
	background-color: #fff
}

[tabindex="-1"]:focus {
	outline: 0 !important
}

hr {
	box-sizing: content-box;
	height: 0;
	overflow: visible
}

h1,
h2,
h3,
h4,
h5,
h6 {
	margin-top: 0;
	margin-bottom: .5rem
}

p {
	margin-top: 0;
	margin-bottom: 1rem
}

abbr[data-original-title],
abbr[title] {
	text-decoration: underline;
	-webkit-text-decoration: underline dotted;
	text-decoration: underline dotted;
	cursor: help;
	border-bottom: 0
}

address {
	margin-bottom: 1rem;
	font-style: normal;
	line-height: inherit
}

dl,
ol,
ul {
	margin-top: 0;
	margin-bottom: 1rem
}

ol ol,
ol ul,
ul ol,
ul ul {
	margin-bottom: 0
}

dt {
	font-weight: 700
}

dd {
	margin-bottom: .5rem;
	margin-left: 0
}

blockquote {
	margin: 0 0 1rem
}

dfn {
	font-style: italic
}

b,
strong {
	font-weight: bolder
}

small {
	font-size: 80%
}

sub,
sup {
	position: relative;
	font-size: 75%;
	line-height: 0;
	vertical-align: baseline
}

sub {
	bottom: -.25em
}

sup {
	top: -.5em
}

a {
	color: #007bff;
	text-decoration: none;
	background-color: transparent;
	-webkit-text-decoration-skip: objects
}

a:hover {
	color: #0056b3;
	text-decoration: underline
}

a:not([href]):not([tabindex]) {
	color: inherit;
	text-decoration: none
}

a:not([href]):not([tabindex]):focus,
a:not([href]):not([tabindex]):hover {
	color: inherit;
	text-decoration: none
}

a:not([href]):not([tabindex]):focus {
	outline: 0
}

code,
kbd,
pre,
samp {
	font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
	font-size: 1em
}

pre {
	margin-top: 0;
	margin-bottom: 1rem;
	overflow: auto;
	-ms-overflow-style: scrollbar
}

figure {
	margin: 0 0 1rem
}

img {
	vertical-align: middle;
	border-style: none
}

svg:not(:root) {
	overflow: hidden
}

table {
	border-collapse: collapse
}

caption {
	padding-top: .75rem;
	padding-bottom: .75rem;
	color: #6c757d;
	text-align: left;
	caption-side: bottom
}

th {
	text-align: inherit
}

label {
	display: inline-block;
	margin-bottom: .5rem
}

button {
	border-radius: 0
}

button:focus {
	outline: 1px dotted;
	outline: 5px auto -webkit-focus-ring-color
}

button,
input,
optgroup,
select,
textarea {
	margin: 0;
	font-family: inherit;
	font-size: inherit;
	line-height: inherit
}

button,
input {
	overflow: visible
}

button,
select {
	text-transform: none
}

[type=reset],
[type=submit],
button,
html [type=button] {
	-webkit-appearance: button
}

[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner,
button::-moz-focus-inner {
	padding: 0;
	border-style: none
}

input[type=checkbox],
input[type=radio] {
	box-sizing: border-box;
	padding: 0;
	height: 20px;
	width: 20px;
}

input[type=date],
input[type=datetime-local],
input[type=month],
input[type=time] {
	-webkit-appearance: listbox
}

textarea {
	overflow: auto;
	resize: vertical
}

fieldset {
	min-width: 0;
	padding: 0;
	margin: 0;
	border: 0
}

legend {
	display: block;
	width: 100%;
	max-width: 100%;
	padding: 0;
	margin-bottom: .5rem;
	font-size: 1.5rem;
	line-height: inherit;
	color: inherit;
	white-space: normal
}

progress {
	vertical-align: baseline
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
	height: auto
}

[type=search] {
	outline-offset: -2px;
	-webkit-appearance: none
}

[type=search]::-webkit-search-cancel-button,
[type=search]::-webkit-search-decoration {
	-webkit-appearance: none
}

::-webkit-file-upload-button {
	font: inherit;
	-webkit-appearance: button
}

output {
	display: inline-block
}

summary {
	display: list-item;
	cursor: pointer
}

template {
	display: none
}

[hidden] {
	display: none !important
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
	margin-bottom: .5rem;
	font-family: inherit;
	font-weight: 500;
	line-height: 1.2;
	color: inherit
}

.h1,
h1 {
	font-size: 2.5rem
}

.h2,
h2 {
	font-size: 2rem
}

.h3,
h3 {
	font-size: 1.75rem
}

.h4,
h4 {
	font-size: 1.5rem
}

.h5,
h5 {
	font-size: 1.25rem
}

.h6,
h6 {
	font-size: 1rem
}

.lead {
	font-size: 1.25rem;
	font-weight: 300
}

.display-1 {
	font-size: 6rem;
	font-weight: 300;
	line-height: 1.2
}

.display-2 {
	font-size: 5.5rem;
	font-weight: 300;
	line-height: 1.2
}

.display-3 {
	font-size: 4.5rem;
	font-weight: 300;
	line-height: 1.2
}

.display-4 {
	font-size: 3.5rem;
	font-weight: 300;
	line-height: 1.2
}

hr {
	margin-top: 1rem;
	margin-bottom: 1rem;
	border: 0;
	border-top: 1px solid rgba(0, 0, 0, .1)
}

.small,
small {
	font-size: 80%;
	font-weight: 400
}

.mark,
mark {
	padding: .2em;
	background-color: #fcf8e3
}

.list-unstyled {
	padding-left: 0;
	list-style: none
}

.list-inline {
	padding-left: 0;
	list-style: none
}

.list-inline-item {
	display: inline-block
}

.list-inline-item:not(:last-child) {
	margin-right: .5rem
}

.initialism {
	font-size: 90%;
	text-transform: uppercase
}

.blockquote {
	margin-bottom: 1rem;
	font-size: 1.25rem
}

.blockquote-footer {
	display: block;
	font-size: 80%;
	color: #6c757d
}

.blockquote-footer::before {
	content: "\\2014 \\00A0"
}

.img-fluid {
	max-width: 100%;
	height: auto
}

.img-thumbnail {
	padding: .25rem;
	background-color: #fff;
	border: 1px solid #dee2e6;
	border-radius: .25rem;
	max-width: 100%;
	height: auto
}

.figure {
	display: inline-block
}

.figure-img {
	margin-bottom: .5rem;
	line-height: 1
}

.figure-caption {
	font-size: 90%;
	color: #6c757d
}

code {
	font-size: 87.5%;
	color: #e83e8c;
	word-break: break-word
}

a>code {
	color: inherit
}

kbd {
	padding: .2rem .4rem;
	font-size: 87.5%;
	color: #fff;
	background-color: #212529;
	border-radius: .2rem
}

kbd kbd {
	padding: 0;
	font-size: 100%;
	font-weight: 700
}

pre {
	display: block;
	font-size: 87.5%;
	color: #212529
}

pre code {
	font-size: inherit;
	color: inherit;
	word-break: normal
}

.pre-scrollable {
	max-height: 340px;
	overflow-y: scroll
}

.container {
	width: 100%;
	padding-right: 15px;
	padding-left: 15px;
	margin-right: auto;
	margin-left: auto
}

@media (min-width:576px) {
	.container {
		max-width: 540px
	}
}

@media (min-width:768px) {
	.container {
		max-width: 720px
	}
}

@media (min-width:992px) {
	.container {
		max-width: 960px
	}
}

@media (min-width:1200px) {
	.container {
		max-width: 1140px
	}
}

.container-fluid {
	width: 100%;
	padding-right: 15px;
	padding-left: 15px;
	margin-right: auto;
	margin-left: auto
}

.row {
	display: flex;
	flex-wrap: wrap;
	margin-right: -15px;
	margin-left: -15px
}

.no-gutters {
	margin-right: 0;
	margin-left: 0
}

.no-gutters>.col,
.no-gutters>[class*=col-] {
	padding-right: 0;
	padding-left: 0
}

.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
	position: relative;
	width: 100%;
	min-height: 1px;
	padding-right: 15px;
	padding-left: 15px
}

.col {
	flex-basis: 0;
	flex-grow: 1;
	max-width: 100%
}

.col-auto {
	flex: 0 0 auto;
	width: auto;
	max-width: none
}

.col-1 {
	flex: 0 0 8.333333%;
	max-width: 8.333333%
}

.col-2 {
	flex: 0 0 16.666667%;
	max-width: 16.666667%
}

.col-3 {
	flex: 0 0 25%;
	max-width: 25%
}

.col-4 {
	flex: 0 0 33.333333%;
	max-width: 33.333333%
}

.col-5 {
	flex: 0 0 41.666667%;
	max-width: 41.666667%
}

.col-6 {
	flex: 0 0 50%;
	max-width: 50%
}

.col-7 {
	flex: 0 0 58.333333%;
	max-width: 58.333333%
}

.col-8 {
	flex: 0 0 66.666667%;
	max-width: 66.666667%
}

.col-9 {
	flex: 0 0 75%;
	max-width: 75%
}

.col-10 {
	flex: 0 0 83.333333%;
	max-width: 83.333333%
}

.col-11 {
	flex: 0 0 91.666667%;
	max-width: 91.666667%
}

.col-12 {
	flex: 0 0 100%;
	max-width: 100%
}

.order-first {
	order: -1
}

.order-last {
	order: 13
}

.order-0 {
	order: 0
}

.order-1 {
	order: 1
}

.order-2 {
	order: 2
}

.order-3 {
	order: 3
}

.order-4 {
	order: 4
}

.order-5 {
	order: 5
}

.order-6 {
	order: 6
}

.order-7 {
	order: 7
}

.order-8 {
	order: 8
}

.order-9 {
	order: 9
}

.order-10 {
	order: 10
}

.order-11 {
	order: 11
}

.order-12 {
	order: 12
}

.offset-1 {
	margin-left: 8.333333%
}

.offset-2 {
	margin-left: 16.666667%
}

.offset-3 {
	margin-left: 25%
}

.offset-4 {
	margin-left: 33.333333%
}

.offset-5 {
	margin-left: 41.666667%
}

.offset-6 {
	margin-left: 50%
}

.offset-7 {
	margin-left: 58.333333%
}

.offset-8 {
	margin-left: 66.666667%
}

.offset-9 {
	margin-left: 75%
}

.offset-10 {
	margin-left: 83.333333%
}

.offset-11 {
	margin-left: 91.666667%
}

@media (min-width:576px) {
	.col-sm {
		flex-basis: 0;
		flex-grow: 1;
		max-width: 100%
	}

	.col-sm-auto {
		flex: 0 0 auto;
		width: auto;
		max-width: none
	}

	.col-sm-1 {
		flex: 0 0 8.333333%;
		max-width: 8.333333%
	}

	.col-sm-2 {
		flex: 0 0 16.666667%;
		max-width: 16.666667%
	}

	.col-sm-3 {
		flex: 0 0 25%;
		max-width: 25%
	}

	.col-sm-4 {
		flex: 0 0 33.333333%;
		max-width: 33.333333%
	}

	.col-sm-5 {
		flex: 0 0 41.666667%;
		max-width: 41.666667%
	}

	.col-sm-6 {
		flex: 0 0 50%;
		max-width: 50%
	}

	.col-sm-7 {
		flex: 0 0 58.333333%;
		max-width: 58.333333%
	}

	.col-sm-8 {
		flex: 0 0 66.666667%;
		max-width: 66.666667%
	}

	.col-sm-9 {
		flex: 0 0 75%;
		max-width: 75%
	}

	.col-sm-10 {
		flex: 0 0 83.333333%;
		max-width: 83.333333%
	}

	.col-sm-11 {
		flex: 0 0 91.666667%;
		max-width: 91.666667%
	}

	.col-sm-12 {
		flex: 0 0 100%;
		max-width: 100%
	}

	.order-sm-first {
		order: -1
	}

	.order-sm-last {
		order: 13
	}

	.order-sm-0 {
		order: 0
	}

	.order-sm-1 {
		order: 1
	}

	.order-sm-2 {
		order: 2
	}

	.order-sm-3 {
		order: 3
	}

	.order-sm-4 {
		order: 4
	}

	.order-sm-5 {
		order: 5
	}

	.order-sm-6 {
		order: 6
	}

	.order-sm-7 {
		order: 7
	}

	.order-sm-8 {
		order: 8
	}

	.order-sm-9 {
		order: 9
	}

	.order-sm-10 {
		order: 10
	}

	.order-sm-11 {
		order: 11
	}

	.order-sm-12 {
		order: 12
	}

	.offset-sm-0 {
		margin-left: 0
	}

	.offset-sm-1 {
		margin-left: 8.333333%
	}

	.offset-sm-2 {
		margin-left: 16.666667%
	}

	.offset-sm-3 {
		margin-left: 25%
	}

	.offset-sm-4 {
		margin-left: 33.333333%
	}

	.offset-sm-5 {
		margin-left: 41.666667%
	}

	.offset-sm-6 {
		margin-left: 50%
	}

	.offset-sm-7 {
		margin-left: 58.333333%
	}

	.offset-sm-8 {
		margin-left: 66.666667%
	}

	.offset-sm-9 {
		margin-left: 75%
	}

	.offset-sm-10 {
		margin-left: 83.333333%
	}

	.offset-sm-11 {
		margin-left: 91.666667%
	}
}

@media (min-width:768px) {
	.col-md {
		flex-basis: 0;
		flex-grow: 1;
		max-width: 100%
	}

	.col-md-auto {
		flex: 0 0 auto;
		width: auto;
		max-width: none
	}

	.col-md-1 {
		flex: 0 0 8.333333%;
		max-width: 8.333333%
	}

	.col-md-2 {
		flex: 0 0 16.666667%;
		max-width: 16.666667%
	}

	.col-md-3 {
		flex: 0 0 25%;
		max-width: 25%
	}

	.col-md-4 {
		flex: 0 0 33.333333%;
		max-width: 33.333333%
	}

	.col-md-5 {
		flex: 0 0 41.666667%;
		max-width: 41.666667%
	}

	.col-md-6 {
		flex: 0 0 50%;
		max-width: 50%
	}

	.col-md-7 {
		flex: 0 0 58.333333%;
		max-width: 58.333333%
	}

	.col-md-8 {
		flex: 0 0 66.666667%;
		max-width: 66.666667%
	}

	.col-md-9 {
		flex: 0 0 75%;
		max-width: 75%
	}

	.col-md-10 {
		flex: 0 0 83.333333%;
		max-width: 83.333333%
	}

	.col-md-11 {
		flex: 0 0 91.666667%;
		max-width: 91.666667%
	}

	.col-md-12 {
		flex: 0 0 100%;
		max-width: 100%
	}

	.order-md-first {
		order: -1
	}

	.order-md-last {
		order: 13
	}

	.order-md-0 {
		order: 0
	}

	.order-md-1 {
		order: 1
	}

	.order-md-2 {
		order: 2
	}

	.order-md-3 {
		order: 3
	}

	.order-md-4 {
		order: 4
	}

	.order-md-5 {
		order: 5
	}

	.order-md-6 {
		order: 6
	}

	.order-md-7 {
		order: 7
	}

	.order-md-8 {
		order: 8
	}

	.order-md-9 {
		order: 9
	}

	.order-md-10 {
		order: 10
	}

	.order-md-11 {
		order: 11
	}

	.order-md-12 {
		order: 12
	}

	.offset-md-0 {
		margin-left: 0
	}

	.offset-md-1 {
		margin-left: 8.333333%
	}

	.offset-md-2 {
		margin-left: 16.666667%
	}

	.offset-md-3 {
		margin-left: 25%
	}

	.offset-md-4 {
		margin-left: 33.333333%
	}

	.offset-md-5 {
		margin-left: 41.666667%
	}

	.offset-md-6 {
		margin-left: 50%
	}

	.offset-md-7 {
		margin-left: 58.333333%
	}

	.offset-md-8 {
		margin-left: 66.666667%
	}

	.offset-md-9 {
		margin-left: 75%
	}

	.offset-md-10 {
		margin-left: 83.333333%
	}

	.offset-md-11 {
		margin-left: 91.666667%
	}
}

@media (min-width:992px) {
	.col-lg {
		flex-basis: 0;
		flex-grow: 1;
		max-width: 100%
	}

	.col-lg-auto {
		flex: 0 0 auto;
		width: auto;
		max-width: none
	}

	.col-lg-1 {
		flex: 0 0 8.333333%;
		max-width: 8.333333%
	}

	.col-lg-2 {
		flex: 0 0 16.666667%;
		max-width: 16.666667%
	}

	.col-lg-3 {
		flex: 0 0 25%;
		max-width: 25%
	}

	.col-lg-4 {
		flex: 0 0 33.333333%;
		max-width: 33.333333%
	}

	.col-lg-5 {
		flex: 0 0 41.666667%;
		max-width: 41.666667%
	}

	.col-lg-6 {
		flex: 0 0 50%;
		max-width: 50%
	}

	.col-lg-7 {
		flex: 0 0 58.333333%;
		max-width: 58.333333%
	}

	.col-lg-8 {
		flex: 0 0 66.666667%;
		max-width: 66.666667%
	}

	.col-lg-9 {
		flex: 0 0 75%;
		max-width: 75%
	}

	.col-lg-10 {
		flex: 0 0 83.333333%;
		max-width: 83.333333%
	}

	.col-lg-11 {
		flex: 0 0 91.666667%;
		max-width: 91.666667%
	}

	.col-lg-12 {
		flex: 0 0 100%;
		max-width: 100%
	}

	.order-lg-first {
		order: -1
	}

	.order-lg-last {
		order: 13
	}

	.order-lg-0 {
		order: 0
	}

	.order-lg-1 {
		order: 1
	}

	.order-lg-2 {
		order: 2
	}

	.order-lg-3 {
		order: 3
	}

	.order-lg-4 {
		order: 4
	}

	.order-lg-5 {
		order: 5
	}

	.order-lg-6 {
		order: 6
	}

	.order-lg-7 {
		order: 7
	}

	.order-lg-8 {
		order: 8
	}

	.order-lg-9 {
		order: 9
	}

	.order-lg-10 {
		order: 10
	}

	.order-lg-11 {
		order: 11
	}

	.order-lg-12 {
		order: 12
	}

	.offset-lg-0 {
		margin-left: 0
	}

	.offset-lg-1 {
		margin-left: 8.333333%
	}

	.offset-lg-2 {
		margin-left: 16.666667%
	}

	.offset-lg-3 {
		margin-left: 25%
	}

	.offset-lg-4 {
		margin-left: 33.333333%
	}

	.offset-lg-5 {
		margin-left: 41.666667%
	}

	.offset-lg-6 {
		margin-left: 50%
	}

	.offset-lg-7 {
		margin-left: 58.333333%
	}

	.offset-lg-8 {
		margin-left: 66.666667%
	}

	.offset-lg-9 {
		margin-left: 75%
	}

	.offset-lg-10 {
		margin-left: 83.333333%
	}

	.offset-lg-11 {
		margin-left: 91.666667%
	}
}

@media (min-width:1200px) {
	.col-xl {
		flex-basis: 0;
		flex-grow: 1;
		max-width: 100%
	}

	.col-xl-auto {
		flex: 0 0 auto;
		width: auto;
		max-width: none
	}

	.col-xl-1 {
		flex: 0 0 8.333333%;
		max-width: 8.333333%
	}

	.col-xl-2 {
		flex: 0 0 16.666667%;
		max-width: 16.666667%
	}

	.col-xl-3 {
		flex: 0 0 25%;
		max-width: 25%
	}

	.col-xl-4 {
		flex: 0 0 33.333333%;
		max-width: 33.333333%
	}

	.col-xl-5 {
		flex: 0 0 41.666667%;
		max-width: 41.666667%
	}

	.col-xl-6 {
		flex: 0 0 50%;
		max-width: 50%
	}

	.col-xl-7 {
		flex: 0 0 58.333333%;
		max-width: 58.333333%
	}

	.col-xl-8 {
		flex: 0 0 66.666667%;
		max-width: 66.666667%
	}

	.col-xl-9 {
		flex: 0 0 75%;
		max-width: 75%
	}

	.col-xl-10 {
		flex: 0 0 83.333333%;
		max-width: 83.333333%
	}

	.col-xl-11 {
		flex: 0 0 91.666667%;
		max-width: 91.666667%
	}

	.col-xl-12 {
		flex: 0 0 100%;
		max-width: 100%
	}

	.order-xl-first {
		order: -1
	}

	.order-xl-last {
		order: 13
	}

	.order-xl-0 {
		order: 0
	}

	.order-xl-1 {
		order: 1
	}

	.order-xl-2 {
		order: 2
	}

	.order-xl-3 {
		order: 3
	}

	.order-xl-4 {
		order: 4
	}

	.order-xl-5 {
		order: 5
	}

	.order-xl-6 {
		order: 6
	}

	.order-xl-7 {
		order: 7
	}

	.order-xl-8 {
		order: 8
	}

	.order-xl-9 {
		order: 9
	}

	.order-xl-10 {
		order: 10
	}

	.order-xl-11 {
		order: 11
	}

	.order-xl-12 {
		order: 12
	}

	.offset-xl-0 {
		margin-left: 0
	}

	.offset-xl-1 {
		margin-left: 8.333333%
	}

	.offset-xl-2 {
		margin-left: 16.666667%
	}

	.offset-xl-3 {
		margin-left: 25%
	}

	.offset-xl-4 {
		margin-left: 33.333333%
	}

	.offset-xl-5 {
		margin-left: 41.666667%
	}

	.offset-xl-6 {
		margin-left: 50%
	}

	.offset-xl-7 {
		margin-left: 58.333333%
	}

	.offset-xl-8 {
		margin-left: 66.666667%
	}

	.offset-xl-9 {
		margin-left: 75%
	}

	.offset-xl-10 {
		margin-left: 83.333333%
	}

	.offset-xl-11 {
		margin-left: 91.666667%
	}
}

.table {
	width: 100%;
	max-width: 100%;
	margin-bottom: 1rem;
	background-color: transparent
}

.table td,
.table th {
	padding: .75rem;
	vertical-align: top;
	border-top: 1px solid #dee2e6
}

.table thead th {
	vertical-align: bottom;
	border-bottom: 2px solid #dee2e6
}

.table tbody+tbody {
	border-top: 2px solid #dee2e6
}

.table .table {
	background-color: #fff
}

.table-sm td,
.table-sm th {
	padding: .3rem
}

.table-bordered {
	border: 1px solid #dee2e6
}

.table-bordered td,
.table-bordered th {
	border: 1px solid #dee2e6
}

.table-bordered thead td,
.table-bordered thead th {
	border-bottom-width: 2px
}

.table-borderless tbody+tbody,
.table-borderless td,
.table-borderless th,
.table-borderless thead th {
	border: 0
}

.table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(0, 0, 0, .05)
}

.table-hover tbody tr:hover {
	background-color: rgba(0, 0, 0, .075)
}

.table-primary,
.table-primary>td,
.table-primary>th {
	background-color: #b8daff
}

.table-hover .table-primary:hover {
	background-color: #9fcdff
}

.table-hover .table-primary:hover>td,
.table-hover .table-primary:hover>th {
	background-color: #9fcdff
}

.table-secondary,
.table-secondary>td,
.table-secondary>th {
	background-color: #d6d8db
}

.table-hover .table-secondary:hover {
	background-color: #c8cbcf
}

.table-hover .table-secondary:hover>td,
.table-hover .table-secondary:hover>th {
	background-color: #c8cbcf
}

.table-success,
.table-success>td,
.table-success>th {
	background-color: #c3e6cb
}

.table-hover .table-success:hover {
	background-color: #b1dfbb
}

.table-hover .table-success:hover>td,
.table-hover .table-success:hover>th {
	background-color: #b1dfbb
}

.table-info,
.table-info>td,
.table-info>th {
	background-color: #bee5eb
}

.table-hover .table-info:hover {
	background-color: #abdde5
}

.table-hover .table-info:hover>td,
.table-hover .table-info:hover>th {
	background-color: #abdde5
}

.table-warning,
.table-warning>td,
.table-warning>th {
	background-color: #ffeeba
}

.table-hover .table-warning:hover {
	background-color: #ffe8a1
}

.table-hover .table-warning:hover>td,
.table-hover .table-warning:hover>th {
	background-color: #ffe8a1
}

.table-danger,
.table-danger>td,
.table-danger>th {
	background-color: #f5c6cb
}

.table-hover .table-danger:hover {
	background-color: #f1b0b7
}

.table-hover .table-danger:hover>td,
.table-hover .table-danger:hover>th {
	background-color: #f1b0b7
}

.table-light,
.table-light>td,
.table-light>th {
	background-color: #fdfdfe
}

.table-hover .table-light:hover {
	background-color: #ececf6
}

.table-hover .table-light:hover>td,
.table-hover .table-light:hover>th {
	background-color: #ececf6
}

.table-dark,
.table-dark>td,
.table-dark>th {
	background-color: #c6c8ca
}

.table-hover .table-dark:hover {
	background-color: #b9bbbe
}

.table-hover .table-dark:hover>td,
.table-hover .table-dark:hover>th {
	background-color: #b9bbbe
}

.table-active,
.table-active>td,
.table-active>th {
	background-color: rgba(0, 0, 0, .075)
}

.table-hover .table-active:hover {
	background-color: rgba(0, 0, 0, .075)
}

.table-hover .table-active:hover>td,
.table-hover .table-active:hover>th {
	background-color: rgba(0, 0, 0, .075)
}

.table .thead-dark th {
	color: #fff;
	background-color: #212529;
	border-color: #32383e
}

.table .thead-light th {
	color: #495057;
	background-color: #e9ecef;
	border-color: #dee2e6
}

.table-dark {
	color: #fff;
	background-color: #212529
}

.table-dark td,
.table-dark th,
.table-dark thead th {
	border-color: #32383e
}

.table-dark.table-bordered {
	border: 0
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(255, 255, 255, .05)
}

.table-dark.table-hover tbody tr:hover {
	background-color: rgba(255, 255, 255, .075)
}

@media (max-width:575.98px) {
	.table-responsive-sm {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		-ms-overflow-style: -ms-autohiding-scrollbar
	}

	.table-responsive-sm>.table-bordered {
		border: 0
	}
}

@media (max-width:767.98px) {
	.table-responsive-md {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		-ms-overflow-style: -ms-autohiding-scrollbar
	}

	.table-responsive-md>.table-bordered {
		border: 0
	}
}

@media (max-width:991.98px) {
	.table-responsive-lg {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		-ms-overflow-style: -ms-autohiding-scrollbar
	}

	.table-responsive-lg>.table-bordered {
		border: 0
	}
}

@media (max-width:1199.98px) {
	.table-responsive-xl {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		-ms-overflow-style: -ms-autohiding-scrollbar
	}

	.table-responsive-xl>.table-bordered {
		border: 0
	}
}

.table-responsive {
	display: block;
	width: 100%;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	-ms-overflow-style: -ms-autohiding-scrollbar
}

.table-responsive>.table-bordered {
	border: 0
}

.form-control {
	display: block;
	width: 100%;
	padding: .375rem .75rem;
	font-size: 1rem;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	border-radius: .25rem;
	transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media screen and (prefers-reduced-motion:reduce) {
	.form-control {
		transition: none
	}
}

.form-control::-ms-expand {
	background-color: transparent;
	border: 0
}

.form-control:focus {
	color: #495057;
	background-color: #fff;
	border-color: #80bdff;
	outline: 0;
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.form-control::placeholder {
	color: #6c757d;
	opacity: 1
}

.form-control:disabled,
.form-control[readonly] {
	background-color: #e9ecef;
	opacity: 1
}

select.form-control:not([size]):not([multiple]) {
	height: calc(2.25rem + 2px)
}

select.form-control:focus::-ms-value {
	color: #495057;
	background-color: #fff
}

.form-control-file,
.form-control-range {
	display: block;
	width: 100%
}

.col-form-label {
	padding-top: calc(.375rem + 1px);
	padding-bottom: calc(.375rem + 1px);
	margin-bottom: 0;
	font-size: inherit;
	line-height: 1.5
}

.col-form-label-lg {
	padding-top: calc(.5rem + 1px);
	padding-bottom: calc(.5rem + 1px);
	font-size: 1.25rem;
	line-height: 1.5
}

.col-form-label-sm {
	padding-top: calc(.25rem + 1px);
	padding-bottom: calc(.25rem + 1px);
	font-size: .875rem;
	line-height: 1.5
}

.form-control-plaintext {
	display: block;
	width: 100%;
	padding-top: .375rem;
	padding-bottom: .375rem;
	margin-bottom: 0;
	line-height: 1.5;
	color: #212529;
	background-color: transparent;
	border: solid transparent;
	border-width: 1px 0
}

.form-control-plaintext.form-control-lg,
.form-control-plaintext.form-control-sm,
.input-group-lg>.form-control-plaintext.form-control,
.input-group-lg>.input-group-append>.form-control-plaintext.btn,
.input-group-lg>.input-group-append>.form-control-plaintext.input-group-text,
.input-group-lg>.input-group-prepend>.form-control-plaintext.btn,
.input-group-lg>.input-group-prepend>.form-control-plaintext.input-group-text,
.input-group-sm>.form-control-plaintext.form-control,
.input-group-sm>.input-group-append>.form-control-plaintext.btn,
.input-group-sm>.input-group-append>.form-control-plaintext.input-group-text,
.input-group-sm>.input-group-prepend>.form-control-plaintext.btn,
.input-group-sm>.input-group-prepend>.form-control-plaintext.input-group-text {
	padding-right: 0;
	padding-left: 0
}

.form-control-sm,
.input-group-sm>.form-control,
.input-group-sm>.input-group-append>.btn,
.input-group-sm>.input-group-append>.input-group-text,
.input-group-sm>.input-group-prepend>.btn,
.input-group-sm>.input-group-prepend>.input-group-text {
	padding: .25rem .5rem;
	font-size: .875rem;
	line-height: 1.5;
	border-radius: .2rem
}

.input-group-sm>.input-group-append>select.btn:not([size]):not([multiple]),
.input-group-sm>.input-group-append>select.input-group-text:not([size]):not([multiple]),
.input-group-sm>.input-group-prepend>select.btn:not([size]):not([multiple]),
.input-group-sm>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),
.input-group-sm>select.form-control:not([size]):not([multiple]),
select.form-control-sm:not([size]):not([multiple]) {
	height: calc(1.8125rem + 2px)
}

.form-control-lg,
.input-group-lg>.form-control,
.input-group-lg>.input-group-append>.btn,
.input-group-lg>.input-group-append>.input-group-text,
.input-group-lg>.input-group-prepend>.btn,
.input-group-lg>.input-group-prepend>.input-group-text {
	padding: .5rem 1rem;
	font-size: 1.25rem;
	line-height: 1.5;
	border-radius: .3rem
}

.input-group-lg>.input-group-append>select.btn:not([size]):not([multiple]),
.input-group-lg>.input-group-append>select.input-group-text:not([size]):not([multiple]),
.input-group-lg>.input-group-prepend>select.btn:not([size]):not([multiple]),
.input-group-lg>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),
.input-group-lg>select.form-control:not([size]):not([multiple]),
select.form-control-lg:not([size]):not([multiple]) {
	height: calc(2.875rem + 2px)
}

.form-group {
	margin-bottom: 1rem
}

.form-text {
	display: block;
	margin-top: .25rem
}

.form-row {
	display: flex;
	flex-wrap: wrap;
	margin-right: -5px;
	margin-left: -5px
}

.form-row>.col,
.form-row>[class*=col-] {
	padding-right: 5px;
	padding-left: 5px
}

.form-check {
	position: relative;
	display: block;
	padding-left: 1.25rem
}

.form-check-input {
	position: absolute;
	margin-top: .3rem;
	margin-left: -1.25rem
}

.form-check-input:disabled~.form-check-label {
	color: #6c757d
}

.form-check-label {
	margin-bottom: 0
}

.form-check-inline {
	display: inline-flex;
	align-items: center;
	padding-left: 0;
	margin-right: .75rem
}

.form-check-inline .form-check-input {
	position: static;
	margin-top: 0;
	margin-right: .3125rem;
	margin-left: 0
}

.valid-feedback {
	display: none;
	width: 100%;
	margin-top: .25rem;
	font-size: 80%;
	color: #28a745
}

.valid-tooltip {
	position: absolute;
	top: 100%;
	z-index: 5;
	display: none;
	max-width: 100%;
	padding: .5rem;
	margin-top: .1rem;
	font-size: .875rem;
	line-height: 1;
	color: #fff;
	background-color: rgba(40, 167, 69, .8);
	border-radius: .2rem
}

.custom-select.is-valid,
.form-control.is-valid,
.was-validated .custom-select:valid,
.was-validated .form-control:valid {
	border-color: #28a745
}

.custom-select.is-valid:focus,
.form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.was-validated .form-control:valid:focus {
	border-color: #28a745;
	box-shadow: 0 0 0 .2rem rgba(40, 167, 69, .25)
}

.custom-select.is-valid~.valid-feedback,
.custom-select.is-valid~.valid-tooltip,
.form-control.is-valid~.valid-feedback,
.form-control.is-valid~.valid-tooltip,
.was-validated .custom-select:valid~.valid-feedback,
.was-validated .custom-select:valid~.valid-tooltip,
.was-validated .form-control:valid~.valid-feedback,
.was-validated .form-control:valid~.valid-tooltip {
	display: block
}

.form-control-file.is-valid~.valid-feedback,
.form-control-file.is-valid~.valid-tooltip,
.was-validated .form-control-file:valid~.valid-feedback,
.was-validated .form-control-file:valid~.valid-tooltip {
	display: block
}

.form-check-input.is-valid~.form-check-label,
.was-validated .form-check-input:valid~.form-check-label {
	color: #28a745
}

.form-check-input.is-valid~.valid-feedback,
.form-check-input.is-valid~.valid-tooltip,
.was-validated .form-check-input:valid~.valid-feedback,
.was-validated .form-check-input:valid~.valid-tooltip {
	display: block
}

.custom-control-input.is-valid~.custom-control-label,
.was-validated .custom-control-input:valid~.custom-control-label {
	color: #28a745
}

.custom-control-input.is-valid~.custom-control-label::before,
.was-validated .custom-control-input:valid~.custom-control-label::before {
	background-color: #71dd8a
}

.custom-control-input.is-valid~.valid-feedback,
.custom-control-input.is-valid~.valid-tooltip,
.was-validated .custom-control-input:valid~.valid-feedback,
.was-validated .custom-control-input:valid~.valid-tooltip {
	display: block
}

.custom-control-input.is-valid:checked~.custom-control-label::before,
.was-validated .custom-control-input:valid:checked~.custom-control-label::before {
	background-color: #34ce57
}

.custom-control-input.is-valid:focus~.custom-control-label::before,
.was-validated .custom-control-input:valid:focus~.custom-control-label::before {
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(40, 167, 69, .25)
}

.custom-file-input.is-valid~.custom-file-label,
.was-validated .custom-file-input:valid~.custom-file-label {
	border-color: #28a745
}

.custom-file-input.is-valid~.custom-file-label::before,
.was-validated .custom-file-input:valid~.custom-file-label::before {
	border-color: inherit
}

.custom-file-input.is-valid~.valid-feedback,
.custom-file-input.is-valid~.valid-tooltip,
.was-validated .custom-file-input:valid~.valid-feedback,
.was-validated .custom-file-input:valid~.valid-tooltip {
	display: block
}

.custom-file-input.is-valid:focus~.custom-file-label,
.was-validated .custom-file-input:valid:focus~.custom-file-label {
	box-shadow: 0 0 0 .2rem rgba(40, 167, 69, .25)
}

.invalid-feedback {
	display: none;
	width: 100%;
	margin-top: .25rem;
	font-size: 80%;
	color: #dc3545
}

.invalid-tooltip {
	position: absolute;
	top: 100%;
	z-index: 5;
	display: none;
	max-width: 100%;
	padding: .5rem;
	margin-top: .1rem;
	font-size: .875rem;
	line-height: 1;
	color: #fff;
	background-color: rgba(220, 53, 69, .8);
	border-radius: .2rem
}

.custom-select.is-invalid,
.form-control.is-invalid,
.was-validated .custom-select:invalid,
.was-validated .form-control:invalid {
	border-color: #dc3545
}

.custom-select.is-invalid:focus,
.form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.was-validated .form-control:invalid:focus {
	border-color: #dc3545;
	box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .25)
}

.custom-select.is-invalid~.invalid-feedback,
.custom-select.is-invalid~.invalid-tooltip,
.form-control.is-invalid~.invalid-feedback,
.form-control.is-invalid~.invalid-tooltip,
.was-validated .custom-select:invalid~.invalid-feedback,
.was-validated .custom-select:invalid~.invalid-tooltip,
.was-validated .form-control:invalid~.invalid-feedback,
.was-validated .form-control:invalid~.invalid-tooltip {
	display: block
}

.form-control-file.is-invalid~.invalid-feedback,
.form-control-file.is-invalid~.invalid-tooltip,
.was-validated .form-control-file:invalid~.invalid-feedback,
.was-validated .form-control-file:invalid~.invalid-tooltip {
	display: block
}

.form-check-input.is-invalid~.form-check-label,
.was-validated .form-check-input:invalid~.form-check-label {
	color: #dc3545
}

.form-check-input.is-invalid~.invalid-feedback,
.form-check-input.is-invalid~.invalid-tooltip,
.was-validated .form-check-input:invalid~.invalid-feedback,
.was-validated .form-check-input:invalid~.invalid-tooltip {
	display: block
}

.custom-control-input.is-invalid~.custom-control-label,
.was-validated .custom-control-input:invalid~.custom-control-label {
	color: #dc3545
}

.custom-control-input.is-invalid~.custom-control-label::before,
.was-validated .custom-control-input:invalid~.custom-control-label::before {
	background-color: #efa2a9
}

.custom-control-input.is-invalid~.invalid-feedback,
.custom-control-input.is-invalid~.invalid-tooltip,
.was-validated .custom-control-input:invalid~.invalid-feedback,
.was-validated .custom-control-input:invalid~.invalid-tooltip {
	display: block
}

.custom-control-input.is-invalid:checked~.custom-control-label::before,
.was-validated .custom-control-input:invalid:checked~.custom-control-label::before {
	background-color: #e4606d
}

.custom-control-input.is-invalid:focus~.custom-control-label::before,
.was-validated .custom-control-input:invalid:focus~.custom-control-label::before {
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(220, 53, 69, .25)
}

.custom-file-input.is-invalid~.custom-file-label,
.was-validated .custom-file-input:invalid~.custom-file-label {
	border-color: #dc3545
}

.custom-file-input.is-invalid~.custom-file-label::before,
.was-validated .custom-file-input:invalid~.custom-file-label::before {
	border-color: inherit
}

.custom-file-input.is-invalid~.invalid-feedback,
.custom-file-input.is-invalid~.invalid-tooltip,
.was-validated .custom-file-input:invalid~.invalid-feedback,
.was-validated .custom-file-input:invalid~.invalid-tooltip {
	display: block
}

.custom-file-input.is-invalid:focus~.custom-file-label,
.was-validated .custom-file-input:invalid:focus~.custom-file-label {
	box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .25)
}

.form-inline {
	display: flex;
	flex-flow: row wrap;
	align-items: center
}

.form-inline .form-check {
	width: 100%
}

@media (min-width:576px) {
	.form-inline label {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 0
	}

	.form-inline .form-group {
		display: flex;
		flex: 0 0 auto;
		flex-flow: row wrap;
		align-items: center;
		margin-bottom: 0
	}

	.form-inline .form-control {
		display: inline-block;
		width: auto;
		vertical-align: middle
	}

	.form-inline .form-control-plaintext {
		display: inline-block
	}

	.form-inline .custom-select,
	.form-inline .input-group {
		width: auto
	}

	.form-inline .form-check {
		display: flex;
		align-items: center;
		justify-content: center;
		width: auto;
		padding-left: 0
	}

	.form-inline .form-check-input {
		position: relative;
		margin-top: 0;
		margin-right: .25rem;
		margin-left: 0
	}

	.form-inline .custom-control {
		align-items: center;
		justify-content: center
	}

	.form-inline .custom-control-label {
		margin-bottom: 0
	}
}

.btn {
	display: inline-block;
	font-weight: 400;
	text-align: center;
	white-space: nowrap;
	vertical-align: middle;
	-webkit-user-select: none;
	user-select: none;
	border: 1px solid transparent;
	padding: .375rem .75rem;
	font-size: 1rem;
	line-height: 1.5;
	border-radius: .25rem;
	transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media screen and (prefers-reduced-motion:reduce) {
	.btn {
		transition: none
	}
}

.btn:focus,
.btn:hover {
	text-decoration: none
}

.btn.focus,
.btn:focus {
	outline: 0;
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.btn.disabled,
.btn:disabled {
	opacity: .65
}

.btn:not(:disabled):not(.disabled) {
	cursor: pointer
}

.btn:not(:disabled):not(.disabled).active,
.btn:not(:disabled):not(.disabled):active {
	background-image: none
}

a.btn.disabled,
fieldset:disabled a.btn {
	pointer-events: none
}

.btn-primary {
	color: #fff;
	background-color: #007bff;
	border-color: #007bff
}

.btn-primary:hover {
	color: #fff;
	background-color: #0069d9;
	border-color: #0062cc
}

.btn-primary.focus,
.btn-primary:focus {
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5)
}

.btn-primary.disabled,
.btn-primary:disabled {
	color: #fff;
	background-color: #007bff;
	border-color: #007bff
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
	color: #fff;
	background-color: #0062cc;
	border-color: #005cbf
}

.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show>.btn-primary.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5)
}

.btn-secondary {
	color: #fff;
	background-color: #6c757d;
	border-color: #6c757d
}

.btn-secondary:hover {
	color: #fff;
	background-color: #5a6268;
	border-color: #545b62
}

.btn-secondary.focus,
.btn-secondary:focus {
	box-shadow: 0 0 0 .2rem rgba(108, 117, 125, .5)
}

.btn-secondary.disabled,
.btn-secondary:disabled {
	color: #fff;
	background-color: #6c757d;
	border-color: #6c757d
}

.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show>.btn-secondary.dropdown-toggle {
	color: #fff;
	background-color: #545b62;
	border-color: #4e555b
}

.btn-secondary:not(:disabled):not(.disabled).active:focus,
.btn-secondary:not(:disabled):not(.disabled):active:focus,
.show>.btn-secondary.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(108, 117, 125, .5)
}

.btn-success {
	color: #fff;
	background-color: #28a745;
	border-color: #28a745
}

.btn-success:hover {
	color: #fff;
	background-color: #218838;
	border-color: #1e7e34
}

.btn-success.focus,
.btn-success:focus {
	box-shadow: 0 0 0 .2rem rgba(40, 167, 69, .5)
}

.btn-success.disabled,
.btn-success:disabled {
	color: #fff;
	background-color: #28a745;
	border-color: #28a745
}

.btn-success:not(:disabled):not(.disabled).active,
.btn-success:not(:disabled):not(.disabled):active,
.show>.btn-success.dropdown-toggle {
	color: #fff;
	background-color: #1e7e34;
	border-color: #1c7430
}

.btn-success:not(:disabled):not(.disabled).active:focus,
.btn-success:not(:disabled):not(.disabled):active:focus,
.show>.btn-success.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(40, 167, 69, .5)
}

.btn-info {
	color: #fff;
	background-color: #17a2b8;
	border-color: #17a2b8
}

.btn-info:hover {
	color: #fff;
	background-color: #138496;
	border-color: #117a8b
}

.btn-info.focus,
.btn-info:focus {
	box-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)
}

.btn-info.disabled,
.btn-info:disabled {
	color: #fff;
	background-color: #17a2b8;
	border-color: #17a2b8
}

.btn-info:not(:disabled):not(.disabled).active,
.btn-info:not(:disabled):not(.disabled):active,
.show>.btn-info.dropdown-toggle {
	color: #fff;
	background-color: #117a8b;
	border-color: #10707f
}

.btn-info:not(:disabled):not(.disabled).active:focus,
.btn-info:not(:disabled):not(.disabled):active:focus,
.show>.btn-info.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)
}

.btn-warning {
	color: #212529;
	background-color: #ffc107;
	border-color: #ffc107
}

.btn-warning:hover {
	color: #212529;
	background-color: #e0a800;
	border-color: #d39e00
}

.btn-warning.focus,
.btn-warning:focus {
	box-shadow: 0 0 0 .2rem rgba(255, 193, 7, .5)
}

.btn-warning.disabled,
.btn-warning:disabled {
	color: #212529;
	background-color: #ffc107;
	border-color: #ffc107
}

.btn-warning:not(:disabled):not(.disabled).active,
.btn-warning:not(:disabled):not(.disabled):active,
.show>.btn-warning.dropdown-toggle {
	color: #212529;
	background-color: #d39e00;
	border-color: #c69500
}

.btn-warning:not(:disabled):not(.disabled).active:focus,
.btn-warning:not(:disabled):not(.disabled):active:focus,
.show>.btn-warning.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(255, 193, 7, .5)
}

.btn-danger {
	color: #fff;
	background-color: #dc3545;
	border-color: #dc3545
}

.btn-danger:hover {
	color: #fff;
	background-color: #c82333;
	border-color: #bd2130
}

.btn-danger.focus,
.btn-danger:focus {
	box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)
}

.btn-danger.disabled,
.btn-danger:disabled {
	color: #fff;
	background-color: #dc3545;
	border-color: #dc3545;
}

.btn-danger:not(:disabled):not(.disabled).active,
.btn-danger:not(:disabled):not(.disabled):active,
.show>.btn-danger.dropdown-toggle {
	color: #fff;
	background-color: #bd2130;
	border-color: #b21f2d;
}

.btn-danger:not(:disabled):not(.disabled).active:focus,
.btn-danger:not(:disabled):not(.disabled):active:focus,
.show>.btn-danger.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)
}

.btn-light {
	color: #212529;
	background-color: #f8f9fa;
	border-color: #facedd;
}

.btn-light:hover {
	color: #212529;
	background-color: #e2e6ea;
	border-color: #dae0e5;
}

.btn-light.focus,
.btn-light:focus {
	box-shadow: 0 0 0 .2rem rgba(248, 249, 250, .5)
}

.btn-light.disabled,
.btn-light:disabled {
	color: #212529;
	background-color: #f8f9fa;
	border-color: #f8f9fa
}

.btn-light:not(:disabled):not(.disabled).active,
.btn-light:not(:disabled):not(.disabled):active,
.show>.btn-light.dropdown-toggle {
	color: #212529;
	background-color: #dae0e5;
	border-color: #d3d9df;
}

.btn-light:not(:disabled):not(.disabled).active:focus,
.btn-light:not(:disabled):not(.disabled):active:focus,
.show>.btn-light.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(248, 249, 250, .5)
}

.btn-dark {
	color: #fff;
	background-color: #343a40;
	border-color: #343a40;
}

.btn-dark:hover {
	color: #fff;
	background-color: #23272b;
	border-color: #1d2124
}

.btn-dark.focus,
.btn-dark:focus {
	box-shadow: 0 0 0 .2rem rgba(52, 58, 64, .5)
}

.btn-dark.disabled,
.btn-dark:disabled {
	color: #fff;
	background-color: #343a40;
	border-color: #343a40
}

.btn-dark:not(:disabled):not(.disabled).active,
.btn-dark:not(:disabled):not(.disabled):active,
.show>.btn-dark.dropdown-toggle {
	color: #fff;
	background-color: #1d2124;
	border-color: #171a1d
}

.btn-dark:not(:disabled):not(.disabled).active:focus,
.btn-dark:not(:disabled):not(.disabled):active:focus,
.show>.btn-dark.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(52, 58, 64, .5)
}

.btn-outline-primary {
	color: #007bff;
	background-color: transparent;
	background-image: none;
	border-color: #007bff
}

.btn-outline-primary:hover {
	color: #fff;
	background-color: #007bff;
	border-color: #007bff
}

.btn-outline-primary.focus,
.btn-outline-primary:focus {
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5)
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
	color: #007bff;
	background-color: transparent
}

.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active,
.show>.btn-outline-primary.dropdown-toggle {
	color: #fff;
	background-color: #007bff;
	border-color: #007bff
}

.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-primary.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5)
}

.btn-outline-secondary {
	color: #6c757d;
	background-color: transparent;
	background-image: none;
	border-color: #6c757d
}

.btn-outline-secondary:hover {
	color: #fff;
	background-color: #6c757d;
	border-color: #6c757d
}

.btn-outline-secondary.focus,
.btn-outline-secondary:focus {
	box-shadow: 0 0 0 .2rem rgba(108, 117, 125, .5)
}

.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled {
	color: #6c757d;
	background-color: transparent
}

.btn-outline-secondary:not(:disabled):not(.disabled).active,
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.show>.btn-outline-secondary.dropdown-toggle {
	color: #fff;
	background-color: #6c757d;
	border-color: #6c757d
}

.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-secondary.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(108, 117, 125, .5)
}

.btn-outline-success {
	color: #28a745;
	background-color: transparent;
	background-image: none;
	border-color: #28a745
}

.btn-outline-success:hover {
	color: #fff;
	background-color: #28a745;
	border-color: #28a745
}

.btn-outline-success.focus,
.btn-outline-success:focus {
	box-shadow: 0 0 0 .2rem rgba(40, 167, 69, .5)
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
	color: #28a745;
	background-color: transparent
}

.btn-outline-success:not(:disabled):not(.disabled).active,
.btn-outline-success:not(:disabled):not(.disabled):active,
.show>.btn-outline-success.dropdown-toggle {
	color: #fff;
	background-color: #28a745;
	border-color: #28a745
}

.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-success.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(40, 167, 69, .5)
}

.btn-outline-info {
	color: #17a2b8;
	background-color: transparent;
	background-image: none;
	border-color: #17a2b8
}

.btn-outline-info:hover {
	color: #fff;
	background-color: #17a2b8;
	border-color: #17a2b8
}

.btn-outline-info.focus,
.btn-outline-info:focus {
	box-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
	color: #17a2b8;
	background-color: transparent
}

.btn-outline-info:not(:disabled):not(.disabled).active,
.btn-outline-info:not(:disabled):not(.disabled):active,
.show>.btn-outline-info.dropdown-toggle {
	color: #fff;
	background-color: #17a2b8;
	border-color: #17a2b8
}

.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-info.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)
}

.btn-outline-warning {
	color: #ffc107;
	background-color: transparent;
	background-image: none;
	border-color: #ffc107
}

.btn-outline-warning:hover {
	color: #212529;
	background-color: #ffc107;
	border-color: #ffc107
}

.btn-outline-warning.focus,
.btn-outline-warning:focus {
	box-shadow: 0 0 0 .2rem rgba(255, 193, 7, .5)
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
	color: #ffc107;
	background-color: transparent
}

.btn-outline-warning:not(:disabled):not(.disabled).active,
.btn-outline-warning:not(:disabled):not(.disabled):active,
.show>.btn-outline-warning.dropdown-toggle {
	color: #212529;
	background-color: #ffc107;
	border-color: #ffc107
}

.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-warning.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(255, 193, 7, .5)
}

.btn-outline-danger {
	color: #dc3545;
	background-color: transparent;
	background-image: none;
	border-color: #dc3545
}

.btn-outline-danger:hover {
	color: #fff;
	background-color: #dc3545;
	border-color: #dc3545
}

.btn-outline-danger.focus,
.btn-outline-danger:focus {
	box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
	color: #dc3545;
	background-color: transparent
}

.btn-outline-danger:not(:disabled):not(.disabled).active,
.btn-outline-danger:not(:disabled):not(.disabled):active,
.show>.btn-outline-danger.dropdown-toggle {
	color: #fff;
	background-color: #dc3545;
	border-color: #dc3545
}

.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-danger.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)
}

.btn-outline-light {
	color: #f8f9fa;
	background-color: transparent;
	background-image: none;
	border-color: #f8f9fa
}

.btn-outline-light:hover {
	color: #212529;
	background-color: #f8f9fa;
	border-color: #f8f9fa
}

.btn-outline-light.focus,
.btn-outline-light:focus {
	box-shadow: 0 0 0 .2rem rgba(248, 249, 250, .5)
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
	color: #f8f9fa;
	background-color: transparent
}

.btn-outline-light:not(:disabled):not(.disabled).active,
.btn-outline-light:not(:disabled):not(.disabled):active,
.show>.btn-outline-light.dropdown-toggle {
	color: #212529;
	background-color: #f8f9fa;
	border-color: #f8f9fa
}

.btn-outline-light:not(:disabled):not(.disabled).active:focus,
.btn-outline-light:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-light.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(248, 249, 250, .5)
}

.btn-outline-dark {
	color: #343a40;
	background-color: transparent;
	background-image: none;
	border-color: #343a40
}

.btn-outline-dark:hover {
	color: #fff;
	background-color: #343a40;
	border-color: #343a40
}

.btn-outline-dark.focus,
.btn-outline-dark:focus {
	box-shadow: 0 0 0 .2rem rgba(52, 58, 64, .5)
}

.btn-outline-dark.disabled,
.btn-outline-dark:disabled {
	color: #343a40;
	background-color: transparent
}

.btn-outline-dark:not(:disabled):not(.disabled).active,
.btn-outline-dark:not(:disabled):not(.disabled):active,
.show>.btn-outline-dark.dropdown-toggle {
	color: #fff;
	background-color: #343a40;
	border-color: #343a40
}

.btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.btn-outline-dark:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-dark.dropdown-toggle:focus {
	box-shadow: 0 0 0 .2rem rgba(52, 58, 64, .5)
}

.btn-link {
	font-weight: 400;
	color: #007bff;
	background-color: transparent
}

.btn-link:hover {
	color: #0056b3;
	text-decoration: underline;
	background-color: transparent;
	border-color: transparent
}

.btn-link.focus,
.btn-link:focus {
	text-decoration: underline;
	border-color: transparent;
	box-shadow: none
}

.btn-link.disabled,
.btn-link:disabled {
	color: #6c757d;
	pointer-events: none
}

.btn-group-lg>.btn,
.btn-lg {
	padding: .5rem 1rem;
	font-size: 1.25rem;
	line-height: 1.5;
	border-radius: .3rem
}

.btn-group-sm>.btn,
.btn-sm {
	padding: .25rem .5rem;
	font-size: .875rem;
	line-height: 1.5;
	border-radius: .2rem
}

.btn-block {
	display: block;
	width: 100%
}

.btn-block+.btn-block {
	margin-top: .5rem
}

input[type=button].btn-block,
input[type=reset].btn-block,
input[type=submit].btn-block {
	width: 100%
}

.fade {
	transition: opacity .15s linear
}

@media screen and (prefers-reduced-motion:reduce) {
	.fade {
		transition: none
	}
}

.fade:not(.show) {
	opacity: 0
}

.collapse:not(.show) {
	display: none
}

.collapsing {
	position: relative;
	height: 0;
	overflow: hidden;
	transition: height .35s ease
}

@media screen and (prefers-reduced-motion:reduce) {
	.collapsing {
		transition: none
	}
}

.dropdown,
.dropleft,
.dropright,
.dropup {
	position: relative
}

.dropdown-toggle::after {
	display: inline-block;
	width: 0;
	height: 0;
	margin-left: .255em;
	vertical-align: .255em;
	content: "";
	border-top: .3em solid;
	border-right: .3em solid transparent;
	border-bottom: 0;
	border-left: .3em solid transparent
}

.dropdown-toggle:empty::after {
	margin-left: 0
}

.dropdown-menu {
	position: absolute;
	top: 100%;
	left: 0;
	z-index: 1000;
	display: none;
	float: left;
	min-width: 10rem;
	padding: .5rem 0;
	margin: .125rem 0 0;
	font-size: 1rem;
	color: #212529;
	text-align: left;
	list-style: none;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, .15);
	border-radius: .25rem
}

.dropdown-menu-right {
	right: 0;
	left: auto
}

.dropup .dropdown-menu {
	top: auto;
	bottom: 100%;
	margin-top: 0;
	margin-bottom: .125rem
}

.dropup .dropdown-toggle::after {
	display: inline-block;
	width: 0;
	height: 0;
	margin-left: .255em;
	vertical-align: .255em;
	content: "";
	border-top: 0;
	border-right: .3em solid transparent;
	border-bottom: .3em solid;
	border-left: .3em solid transparent
}

.dropup .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropright .dropdown-menu {
	top: 0;
	right: auto;
	left: 100%;
	margin-top: 0;
	margin-left: .125rem
}

.dropright .dropdown-toggle::after {
	display: inline-block;
	width: 0;
	height: 0;
	margin-left: .255em;
	vertical-align: .255em;
	content: "";
	border-top: .3em solid transparent;
	border-right: 0;
	border-bottom: .3em solid transparent;
	border-left: .3em solid
}

.dropright .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropright .dropdown-toggle::after {
	vertical-align: 0
}

.dropleft .dropdown-menu {
	top: 0;
	right: 100%;
	left: auto;
	margin-top: 0;
	margin-right: .125rem
}

.dropleft .dropdown-toggle::after {
	display: inline-block;
	width: 0;
	height: 0;
	margin-left: .255em;
	vertical-align: .255em;
	content: ""
}

.dropleft .dropdown-toggle::after {
	display: none
}

.dropleft .dropdown-toggle::before {
	display: inline-block;
	width: 0;
	height: 0;
	margin-right: .255em;
	vertical-align: .255em;
	content: "";
	border-top: .3em solid transparent;
	border-right: .3em solid;
	border-bottom: .3em solid transparent
}

.dropleft .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropleft .dropdown-toggle::before {
	vertical-align: 0
}

.dropdown-menu[x-placement^=bottom],
.dropdown-menu[x-placement^=left],
.dropdown-menu[x-placement^=right],
.dropdown-menu[x-placement^=top] {
	right: auto;
	bottom: auto
}

.dropdown-divider {
	height: 0;
	margin: .5rem 0;
	overflow: hidden;
	border-top: 1px solid #e9ecef
}

.dropdown-item {
	display: block;
	width: 100%;
	padding: .25rem 1.5rem;
	clear: both;
	font-weight: 400;
	color: #212529;
	text-align: inherit;
	white-space: nowrap;
	background-color: transparent;
	border: 0
}

.dropdown-item:focus,
.dropdown-item:hover {
	color: #16181b;
	text-decoration: none;
	background-color: #f8f9fa
}

.dropdown-item.active,
.dropdown-item:active {
	color: #fff;
	text-decoration: none;
	background-color: #ec167f;
}

.dropdown-item.disabled,
.dropdown-item:disabled {
	color: #6c757d;
	background-color: transparent
}

.dropdown-menu.show {
	display: block
}

.dropdown-header {
	display: block;
	padding: .5rem 1.5rem;
	margin-bottom: 0;
	font-size: .875rem;
	color: #6c757d;
	white-space: nowrap
}

.dropdown-item-text {
	display: block;
	padding: .25rem 1.5rem;
	color: #212529
}

.btn-group,
.btn-group-vertical {
	position: relative;
	display: inline-flex;
	vertical-align: middle
}

.btn-group-vertical>.btn,
.btn-group>.btn {
	position: relative;
	flex: 0 1 auto
}

.btn-group-vertical>.btn:hover,
.btn-group>.btn:hover {
	z-index: 1
}

.btn-group-vertical>.btn.active,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn:focus,
.btn-group>.btn.active,
.btn-group>.btn:active,
.btn-group>.btn:focus {
	z-index: 1
}

.btn-group .btn+.btn,
.btn-group .btn+.btn-group,
.btn-group .btn-group+.btn,
.btn-group .btn-group+.btn-group,
.btn-group-vertical .btn+.btn,
.btn-group-vertical .btn+.btn-group,
.btn-group-vertical .btn-group+.btn,
.btn-group-vertical .btn-group+.btn-group {
	margin-left: -1px
}

.btn-toolbar {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start
}

.btn-toolbar .input-group {
	width: auto
}

.btn-group>.btn:first-child {
	margin-left: 0
}

.btn-group>.btn-group:not(:last-child)>.btn,
.btn-group>.btn:not(:last-child):not(.dropdown-toggle) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0
}

.btn-group>.btn-group:not(:first-child)>.btn,
.btn-group>.btn:not(:first-child) {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0
}

.dropdown-toggle-split {
	padding-right: .5625rem;
	padding-left: .5625rem
}

.dropdown-toggle-split::after,
.dropright .dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after {
	margin-left: 0
}

.dropleft .dropdown-toggle-split::before {
	margin-right: 0
}

.btn-group-sm>.btn+.dropdown-toggle-split,
.btn-sm+.dropdown-toggle-split {
	padding-right: .375rem;
	padding-left: .375rem
}

.btn-group-lg>.btn+.dropdown-toggle-split,
.btn-lg+.dropdown-toggle-split {
	padding-right: .75rem;
	padding-left: .75rem
}

.btn-group-vertical {
	flex-direction: column;
	align-items: flex-start;
	justify-content: center
}

.btn-group-vertical .btn,
.btn-group-vertical .btn-group {
	width: 100%
}

.btn-group-vertical>.btn+.btn,
.btn-group-vertical>.btn+.btn-group,
.btn-group-vertical>.btn-group+.btn,
.btn-group-vertical>.btn-group+.btn-group {
	margin-top: -1px;
	margin-left: 0
}

.btn-group-vertical>.btn-group:not(:last-child)>.btn,
.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle) {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0
}

.btn-group-vertical>.btn-group:not(:first-child)>.btn,
.btn-group-vertical>.btn:not(:first-child) {
	border-top-left-radius: 0;
	border-top-right-radius: 0
}

.btn-group-toggle>.btn,
.btn-group-toggle>.btn-group>.btn {
	margin-bottom: 0
}

.btn-group-toggle>.btn input[type=checkbox],
.btn-group-toggle>.btn input[type=radio],
.btn-group-toggle>.btn-group>.btn input[type=checkbox],
.btn-group-toggle>.btn-group>.btn input[type=radio] {
	position: absolute;
	clip: rect(0, 0, 0, 0);
	pointer-events: none
}

.input-group {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	width: 100%
}

.input-group>.custom-file,
.input-group>.custom-select,
.input-group>.form-control {
	position: relative;
	flex: 1 1 auto;
	width: 1%;
	margin-bottom: 0
}

.input-group>.custom-file:focus,
.input-group>.custom-select:focus,
.input-group>.form-control:focus {
	z-index: 3
}

.input-group>.custom-file+.custom-file,
.input-group>.custom-file+.custom-select,
.input-group>.custom-file+.form-control,
.input-group>.custom-select+.custom-file,
.input-group>.custom-select+.custom-select,
.input-group>.custom-select+.form-control,
.input-group>.form-control+.custom-file,
.input-group>.form-control+.custom-select,
.input-group>.form-control+.form-control {
	margin-left: -1px
}

.input-group>.custom-select:not(:last-child),
.input-group>.form-control:not(:last-child) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0
}

.input-group>.custom-select:not(:first-child),
.input-group>.form-control:not(:first-child) {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0
}

.input-group>.custom-file {
	display: flex;
	align-items: center
}

.input-group>.custom-file:not(:last-child) .custom-file-label,
.input-group>.custom-file:not(:last-child) .custom-file-label::after {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0
}

.input-group>.custom-file:not(:first-child) .custom-file-label {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0
}

.input-group-append,
.input-group-prepend {
	display: flex
}

.input-group-append .btn,
.input-group-prepend .btn {
	position: relative;
	z-index: 2
}

.input-group-append .btn+.btn,
.input-group-append .btn+.input-group-text,
.input-group-append .input-group-text+.btn,
.input-group-append .input-group-text+.input-group-text,
.input-group-prepend .btn+.btn,
.input-group-prepend .btn+.input-group-text,
.input-group-prepend .input-group-text+.btn,
.input-group-prepend .input-group-text+.input-group-text {
	margin-left: -1px
}

.input-group-prepend {
	margin-right: -1px
}

.input-group-append {
	margin-left: -1px
}

.input-group-text {
	display: flex;
	align-items: center;
	padding: .375rem .75rem;
	margin-bottom: 0;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	text-align: center;
	white-space: nowrap;
	background-color: #e9ecef;
	border: 1px solid #ced4da;
	border-radius: .25rem
}

.input-group-text input[type=checkbox],
.input-group-text input[type=radio] {
	margin-top: 0
}

.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),
.input-group>.input-group-append:not(:last-child)>.btn,
.input-group>.input-group-append:not(:last-child)>.input-group-text,
.input-group>.input-group-prepend>.btn,
.input-group>.input-group-prepend>.input-group-text {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0
}

.input-group>.input-group-append>.btn,
.input-group>.input-group-append>.input-group-text,
.input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
.input-group>.input-group-prepend:not(:first-child)>.btn,
.input-group>.input-group-prepend:not(:first-child)>.input-group-text {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0
}

.custom-control {
	position: relative;
	display: block;
	min-height: 1.5rem;
	padding-left: 1.5rem
}

.custom-control-inline {
	display: inline-flex;
	margin-right: 1rem
}

.custom-control-input {
	position: absolute;
	z-index: -1;
	opacity: 0
}

.custom-control-input:checked~.custom-control-label::before {
	color: #fff;
	background-color: #007bff
}

.custom-control-input:focus~.custom-control-label::before {
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-control-input:active~.custom-control-label::before {
	color: #fff;
	background-color: #b3d7ff
}

.custom-control-input:disabled~.custom-control-label {
	color: #6c757d
}

.custom-control-input:disabled~.custom-control-label::before {
	background-color: #e9ecef
}

.custom-control-label {
	position: relative;
	margin-bottom: 0
}

.custom-control-label::before {
	position: absolute;
	top: .25rem;
	left: -1.5rem;
	display: block;
	width: 1rem;
	height: 1rem;
	pointer-events: none;
	content: "";
	-webkit-user-select: none;
	user-select: none;
	background-color: #dee2e6
}

.custom-control-label::after {
	position: absolute;
	top: .25rem;
	left: -1.5rem;
	display: block;
	width: 1rem;
	height: 1rem;
	content: "";
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 50% 50%
}

.custom-checkbox .custom-control-label::before {
	border-radius: .25rem
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
	background-color: #007bff
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
	background-color: #007bff
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
	background-color: rgba(0, 123, 255, .5)
}

.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {
	background-color: rgba(0, 123, 255, .5)
}

.custom-radio .custom-control-label::before {
	border-radius: 50%
}

.custom-radio .custom-control-input:checked~.custom-control-label::before {
	background-color: #007bff
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
}

.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {
	background-color: rgba(0, 123, 255, .5)
}

.custom-select {
	display: inline-block;
	width: 100%;
	height: calc(2.25rem + 2px);
	padding: .375rem 1.75rem .375rem .75rem;
	line-height: 1.5;
	color: #495057;
	vertical-align: middle;
	background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat right .75rem center;
	background-size: 8px 10px;
	border: 1px solid #ced4da;
	border-radius: .25rem;
	appearance: none
}

.custom-select:focus {
	border-color: #80bdff;
	outline: 0;
	box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(128, 189, 255, .5)
}

.custom-select:focus::-ms-value {
	color: #495057;
	background-color: #fff
}

.custom-select[multiple],
.custom-select[size]:not([size="1"]) {
	height: auto;
	padding-right: .75rem;
	background-image: none
}

.custom-select:disabled {
	color: #6c757d;
	background-color: #e9ecef
}

.custom-select::-ms-expand {
	opacity: 0
}

.custom-select-sm {
	height: calc(1.8125rem + 2px);
	padding-top: .375rem;
	padding-bottom: .375rem;
	font-size: 75%
}

.custom-select-lg {
	height: calc(2.875rem + 2px);
	padding-top: .375rem;
	padding-bottom: .375rem;
	font-size: 125%
}

.custom-file {
	position: relative;
	display: inline-block;
	width: 100%;
	height: calc(2.25rem + 2px);
	margin-bottom: 0
}

.custom-file-input {
	position: relative;
	z-index: 2;
	width: 100%;
	height: calc(2.25rem + 2px);
	margin: 0;
	opacity: 0
}

.custom-file-input:focus~.custom-file-label {
	border-color: #80bdff;
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-file-input:focus~.custom-file-label::after {
	border-color: #80bdff
}

.custom-file-input:lang(en)~.custom-file-label::after {
	content: "Browse"
}

.custom-file-label {
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	z-index: 1;
	height: calc(2.25rem + 2px);
	padding: .375rem .75rem;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	border: 1px solid #ced4da;
	border-radius: .25rem
}

.custom-file-label::after {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 3;
	display: block;
	height: 2.25rem;
	padding: .375rem .75rem;
	line-height: 1.5;
	color: #495057;
	content: "Browse";
	background-color: #e9ecef;
	border-left: 1px solid #ced4da;
	border-radius: 0 .25rem .25rem 0
}

.custom-range {
	width: 100%;
	padding-left: 0;
	background-color: transparent;
	appearance: none
}

.custom-range:focus {
	outline: 0
}

.custom-range::-moz-focus-outer {
	border: 0
}

.custom-range::-webkit-slider-thumb {
	width: 1rem;
	height: 1rem;
	margin-top: -.25rem;
	background-color: #007bff;
	border: 0;
	border-radius: 1rem;
	appearance: none
}

.custom-range::-webkit-slider-thumb:focus {
	outline: 0;
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-range::-webkit-slider-thumb:active {
	background-color: #b3d7ff
}

.custom-range::-webkit-slider-runnable-track {
	width: 100%;
	height: .5rem;
	color: transparent;
	cursor: pointer;
	background-color: #dee2e6;
	border-color: transparent;
	border-radius: 1rem
}

.custom-range::-moz-range-thumb {
	width: 1rem;
	height: 1rem;
	background-color: #007bff;
	border: 0;
	border-radius: 1rem;
	appearance: none
}

.custom-range::-moz-range-thumb:focus {
	outline: 0;
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-range::-moz-range-thumb:active {
	background-color: #b3d7ff
}

.custom-range::-moz-range-track {
	width: 100%;
	height: .5rem;
	color: transparent;
	cursor: pointer;
	background-color: #dee2e6;
	border-color: transparent;
	border-radius: 1rem
}

.custom-range::-ms-thumb {
	width: 1rem;
	height: 1rem;
	background-color: #007bff;
	border: 0;
	border-radius: 1rem;
	appearance: none
}

.custom-range::-ms-thumb:focus {
	outline: 0;
	box-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.custom-range::-ms-thumb:active {
	background-color: #b3d7ff
}

.custom-range::-ms-track {
	width: 100%;
	height: .5rem;
	color: transparent;
	cursor: pointer;
	background-color: transparent;
	border-color: transparent;
	border-width: .5rem
}

.custom-range::-ms-fill-lower {
	background-color: #dee2e6;
	border-radius: 1rem
}

.custom-range::-ms-fill-upper {
	margin-right: 15px;
	background-color: #dee2e6;
	border-radius: 1rem
}

.nav {
	display: flex;
	flex-wrap: wrap;
	padding-left: 0;
	margin-bottom: 0;
	list-style: none
}

.nav-link {
	display: block;
	padding: .5rem 1rem
}

.nav-link:focus,
.nav-link:hover {
	text-decoration: none
}

.nav-link.disabled {
	color: #6c757d
}

.nav-tabs {
	border-bottom: 1px solid #dee2e6
}

.nav-tabs .nav-item {
	margin-bottom: -1px
}

.nav-tabs .nav-link {
	border: 1px solid transparent;
	border-top-left-radius: .25rem;
	border-top-right-radius: .25rem
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
	border-color: #e9ecef #e9ecef #dee2e6
}

.nav-tabs .nav-link.disabled {
	color: #6c757d;
	background-color: transparent;
	border-color: transparent
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
	color: #495057;
	background-color: #fff;
	border-color: #dee2e6 #dee2e6 #fff
}

.nav-tabs .dropdown-menu {
	margin-top: -1px;
	border-top-left-radius: 0;
	border-top-right-radius: 0
}

.nav-pills .nav-link {
	border-radius: .25rem
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
	color: #fff;
	background-color: #007bff
}

.nav-fill .nav-item {
	flex: 1 1 auto;
	text-align: center
}

.nav-justified .nav-item {
	flex-basis: 0;
	flex-grow: 1;
	text-align: center
}

.tab-content>.tab-pane {
	display: none
}

.tab-content>.active {
	display: block
}

.navbar {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	padding: .5rem 1rem
}

.navbar>.container,
.navbar>.container-fluid {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between
}

.navbar-brand {
	display: inline-block;
	padding-top: .3125rem;
	padding-bottom: .3125rem;
	margin-right: 1rem;
	font-size: 1.25rem;
	line-height: inherit;
	white-space: nowrap
}

.navbar-brand:focus,
.navbar-brand:hover {
	text-decoration: none
}

.navbar-nav {
	display: flex;
	flex-direction: column;
	padding-left: 0;
	margin-bottom: 0;
	list-style: none
}

.navbar-nav .nav-link {
	padding-right: 0;
	padding-left: 0
}

.navbar-nav .dropdown-menu {
	position: static;
	float: none
}

.navbar-text {
	display: inline-block;
	padding-top: .5rem;
	padding-bottom: .5rem
}

.navbar-collapse {
	flex-basis: 100%;
	flex-grow: 1;
	align-items: center
}

.navbar-toggler {
	padding: .25rem .75rem;
	font-size: 1.25rem;
	line-height: 1;
	background-color: transparent;
	border: 1px solid transparent;
	border-radius: .25rem
}

.navbar-toggler:focus,
.navbar-toggler:hover {
	text-decoration: none
}

.navbar-toggler:not(:disabled):not(.disabled) {
	cursor: pointer
}

.navbar-toggler-icon {
	display: inline-block;
	width: 1.5em;
	height: 1.5em;
	vertical-align: middle;
	content: "";
	background: no-repeat center center;
	background-size: 100% 100%
}

@media (max-width:575.98px) {

	.navbar-expand-sm>.container,
	.navbar-expand-sm>.container-fluid {
		padding-right: 0;
		padding-left: 0
	}
}

@media (min-width:576px) {
	.navbar-expand-sm {
		flex-flow: row nowrap;
		justify-content: flex-start
	}

	.navbar-expand-sm .navbar-nav {
		flex-direction: row
	}

	.navbar-expand-sm .navbar-nav .dropdown-menu {
		position: absolute
	}

	.navbar-expand-sm .navbar-nav .nav-link {
		padding-right: .5rem;
		padding-left: .5rem
	}

	.navbar-expand-sm>.container,
	.navbar-expand-sm>.container-fluid {
		flex-wrap: nowrap
	}

	.navbar-expand-sm .navbar-collapse {
		display: flex !important;
		flex-basis: auto
	}

	.navbar-expand-sm .navbar-toggler {
		display: none
	}
}

@media (max-width:767.98px) {

	.navbar-expand-md>.container,
	.navbar-expand-md>.container-fluid {
		padding-right: 0;
		padding-left: 0
	}
}

@media (min-width:768px) {
	.navbar-expand-md {
		flex-flow: row nowrap;
		justify-content: flex-start
	}

	.navbar-expand-md .navbar-nav {
		flex-direction: row
	}

	.navbar-expand-md .navbar-nav .dropdown-menu {
		position: absolute
	}

	.navbar-expand-md .navbar-nav .nav-link {
		padding-right: .5rem;
		padding-left: .5rem
	}

	.navbar-expand-md>.container,
	.navbar-expand-md>.container-fluid {
		flex-wrap: nowrap
	}

	.navbar-expand-md .navbar-collapse {
		display: flex !important;
		flex-basis: auto
	}

	.navbar-expand-md .navbar-toggler {
		display: none
	}
}

@media (max-width:991.98px) {

	.navbar-expand-lg>.container,
	.navbar-expand-lg>.container-fluid {
		padding-right: 0;
		padding-left: 0
	}
}

@media (min-width:992px) {
	.navbar-expand-lg {
		flex-flow: row nowrap;
		justify-content: flex-start
	}

	.navbar-expand-lg .navbar-nav {
		flex-direction: row
	}

	.navbar-expand-lg .navbar-nav .dropdown-menu {
		position: absolute
	}

	.navbar-expand-lg .navbar-nav .nav-link {
		padding-right: .5rem;
		padding-left: .5rem
	}

	.navbar-expand-lg>.container,
	.navbar-expand-lg>.container-fluid {
		flex-wrap: nowrap
	}

	.navbar-expand-lg .navbar-collapse {
		display: flex !important;
		flex-basis: auto
	}

	.navbar-expand-lg .navbar-toggler {
		display: none
	}
}

@media (max-width:1199.98px) {

	.navbar-expand-xl>.container,
	.navbar-expand-xl>.container-fluid {
		padding-right: 0;
		padding-left: 0
	}
}

@media (min-width:1200px) {
	.navbar-expand-xl {
		flex-flow: row nowrap;
		justify-content: flex-start
	}

	.navbar-expand-xl .navbar-nav {
		flex-direction: row
	}

	.navbar-expand-xl .navbar-nav .dropdown-menu {
		position: absolute
	}

	.navbar-expand-xl .navbar-nav .nav-link {
		padding-right: .5rem;
		padding-left: .5rem
	}

	.navbar-expand-xl>.container,
	.navbar-expand-xl>.container-fluid {
		flex-wrap: nowrap
	}

	.navbar-expand-xl .navbar-collapse {
		display: flex !important;
		flex-basis: auto
	}

	.navbar-expand-xl .navbar-toggler {
		display: none
	}
}

.navbar-expand {
	flex-flow: row nowrap;
	justify-content: flex-start
}

.navbar-expand>.container,
.navbar-expand>.container-fluid {
	padding-right: 0;
	padding-left: 0
}

.navbar-expand .navbar-nav {
	flex-direction: row
}

.navbar-expand .navbar-nav .dropdown-menu {
	position: absolute
}

.navbar-expand .navbar-nav .nav-link {
	padding-right: .5rem;
	padding-left: .5rem
}

.navbar-expand>.container,
.navbar-expand>.container-fluid {
	flex-wrap: nowrap
}

.navbar-expand .navbar-collapse {
	display: flex !important;
	flex-basis: auto
}

.navbar-expand .navbar-toggler {
	display: none
}

.navbar-light .navbar-brand {
	color: rgba(0, 0, 0, .9)
}

.navbar-light .navbar-brand:focus,
.navbar-light .navbar-brand:hover {
	color: rgba(0, 0, 0, .9)
}

.navbar-light .navbar-nav .nav-link {
	color: rgba(0, 0, 0, .5)
}

.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
	color: rgba(0, 0, 0, .7)
}

.navbar-light .navbar-nav .nav-link.disabled {
	color: rgba(0, 0, 0, .3)
}

.navbar-light .navbar-nav .active>.nav-link,
.navbar-light .navbar-nav .nav-link.active,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .show>.nav-link {
	color: rgba(0, 0, 0, .9)
}

.navbar-light .navbar-toggler {
	color: rgba(0, 0, 0, .5);
	border-color: rgba(0, 0, 0, .1)
}

.navbar-light .navbar-toggler-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
}

.navbar-light .navbar-text {
	color: rgba(0, 0, 0, .5)
}

.navbar-light .navbar-text a {
	color: rgba(0, 0, 0, .9)
}

.navbar-light .navbar-text a:focus,
.navbar-light .navbar-text a:hover {
	color: rgba(0, 0, 0, .9)
}

.navbar-dark .navbar-brand {
	color: #fff
}

.navbar-dark .navbar-brand:focus,
.navbar-dark .navbar-brand:hover {
	color: #fff
}

.navbar-dark .navbar-nav .nav-link {
	color: rgba(255, 255, 255, .5)
}

.navbar-dark .navbar-nav .nav-link:focus,
.navbar-dark .navbar-nav .nav-link:hover {
	color: rgba(255, 255, 255, .75)
}

.navbar-dark .navbar-nav .nav-link.disabled {
	color: rgba(255, 255, 255, .25)
}

.navbar-dark .navbar-nav .active>.nav-link,
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .show>.nav-link {
	color: #fff
}

.navbar-dark .navbar-toggler {
	color: rgba(255, 255, 255, .5);
	border-color: rgba(255, 255, 255, .1)
}

.navbar-dark .navbar-toggler-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
}

.navbar-dark .navbar-text {
	color: rgba(255, 255, 255, .5)
}

.navbar-dark .navbar-text a {
	color: #fff
}

.navbar-dark .navbar-text a:focus,
.navbar-dark .navbar-text a:hover {
	color: #fff
}

.card {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: border-box;
	border: 1px solid rgba(0, 0, 0, .125);
	border-radius: .25rem
}

.card>hr {
	margin-right: 0;
	margin-left: 0
}

.card>.list-group:first-child .list-group-item:first-child {
	border-top-left-radius: .25rem;
	border-top-right-radius: .25rem
}

.card>.list-group:last-child .list-group-item:last-child {
	border-bottom-right-radius: .25rem;
	border-bottom-left-radius: .25rem
}

.card-body {
	flex: 1 1 auto;
	padding: 1.25rem
}

.card-title {
	margin-bottom: .75rem
}

.card-subtitle {
	margin-top: -.375rem;
	margin-bottom: 0
}

.card-text:last-child {
	margin-bottom: 0
}

.card-link:hover {
	text-decoration: none
}

.card-link+.card-link {
	margin-left: 1.25rem
}

.card-header {
	padding: .75rem 1.25rem;
	margin-bottom: 0;
	background-color: rgba(0, 0, 0, .03);
	border-bottom: 1px solid rgba(0, 0, 0, .125)
}

.card-header:first-child {
	border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0
}

.card-header+.list-group .list-group-item:first-child {
	border-top: 0
}

.card-footer {
	padding: .75rem 1.25rem;
	background-color: rgba(0, 0, 0, .03);
	border-top: 1px solid rgba(0, 0, 0, .125)
}

.card-footer:last-child {
	border-radius: 0 0 calc(.25rem - 1px) calc(.25rem - 1px)
}

.card-header-tabs {
	margin-right: -.625rem;
	margin-bottom: -.75rem;
	margin-left: -.625rem;
	border-bottom: 0
}

.card-header-pills {
	margin-right: -.625rem;
	margin-left: -.625rem
}

.card-img-overlay {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	padding: 1.25rem
}

.card-img {
	width: 100%;
	border-radius: calc(.25rem - 1px)
}

.card-img-top {
	width: 100%;
	border-top-left-radius: calc(.25rem - 1px);
	border-top-right-radius: calc(.25rem - 1px)
}

.card-img-bottom {
	width: 100%;
	border-bottom-right-radius: calc(.25rem - 1px);
	border-bottom-left-radius: calc(.25rem - 1px)
}

.card-deck {
	display: flex;
	flex-direction: column
}

.card-deck .card {
	margin-bottom: 15px
}

@media (min-width:576px) {
	.card-deck {
		flex-flow: row wrap;
		margin-right: -15px;
		margin-left: -15px
	}

	.card-deck .card {
		display: flex;
		flex: 1 0;
		flex-direction: column;
		margin-right: 15px;
		margin-bottom: 0;
		margin-left: 15px
	}
}

.card-group {
	display: flex;
	flex-direction: column
}

.card-group>.card {
	margin-bottom: 15px
}

@media (min-width:576px) {
	.card-group {
		flex-flow: row wrap
	}

	.card-group>.card {
		flex: 1 0;
		margin-bottom: 0
	}

	.card-group>.card+.card {
		margin-left: 0;
		border-left: 0
	}

	.card-group>.card:first-child {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0
	}

	.card-group>.card:first-child .card-header,
	.card-group>.card:first-child .card-img-top {
		border-top-right-radius: 0
	}

	.card-group>.card:first-child .card-footer,
	.card-group>.card:first-child .card-img-bottom {
		border-bottom-right-radius: 0
	}

	.card-group>.card:last-child {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0
	}

	.card-group>.card:last-child .card-header,
	.card-group>.card:last-child .card-img-top {
		border-top-left-radius: 0
	}

	.card-group>.card:last-child .card-footer,
	.card-group>.card:last-child .card-img-bottom {
		border-bottom-left-radius: 0
	}

	.card-group>.card:only-child {
		border-radius: .25rem
	}

	.card-group>.card:only-child .card-header,
	.card-group>.card:only-child .card-img-top {
		border-top-left-radius: .25rem;
		border-top-right-radius: .25rem
	}

	.card-group>.card:only-child .card-footer,
	.card-group>.card:only-child .card-img-bottom {
		border-bottom-right-radius: .25rem;
		border-bottom-left-radius: .25rem
	}

	.card-group>.card:not(:first-child):not(:last-child):not(:only-child) {
		border-radius: 0
	}

	.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer,
	.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,
	.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,
	.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top {
		border-radius: 0
	}
}

.card-columns .card {
	margin-bottom: .75rem
}

@media (min-width:576px) {
	.card-columns {
		column-count: 3;
		column-gap: 1.25rem;
		orphans: 1;
		widows: 1
	}

	.card-columns .card {
		display: inline-block;
		width: 100%
	}
}

.accordion .card:not(:first-of-type):not(:last-of-type) {
	border-bottom: 0;
	border-radius: 0
}

.accordion .card:not(:first-of-type) .card-header:first-child {
	border-radius: 0
}

.accordion .card:first-of-type {
	border-bottom: 0;
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0
}

.accordion .card:last-of-type {
	border-top-left-radius: 0;
	border-top-right-radius: 0
}

.breadcrumb {
	display: flex;
	flex-wrap: wrap;
	padding: .75rem 1rem;
	margin-bottom: 1rem;
	list-style: none;
	background-color: #e9ecef;
	border-radius: .25rem
}

.breadcrumb-item+.breadcrumb-item {
	padding-left: .5rem
}

.breadcrumb-item+.breadcrumb-item::before {
	display: inline-block;
	padding-right: .5rem;
	color: #6c757d;
	content: "/"
}

.breadcrumb-item+.breadcrumb-item:hover::before {
	text-decoration: underline
}

.breadcrumb-item+.breadcrumb-item:hover::before {
	text-decoration: none
}

.breadcrumb-item.active {
	color: #6c757d
}

.pagination {
	display: flex;
	padding-left: 0;
	list-style: none;
	border-radius: .25rem
}

.page-link {
	position: relative;
	display: block;
	padding: .5rem .75rem;
	margin-left: -1px;
	line-height: 1.25;
	color: #007bff;
	background-color: #fff;
	border: 1px solid #dee2e6
}

.page-link:hover {
	z-index: 2;
	color: #0056b3;
	text-decoration: none;
	background-color: #e9ecef;
	border-color: #dee2e6
}

.page-link:focus {
	z-index: 2;
	outline: 0;
	box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)
}

.page-link:not(:disabled):not(.disabled) {
	cursor: pointer
}

.page-item:first-child .page-link {
	margin-left: 0;
	border-top-left-radius: .25rem;
	border-bottom-left-radius: .25rem
}

.page-item:last-child .page-link {
	border-top-right-radius: .25rem;
	border-bottom-right-radius: .25rem
}

.page-item.active .page-link {
	z-index: 1;
	color: #fff;
	background-color: #007bff;
	border-color: #007bff
}

.page-item.disabled .page-link {
	color: #6c757d;
	pointer-events: none;
	cursor: auto;
	background-color: #fff;
	border-color: #dee2e6
}

.pagination-lg .page-link {
	padding: .75rem 1.5rem;
	font-size: 1.25rem;
	line-height: 1.5
}

.pagination-lg .page-item:first-child .page-link {
	border-top-left-radius: .3rem;
	border-bottom-left-radius: .3rem
}

.pagination-lg .page-item:last-child .page-link {
	border-top-right-radius: .3rem;
	border-bottom-right-radius: .3rem
}

.pagination-sm .page-link {
	padding: .25rem .5rem;
	font-size: .875rem;
	line-height: 1.5
}

.pagination-sm .page-item:first-child .page-link {
	border-top-left-radius: .2rem;
	border-bottom-left-radius: .2rem
}

.pagination-sm .page-item:last-child .page-link {
	border-top-right-radius: .2rem;
	border-bottom-right-radius: .2rem
}

.badge {
	display: inline-block;
	padding: .25em .4em;
	font-size: 75%;
	font-weight: 700;
	line-height: 1;
	text-align: center;
	white-space: nowrap;
	vertical-align: baseline;
	border-radius: .25rem
}

.badge:empty {
	display: none
}

.btn .badge {
	position: relative;
	top: -1px
}

.badge-pill {
	padding-right: .6em;
	padding-left: .6em;
	border-radius: 10rem
}

.badge-primary {
	color: #fff;
	background-color: #007bff
}

.badge-primary[href]:focus,
.badge-primary[href]:hover {
	color: #fff;
	text-decoration: none;
	background-color: #0062cc
}

.badge-secondary {
	color: #fff;
	background-color: #6c757d
}

.badge-secondary[href]:focus,
.badge-secondary[href]:hover {
	color: #fff;
	text-decoration: none;
	background-color: #545b62
}

.badge-success {
	color: #fff;
	background-color: #28a745
}

.badge-success[href]:focus,
.badge-success[href]:hover {
	color: #fff;
	text-decoration: none;
	background-color: #1e7e34
}

.badge-info {
	color: #fff;
	background-color: #17a2b8
}

.badge-info[href]:focus,
.badge-info[href]:hover {
	color: #fff;
	text-decoration: none;
	background-color: #117a8b
}

.badge-warning {
	color: #212529;
	background-color: #ffc107
}

.badge-warning[href]:focus,
.badge-warning[href]:hover {
	color: #212529;
	text-decoration: none;
	background-color: #d39e00
}

.badge-danger {
	color: #fff;
	background-color: #dc3545
}

.badge-danger[href]:focus,
.badge-danger[href]:hover {
	color: #fff;
	text-decoration: none;
	background-color: #bd2130
}

.badge-light {
	color: #212529;
	background-color: #f8f9fa
}

.badge-light[href]:focus,
.badge-light[href]:hover {
	color: #212529;
	text-decoration: none;
	background-color: #dae0e5
}

.badge-dark {
	color: #fff;
	background-color: #343a40
}

.badge-dark[href]:focus,
.badge-dark[href]:hover {
	color: #fff;
	text-decoration: none;
	background-color: #1d2124
}

.jumbotron {
	padding: 2rem 1rem;
	margin-bottom: 2rem;
	background-color: #e9ecef;
	border-radius: .3rem
}

@media (min-width:576px) {
	.jumbotron {
		padding: 4rem 2rem
	}
}

.jumbotron-fluid {
	padding-right: 0;
	padding-left: 0;
	border-radius: 0
}

.alert {
	position: relative;
	padding: .75rem 1.25rem;
	margin-bottom: 1rem;
	border: 1px solid transparent;
	border-radius: .25rem
}

.alert-heading {
	color: inherit
}

.alert-link {
	font-weight: 700
}

.alert-dismissible {
	padding-right: 4rem
}

.alert-dismissible .close {
	position: absolute;
	top: 0;
	right: 0;
	padding: .75rem 1.25rem;
	color: inherit
}

.alert-primary {
	color: #004085;
	background-color: #cce5ff;
	border-color: #b8daff
}

.alert-primary hr {
	border-top-color: #9fcdff
}

.alert-primary .alert-link {
	color: #002752
}

.alert-secondary {
	color: #383d41;
	background-color: #e2e3e5;
	border-color: #d6d8db
}

.alert-secondary hr {
	border-top-color: #c8cbcf
}

.alert-secondary .alert-link {
	color: #202326
}

.alert-success {
	color: #155724;
	background-color: #d4edda;
	border-color: #c3e6cb
}

.alert-success hr {
	border-top-color: #b1dfbb
}

.alert-success .alert-link {
	color: #0b2e13
}

.alert-info {
	color: #0c5460;
	background-color: #d1ecf1;
	border-color: #bee5eb
}

.alert-info hr {
	border-top-color: #abdde5
}

.alert-info .alert-link {
	color: #062c33
}

.alert-warning {
	color: #856404;
	background-color: #fff3cd;
	border-color: #ffeeba
}

.close {
	color: #fff;
	opacity: 20;
}

.alert-warning hr {
	border-top-color: #ffe8a1
}

.alert-warning .alert-link {
	color: #533f03
}

.alert-danger {
	color: #721c24;
	background-color: #f8d7da;
	border-color: #f5c6cb
}

.alert-danger hr {
	border-top-color: #f1b0b7
}

.alert-danger .alert-link {
	color: #491217
}

.alert-light {
	color: #818182;
	background-color: #fefefe;
	border-color: #fdfdfe
}

.alert-light hr {
	border-top-color: #ececf6
}

.alert-light .alert-link {
	color: #686868
}

.alert-dark {
	color: #1b1e21;
	background-color: #d6d8d9;
	border-color: #c6c8ca
}

.alert-dark hr {
	border-top-color: #b9bbbe
}

.alert-dark .alert-link {
	color: #040505
}

@keyframes progress-bar-stripes {
	from {
		background-position: 1rem 0
	}

	to {
		background-position: 0 0
	}
}

.progress {
	display: flex;
	height: 1rem;
	overflow: hidden;
	font-size: .75rem;
	background-color: #e9ecef;
	border-radius: .25rem
}

.progress-bar {
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: #fff;
	text-align: center;
	white-space: nowrap;
	background-color: #007bff;
	transition: width .6s ease
}

@media screen and (prefers-reduced-motion:reduce) {
	.progress-bar {
		transition: none
	}
}

.progress-bar-striped {
	background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
	background-size: 1rem 1rem
}

.progress-bar-animated {
	animation: progress-bar-stripes 1s linear infinite
}

.media {
	display: flex;
	align-items: flex-start
}

.media-body {
	flex: 1 1
}

.list-group {
	display: flex;
	flex-direction: column;
	padding-left: 0;
	margin-bottom: 0
}

.list-group-item-action {
	width: 100%;
	color: #495057;
	text-align: inherit
}

.list-group-item-action:focus,
.list-group-item-action:hover {
	color: #495057;
	text-decoration: none;
	background-color: #f8f9fa
}

.list-group-item-action:active {
	color: #212529;
	background-color: #e9ecef
}

.list-group-item {
	position: relative;
	display: block;
	padding: .75rem 1.25rem;
	margin-bottom: -1px;
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, .125)
}

.list-group-item:first-child {
	border-top-left-radius: .25rem;
	border-top-right-radius: .25rem
}

.list-group-item:last-child {
	margin-bottom: 0;
	border-bottom-right-radius: .25rem;
	border-bottom-left-radius: .25rem
}

.list-group-item:focus,
.list-group-item:hover {
	z-index: 1;
	text-decoration: none
}

.list-group-item.disabled,
.list-group-item:disabled {
	color: #6c757d;
	background-color: #fff
}

.list-group-item.active {
	z-index: 2;
	color: #fff;
	background-color: #007bff;
	border-color: #007bff
}

.list-group-flush .list-group-item {
	border-right: 0;
	border-left: 0;
	border-radius: 0
}

.list-group-flush:first-child .list-group-item:first-child {
	border-top: 0
}

.list-group-flush:last-child .list-group-item:last-child {
	border-bottom: 0
}

.list-group-item-primary {
	color: #004085;
	background-color: #b8daff
}

.list-group-item-primary.list-group-item-action:focus,
.list-group-item-primary.list-group-item-action:hover {
	color: #004085;
	background-color: #9fcdff
}

.list-group-item-primary.list-group-item-action.active {
	color: #fff;
	background-color: #004085;
	border-color: #004085
}

.list-group-item-secondary {
	color: #383d41;
	background-color: #d6d8db
}

.list-group-item-secondary.list-group-item-action:focus,
.list-group-item-secondary.list-group-item-action:hover {
	color: #383d41;
	background-color: #c8cbcf
}

.list-group-item-secondary.list-group-item-action.active {
	color: #fff;
	background-color: #383d41;
	border-color: #383d41
}

.list-group-item-success {
	color: #155724;
	background-color: #c3e6cb
}

.list-group-item-success.list-group-item-action:focus,
.list-group-item-success.list-group-item-action:hover {
	color: #155724;
	background-color: #b1dfbb
}

.list-group-item-success.list-group-item-action.active {
	color: #fff;
	background-color: #155724;
	border-color: #155724
}

.list-group-item-info {
	color: #0c5460;
	background-color: #bee5eb
}

.list-group-item-info.list-group-item-action:focus,
.list-group-item-info.list-group-item-action:hover {
	color: #0c5460;
	background-color: #abdde5
}

.list-group-item-info.list-group-item-action.active {
	color: #fff;
	background-color: #0c5460;
	border-color: #0c5460
}

.list-group-item-warning {
	color: #856404;
	background-color: #ffeeba
}

.list-group-item-warning.list-group-item-action:focus,
.list-group-item-warning.list-group-item-action:hover {
	color: #856404;
	background-color: #ffe8a1
}

.list-group-item-warning.list-group-item-action.active {
	color: #fff;
	background-color: #856404;
	border-color: #856404
}

.list-group-item-danger {
	color: #721c24;
	background-color: #f5c6cb
}

.list-group-item-danger.list-group-item-action:focus,
.list-group-item-danger.list-group-item-action:hover {
	color: #721c24;
	background-color: #f1b0b7
}

.list-group-item-danger.list-group-item-action.active {
	color: #fff;
	background-color: #721c24;
	border-color: #721c24
}

.list-group-item-light {
	color: #818182;
	background-color: #fdfdfe
}

.list-group-item-light.list-group-item-action:focus,
.list-group-item-light.list-group-item-action:hover {
	color: #818182;
	background-color: #ececf6
}

.list-group-item-light.list-group-item-action.active {
	color: #fff;
	background-color: #818182;
	border-color: #818182
}

.list-group-item-dark {
	color: #1b1e21;
	background-color: #c6c8ca
}

.list-group-item-dark.list-group-item-action:focus,
.list-group-item-dark.list-group-item-action:hover {
	color: #1b1e21;
	background-color: #b9bbbe
}

.list-group-item-dark.list-group-item-action.active {
	color: #fff;
	background-color: #1b1e21;
	border-color: #1b1e21
}

.close {
	float: right;
	font-size: 1.5rem;
	font-weight: 700;
	line-height: 1;
	color: #000;
	text-shadow: 0 1px 0 #fff;
	opacity: .5
}

.close:focus,
.close:hover {
	color: #000;
	text-decoration: none;
	opacity: .75
}

.close:not(:disabled):not(.disabled) {
	cursor: pointer
}

button.close {
	padding: 0;
	background-color: transparent;
	border: 0;
	-webkit-appearance: none
}

.modal-open {
	overflow: hidden
}

.modal {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1050;
	display: none;
	overflow: hidden;
	outline: 0
}

.modal-open .modal {
	overflow-x: hidden;
	overflow-y: auto
}

.modal-dialog {
	position: relative;
	width: auto;
	margin: .5rem;
	pointer-events: none
}

.modal.fade .modal-dialog {
	transition: transform .3s ease-out;
	transform: translate(0, -25%)
}

@media screen and (prefers-reduced-motion:reduce) {
	.modal.fade .modal-dialog {
		transition: none
	}
}

.modal.show .modal-dialog {
	transform: translate(0, 0)
}

.modal-dialog-centered {
	display: flex;
	align-items: center;
	min-height: calc(100% - (.5rem * 2))
}

.modal-content {
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	pointer-events: auto;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, .2);
	border-radius: .3rem;
	outline: 0
}

.modal-backdrop {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1040;
	background-color: #000
}

.modal-backdrop.fade {
	opacity: 0
}

.modal-backdrop.show {
	opacity: .5
}

.modal-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	padding: 1rem;
	border-bottom: 1px solid #e9ecef;
	border-top-left-radius: .3rem;
	border-top-right-radius: .3rem
}

.modal-header .close {
	padding: 1rem;
	margin: -1rem -1rem -1rem auto
}

.modal-title {
	margin-bottom: 0;
	line-height: 1.5
}

.modal-body {
	position: relative;
	flex: 1 1 auto;
	padding: 1rem
}

.modal-footer {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 1rem;
	border-top: 1px solid #e9ecef
}

.modal-footer>:not(:first-child) {
	margin-left: .25rem
}

.modal-footer>:not(:last-child) {
	margin-right: .25rem
}

.modal-scrollbar-measure {
	position: absolute;
	top: -9999px;
	width: 50px;
	height: 50px;
	overflow: scroll
}

@media (min-width:576px) {
	.modal-dialog {
		max-width: 500px;
		margin: 1.75rem auto
	}

	.modal-dialog-centered {
		min-height: calc(100% - (1.75rem * 2))
	}

	.modal-sm {
		max-width: 300px
	}
}

@media (min-width:992px) {
	.modal-lg {
		max-width: 800px
	}
}

.tooltip {
	position: absolute;
	z-index: 1070;
	display: block;
	margin: 0;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	text-align: left;
	text-align: start;
	text-decoration: none;
	text-shadow: none;
	text-transform: none;
	letter-spacing: normal;
	word-break: normal;
	word-spacing: normal;
	white-space: normal;
	line-break: auto;
	font-size: .875rem;
	word-wrap: break-word;
	opacity: 0
}

.tooltip.show {
	opacity: .9
}

.tooltip .arrow {
	position: absolute;
	display: block;
	width: .8rem;
	height: .4rem
}

.tooltip .arrow::before {
	position: absolute;
	content: "";
	border-color: transparent;
	border-style: solid
}

.bs-tooltip-auto[x-placement^=top],
.bs-tooltip-top {
	padding: .4rem 0
}

.bs-tooltip-auto[x-placement^=top] .arrow,
.bs-tooltip-top .arrow {
	bottom: 0
}

.bs-tooltip-auto[x-placement^=top] .arrow::before,
.bs-tooltip-top .arrow::before {
	top: 0;
	border-width: .4rem .4rem 0;
	border-top-color: #000
}

.bs-tooltip-auto[x-placement^=right],
.bs-tooltip-right {
	padding: 0 .4rem
}

.bs-tooltip-auto[x-placement^=right] .arrow,
.bs-tooltip-right .arrow {
	left: 0;
	width: .4rem;
	height: .8rem
}

.bs-tooltip-auto[x-placement^=right] .arrow::before,
.bs-tooltip-right .arrow::before {
	right: 0;
	border-width: .4rem .4rem .4rem 0;
	border-right-color: #000
}

.bs-tooltip-auto[x-placement^=bottom],
.bs-tooltip-bottom {
	padding: .4rem 0
}

.bs-tooltip-auto[x-placement^=bottom] .arrow,
.bs-tooltip-bottom .arrow {
	top: 0
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::before,
.bs-tooltip-bottom .arrow::before {
	bottom: 0;
	border-width: 0 .4rem .4rem;
	border-bottom-color: #000
}

.bs-tooltip-auto[x-placement^=left],
.bs-tooltip-left {
	padding: 0 .4rem
}

.bs-tooltip-auto[x-placement^=left] .arrow,
.bs-tooltip-left .arrow {
	right: 0;
	width: .4rem;
	height: .8rem
}

.bs-tooltip-auto[x-placement^=left] .arrow::before,
.bs-tooltip-left .arrow::before {
	left: 0;
	border-width: .4rem 0 .4rem .4rem;
	border-left-color: #000
}

.tooltip-inner {
	max-width: 200px;
	padding: .25rem .5rem;
	color: #fff;
	text-align: center;
	background-color: #000;
	border-radius: .25rem
}

.popover {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1060;
	display: block;
	max-width: 276px;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	text-align: left;
	text-align: start;
	text-decoration: none;
	text-shadow: none;
	text-transform: none;
	letter-spacing: normal;
	word-break: normal;
	word-spacing: normal;
	white-space: normal;
	line-break: auto;
	font-size: .875rem;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, .2);
	border-radius: .3rem
}

.popover .arrow {
	position: absolute;
	display: block;
	width: 1rem;
	height: .5rem;
	margin: 0 .3rem
}

.popover .arrow::after,
.popover .arrow::before {
	position: absolute;
	display: block;
	content: "";
	border-color: transparent;
	border-style: solid
}

.bs-popover-auto[x-placement^=top],
.bs-popover-top {
	margin-bottom: .5rem
}

.bs-popover-auto[x-placement^=top] .arrow,
.bs-popover-top .arrow {
	bottom: calc((.5rem + 1px) * -1)
}

.bs-popover-auto[x-placement^=top] .arrow::after,
.bs-popover-auto[x-placement^=top] .arrow::before,
.bs-popover-top .arrow::after,
.bs-popover-top .arrow::before {
	border-width: .5rem .5rem 0
}

.bs-popover-auto[x-placement^=top] .arrow::before,
.bs-popover-top .arrow::before {
	bottom: 0;
	border-top-color: rgba(0, 0, 0, .25)
}

.bs-popover-auto[x-placement^=top] .arrow::after,
.bs-popover-top .arrow::after {
	bottom: 1px;
	border-top-color: #fff
}

.bs-popover-auto[x-placement^=right],
.bs-popover-right {
	margin-left: .5rem
}

.bs-popover-auto[x-placement^=right] .arrow,
.bs-popover-right .arrow {
	left: calc((.5rem + 1px) * -1);
	width: .5rem;
	height: 1rem;
	margin: .3rem 0
}

.bs-popover-auto[x-placement^=right] .arrow::after,
.bs-popover-auto[x-placement^=right] .arrow::before,
.bs-popover-right .arrow::after,
.bs-popover-right .arrow::before {
	border-width: .5rem .5rem .5rem 0
}

.bs-popover-auto[x-placement^=right] .arrow::before,
.bs-popover-right .arrow::before {
	left: 0;
	border-right-color: rgba(0, 0, 0, .25)
}

.bs-popover-auto[x-placement^=right] .arrow::after,
.bs-popover-right .arrow::after {
	left: 1px;
	border-right-color: #fff
}

.bs-popover-auto[x-placement^=bottom],
.bs-popover-bottom {
	margin-top: .5rem
}

.bs-popover-auto[x-placement^=bottom] .arrow,
.bs-popover-bottom .arrow {
	top: calc((.5rem + 1px) * -1)
}

.bs-popover-auto[x-placement^=bottom] .arrow::after,
.bs-popover-auto[x-placement^=bottom] .arrow::before,
.bs-popover-bottom .arrow::after,
.bs-popover-bottom .arrow::before {
	border-width: 0 .5rem .5rem .5rem
}

.bs-popover-auto[x-placement^=bottom] .arrow::before,
.bs-popover-bottom .arrow::before {
	top: 0;
	border-bottom-color: rgba(0, 0, 0, .25)
}

.bs-popover-auto[x-placement^=bottom] .arrow::after,
.bs-popover-bottom .arrow::after {
	top: 1px;
	border-bottom-color: #fff
}

.bs-popover-auto[x-placement^=bottom] .popover-header::before,
.bs-popover-bottom .popover-header::before {
	position: absolute;
	top: 0;
	left: 50%;
	display: block;
	width: 1rem;
	margin-left: -.5rem;
	content: "";
	border-bottom: 1px solid #f7f7f7
}

.bs-popover-auto[x-placement^=left],
.bs-popover-left {
	margin-right: .5rem
}

.bs-popover-auto[x-placement^=left] .arrow,
.bs-popover-left .arrow {
	right: calc((.5rem + 1px) * -1);
	width: .5rem;
	height: 1rem;
	margin: .3rem 0
}

.bs-popover-auto[x-placement^=left] .arrow::after,
.bs-popover-auto[x-placement^=left] .arrow::before,
.bs-popover-left .arrow::after,
.bs-popover-left .arrow::before {
	border-width: .5rem 0 .5rem .5rem
}

.bs-popover-auto[x-placement^=left] .arrow::before,
.bs-popover-left .arrow::before {
	right: 0;
	border-left-color: rgba(0, 0, 0, .25)
}

.bs-popover-auto[x-placement^=left] .arrow::after,
.bs-popover-left .arrow::after {
	right: 1px;
	border-left-color: #fff
}

.popover-header {
	padding: .5rem .75rem;
	margin-bottom: 0;
	font-size: 1rem;
	color: inherit;
	background-color: #f7f7f7;
	border-bottom: 1px solid #ebebeb;
	border-top-left-radius: calc(.3rem - 1px);
	border-top-right-radius: calc(.3rem - 1px)
}

.popover-header:empty {
	display: none
}

.popover-body {
	padding: .5rem .75rem;
	color: #212529
}

.carousel {
	position: relative
}

.carousel-inner {
	position: relative;
	width: 100%;
	overflow: hidden
}

.carousel-item {
	position: relative;
	display: none;
	align-items: center;
	width: 100%;
	transition: transform .6s ease;
	backface-visibility: hidden;
	perspective: 1000px
}

@media screen and (prefers-reduced-motion:reduce) {
	.carousel-item {
		transition: none
	}
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
	display: block
}

.carousel-item-next,
.carousel-item-prev {
	position: absolute;
	top: 0
}

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right {
	transform: translateX(0)
}

@supports (transform-style:preserve-3d) {

	.carousel-item-next.carousel-item-left,
	.carousel-item-prev.carousel-item-right {
		transform: translate3d(0, 0, 0)
	}
}

.active.carousel-item-right,
.carousel-item-next {
	transform: translateX(100%)
}

@supports (transform-style:preserve-3d) {

	.active.carousel-item-right,
	.carousel-item-next {
		transform: translate3d(100%, 0, 0)
	}
}

.active.carousel-item-left,
.carousel-item-prev {
	transform: translateX(-100%)
}

@supports (transform-style:preserve-3d) {

	.active.carousel-item-left,
	.carousel-item-prev {
		transform: translate3d(-100%, 0, 0)
	}
}

.carousel-fade .carousel-item {
	opacity: 0;
	transition-duration: .6s;
	transition-property: opacity
}

.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right,
.carousel-fade .carousel-item.active {
	opacity: 1
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
	opacity: 0
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-prev,
.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active {
	transform: translateX(0)
}

@supports (transform-style:preserve-3d) {

	.carousel-fade .active.carousel-item-left,
	.carousel-fade .active.carousel-item-prev,
	.carousel-fade .carousel-item-next,
	.carousel-fade .carousel-item-prev,
	.carousel-fade .carousel-item.active {
		transform: translate3d(0, 0, 0)
	}
}

.carousel-control-next,
.carousel-control-prev {
	position: absolute;
	top: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 15%;
	color: #fff;
	text-align: center;
	opacity: .5
}

.carousel-control-next:focus,
.carousel-control-next:hover,
.carousel-control-prev:focus,
.carousel-control-prev:hover {
	color: #fff;
	text-decoration: none;
	outline: 0;
	opacity: .9
}

.carousel-control-prev {
	left: 0
}

.carousel-control-next {
	right: 0
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
	display: inline-block;
	width: 20px;
	height: 20px;
	background: transparent no-repeat center center;
	background-size: 100% 100%
}

.carousel-control-prev-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
}

.carousel-control-next-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
}

.carousel-indicators {
	position: absolute;
	right: 0;
	bottom: 10px;
	left: 0;
	z-index: 15;
	display: flex;
	justify-content: center;
	padding-left: 0;
	margin-right: 15%;
	margin-left: 15%;
	list-style: none
}

.carousel-indicators li {
	position: relative;
	flex: 0 1 auto;
	width: 30px;
	height: 3px;
	margin-right: 3px;
	margin-left: 3px;
	text-indent: -999px;
	cursor: pointer;
	background-color: rgba(255, 255, 255, .5)
}

.pointer {
	cursor: pointer;
}

.carousel-indicators li::before {
	position: absolute;
	top: -10px;
	left: 0;
	display: inline-block;
	width: 100%;
	height: 10px;
	content: ""
}

.carousel-indicators li::after {
	position: absolute;
	bottom: -10px;
	left: 0;
	display: inline-block;
	width: 100%;
	height: 10px;
	content: ""
}

.carousel-indicators .active {
	background-color: #fff
}

.carousel-caption {
	position: absolute;
	right: 15%;
	bottom: 20px;
	left: 15%;
	z-index: 10;
	padding-top: 20px;
	padding-bottom: 20px;
	color: #fff;
	text-align: center
}

.align-baseline {
	vertical-align: baseline !important
}

.align-top {
	vertical-align: top !important
}

.align-middle {
	vertical-align: middle !important
}

.align-bottom {
	vertical-align: bottom !important
}

.align-text-bottom {
	vertical-align: text-bottom !important
}

.align-text-top {
	vertical-align: text-top !important
}

.bg-primary {
	background-color: #007bff !important
}

a.bg-primary:focus,
a.bg-primary:hover,
button.bg-primary:focus,
button.bg-primary:hover {
	background-color: #0062cc !important
}

.bg-secondary {
	background-color: #6c757d !important
}

a.bg-secondary:focus,
a.bg-secondary:hover,
button.bg-secondary:focus,
button.bg-secondary:hover {
	background-color: #545b62 !important
}

.bg-success {
	background-color: #28a745 !important
}

a.bg-success:focus,
a.bg-success:hover,
button.bg-success:focus,
button.bg-success:hover {
	background-color: #1e7e34 !important
}

.bg-info {
	background-color: #17a2b8 !important
}

a.bg-info:focus,
a.bg-info:hover,
button.bg-info:focus,
button.bg-info:hover {
	background-color: #117a8b !important
}

.bg-warning {
	background-color: #ffc107 !important
}

a.bg-warning:focus,
a.bg-warning:hover,
button.bg-warning:focus,
button.bg-warning:hover {
	background-color: #d39e00 !important
}

.bg-danger {
	background-color: #dc3545 !important
}

a.bg-danger:focus,
a.bg-danger:hover,
button.bg-danger:focus,
button.bg-danger:hover {
	background-color: #bd2130 !important
}

.bg-light {
	background-color: #f8f9fa !important
}

a.bg-light:focus,
a.bg-light:hover,
button.bg-light:focus,
button.bg-light:hover {
	background-color: #dae0e5 !important
}

.bg-dark {
	background-color: #343a40 !important
}

a.bg-dark:focus,
a.bg-dark:hover,
button.bg-dark:focus,
button.bg-dark:hover {
	background-color: #1d2124 !important
}

.bg-white {
	background-color: #fff !important
}

.bg-transparent {
	background-color: transparent !important
}

.border {
	border: 1px solid #dee2e6 !important
}

.border-top {
	border-top: 1px solid #dee2e6 !important
}

.border-right {
	border-right: 1px solid #dee2e6 !important
}

.border-bottom {
	border-bottom: 1px solid #dee2e6 !important
}

.border-left {
	border-left: 1px solid #dee2e6 !important
}

.border-0 {
	border: 0 !important
}

.border-top-0 {
	border-top: 0 !important
}

.border-right-0 {
	border-right: 0 !important
}

.border-bottom-0 {
	border-bottom: 0 !important
}

.border-left-0 {
	border-left: 0 !important
}

.border-primary {
	border-color: #007bff !important
}

.border-secondary {
	border-color: #6c757d !important
}

.border-success {
	border-color: #28a745 !important
}

.border-info {
	border-color: #17a2b8 !important
}

.border-warning {
	border-color: #ffc107 !important
}

.border-danger {
	border-color: #dc3545 !important
}

.border-light {
	border-color: #f8f9fa !important
}

.border-dark {
	border-color: #343a40 !important
}

.border-white {
	border-color: #fff !important
}

.rounded {
	border-radius: .25rem !important
}

.rounded-top {
	border-top-left-radius: .25rem !important;
	border-top-right-radius: .25rem !important
}

.rounded-right {
	border-top-right-radius: .25rem !important;
	border-bottom-right-radius: .25rem !important
}

.rounded-bottom {
	border-bottom-right-radius: .25rem !important;
	border-bottom-left-radius: .25rem !important
}

.rounded-left {
	border-top-left-radius: .25rem !important;
	border-bottom-left-radius: .25rem !important
}

.rounded-circle {
	border-radius: 50% !important
}

.rounded-0 {
	border-radius: 0 !important
}

.clearfix::after {
	display: block;
	clear: both;
	content: ""
}

.d-none {
	display: none !important
}

.d-inline {
	display: inline !important
}

.d-inline-block {
	display: inline-block !important
}

.d-block {
	display: block !important
}

.d-table {
	display: table !important
}

.d-table-row {
	display: table-row !important
}

.d-table-cell {
	display: table-cell !important
}

.d-flex {
	display: flex !important
}

.d-inline-flex {
	display: inline-flex !important
}

@media (min-width:576px) {
	.d-sm-none {
		display: none !important
	}

	.d-sm-inline {
		display: inline !important
	}

	.d-sm-inline-block {
		display: inline-block !important
	}

	.d-sm-block {
		display: block !important
	}

	.d-sm-table {
		display: table !important
	}

	.d-sm-table-row {
		display: table-row !important
	}

	.d-sm-table-cell {
		display: table-cell !important
	}

	.d-sm-flex {
		display: flex !important
	}

	.d-sm-inline-flex {
		display: inline-flex !important
	}
}

@media (min-width:768px) {
	.d-md-none {
		display: none !important
	}

	.d-md-inline {
		display: inline !important
	}

	.d-md-inline-block {
		display: inline-block !important
	}

	.d-md-block {
		display: block !important
	}

	.d-md-table {
		display: table !important
	}

	.d-md-table-row {
		display: table-row !important
	}

	.d-md-table-cell {
		display: table-cell !important
	}

	.d-md-flex {
		display: flex !important
	}

	.d-md-inline-flex {
		display: inline-flex !important
	}
}

@media (min-width:992px) {
	.d-lg-none {
		display: none !important
	}

	.d-lg-inline {
		display: inline !important
	}

	.d-lg-inline-block {
		display: inline-block !important
	}

	.d-lg-block {
		display: block !important
	}

	.d-lg-table {
		display: table !important
	}

	.d-lg-table-row {
		display: table-row !important
	}

	.d-lg-table-cell {
		display: table-cell !important
	}

	.d-lg-flex {
		display: flex !important
	}

	.d-lg-inline-flex {
		display: inline-flex !important
	}
}

@media (min-width:1200px) {
	.d-xl-none {
		display: none !important
	}

	.d-xl-inline {
		display: inline !important
	}

	.d-xl-inline-block {
		display: inline-block !important
	}

	.d-xl-block {
		display: block !important
	}

	.d-xl-table {
		display: table !important
	}

	.d-xl-table-row {
		display: table-row !important
	}

	.d-xl-table-cell {
		display: table-cell !important
	}

	.d-xl-flex {
		display: flex !important
	}

	.d-xl-inline-flex {
		display: inline-flex !important
	}
}

@media print {
	.d-print-none {
		display: none !important
	}

	.d-print-inline {
		display: inline !important
	}

	.d-print-inline-block {
		display: inline-block !important
	}

	.d-print-block {
		display: block !important
	}

	.d-print-table {
		display: table !important
	}

	.d-print-table-row {
		display: table-row !important
	}

	.d-print-table-cell {
		display: table-cell !important
	}

	.d-print-flex {
		display: flex !important
	}

	.d-print-inline-flex {
		display: inline-flex !important
	}
}

.embed-responsive {
	position: relative;
	display: block;
	width: 100%;
	padding: 0;
	overflow: hidden
}

.embed-responsive::before {
	display: block;
	content: ""
}

.embed-responsive .embed-responsive-item,
.embed-responsive embed,
.embed-responsive iframe,
.embed-responsive object,
.embed-responsive video {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: 0
}

.embed-responsive-21by9::before {
	padding-top: 42.857143%
}

.embed-responsive-16by9::before {
	padding-top: 56.25%
}

.embed-responsive-4by3::before {
	padding-top: 75%
}

.embed-responsive-1by1::before {
	padding-top: 100%
}

.flex-row {
	flex-direction: row !important
}

.flex-column {
	flex-direction: column !important
}

.flex-row-reverse {
	flex-direction: row-reverse !important
}

.flex-column-reverse {
	flex-direction: column-reverse !important
}

.flex-wrap {
	flex-wrap: wrap !important
}

.flex-nowrap {
	flex-wrap: nowrap !important
}

.flex-wrap-reverse {
	flex-wrap: wrap-reverse !important
}

.flex-fill {
	flex: 1 1 auto !important
}

.flex-grow-0 {
	flex-grow: 0 !important
}

.flex-grow-1 {
	flex-grow: 1 !important
}

.flex-shrink-0 {
	flex-shrink: 0 !important
}

.flex-shrink-1 {
	flex-shrink: 1 !important
}

.justify-content-start {
	justify-content: flex-start !important
}

.justify-content-end {
	justify-content: flex-end !important
}

.justify-content-center {
	justify-content: center !important
}

.justify-content-between {
	justify-content: space-between !important
}

.justify-content-around {
	justify-content: space-around !important
}

.align-items-start {
	align-items: flex-start !important
}

.align-items-end {
	align-items: flex-end !important
}

.align-items-center {
	align-items: center !important
}

.align-items-baseline {
	align-items: baseline !important
}

.align-items-stretch {
	align-items: stretch !important
}

.align-content-start {
	align-content: flex-start !important
}

.align-content-end {
	align-content: flex-end !important
}

.align-content-center {
	align-content: center !important
}

.align-content-between {
	align-content: space-between !important
}

.align-content-around {
	align-content: space-around !important
}

.align-content-stretch {
	align-content: stretch !important
}

.align-self-auto {
	align-self: auto !important
}

.align-self-start {
	align-self: flex-start !important
}

.align-self-end {
	align-self: flex-end !important
}

.align-self-center {
	align-self: center !important
}

.align-self-baseline {
	align-self: baseline !important
}

.align-self-stretch {
	align-self: stretch !important
}

@media (min-width:576px) {
	.flex-sm-row {
		flex-direction: row !important
	}

	.flex-sm-column {
		flex-direction: column !important
	}

	.flex-sm-row-reverse {
		flex-direction: row-reverse !important
	}

	.flex-sm-column-reverse {
		flex-direction: column-reverse !important
	}

	.flex-sm-wrap {
		flex-wrap: wrap !important
	}

	.flex-sm-nowrap {
		flex-wrap: nowrap !important
	}

	.flex-sm-wrap-reverse {
		flex-wrap: wrap-reverse !important
	}

	.flex-sm-fill {
		flex: 1 1 auto !important
	}

	.flex-sm-grow-0 {
		flex-grow: 0 !important
	}

	.flex-sm-grow-1 {
		flex-grow: 1 !important
	}

	.flex-sm-shrink-0 {
		flex-shrink: 0 !important
	}

	.flex-sm-shrink-1 {
		flex-shrink: 1 !important
	}

	.justify-content-sm-start {
		justify-content: flex-start !important
	}

	.justify-content-sm-end {
		justify-content: flex-end !important
	}

	.justify-content-sm-center {
		justify-content: center !important
	}

	.justify-content-sm-between {
		justify-content: space-between !important
	}

	.justify-content-sm-around {
		justify-content: space-around !important
	}

	.align-items-sm-start {
		align-items: flex-start !important
	}

	.align-items-sm-end {
		align-items: flex-end !important
	}

	.align-items-sm-center {
		align-items: center !important
	}

	.align-items-sm-baseline {
		align-items: baseline !important
	}

	.align-items-sm-stretch {
		align-items: stretch !important
	}

	.align-content-sm-start {
		align-content: flex-start !important
	}

	.align-content-sm-end {
		align-content: flex-end !important
	}

	.align-content-sm-center {
		align-content: center !important
	}

	.align-content-sm-between {
		align-content: space-between !important
	}

	.align-content-sm-around {
		align-content: space-around !important
	}

	.align-content-sm-stretch {
		align-content: stretch !important
	}

	.align-self-sm-auto {
		align-self: auto !important
	}

	.align-self-sm-start {
		align-self: flex-start !important
	}

	.align-self-sm-end {
		align-self: flex-end !important
	}

	.align-self-sm-center {
		align-self: center !important
	}

	.align-self-sm-baseline {
		align-self: baseline !important
	}

	.align-self-sm-stretch {
		align-self: stretch !important
	}
}

@media (min-width:768px) {
	.flex-md-row {
		flex-direction: row !important
	}

	.flex-md-column {
		flex-direction: column !important
	}

	.flex-md-row-reverse {
		flex-direction: row-reverse !important
	}

	.flex-md-column-reverse {
		flex-direction: column-reverse !important
	}

	.flex-md-wrap {
		flex-wrap: wrap !important
	}

	.flex-md-nowrap {
		flex-wrap: nowrap !important
	}

	.flex-md-wrap-reverse {
		flex-wrap: wrap-reverse !important
	}

	.flex-md-fill {
		flex: 1 1 auto !important
	}

	.flex-md-grow-0 {
		flex-grow: 0 !important
	}

	.flex-md-grow-1 {
		flex-grow: 1 !important
	}

	.flex-md-shrink-0 {
		flex-shrink: 0 !important
	}

	.flex-md-shrink-1 {
		flex-shrink: 1 !important
	}

	.justify-content-md-start {
		justify-content: flex-start !important
	}

	.justify-content-md-end {
		justify-content: flex-end !important
	}

	.justify-content-md-center {
		justify-content: center !important
	}

	.justify-content-md-between {
		justify-content: space-between !important
	}

	.justify-content-md-around {
		justify-content: space-around !important
	}

	.align-items-md-start {
		align-items: flex-start !important
	}

	.align-items-md-end {
		align-items: flex-end !important
	}

	.align-items-md-center {
		align-items: center !important
	}

	.align-items-md-baseline {
		align-items: baseline !important
	}

	.align-items-md-stretch {
		align-items: stretch !important
	}

	.align-content-md-start {
		align-content: flex-start !important
	}

	.align-content-md-end {
		align-content: flex-end !important
	}

	.align-content-md-center {
		align-content: center !important
	}

	.align-content-md-between {
		align-content: space-between !important
	}

	.align-content-md-around {
		align-content: space-around !important
	}

	.align-content-md-stretch {
		align-content: stretch !important
	}

	.align-self-md-auto {
		align-self: auto !important
	}

	.align-self-md-start {
		align-self: flex-start !important
	}

	.align-self-md-end {
		align-self: flex-end !important
	}

	.align-self-md-center {
		align-self: center !important
	}

	.align-self-md-baseline {
		align-self: baseline !important
	}

	.align-self-md-stretch {
		align-self: stretch !important
	}
}

@media (min-width:992px) {
	.flex-lg-row {
		flex-direction: row !important
	}

	.flex-lg-column {
		flex-direction: column !important
	}

	.flex-lg-row-reverse {
		flex-direction: row-reverse !important
	}

	.flex-lg-column-reverse {
		flex-direction: column-reverse !important
	}

	.flex-lg-wrap {
		flex-wrap: wrap !important
	}

	.flex-lg-nowrap {
		flex-wrap: nowrap !important
	}

	.flex-lg-wrap-reverse {
		flex-wrap: wrap-reverse !important
	}

	.flex-lg-fill {
		flex: 1 1 auto !important
	}

	.flex-lg-grow-0 {
		flex-grow: 0 !important
	}

	.flex-lg-grow-1 {
		flex-grow: 1 !important
	}

	.flex-lg-shrink-0 {
		flex-shrink: 0 !important
	}

	.flex-lg-shrink-1 {
		flex-shrink: 1 !important
	}

	.justify-content-lg-start {
		justify-content: flex-start !important
	}

	.justify-content-lg-end {
		justify-content: flex-end !important
	}

	.justify-content-lg-center {
		justify-content: center !important
	}

	.justify-content-lg-between {
		justify-content: space-between !important
	}

	.justify-content-lg-around {
		justify-content: space-around !important
	}

	.align-items-lg-start {
		align-items: flex-start !important
	}

	.align-items-lg-end {
		align-items: flex-end !important
	}

	.align-items-lg-center {
		align-items: center !important
	}

	.align-items-lg-baseline {
		align-items: baseline !important
	}

	.align-items-lg-stretch {
		align-items: stretch !important
	}

	.align-content-lg-start {
		align-content: flex-start !important
	}

	.align-content-lg-end {
		align-content: flex-end !important
	}

	.align-content-lg-center {
		align-content: center !important
	}

	.align-content-lg-between {
		align-content: space-between !important
	}

	.align-content-lg-around {
		align-content: space-around !important
	}

	.align-content-lg-stretch {
		align-content: stretch !important
	}

	.align-self-lg-auto {
		align-self: auto !important
	}

	.align-self-lg-start {
		align-self: flex-start !important
	}

	.align-self-lg-end {
		align-self: flex-end !important
	}

	.align-self-lg-center {
		align-self: center !important
	}

	.align-self-lg-baseline {
		align-self: baseline !important
	}

	.align-self-lg-stretch {
		align-self: stretch !important
	}
}

@media (min-width:1200px) {
	.flex-xl-row {
		flex-direction: row !important
	}

	.flex-xl-column {
		flex-direction: column !important
	}

	.flex-xl-row-reverse {
		flex-direction: row-reverse !important
	}

	.flex-xl-column-reverse {
		flex-direction: column-reverse !important
	}

	.flex-xl-wrap {
		flex-wrap: wrap !important
	}

	.flex-xl-nowrap {
		flex-wrap: nowrap !important
	}

	.flex-xl-wrap-reverse {
		flex-wrap: wrap-reverse !important
	}

	.flex-xl-fill {
		flex: 1 1 auto !important
	}

	.flex-xl-grow-0 {
		flex-grow: 0 !important
	}

	.flex-xl-grow-1 {
		flex-grow: 1 !important
	}

	.flex-xl-shrink-0 {
		flex-shrink: 0 !important
	}

	.flex-xl-shrink-1 {
		flex-shrink: 1 !important
	}

	.justify-content-xl-start {
		justify-content: flex-start !important
	}

	.justify-content-xl-end {
		justify-content: flex-end !important
	}

	.justify-content-xl-center {
		justify-content: center !important
	}

	.justify-content-xl-between {
		justify-content: space-between !important
	}

	.justify-content-xl-around {
		justify-content: space-around !important
	}

	.align-items-xl-start {
		align-items: flex-start !important
	}

	.align-items-xl-end {
		align-items: flex-end !important
	}

	.align-items-xl-center {
		align-items: center !important
	}

	.align-items-xl-baseline {
		align-items: baseline !important
	}

	.align-items-xl-stretch {
		align-items: stretch !important
	}

	.align-content-xl-start {
		align-content: flex-start !important
	}

	.align-content-xl-end {
		align-content: flex-end !important
	}

	.align-content-xl-center {
		align-content: center !important
	}

	.align-content-xl-between {
		align-content: space-between !important
	}

	.align-content-xl-around {
		align-content: space-around !important
	}

	.align-content-xl-stretch {
		align-content: stretch !important
	}

	.align-self-xl-auto {
		align-self: auto !important
	}

	.align-self-xl-start {
		align-self: flex-start !important
	}

	.align-self-xl-end {
		align-self: flex-end !important
	}

	.align-self-xl-center {
		align-self: center !important
	}

	.align-self-xl-baseline {
		align-self: baseline !important
	}

	.align-self-xl-stretch {
		align-self: stretch !important
	}
}

.float-left {
	float: left !important
}

.float-right {
	float: right !important
}

.float-none {
	float: none !important
}

@media (min-width:576px) {
	.float-sm-left {
		float: left !important
	}

	.float-sm-right {
		float: right !important
	}

	.float-sm-none {
		float: none !important
	}
}

@media (min-width:768px) {
	.float-md-left {
		float: left !important
	}

	.float-md-right {
		float: right !important
	}

	.float-md-none {
		float: none !important
	}
}

@media (min-width:992px) {
	.float-lg-left {
		float: left !important
	}

	.float-lg-right {
		float: right !important
	}

	.float-lg-none {
		float: none !important
	}
}

@media (min-width:1200px) {
	.float-xl-left {
		float: left !important
	}

	.float-xl-right {
		float: right !important
	}

	.float-xl-none {
		float: none !important
	}
}

.position-static {
	position: static !important
}

.position-relative {
	position: relative !important
}

.position-absolute {
	position: absolute !important
}

.position-fixed {
	position: fixed !important
}

.position-sticky {
	position: sticky !important
}

.fixed-top {
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	z-index: 1030
}

.fixed-bottom {
	position: fixed;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1030
}

@supports (position:sticky) {
	.sticky-top {
		position: sticky;
		top: 0;
		z-index: 1020
	}
}

.sr-only {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
	position: static;
	width: auto;
	height: auto;
	overflow: visible;
	clip: auto;
	white-space: normal
}

.shadow-sm {
	box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important
}

.shadow {
	box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important
}

.shadow-lg {
	box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important
}

.shadow-none {
	box-shadow: none !important
}

.w-25 {
	width: 25% !important
}

.w-50 {
	width: 50% !important
}

.w-75 {
	width: 75% !important
}

.w-100 {
	width: 100% !important
}

.w-auto {
	width: auto !important
}

.h-25 {
	height: 25% !important
}

.h-50 {
	height: 50% !important
}

.h-75 {
	height: 75% !important
}

.h-100 {
	height: 100% !important
}

.h-auto {
	height: auto !important
}

.mw-100 {
	max-width: 100% !important
}

.mh-100 {
	max-height: 100% !important
}

.m-0 {
	margin: 0 !important
}

.mt-0,
.my-0 {
	margin-top: 0 !important
}

.mr-0,
.mx-0 {
	margin-right: 0 !important
}

.mb-0,
.my-0 {
	margin-bottom: 0 !important
}

.ml-0,
.mx-0 {
	margin-left: 0 !important
}

.m-1 {
	margin: .25rem !important
}

.mt-1,
.my-1 {
	margin-top: .25rem !important
}

.mr-1,
.mx-1 {
	margin-right: .25rem !important
}

.mb-1,
.my-1 {
	margin-bottom: .25rem !important
}

.ml-1,
.mx-1 {
	margin-left: .25rem !important
}

.m-2 {
	margin: .5rem !important
}

.mt-2,
.my-2 {
	margin-top: .5rem !important
}

.mr-2,
.mx-2 {
	margin-right: .5rem !important
}

.mb-2,
.my-2 {
	margin-bottom: .5rem !important
}

.ml-2,
.mx-2 {
	margin-left: .5rem !important
}

.m-3 {
	margin: 1rem !important
}

.mt-3,
.my-3 {
	margin-top: 1rem !important
}

.mr-3,
.mx-3 {
	margin-right: 1rem !important
}

.mb-3,
.my-3 {
	margin-bottom: 1rem !important
}

.ml-3,
.mx-3 {
	margin-left: 1rem !important
}

.m-4 {
	margin: 1.5rem !important
}

.mt-4,
.my-4 {
	margin-top: 1.5rem !important
}

.mr-4,
.mx-4 {
	margin-right: 1.5rem !important
}

.mb-4,
.my-4 {
	margin-bottom: 1.5rem !important
}

.ml-4,
.mx-4 {
	margin-left: 1.5rem !important
}

.m-5 {
	margin: 3rem !important
}

.mt-5,
.my-5 {
	margin-top: 3rem !important
}

.mr-5,
.mx-5 {
	margin-right: 3rem !important
}

.mb-5,
.my-5 {
	margin-bottom: 3rem !important
}

.ml-5,
.mx-5 {
	margin-left: 3rem !important
}

.p-0 {
	padding: 0 !important
}

.pt-0,
.py-0 {
	padding-top: 0 !important
}

.pr-0,
.px-0 {
	padding-right: 0 !important
}

.pb-0,
.py-0 {
	padding-bottom: 0 !important
}

.pl-0,
.px-0 {
	padding-left: 0 !important
}

.p-1 {
	padding: .25rem !important
}

.pt-1,
.py-1 {
	padding-top: .25rem !important
}

.pr-1,
.px-1 {
	padding-right: .25rem !important
}

.pb-1,
.py-1 {
	padding-bottom: .25rem !important
}

.pl-1,
.px-1 {
	padding-left: .25rem !important
}

.p-2 {
	padding: .5rem !important
}

.pt-2,
.py-2 {
	padding-top: .5rem !important
}

.pr-2,
.px-2 {
	padding-right: .5rem !important
}

.pb-2,
.py-2 {
	padding-bottom: .5rem !important
}

.pl-2,
.px-2 {
	padding-left: .5rem !important
}

.p-3 {
	padding: 1rem !important
}

.pt-3,
.py-3 {
	padding-top: 1rem !important
}

.pr-3,
.px-3 {
	padding-right: 1rem !important
}

.pb-3,
.py-3 {
	padding-bottom: 1rem !important
}

.pl-3,
.px-3 {
	padding-left: 1rem !important
}

.p-4 {
	padding: 1.5rem !important
}

.pt-4,
.py-4 {
	padding-top: 1.5rem !important
}

.pr-4,
.px-4 {
	padding-right: 1.5rem !important
}

.pb-4,
.py-4 {
	padding-bottom: 1.5rem !important
}

.pl-4,
.px-4 {
	padding-left: 1.5rem !important
}

.p-5 {
	padding: 3rem !important
}

.pt-5,
.py-5 {
	padding-top: 3rem !important
}

.pr-5,
.px-5 {
	padding-right: 3rem !important
}

.pb-5,
.py-5 {
	padding-bottom: 3rem !important
}

.pl-5,
.px-5 {
	padding-left: 3rem !important
}

.m-auto {
	margin: auto !important
}

.mt-auto,
.my-auto {
	margin-top: auto !important
}

.mr-auto,
.mx-auto {
	margin-right: auto !important
}

.mb-auto,
.my-auto {
	margin-bottom: auto !important
}

.ml-auto,
.mx-auto {
	margin-left: auto !important
}

@media (min-width:576px) {
	.m-sm-0 {
		margin: 0 !important
	}

	.mt-sm-0,
	.my-sm-0 {
		margin-top: 0 !important
	}

	.mr-sm-0,
	.mx-sm-0 {
		margin-right: 0 !important
	}

	.mb-sm-0,
	.my-sm-0 {
		margin-bottom: 0 !important
	}

	.ml-sm-0,
	.mx-sm-0 {
		margin-left: 0 !important
	}

	.m-sm-1 {
		margin: .25rem !important
	}

	.mt-sm-1,
	.my-sm-1 {
		margin-top: .25rem !important
	}

	.mr-sm-1,
	.mx-sm-1 {
		margin-right: .25rem !important
	}

	.mb-sm-1,
	.my-sm-1 {
		margin-bottom: .25rem !important
	}

	.ml-sm-1,
	.mx-sm-1 {
		margin-left: .25rem !important
	}

	.m-sm-2 {
		margin: .5rem !important
	}

	.mt-sm-2,
	.my-sm-2 {
		margin-top: .5rem !important
	}

	.mr-sm-2,
	.mx-sm-2 {
		margin-right: .5rem !important
	}

	.mb-sm-2,
	.my-sm-2 {
		margin-bottom: .5rem !important
	}

	.ml-sm-2,
	.mx-sm-2 {
		margin-left: .5rem !important
	}

	.m-sm-3 {
		margin: 1rem !important
	}

	.mt-sm-3,
	.my-sm-3 {
		margin-top: 1rem !important
	}

	.mr-sm-3,
	.mx-sm-3 {
		margin-right: 1rem !important
	}

	.mb-sm-3,
	.my-sm-3 {
		margin-bottom: 1rem !important
	}

	.ml-sm-3,
	.mx-sm-3 {
		margin-left: 1rem !important
	}

	.m-sm-4 {
		margin: 1.5rem !important
	}

	.mt-sm-4,
	.my-sm-4 {
		margin-top: 1.5rem !important
	}

	.mr-sm-4,
	.mx-sm-4 {
		margin-right: 1.5rem !important
	}

	.mb-sm-4,
	.my-sm-4 {
		margin-bottom: 1.5rem !important
	}

	.ml-sm-4,
	.mx-sm-4 {
		margin-left: 1.5rem !important
	}

	.m-sm-5 {
		margin: 3rem !important
	}

	.mt-sm-5,
	.my-sm-5 {
		margin-top: 3rem !important
	}

	.mr-sm-5,
	.mx-sm-5 {
		margin-right: 3rem !important
	}

	.mb-sm-5,
	.my-sm-5 {
		margin-bottom: 3rem !important
	}

	.ml-sm-5,
	.mx-sm-5 {
		margin-left: 3rem !important
	}

	.p-sm-0 {
		padding: 0 !important
	}

	.pt-sm-0,
	.py-sm-0 {
		padding-top: 0 !important
	}

	.pr-sm-0,
	.px-sm-0 {
		padding-right: 0 !important
	}

	.pb-sm-0,
	.py-sm-0 {
		padding-bottom: 0 !important
	}

	.pl-sm-0,
	.px-sm-0 {
		padding-left: 0 !important
	}

	.p-sm-1 {
		padding: .25rem !important
	}

	.pt-sm-1,
	.py-sm-1 {
		padding-top: .25rem !important
	}

	.pr-sm-1,
	.px-sm-1 {
		padding-right: .25rem !important
	}

	.pb-sm-1,
	.py-sm-1 {
		padding-bottom: .25rem !important
	}

	.pl-sm-1,
	.px-sm-1 {
		padding-left: .25rem !important
	}

	.p-sm-2 {
		padding: .5rem !important
	}

	.pt-sm-2,
	.py-sm-2 {
		padding-top: .5rem !important
	}

	.pr-sm-2,
	.px-sm-2 {
		padding-right: .5rem !important
	}

	.pb-sm-2,
	.py-sm-2 {
		padding-bottom: .5rem !important
	}

	.pl-sm-2,
	.px-sm-2 {
		padding-left: .5rem !important
	}

	.p-sm-3 {
		padding: 1rem !important
	}

	.pt-sm-3,
	.py-sm-3 {
		padding-top: 1rem !important
	}

	.pr-sm-3,
	.px-sm-3 {
		padding-right: 1rem !important
	}

	.pb-sm-3,
	.py-sm-3 {
		padding-bottom: 1rem !important
	}

	.pl-sm-3,
	.px-sm-3 {
		padding-left: 1rem !important
	}

	.p-sm-4 {
		padding: 1.5rem !important
	}

	.pt-sm-4,
	.py-sm-4 {
		padding-top: 1.5rem !important
	}

	.pr-sm-4,
	.px-sm-4 {
		padding-right: 1.5rem !important
	}

	.pb-sm-4,
	.py-sm-4 {
		padding-bottom: 1.5rem !important
	}

	.pl-sm-4,
	.px-sm-4 {
		padding-left: 1.5rem !important
	}

	.p-sm-5 {
		padding: 3rem !important
	}

	.pt-sm-5,
	.py-sm-5 {
		padding-top: 3rem !important
	}

	.pr-sm-5,
	.px-sm-5 {
		padding-right: 3rem !important
	}

	.pb-sm-5,
	.py-sm-5 {
		padding-bottom: 3rem !important
	}

	.pl-sm-5,
	.px-sm-5 {
		padding-left: 3rem !important
	}

	.m-sm-auto {
		margin: auto !important
	}

	.mt-sm-auto,
	.my-sm-auto {
		margin-top: auto !important
	}

	.mr-sm-auto,
	.mx-sm-auto {
		margin-right: auto !important
	}

	.mb-sm-auto,
	.my-sm-auto {
		margin-bottom: auto !important
	}

	.ml-sm-auto,
	.mx-sm-auto {
		margin-left: auto !important
	}
}

@media (min-width:768px) {
	.m-md-0 {
		margin: 0 !important
	}

	.mt-md-0,
	.my-md-0 {
		margin-top: 0 !important
	}

	.mr-md-0,
	.mx-md-0 {
		margin-right: 0 !important
	}

	.mb-md-0,
	.my-md-0 {
		margin-bottom: 0 !important
	}

	.ml-md-0,
	.mx-md-0 {
		margin-left: 0 !important
	}

	.m-md-1 {
		margin: .25rem !important
	}

	.mt-md-1,
	.my-md-1 {
		margin-top: .25rem !important
	}

	.mr-md-1,
	.mx-md-1 {
		margin-right: .25rem !important
	}

	.mb-md-1,
	.my-md-1 {
		margin-bottom: .25rem !important
	}

	.ml-md-1,
	.mx-md-1 {
		margin-left: .25rem !important
	}

	.m-md-2 {
		margin: .5rem !important
	}

	.mt-md-2,
	.my-md-2 {
		margin-top: .5rem !important
	}

	.mr-md-2,
	.mx-md-2 {
		margin-right: .5rem !important
	}

	.mb-md-2,
	.my-md-2 {
		margin-bottom: .5rem !important
	}

	.ml-md-2,
	.mx-md-2 {
		margin-left: .5rem !important
	}

	.m-md-3 {
		margin: 1rem !important
	}

	.mt-md-3,
	.my-md-3 {
		margin-top: 1rem !important
	}

	.mr-md-3,
	.mx-md-3 {
		margin-right: 1rem !important
	}

	.mb-md-3,
	.my-md-3 {
		margin-bottom: 1rem !important
	}

	.ml-md-3,
	.mx-md-3 {
		margin-left: 1rem !important
	}

	.m-md-4 {
		margin: 1.5rem !important
	}

	.mt-md-4,
	.my-md-4 {
		margin-top: 1.5rem !important
	}

	.mr-md-4,
	.mx-md-4 {
		margin-right: 1.5rem !important
	}

	.mb-md-4,
	.my-md-4 {
		margin-bottom: 1.5rem !important
	}

	.ml-md-4,
	.mx-md-4 {
		margin-left: 1.5rem !important
	}

	.m-md-5 {
		margin: 3rem !important
	}

	.mt-md-5,
	.my-md-5 {
		margin-top: 3rem !important
	}

	.mr-md-5,
	.mx-md-5 {
		margin-right: 3rem !important
	}

	.mb-md-5,
	.my-md-5 {
		margin-bottom: 3rem !important
	}

	.ml-md-5,
	.mx-md-5 {
		margin-left: 3rem !important
	}

	.p-md-0 {
		padding: 0 !important
	}

	.pt-md-0,
	.py-md-0 {
		padding-top: 0 !important
	}

	.pr-md-0,
	.px-md-0 {
		padding-right: 0 !important
	}

	.pb-md-0,
	.py-md-0 {
		padding-bottom: 0 !important
	}

	.pl-md-0,
	.px-md-0 {
		padding-left: 0 !important
	}

	.p-md-1 {
		padding: .25rem !important
	}

	.pt-md-1,
	.py-md-1 {
		padding-top: .25rem !important
	}

	.pr-md-1,
	.px-md-1 {
		padding-right: .25rem !important
	}

	.pb-md-1,
	.py-md-1 {
		padding-bottom: .25rem !important
	}

	.pl-md-1,
	.px-md-1 {
		padding-left: .25rem !important
	}

	.p-md-2 {
		padding: .5rem !important
	}

	.pt-md-2,
	.py-md-2 {
		padding-top: .5rem !important
	}

	.pr-md-2,
	.px-md-2 {
		padding-right: .5rem !important
	}

	.pb-md-2,
	.py-md-2 {
		padding-bottom: .5rem !important
	}

	.pl-md-2,
	.px-md-2 {
		padding-left: .5rem !important
	}

	.p-md-3 {
		padding: 1rem !important
	}

	.pt-md-3,
	.py-md-3 {
		padding-top: 1rem !important
	}

	.pr-md-3,
	.px-md-3 {
		padding-right: 1rem !important
	}

	.pb-md-3,
	.py-md-3 {
		padding-bottom: 1rem !important
	}

	.pl-md-3,
	.px-md-3 {
		padding-left: 1rem !important
	}

	.p-md-4 {
		padding: 1.5rem !important
	}

	.pt-md-4,
	.py-md-4 {
		padding-top: 1.5rem !important
	}

	.pr-md-4,
	.px-md-4 {
		padding-right: 1.5rem !important
	}

	.pb-md-4,
	.py-md-4 {
		padding-bottom: 1.5rem !important
	}

	.pl-md-4,
	.px-md-4 {
		padding-left: 1.5rem !important
	}

	.p-md-5 {
		padding: 3rem !important
	}

	.pt-md-5,
	.py-md-5 {
		padding-top: 3rem !important
	}

	.pr-md-5,
	.px-md-5 {
		padding-right: 3rem !important
	}

	.pb-md-5,
	.py-md-5 {
		padding-bottom: 3rem !important
	}

	.pl-md-5,
	.px-md-5 {
		padding-left: 3rem !important
	}

	.m-md-auto {
		margin: auto !important
	}

	.mt-md-auto,
	.my-md-auto {
		margin-top: auto !important
	}

	.mr-md-auto,
	.mx-md-auto {
		margin-right: auto !important
	}

	.mb-md-auto,
	.my-md-auto {
		margin-bottom: auto !important
	}

	.ml-md-auto,
	.mx-md-auto {
		margin-left: auto !important
	}
}

@media (min-width:992px) {
	.m-lg-0 {
		margin: 0 !important
	}

	.mt-lg-0,
	.my-lg-0 {
		margin-top: 0 !important
	}

	.mr-lg-0,
	.mx-lg-0 {
		margin-right: 0 !important
	}

	.mb-lg-0,
	.my-lg-0 {
		margin-bottom: 0 !important
	}

	.ml-lg-0,
	.mx-lg-0 {
		margin-left: 0 !important
	}

	.m-lg-1 {
		margin: .25rem !important
	}

	.mt-lg-1,
	.my-lg-1 {
		margin-top: .25rem !important
	}

	.mr-lg-1,
	.mx-lg-1 {
		margin-right: .25rem !important
	}

	.mb-lg-1,
	.my-lg-1 {
		margin-bottom: .25rem !important
	}

	.ml-lg-1,
	.mx-lg-1 {
		margin-left: .25rem !important
	}

	.m-lg-2 {
		margin: .5rem !important
	}

	.mt-lg-2,
	.my-lg-2 {
		margin-top: .5rem !important
	}

	.mr-lg-2,
	.mx-lg-2 {
		margin-right: .5rem !important
	}

	.mb-lg-2,
	.my-lg-2 {
		margin-bottom: .5rem !important
	}

	.ml-lg-2,
	.mx-lg-2 {
		margin-left: .5rem !important
	}

	.m-lg-3 {
		margin: 1rem !important
	}

	.mt-lg-3,
	.my-lg-3 {
		margin-top: 1rem !important
	}

	.mr-lg-3,
	.mx-lg-3 {
		margin-right: 1rem !important
	}

	.mb-lg-3,
	.my-lg-3 {
		margin-bottom: 1rem !important
	}

	.ml-lg-3,
	.mx-lg-3 {
		margin-left: 1rem !important
	}

	.m-lg-4 {
		margin: 1.5rem !important
	}

	.mt-lg-4,
	.my-lg-4 {
		margin-top: 1.5rem !important
	}

	.mr-lg-4,
	.mx-lg-4 {
		margin-right: 1.5rem !important
	}

	.mb-lg-4,
	.my-lg-4 {
		margin-bottom: 1.5rem !important
	}

	.ml-lg-4,
	.mx-lg-4 {
		margin-left: 1.5rem !important
	}

	.m-lg-5 {
		margin: 3rem !important
	}

	.mt-lg-5,
	.my-lg-5 {
		margin-top: 3rem !important
	}

	.mr-lg-5,
	.mx-lg-5 {
		margin-right: 3rem !important
	}

	.mb-lg-5,
	.my-lg-5 {
		margin-bottom: 3rem !important
	}

	.ml-lg-5,
	.mx-lg-5 {
		margin-left: 3rem !important
	}

	.p-lg-0 {
		padding: 0 !important
	}

	.pt-lg-0,
	.py-lg-0 {
		padding-top: 0 !important
	}

	.pr-lg-0,
	.px-lg-0 {
		padding-right: 0 !important
	}

	.pb-lg-0,
	.py-lg-0 {
		padding-bottom: 0 !important
	}

	.pl-lg-0,
	.px-lg-0 {
		padding-left: 0 !important
	}

	.p-lg-1 {
		padding: .25rem !important
	}

	.pt-lg-1,
	.py-lg-1 {
		padding-top: .25rem !important
	}

	.pr-lg-1,
	.px-lg-1 {
		padding-right: .25rem !important
	}

	.pb-lg-1,
	.py-lg-1 {
		padding-bottom: .25rem !important
	}

	.pl-lg-1,
	.px-lg-1 {
		padding-left: .25rem !important
	}

	.p-lg-2 {
		padding: .5rem !important
	}

	.pt-lg-2,
	.py-lg-2 {
		padding-top: .5rem !important
	}

	.pr-lg-2,
	.px-lg-2 {
		padding-right: .5rem !important
	}

	.pb-lg-2,
	.py-lg-2 {
		padding-bottom: .5rem !important
	}

	.pl-lg-2,
	.px-lg-2 {
		padding-left: .5rem !important
	}

	.p-lg-3 {
		padding: 1rem !important
	}

	.pt-lg-3,
	.py-lg-3 {
		padding-top: 1rem !important
	}

	.pr-lg-3,
	.px-lg-3 {
		padding-right: 1rem !important
	}

	.pb-lg-3,
	.py-lg-3 {
		padding-bottom: 1rem !important
	}

	.pl-lg-3,
	.px-lg-3 {
		padding-left: 1rem !important
	}

	.p-lg-4 {
		padding: 1.5rem !important
	}

	.pt-lg-4,
	.py-lg-4 {
		padding-top: 1.5rem !important
	}

	.pr-lg-4,
	.px-lg-4 {
		padding-right: 1.5rem !important
	}

	.pb-lg-4,
	.py-lg-4 {
		padding-bottom: 1.5rem !important
	}

	.pl-lg-4,
	.px-lg-4 {
		padding-left: 1.5rem !important
	}

	.p-lg-5 {
		padding: 3rem !important
	}

	.pt-lg-5,
	.py-lg-5 {
		padding-top: 3rem !important
	}

	.pr-lg-5,
	.px-lg-5 {
		padding-right: 3rem !important
	}

	.pb-lg-5,
	.py-lg-5 {
		padding-bottom: 3rem !important
	}

	.pl-lg-5,
	.px-lg-5 {
		padding-left: 3rem !important
	}

	.m-lg-auto {
		margin: auto !important
	}

	.mt-lg-auto,
	.my-lg-auto {
		margin-top: auto !important
	}

	.mr-lg-auto,
	.mx-lg-auto {
		margin-right: auto !important
	}

	.mb-lg-auto,
	.my-lg-auto {
		margin-bottom: auto !important
	}

	.ml-lg-auto,
	.mx-lg-auto {
		margin-left: auto !important
	}
}

@media (min-width:1200px) {
	.m-xl-0 {
		margin: 0 !important
	}

	.mt-xl-0,
	.my-xl-0 {
		margin-top: 0 !important
	}

	.mr-xl-0,
	.mx-xl-0 {
		margin-right: 0 !important
	}

	.mb-xl-0,
	.my-xl-0 {
		margin-bottom: 0 !important
	}

	.ml-xl-0,
	.mx-xl-0 {
		margin-left: 0 !important
	}

	.m-xl-1 {
		margin: .25rem !important
	}

	.mt-xl-1,
	.my-xl-1 {
		margin-top: .25rem !important
	}

	.mr-xl-1,
	.mx-xl-1 {
		margin-right: .25rem !important
	}

	.mb-xl-1,
	.my-xl-1 {
		margin-bottom: .25rem !important
	}

	.ml-xl-1,
	.mx-xl-1 {
		margin-left: .25rem !important
	}

	.m-xl-2 {
		margin: .5rem !important
	}

	.mt-xl-2,
	.my-xl-2 {
		margin-top: .5rem !important
	}

	.mr-xl-2,
	.mx-xl-2 {
		margin-right: .5rem !important
	}

	.mb-xl-2,
	.my-xl-2 {
		margin-bottom: .5rem !important
	}

	.ml-xl-2,
	.mx-xl-2 {
		margin-left: .5rem !important
	}

	.m-xl-3 {
		margin: 1rem !important
	}

	.mt-xl-3,
	.my-xl-3 {
		margin-top: 1rem !important
	}

	.mr-xl-3,
	.mx-xl-3 {
		margin-right: 1rem !important
	}

	.mb-xl-3,
	.my-xl-3 {
		margin-bottom: 1rem !important
	}

	.ml-xl-3,
	.mx-xl-3 {
		margin-left: 1rem !important
	}

	.m-xl-4 {
		margin: 1.5rem !important
	}

	.mt-xl-4,
	.my-xl-4 {
		margin-top: 1.5rem !important
	}

	.mr-xl-4,
	.mx-xl-4 {
		margin-right: 1.5rem !important
	}

	.mb-xl-4,
	.my-xl-4 {
		margin-bottom: 1.5rem !important
	}

	.ml-xl-4,
	.mx-xl-4 {
		margin-left: 1.5rem !important
	}

	.m-xl-5 {
		margin: 3rem !important
	}

	.mt-xl-5,
	.my-xl-5 {
		margin-top: 3rem !important
	}

	.mr-xl-5,
	.mx-xl-5 {
		margin-right: 3rem !important
	}

	.mb-xl-5,
	.my-xl-5 {
		margin-bottom: 3rem !important
	}

	.ml-xl-5,
	.mx-xl-5 {
		margin-left: 3rem !important
	}

	.p-xl-0 {
		padding: 0 !important
	}

	.pt-xl-0,
	.py-xl-0 {
		padding-top: 0 !important
	}

	.pr-xl-0,
	.px-xl-0 {
		padding-right: 0 !important
	}

	.pb-xl-0,
	.py-xl-0 {
		padding-bottom: 0 !important
	}

	.pl-xl-0,
	.px-xl-0 {
		padding-left: 0 !important
	}

	.p-xl-1 {
		padding: .25rem !important
	}

	.pt-xl-1,
	.py-xl-1 {
		padding-top: .25rem !important
	}

	.pr-xl-1,
	.px-xl-1 {
		padding-right: .25rem !important
	}

	.pb-xl-1,
	.py-xl-1 {
		padding-bottom: .25rem !important
	}

	.pl-xl-1,
	.px-xl-1 {
		padding-left: .25rem !important
	}

	.p-xl-2 {
		padding: .5rem !important
	}

	.pt-xl-2,
	.py-xl-2 {
		padding-top: .5rem !important
	}

	.pr-xl-2,
	.px-xl-2 {
		padding-right: .5rem !important
	}

	.pb-xl-2,
	.py-xl-2 {
		padding-bottom: .5rem !important
	}

	.pl-xl-2,
	.px-xl-2 {
		padding-left: .5rem !important
	}

	.p-xl-3 {
		padding: 1rem !important
	}

	.pt-xl-3,
	.py-xl-3 {
		padding-top: 1rem !important
	}

	.pr-xl-3,
	.px-xl-3 {
		padding-right: 1rem !important
	}

	.pb-xl-3,
	.py-xl-3 {
		padding-bottom: 1rem !important
	}

	.pl-xl-3,
	.px-xl-3 {
		padding-left: 1rem !important
	}

	.p-xl-4 {
		padding: 1.5rem !important
	}

	.pt-xl-4,
	.py-xl-4 {
		padding-top: 1.5rem !important
	}

	.pr-xl-4,
	.px-xl-4 {
		padding-right: 1.5rem !important
	}

	.pb-xl-4,
	.py-xl-4 {
		padding-bottom: 1.5rem !important
	}

	.pl-xl-4,
	.px-xl-4 {
		padding-left: 1.5rem !important
	}

	.p-xl-5 {
		padding: 3rem !important
	}

	.pt-xl-5,
	.py-xl-5 {
		padding-top: 3rem !important
	}

	.pr-xl-5,
	.px-xl-5 {
		padding-right: 3rem !important
	}

	.pb-xl-5,
	.py-xl-5 {
		padding-bottom: 3rem !important
	}

	.pl-xl-5,
	.px-xl-5 {
		padding-left: 3rem !important
	}

	.m-xl-auto {
		margin: auto !important
	}

	.mt-xl-auto,
	.my-xl-auto {
		margin-top: auto !important
	}

	.mr-xl-auto,
	.mx-xl-auto {
		margin-right: auto !important
	}

	.mb-xl-auto,
	.my-xl-auto {
		margin-bottom: auto !important
	}

	.ml-xl-auto,
	.mx-xl-auto {
		margin-left: auto !important
	}
}

.text-monospace {
	font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace
}

.text-justify {
	text-align: justify !important
}

.text-nowrap {
	white-space: nowrap !important
}

.text-truncate {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap
}

.text-left {
	text-align: left !important
}

.text-right {
	text-align: right !important
}

.text-center {
	text-align: center !important
}

@media (min-width:576px) {
	.text-sm-left {
		text-align: left !important
	}

	.text-sm-right {
		text-align: right !important
	}

	.text-sm-center {
		text-align: center !important
	}
}

@media (min-width:768px) {
	.text-md-left {
		text-align: left !important
	}

	.text-md-right {
		text-align: right !important
	}

	.text-md-center {
		text-align: center !important
	}
}

@media (min-width:992px) {
	.text-lg-left {
		text-align: left !important
	}

	.text-lg-right {
		text-align: right !important
	}

	.text-lg-center {
		text-align: center !important
	}
}

@media (min-width:1200px) {
	.text-xl-left {
		text-align: left !important
	}

	.text-xl-right {
		text-align: right !important
	}

	.text-xl-center {
		text-align: center !important
	}
}

.text-lowercase {
	text-transform: lowercase !important
}

.text-uppercase {
	text-transform: uppercase !important
}

.text-capitalize {
	text-transform: capitalize !important
}

.font-weight-light {
	font-weight: 300 !important
}

.font-weight-normal {
	font-weight: 400 !important
}

.font-weight-bold {
	font-weight: 700 !important
}

.font-italic {
	font-style: italic !important
}

.text-white {
	color: #fff !important
}

.text-primary {
	color: #007bff !important
}

a.text-primary:focus,
a.text-primary:hover {
	color: #0062cc !important
}

.text-secondary {
	color: #6c757d !important
}

a.text-secondary:focus,
a.text-secondary:hover {
	color: #545b62 !important
}

.text-success {
	color: #28a745 !important
}

a.text-success:focus,
a.text-success:hover {
	color: #1e7e34 !important
}

.text-info {
	color: #17a2b8 !important
}

a.text-info:focus,
a.text-info:hover {
	color: #117a8b !important
}

.text-warning {
	color: #ffc107 !important
}

a.text-warning:focus,
a.text-warning:hover {
	color: #d39e00 !important
}

.text-danger {
	color: #dc3545 !important
}

a.text-danger:focus,
a.text-danger:hover {
	color: #bd2130 !important
}

.text-light {
	color: #f8f9fa !important
}

a.text-light:focus,
a.text-light:hover {
	color: #dae0e5 !important
}

.text-dark {
	color: #343a40 !important
}

a.text-dark:focus,
a.text-dark:hover {
	color: #1d2124 !important
}

.text-body {
	color: #212529 !important
}

.text-muted {
	color: #6c757d !important
}

.text-black-50 {
	color: rgba(0, 0, 0, .5) !important
}

.text-white-50 {
	color: rgba(255, 255, 255, .5) !important
}

.text-hide {
	font: 0/0 a;
	color: transparent;
	text-shadow: none;
	background-color: transparent;
	border: 0
}

.visible {
	visibility: visible !important
}

.invisible {
	visibility: hidden !important
}

@media print {

	*,
	::after,
	::before {
		text-shadow: none !important;
		box-shadow: none !important
	}

	a:not(.btn) {
		text-decoration: underline
	}

	abbr[title]::after {
		content: " (" attr(title) ")"
	}

	pre {
		white-space: pre-wrap !important
	}

	blockquote,
	pre {
		border: 1px solid #adb5bd;
		page-break-inside: avoid
	}

	thead {
		display: table-header-group
	}

	img,
	tr {
		page-break-inside: avoid
	}

	h2,
	h3,
	p {
		orphans: 3;
		widows: 3
	}

	h2,
	h3 {
		page-break-after: avoid
	}

	@page {
		size: a3
	}

	body {
		min-width: 992px !important
	}

	.container {
		min-width: 992px !important
	}

	.navbar {
		display: none
	}

	.badge {
		border: 1px solid #000
	}

	.table {
		border-collapse: collapse !important
	}

	.table td,
	.table th {
		background-color: #fff !important
	}

	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dee2e6 !important
	}

	.table-dark {
		color: inherit
	}

	.table-dark tbody+tbody,
	.table-dark td,
	.table-dark th,
	.table-dark thead th {
		border-color: #dee2e6
	}

	.table .thead-dark th {
		color: inherit;
		border-color: #dee2e6
	}
}

.form-control:focus {
	color: #495057;
	background-color: #f1f1f1;
	border-color: #ef7b06;
	outline: 0;
	box-shadow: 0 0 0 0.2rem rgba(255, 193, 71);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/bootstrap.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,aAAa;CACb,eAAe;CACf,oBAAoB;CACpB,kBAAkB;CAClB,oBAAoB;CACpB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,sBAAsB;CACtB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,8KAA8K;CAC9K;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,8BAA8B;CAC9B,0BAA0B;CAC1B,6BAA6B;CAC7B;AACD;;AAMA;;;;;;;;;;CAUC;AACD;;AAEA;CACC,SAAS;CACT,iKAAiK;CACjK,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,uBAAuB;CACvB,SAAS;CACT;AACD;;AAEA;;;;;;CAMC,aAAa;CACb;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;;CAEC,0BAA0B;CAC1B,yCAAyC;CACzC,iCAAiC;CACjC,YAAY;CACZ;AACD;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;;;CAGC,aAAa;CACb;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,6BAA6B;CAC7B;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC,iGAAiG;CACjG;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;;;;;CAKC,SAAS;CACT,oBAAoB;CACpB,kBAAkB;CAClB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;;;CAIC,UAAU;CACV;AACD;;AAEA;;CAEC,sBAAsB;CACtB,UAAU;CACV,YAAY;CACZ,WAAW;AACZ;;AAEA;;;;CAIC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,SAAS;CACT;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,eAAe;CACf,UAAU;CACV,oBAAoB;CACpB,iBAAiB;CACjB,oBAAoB;CACpB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;;;;;;;CAYC,oBAAoB;CACpB,oBAAoB;CACpB,gBAAgB;CAChB,gBAAgB;CAChB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;CAEC,aAAa;CACb;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,cAAc;CACd,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,eAAe;CACf,sBAAsB;CACtB,yBAAyB;CACzB,qBAAqB;CACrB,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,UAAU;CACV,eAAe;CACf;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CAEC,aAAa;CAEb,eAAe;CACf,mBAAmB;CACnB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;;CAEC,gBAAgB;CAChB;AACD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsEC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB;AACD;;AAEA;CAEC,aAAa;CAEb,YAAY;CACZ;AACD;;AAEA;CAEC,cAAc;CACd,WAAW;CACX;AACD;;AAEA;CAEC,mBAAmB;CACnB;AACD;;AAEA;CAEC,oBAAoB;CACpB;AACD;;AAEA;CAEC,aAAa;CACb;AACD;;AAEA;CAEC,oBAAoB;CACpB;AACD;;AAEA;CAEC,oBAAoB;CACpB;AACD;;AAEA;CAEC,aAAa;CACb;AACD;;AAEA;CAEC,oBAAoB;CACpB;AACD;;AAEA;CAEC,oBAAoB;CACpB;AACD;;AAEA;CAEC,aAAa;CACb;AACD;;AAEA;CAEC,oBAAoB;CACpB;AACD;;AAEA;CAEC,oBAAoB;CACpB;AACD;;AAEA;CAEC,cAAc;CACd;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EAEC,aAAa;EAEb,YAAY;EACZ;CACD;;CAEA;EAEC,cAAc;EACd,WAAW;EACX;CACD;;CAEA;EAEC,mBAAmB;EACnB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,cAAc;EACd;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EAEC,aAAa;EAEb,YAAY;EACZ;CACD;;CAEA;EAEC,cAAc;EACd,WAAW;EACX;CACD;;CAEA;EAEC,mBAAmB;EACnB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,cAAc;EACd;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EAEC,aAAa;EAEb,YAAY;EACZ;CACD;;CAEA;EAEC,cAAc;EACd,WAAW;EACX;CACD;;CAEA;EAEC,mBAAmB;EACnB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,cAAc;EACd;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EAEC,aAAa;EAEb,YAAY;EACZ;CACD;;CAEA;EAEC,cAAc;EACd,WAAW;EACX;CACD;;CAEA;EAEC,mBAAmB;EACnB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,aAAa;EACb;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,oBAAoB;EACpB;CACD;;CAEA;EAEC,cAAc;EACd;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB;AACD;;AAEA;;CAEC,eAAe;CACf,mBAAmB;CACnB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,iCAAiC;CACjC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,sBAAsB;CACtB,4BAA4B;CAC5B,yBAAyB;CACzB,qBAAqB;CACrB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,6BAA6B;CAC7B;AACD;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,qBAAqB;CACrB,UAAU;CACV;AACD;;AAsBA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,gCAAgC;CAChC,mCAAmC;CACnC,gBAAgB;CAChB,kBAAkB;CAClB;AACD;;AAEA;CACC,8BAA8B;CAC9B,iCAAiC;CACjC,kBAAkB;CAClB;AACD;;AAEA;CACC,+BAA+B;CAC/B,kCAAkC;CAClC,kBAAkB;CAClB;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,oBAAoB;CACpB,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,6BAA6B;CAC7B,yBAAyB;CACzB;AACD;;AAEA;;;;;;;;;;;;CAYC,gBAAgB;CAChB;AACD;;AAEA;;;;;;CAMC,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;;;;;;CAMC;AACD;;AAEA;;;;;;CAMC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;;;;;;CAMC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CAEC,aAAa;CAEb,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;;CAEC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,oBAAoB;CAEpB,mBAAmB;CACnB,eAAe;CACf;AACD;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB;AACD;;AAEA;CACC,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,aAAa;CACb,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,uCAAuC;CACvC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;;;CAIC,qBAAqB;CACrB;AACD;;AAEA;;;;;;;;CAQC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,aAAa;CACb,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,uCAAuC;CACvC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;;;CAIC,qBAAqB;CACrB;AACD;;AAEA;;;;;;;;CAQC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;CAEC,aAAa;CAEb,mBAAmB;CAEnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EAEC,aAAa;EAEb,mBAAmB;EAEnB,uBAAuB;EACvB;CACD;;CAEA;EAEC,aAAa;EAEb,cAAc;EAEd,mBAAmB;EAEnB,mBAAmB;EACnB;CACD;;CAEA;EACC,qBAAqB;EACrB,WAAW;EACX;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;EAEC,aAAa;EAEb,mBAAmB;EAEnB,uBAAuB;EACvB,WAAW;EACX;CACD;;CAEA;EACC,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB;CACD;;CAEA;EAEC,mBAAmB;EAEnB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,sBAAsB;CACtB,yBAAyB;CAGzB,iBAAiB;CACjB,6BAA6B;CAC7B,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,UAAU;CACV;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;;CAGC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;;CAGC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;;CAGC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd,0BAA0B;CAC1B,6BAA6B;CAC7B;AACD;;AAEA;;CAEC,0BAA0B;CAC1B,yBAAyB;CACzB;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;CAEC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;;CAEC,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,gBAAgB;CAChB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,mBAAmB;CACnB,sBAAsB;CACtB,WAAW;CACX,sBAAsB;CACtB,oCAAoC;CACpC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,aAAa;CACb,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,sBAAsB;CACtB,4BAA4B;CAC5B,oCAAoC;CACpC;AACD;;AAEA;CACC,QAAQ;CACR;AACD;;AAEA;CACC,SAAS;CACT,YAAY;CACZ,aAAa;CACb;AACD;;AAEA;CACC,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,mBAAmB;CACnB,sBAAsB;CACtB,WAAW;CACX,aAAa;CACb,oCAAoC;CACpC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,MAAM;CACN,WAAW;CACX,UAAU;CACV,aAAa;CACb;AACD;;AAEA;CACC,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,mBAAmB;CACnB,sBAAsB;CACtB,WAAW;CACX,kCAAkC;CAClC,eAAe;CACf,qCAAqC;CACrC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,MAAM;CACN,WAAW;CACX,UAAU;CACV,aAAa;CACb;AACD;;AAEA;CACC,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,mBAAmB;CACnB,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,oBAAoB;CACpB,sBAAsB;CACtB,WAAW;CACX,kCAAkC;CAClC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC,WAAW;CACX;AACD;;AAEA;CACC,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;CACtB,WAAW;CACX,gBAAgB;CAChB,cAAc;CACd,mBAAmB;CACnB,mBAAmB;CACnB,6BAA6B;CAC7B;AACD;;AAEA;;CAEC,cAAc;CACd,qBAAqB;CACrB;AACD;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB;AACD;;AAEA;;CAEC,kBAAkB;CAElB,oBAAoB;CACpB;AACD;;AAEA;;CAEC,kBAAkB;CAElB;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;;;CAMC;AACD;;AAEA;;;;;;;;CAQC;AACD;;AAEA;CAEC,aAAa;CAEb,eAAe;CAEf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,0BAA0B;CAC1B;AACD;;AAEA;;CAEC,yBAAyB;CACzB;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,sBAAsB;CACtB;AACD;;AAEA;;CAEC,qBAAqB;CACrB;AACD;;AAEA;CAEC,sBAAsB;CAEtB,uBAAuB;CAEvB;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC,gBAAgB;CAChB;AACD;;AAEA;;CAEC,6BAA6B;CAC7B;AACD;;AAEA;;CAEC,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC,kBAAkB;CAClB,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAElB,aAAa;CAEb,eAAe;CAEf,oBAAoB;CACpB;AACD;;AAEA;;;CAGC,kBAAkB;CAElB,cAAc;CACd,SAAS;CACT;AACD;;AAEA;;;CAGC;AACD;;AAEA;;;;;;;;;CASC;AACD;;AAEA;;CAEC,0BAA0B;CAC1B;AACD;;AAEA;;CAEC,yBAAyB;CACzB;AACD;;AAEA;CAEC,aAAa;CAEb;AACD;;AAEA;;CAEC,0BAA0B;CAC1B;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;;CAGC;AACD;;AAEA;;CAEC,kBAAkB;CAClB;AACD;;AAEA;;;;;;;;CAQC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,aAAa;CAEb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;;;CAMC,0BAA0B;CAC1B;AACD;;AAEA;;;;;;CAMC,yBAAyB;CACzB;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;CAEC,oBAAoB;CACpB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,cAAc;CACd,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,WAAW;CACX,yBAAyB;CAGzB,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,cAAc;CACd,WAAW;CACX,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,kCAAkC;CAClC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,2BAA2B;CAC3B,uCAAuC;CACvC,gBAAgB;CAChB,cAAc;CACd,sBAAsB;CACtB,sFAAqN;CACrN,yBAAyB;CACzB,yBAAyB;CACzB,qBAAqB;CAGrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,YAAY;CACZ,qBAAqB;CACrB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,oBAAoB;CACpB,uBAAuB;CACvB;AACD;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,uBAAuB;CACvB;AACD;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,2BAA2B;CAC3B;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,2BAA2B;CAC3B,SAAS;CACT;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,OAAO;CACP,UAAU;CACV,2BAA2B;CAC3B,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;CACd,sBAAsB;CACtB,yBAAyB;CACzB;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,SAAS;CACT,UAAU;CACV,cAAc;CACd,eAAe;CACf,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,8BAA8B;CAC9B;AACD;;AAEA;CACC,WAAW;CACX,eAAe;CACf,6BAA6B;CAG7B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,SAAS;CACT,mBAAmB;CAEnB;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,SAAS;CACT,mBAAmB;CAEnB;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,SAAS;CACT,mBAAmB;CACnB;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,6BAA6B;CAC7B,yBAAyB;CACzB;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB;AACD;;AAEA;CAEC,aAAa;CAEb,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,8BAA8B;CAC9B;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B;AACD;;AAEA;;CAEC,cAAc;CACd,sBAAsB;CACtB;AACD;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,WAAW;CACX;AACD;;AAEA;CAEC,cAAc;CACd;AACD;;AAEA;CAEC,aAAa;CAEb,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAElB,aAAa;CAEb,eAAe;CAEf,mBAAmB;CAEnB,8BAA8B;CAC9B;AACD;;AAEA;;CAGC,aAAa;CAEb,eAAe;CAEf,mBAAmB;CAEnB;AACD;;AAEA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,wBAAwB;CACxB,kBAAkB;CAClB,kBAAkB;CAClB,oBAAoB;CACpB;AACD;;AAEA;;CAEC;AACD;;AAEA;CAEC,aAAa;CAEb,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB;AACD;;AAEA;CAEC,gBAAgB;CAEhB,YAAY;CAEZ;AACD;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,6BAA6B;CAC7B,6BAA6B;CAC7B;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,mCAAmC;CACnC;AACD;;AAEA;;CAEC;;EAEC,gBAAgB;EAChB;CACD;AACD;;AAEA;CACC;EAEC,qBAAqB;EAErB;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,oBAAoB;EACpB;CACD;;CAEA;;EAGC;CACD;;CAEA;EAEC,wBAAwB;EAExB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;;CAEC;;EAEC,gBAAgB;EAChB;CACD;AACD;;AAEA;CACC;EAEC,qBAAqB;EAErB;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,oBAAoB;EACpB;CACD;;CAEA;;EAGC;CACD;;CAEA;EAEC,wBAAwB;EAExB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;;CAEC;;EAEC,gBAAgB;EAChB;CACD;AACD;;AAEA;CACC;EAEC,qBAAqB;EAErB;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,oBAAoB;EACpB;CACD;;CAEA;;EAGC;CACD;;CAEA;EAEC,wBAAwB;EAExB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;;CAEC;;EAEC,gBAAgB;EAChB;CACD;AACD;;AAEA;CACC;EAEC,qBAAqB;EAErB;CACD;;CAEA;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,oBAAoB;EACpB;CACD;;CAEA;;EAGC;CACD;;CAEA;EAEC,wBAAwB;EAExB;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CAEC,qBAAqB;CAErB;AACD;;AAEA;;CAEC,gBAAgB;CAChB;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;;CAGC;AACD;;AAEA;CAEC,wBAAwB;CAExB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,kBAAkB;CAElB,aAAa;CAEb,sBAAsB;CACtB,YAAY;CACZ,qBAAqB;CACrB,sBAAsB;CACtB,2BAA2B;CAC3B,qCAAqC;CACrC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC,kCAAkC;CAClC;AACD;;AAEA;CAEC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,oCAAoC;CACpC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,uBAAuB;CACvB,oCAAoC;CACpC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,qBAAqB;CACrB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,0CAA0C;CAC1C;AACD;;AAEA;CACC,WAAW;CACX,8CAA8C;CAC9C;AACD;;AAEA;CAEC,aAAa;CAEb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EAEC,mBAAmB;EACnB,mBAAmB;EACnB;CACD;;CAEA;EAEC,aAAa;EAEb,SAAY;EAEZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB;CACD;AACD;;AAEA;CAEC,aAAa;CAEb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EAEC;CACD;;CAEA;EAEC,SAAY;EACZ;CACD;;CAEA;EACC,cAAc;EACd;CACD;;CAEA;EACC,0BAA0B;EAC1B;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC,yBAAyB;EACzB;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC,8BAA8B;EAC9B;CACD;;CAEA;;EAEC,kCAAkC;EAClC;CACD;;CAEA;EACC;CACD;;CAEA;;;;EAIC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EAGC,eAAe;EAGf,mBAAmB;EACnB,UAAU;EACV;CACD;;CAEA;EACC,qBAAqB;EACrB;CACD;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CAEC,aAAa;CAEb,eAAe;CACf,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,qBAAqB;CACrB,iBAAiB;CACjB,iBAAiB;CACjB,cAAc;CACd,sBAAsB;CACtB;AACD;;AAEA;CACC,UAAU;CACV,cAAc;CACd,qBAAqB;CACrB,yBAAyB;CACzB;AACD;;AAEA;CACC,UAAU;CACV,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,8BAA8B;CAC9B;AACD;;AAEA;CACC,+BAA+B;CAC/B;AACD;;AAEA;CACC,UAAU;CACV,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,YAAY;CACZ,sBAAsB;CACtB;AACD;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB;AACD;;AAEA;CACC,6BAA6B;CAC7B;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB;AACD;;AAEA;CACC,6BAA6B;CAC7B;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf;AACD;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,6BAA6B;CAC7B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,uBAAuB;CACvB;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,WAAW;AACZ;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAYA;CACC;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CAEC,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB;AACD;;AAEA;CAEC,aAAa;CAEb,sBAAsB;CAEtB,uBAAuB;CACvB,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,kMAAkM;CAClM;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC,aAAa;CAEb;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC,aAAa;CAEb,sBAAsB;CACtB,eAAe;CACf;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd,qBAAqB;CACrB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC;AACD;;AAEA;;CAEC,UAAU;CACV;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,UAAU;CACV,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,eAAe;CACf,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,6BAA6B;CAC7B,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,aAAa;CACb,aAAa;CACb,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb;AACD;;AAEA;CAEC,kCAAkC;CAGlC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC,aAAa;CAEb,mBAAmB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAElB,aAAa;CAEb,sBAAsB;CACtB,WAAW;CACX,oBAAoB;CACpB,sBAAsB;CACtB,4BAA4B;CAC5B,mCAAmC;CACnC,oBAAoB;CACpB;AACD;;AAEA;CACC,eAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC,aAAa;CAEb,uBAAuB;CAEvB,8BAA8B;CAC9B,aAAa;CACb,gCAAgC;CAChC,6BAA6B;CAC7B;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAElB,cAAc;CACd;AACD;;AAEA;CAEC,aAAa;CAEb,mBAAmB;CAEnB,yBAAyB;CACzB,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC;EACC,gBAAgB;EAChB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,cAAc;CACd,SAAS;CACT,iKAAiK;CACjK,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,iBAAiB;CACjB,oBAAoB;CACpB,sBAAsB;CACtB,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,MAAM;CACN,2BAA2B;CAC3B;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,OAAO;CACP,YAAY;CACZ;AACD;;AAEA;;CAEC,QAAQ;CACR,iCAAiC;CACjC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,SAAS;CACT,2BAA2B;CAC3B;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,QAAQ;CACR,YAAY;CACZ;AACD;;AAEA;;CAEC,OAAO;CACP,iCAAiC;CACjC;AACD;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,WAAW;CACX,kBAAkB;CAClB,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,aAAa;CACb,cAAc;CACd,gBAAgB;CAChB,iKAAiK;CACjK,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,iBAAiB;CACjB,oBAAoB;CACpB,sBAAsB;CACtB,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,4BAA4B;CAC5B,mCAAmC;CACnC;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,aAAa;CACb;AACD;;AAEA;;CAEC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC,SAAS;CACT;AACD;;AAEA;;CAEC,WAAW;CACX;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,8BAA8B;CAC9B,YAAY;CACZ,YAAY;CACZ;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC,OAAO;CACP;AACD;;AAEA;;CAEC,SAAS;CACT;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC,MAAM;CACN;AACD;;AAEA;;CAEC,QAAQ;CACR;AACD;;AAEA;;CAEC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,cAAc;CACd,WAAW;CACX,mBAAmB;CACnB,WAAW;CACX;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,+BAA+B;CAC/B,YAAY;CACZ,YAAY;CACZ;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC,QAAQ;CACR;AACD;;AAEA;;CAEC,UAAU;CACV;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,gCAAgC;CAChC,yCAAyC;CACzC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CAEb,mBAAmB;CACnB,WAAW;CAEX,8BAA8B;CAG9B,2BAA2B;CAE3B;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;;;CAGC;AACD;;AAEA;;CAEC,kBAAkB;CAClB;AACD;;AAEA;;CAGC;AACD;;AAEA;;CAEC;;EAGC;CACD;AACD;;AAEA;;CAGC;AACD;;AAEA;;CAEC;;EAGC;CACD;AACD;;AAEA;;CAGC;AACD;;AAEA;;CAEC;;EAGC;CACD;AACD;;AAEA;CACC,UAAU;CACV,wBAAwB;CACxB;AACD;;AAEA;;;CAGC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;;CAMC;AACD;;AAEA;;CAEC;;;;;EAMC;CACD;AACD;;AAEA;;CAEC,kBAAkB;CAClB,MAAM;CACN,SAAS;CAET,aAAa;CAEb,mBAAmB;CAEnB,uBAAuB;CACvB,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB;AACD;;AAEA;;;;CAIC,WAAW;CACX,qBAAqB;CACrB,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,+CAA+C;CAC/C;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,OAAO;CACP,WAAW;CAEX,aAAa;CAEb,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAElB,cAAc;CACd,WAAW;CACX,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf;AACD;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,OAAO;CACP,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,OAAO;CACP,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,SAAS;CACT,WAAW;CACX,iBAAiB;CACjB,oBAAoB;CACpB,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yCAAyC;CACzC;AACD;;AAEA;CACC,0CAA0C;CAC1C;AACD;;AAEA;CACC,6CAA6C;CAC7C;AACD;;AAEA;CACC,yCAAyC;CACzC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,UAAU;CACV;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;;;;CAKC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,OAAO;CACP,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;;CAEA;EAEC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CAEC;AACD;;AAEA;CACC,eAAe;CACf,MAAM;CACN,QAAQ;CACR,OAAO;CACP;AACD;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,SAAS;CACT,OAAO;CACP;AACD;;AAEA;CACC;EAEC,gBAAgB;EAChB,MAAM;EACN;CACD;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;CACnB;AACD;;AAEA;;CAEC,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,6BAA6B;CAC7B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;;;EAGC,4BAA4B;EAC5B;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC,yBAAyB;EACzB;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;;EAGC,UAAU;EACV;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;;;;EAIC;CACD;;CAEA;EACC,cAAc;EACd;CACD;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;CACrB,UAAU;CACV,2CAA2C;AAC5C","sourcesContent":[":root {\r\n\t--blue: #007bff;\r\n\t--indigo: #6610f2;\r\n\t--purple: #6f42c1;\r\n\t--pink: #e83e8c;\r\n\t--red: #dc3545;\r\n\t--orange: #fd7e14;\r\n\t--yellow: #ffc107;\r\n\t--green: #28a745;\r\n\t--teal: #20c997;\r\n\t--cyan: #17a2b8;\r\n\t--white: #fff;\r\n\t--gray: #6c757d;\r\n\t--gray-dark: #343a40;\r\n\t--primary: #007bff;\r\n\t--secondary: #6c757d;\r\n\t--success: #28a745;\r\n\t--info: #17a2b8;\r\n\t--warning: #ffc107;\r\n\t--danger: #dc3545;\r\n\t--light: #f8f9fa;\r\n\t--dark: #343a40;\r\n\t--breakpoint-xs: 0;\r\n\t--breakpoint-sm: 576px;\r\n\t--breakpoint-md: 768px;\r\n\t--breakpoint-lg: 992px;\r\n\t--breakpoint-xl: 1200px;\r\n\t--font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\r\n\t--font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace\r\n}\r\n\r\n*,\r\n::after,\r\n::before {\r\n\tbox-sizing: border-box\r\n}\r\n\r\nhtml {\r\n\tfont-family: sans-serif;\r\n\tline-height: 1.15;\r\n\t-webkit-text-size-adjust: 100%;\r\n\t-ms-text-size-adjust: 100%;\r\n\t-ms-overflow-style: scrollbar;\r\n\t-webkit-tap-highlight-color: transparent\r\n}\r\n\r\n@-ms-viewport {\r\n\twidth: device-width\r\n}\r\n\r\narticle,\r\naside,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmain,\r\nnav,\r\nsection {\r\n\tdisplay: block\r\n}\r\n\r\nbody {\r\n\tmargin: 0;\r\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\r\n\tfont-size: 1rem;\r\n\tfont-weight: 400;\r\n\tline-height: 1.5;\r\n\tcolor: #212529;\r\n\ttext-align: left;\r\n\tbackground-color: #fff\r\n}\r\n\r\n[tabindex=\"-1\"]:focus {\r\n\toutline: 0 !important\r\n}\r\n\r\nhr {\r\n\tbox-sizing: content-box;\r\n\theight: 0;\r\n\toverflow: visible\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n\tmargin-top: 0;\r\n\tmargin-bottom: .5rem\r\n}\r\n\r\np {\r\n\tmargin-top: 0;\r\n\tmargin-bottom: 1rem\r\n}\r\n\r\nabbr[data-original-title],\r\nabbr[title] {\r\n\ttext-decoration: underline;\r\n\t-webkit-text-decoration: underline dotted;\r\n\ttext-decoration: underline dotted;\r\n\tcursor: help;\r\n\tborder-bottom: 0\r\n}\r\n\r\naddress {\r\n\tmargin-bottom: 1rem;\r\n\tfont-style: normal;\r\n\tline-height: inherit\r\n}\r\n\r\ndl,\r\nol,\r\nul {\r\n\tmargin-top: 0;\r\n\tmargin-bottom: 1rem\r\n}\r\n\r\nol ol,\r\nol ul,\r\nul ol,\r\nul ul {\r\n\tmargin-bottom: 0\r\n}\r\n\r\ndt {\r\n\tfont-weight: 700\r\n}\r\n\r\ndd {\r\n\tmargin-bottom: .5rem;\r\n\tmargin-left: 0\r\n}\r\n\r\nblockquote {\r\n\tmargin: 0 0 1rem\r\n}\r\n\r\ndfn {\r\n\tfont-style: italic\r\n}\r\n\r\nb,\r\nstrong {\r\n\tfont-weight: bolder\r\n}\r\n\r\nsmall {\r\n\tfont-size: 80%\r\n}\r\n\r\nsub,\r\nsup {\r\n\tposition: relative;\r\n\tfont-size: 75%;\r\n\tline-height: 0;\r\n\tvertical-align: baseline\r\n}\r\n\r\nsub {\r\n\tbottom: -.25em\r\n}\r\n\r\nsup {\r\n\ttop: -.5em\r\n}\r\n\r\na {\r\n\tcolor: #007bff;\r\n\ttext-decoration: none;\r\n\tbackground-color: transparent;\r\n\t-webkit-text-decoration-skip: objects\r\n}\r\n\r\na:hover {\r\n\tcolor: #0056b3;\r\n\ttext-decoration: underline\r\n}\r\n\r\na:not([href]):not([tabindex]) {\r\n\tcolor: inherit;\r\n\ttext-decoration: none\r\n}\r\n\r\na:not([href]):not([tabindex]):focus,\r\na:not([href]):not([tabindex]):hover {\r\n\tcolor: inherit;\r\n\ttext-decoration: none\r\n}\r\n\r\na:not([href]):not([tabindex]):focus {\r\n\toutline: 0\r\n}\r\n\r\ncode,\r\nkbd,\r\npre,\r\nsamp {\r\n\tfont-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n\tfont-size: 1em\r\n}\r\n\r\npre {\r\n\tmargin-top: 0;\r\n\tmargin-bottom: 1rem;\r\n\toverflow: auto;\r\n\t-ms-overflow-style: scrollbar\r\n}\r\n\r\nfigure {\r\n\tmargin: 0 0 1rem\r\n}\r\n\r\nimg {\r\n\tvertical-align: middle;\r\n\tborder-style: none\r\n}\r\n\r\nsvg:not(:root) {\r\n\toverflow: hidden\r\n}\r\n\r\ntable {\r\n\tborder-collapse: collapse\r\n}\r\n\r\ncaption {\r\n\tpadding-top: .75rem;\r\n\tpadding-bottom: .75rem;\r\n\tcolor: #6c757d;\r\n\ttext-align: left;\r\n\tcaption-side: bottom\r\n}\r\n\r\nth {\r\n\ttext-align: inherit\r\n}\r\n\r\nlabel {\r\n\tdisplay: inline-block;\r\n\tmargin-bottom: .5rem\r\n}\r\n\r\nbutton {\r\n\tborder-radius: 0\r\n}\r\n\r\nbutton:focus {\r\n\toutline: 1px dotted;\r\n\toutline: 5px auto -webkit-focus-ring-color\r\n}\r\n\r\nbutton,\r\ninput,\r\noptgroup,\r\nselect,\r\ntextarea {\r\n\tmargin: 0;\r\n\tfont-family: inherit;\r\n\tfont-size: inherit;\r\n\tline-height: inherit\r\n}\r\n\r\nbutton,\r\ninput {\r\n\toverflow: visible\r\n}\r\n\r\nbutton,\r\nselect {\r\n\ttext-transform: none\r\n}\r\n\r\n[type=reset],\r\n[type=submit],\r\nbutton,\r\nhtml [type=button] {\r\n\t-webkit-appearance: button\r\n}\r\n\r\n[type=button]::-moz-focus-inner,\r\n[type=reset]::-moz-focus-inner,\r\n[type=submit]::-moz-focus-inner,\r\nbutton::-moz-focus-inner {\r\n\tpadding: 0;\r\n\tborder-style: none\r\n}\r\n\r\ninput[type=checkbox],\r\ninput[type=radio] {\r\n\tbox-sizing: border-box;\r\n\tpadding: 0;\r\n\theight: 20px;\r\n\twidth: 20px;\r\n}\r\n\r\ninput[type=date],\r\ninput[type=datetime-local],\r\ninput[type=month],\r\ninput[type=time] {\r\n\t-webkit-appearance: listbox\r\n}\r\n\r\ntextarea {\r\n\toverflow: auto;\r\n\tresize: vertical\r\n}\r\n\r\nfieldset {\r\n\tmin-width: 0;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tborder: 0\r\n}\r\n\r\nlegend {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tmax-width: 100%;\r\n\tpadding: 0;\r\n\tmargin-bottom: .5rem;\r\n\tfont-size: 1.5rem;\r\n\tline-height: inherit;\r\n\tcolor: inherit;\r\n\twhite-space: normal\r\n}\r\n\r\nprogress {\r\n\tvertical-align: baseline\r\n}\r\n\r\n[type=number]::-webkit-inner-spin-button,\r\n[type=number]::-webkit-outer-spin-button {\r\n\theight: auto\r\n}\r\n\r\n[type=search] {\r\n\toutline-offset: -2px;\r\n\t-webkit-appearance: none\r\n}\r\n\r\n[type=search]::-webkit-search-cancel-button,\r\n[type=search]::-webkit-search-decoration {\r\n\t-webkit-appearance: none\r\n}\r\n\r\n::-webkit-file-upload-button {\r\n\tfont: inherit;\r\n\t-webkit-appearance: button\r\n}\r\n\r\noutput {\r\n\tdisplay: inline-block\r\n}\r\n\r\nsummary {\r\n\tdisplay: list-item;\r\n\tcursor: pointer\r\n}\r\n\r\ntemplate {\r\n\tdisplay: none\r\n}\r\n\r\n[hidden] {\r\n\tdisplay: none !important\r\n}\r\n\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n\tmargin-bottom: .5rem;\r\n\tfont-family: inherit;\r\n\tfont-weight: 500;\r\n\tline-height: 1.2;\r\n\tcolor: inherit\r\n}\r\n\r\n.h1,\r\nh1 {\r\n\tfont-size: 2.5rem\r\n}\r\n\r\n.h2,\r\nh2 {\r\n\tfont-size: 2rem\r\n}\r\n\r\n.h3,\r\nh3 {\r\n\tfont-size: 1.75rem\r\n}\r\n\r\n.h4,\r\nh4 {\r\n\tfont-size: 1.5rem\r\n}\r\n\r\n.h5,\r\nh5 {\r\n\tfont-size: 1.25rem\r\n}\r\n\r\n.h6,\r\nh6 {\r\n\tfont-size: 1rem\r\n}\r\n\r\n.lead {\r\n\tfont-size: 1.25rem;\r\n\tfont-weight: 300\r\n}\r\n\r\n.display-1 {\r\n\tfont-size: 6rem;\r\n\tfont-weight: 300;\r\n\tline-height: 1.2\r\n}\r\n\r\n.display-2 {\r\n\tfont-size: 5.5rem;\r\n\tfont-weight: 300;\r\n\tline-height: 1.2\r\n}\r\n\r\n.display-3 {\r\n\tfont-size: 4.5rem;\r\n\tfont-weight: 300;\r\n\tline-height: 1.2\r\n}\r\n\r\n.display-4 {\r\n\tfont-size: 3.5rem;\r\n\tfont-weight: 300;\r\n\tline-height: 1.2\r\n}\r\n\r\nhr {\r\n\tmargin-top: 1rem;\r\n\tmargin-bottom: 1rem;\r\n\tborder: 0;\r\n\tborder-top: 1px solid rgba(0, 0, 0, .1)\r\n}\r\n\r\n.small,\r\nsmall {\r\n\tfont-size: 80%;\r\n\tfont-weight: 400\r\n}\r\n\r\n.mark,\r\nmark {\r\n\tpadding: .2em;\r\n\tbackground-color: #fcf8e3\r\n}\r\n\r\n.list-unstyled {\r\n\tpadding-left: 0;\r\n\tlist-style: none\r\n}\r\n\r\n.list-inline {\r\n\tpadding-left: 0;\r\n\tlist-style: none\r\n}\r\n\r\n.list-inline-item {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.list-inline-item:not(:last-child) {\r\n\tmargin-right: .5rem\r\n}\r\n\r\n.initialism {\r\n\tfont-size: 90%;\r\n\ttext-transform: uppercase\r\n}\r\n\r\n.blockquote {\r\n\tmargin-bottom: 1rem;\r\n\tfont-size: 1.25rem\r\n}\r\n\r\n.blockquote-footer {\r\n\tdisplay: block;\r\n\tfont-size: 80%;\r\n\tcolor: #6c757d\r\n}\r\n\r\n.blockquote-footer::before {\r\n\tcontent: \"\\2014 \\00A0\"\r\n}\r\n\r\n.img-fluid {\r\n\tmax-width: 100%;\r\n\theight: auto\r\n}\r\n\r\n.img-thumbnail {\r\n\tpadding: .25rem;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #dee2e6;\r\n\tborder-radius: .25rem;\r\n\tmax-width: 100%;\r\n\theight: auto\r\n}\r\n\r\n.figure {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.figure-img {\r\n\tmargin-bottom: .5rem;\r\n\tline-height: 1\r\n}\r\n\r\n.figure-caption {\r\n\tfont-size: 90%;\r\n\tcolor: #6c757d\r\n}\r\n\r\ncode {\r\n\tfont-size: 87.5%;\r\n\tcolor: #e83e8c;\r\n\tword-break: break-word\r\n}\r\n\r\na>code {\r\n\tcolor: inherit\r\n}\r\n\r\nkbd {\r\n\tpadding: .2rem .4rem;\r\n\tfont-size: 87.5%;\r\n\tcolor: #fff;\r\n\tbackground-color: #212529;\r\n\tborder-radius: .2rem\r\n}\r\n\r\nkbd kbd {\r\n\tpadding: 0;\r\n\tfont-size: 100%;\r\n\tfont-weight: 700\r\n}\r\n\r\npre {\r\n\tdisplay: block;\r\n\tfont-size: 87.5%;\r\n\tcolor: #212529\r\n}\r\n\r\npre code {\r\n\tfont-size: inherit;\r\n\tcolor: inherit;\r\n\tword-break: normal\r\n}\r\n\r\n.pre-scrollable {\r\n\tmax-height: 340px;\r\n\toverflow-y: scroll\r\n}\r\n\r\n.container {\r\n\twidth: 100%;\r\n\tpadding-right: 15px;\r\n\tpadding-left: 15px;\r\n\tmargin-right: auto;\r\n\tmargin-left: auto\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.container {\r\n\t\tmax-width: 540px\r\n\t}\r\n}\r\n\r\n@media (min-width:768px) {\r\n\t.container {\r\n\t\tmax-width: 720px\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.container {\r\n\t\tmax-width: 960px\r\n\t}\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\t.container {\r\n\t\tmax-width: 1140px\r\n\t}\r\n}\r\n\r\n.container-fluid {\r\n\twidth: 100%;\r\n\tpadding-right: 15px;\r\n\tpadding-left: 15px;\r\n\tmargin-right: auto;\r\n\tmargin-left: auto\r\n}\r\n\r\n.row {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tmargin-right: -15px;\r\n\tmargin-left: -15px\r\n}\r\n\r\n.no-gutters {\r\n\tmargin-right: 0;\r\n\tmargin-left: 0\r\n}\r\n\r\n.no-gutters>.col,\r\n.no-gutters>[class*=col-] {\r\n\tpadding-right: 0;\r\n\tpadding-left: 0\r\n}\r\n\r\n.col,\r\n.col-1,\r\n.col-10,\r\n.col-11,\r\n.col-12,\r\n.col-2,\r\n.col-3,\r\n.col-4,\r\n.col-5,\r\n.col-6,\r\n.col-7,\r\n.col-8,\r\n.col-9,\r\n.col-auto,\r\n.col-lg,\r\n.col-lg-1,\r\n.col-lg-10,\r\n.col-lg-11,\r\n.col-lg-12,\r\n.col-lg-2,\r\n.col-lg-3,\r\n.col-lg-4,\r\n.col-lg-5,\r\n.col-lg-6,\r\n.col-lg-7,\r\n.col-lg-8,\r\n.col-lg-9,\r\n.col-lg-auto,\r\n.col-md,\r\n.col-md-1,\r\n.col-md-10,\r\n.col-md-11,\r\n.col-md-12,\r\n.col-md-2,\r\n.col-md-3,\r\n.col-md-4,\r\n.col-md-5,\r\n.col-md-6,\r\n.col-md-7,\r\n.col-md-8,\r\n.col-md-9,\r\n.col-md-auto,\r\n.col-sm,\r\n.col-sm-1,\r\n.col-sm-10,\r\n.col-sm-11,\r\n.col-sm-12,\r\n.col-sm-2,\r\n.col-sm-3,\r\n.col-sm-4,\r\n.col-sm-5,\r\n.col-sm-6,\r\n.col-sm-7,\r\n.col-sm-8,\r\n.col-sm-9,\r\n.col-sm-auto,\r\n.col-xl,\r\n.col-xl-1,\r\n.col-xl-10,\r\n.col-xl-11,\r\n.col-xl-12,\r\n.col-xl-2,\r\n.col-xl-3,\r\n.col-xl-4,\r\n.col-xl-5,\r\n.col-xl-6,\r\n.col-xl-7,\r\n.col-xl-8,\r\n.col-xl-9,\r\n.col-xl-auto {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tmin-height: 1px;\r\n\tpadding-right: 15px;\r\n\tpadding-left: 15px\r\n}\r\n\r\n.col {\r\n\t-ms-flex-preferred-size: 0;\r\n\tflex-basis: 0;\r\n\t-ms-flex-positive: 1;\r\n\tflex-grow: 1;\r\n\tmax-width: 100%\r\n}\r\n\r\n.col-auto {\r\n\t-ms-flex: 0 0 auto;\r\n\tflex: 0 0 auto;\r\n\twidth: auto;\r\n\tmax-width: none\r\n}\r\n\r\n.col-1 {\r\n\t-ms-flex: 0 0 8.333333%;\r\n\tflex: 0 0 8.333333%;\r\n\tmax-width: 8.333333%\r\n}\r\n\r\n.col-2 {\r\n\t-ms-flex: 0 0 16.666667%;\r\n\tflex: 0 0 16.666667%;\r\n\tmax-width: 16.666667%\r\n}\r\n\r\n.col-3 {\r\n\t-ms-flex: 0 0 25%;\r\n\tflex: 0 0 25%;\r\n\tmax-width: 25%\r\n}\r\n\r\n.col-4 {\r\n\t-ms-flex: 0 0 33.333333%;\r\n\tflex: 0 0 33.333333%;\r\n\tmax-width: 33.333333%\r\n}\r\n\r\n.col-5 {\r\n\t-ms-flex: 0 0 41.666667%;\r\n\tflex: 0 0 41.666667%;\r\n\tmax-width: 41.666667%\r\n}\r\n\r\n.col-6 {\r\n\t-ms-flex: 0 0 50%;\r\n\tflex: 0 0 50%;\r\n\tmax-width: 50%\r\n}\r\n\r\n.col-7 {\r\n\t-ms-flex: 0 0 58.333333%;\r\n\tflex: 0 0 58.333333%;\r\n\tmax-width: 58.333333%\r\n}\r\n\r\n.col-8 {\r\n\t-ms-flex: 0 0 66.666667%;\r\n\tflex: 0 0 66.666667%;\r\n\tmax-width: 66.666667%\r\n}\r\n\r\n.col-9 {\r\n\t-ms-flex: 0 0 75%;\r\n\tflex: 0 0 75%;\r\n\tmax-width: 75%\r\n}\r\n\r\n.col-10 {\r\n\t-ms-flex: 0 0 83.333333%;\r\n\tflex: 0 0 83.333333%;\r\n\tmax-width: 83.333333%\r\n}\r\n\r\n.col-11 {\r\n\t-ms-flex: 0 0 91.666667%;\r\n\tflex: 0 0 91.666667%;\r\n\tmax-width: 91.666667%\r\n}\r\n\r\n.col-12 {\r\n\t-ms-flex: 0 0 100%;\r\n\tflex: 0 0 100%;\r\n\tmax-width: 100%\r\n}\r\n\r\n.order-first {\r\n\t-ms-flex-order: -1;\r\n\torder: -1\r\n}\r\n\r\n.order-last {\r\n\t-ms-flex-order: 13;\r\n\torder: 13\r\n}\r\n\r\n.order-0 {\r\n\t-ms-flex-order: 0;\r\n\torder: 0\r\n}\r\n\r\n.order-1 {\r\n\t-ms-flex-order: 1;\r\n\torder: 1\r\n}\r\n\r\n.order-2 {\r\n\t-ms-flex-order: 2;\r\n\torder: 2\r\n}\r\n\r\n.order-3 {\r\n\t-ms-flex-order: 3;\r\n\torder: 3\r\n}\r\n\r\n.order-4 {\r\n\t-ms-flex-order: 4;\r\n\torder: 4\r\n}\r\n\r\n.order-5 {\r\n\t-ms-flex-order: 5;\r\n\torder: 5\r\n}\r\n\r\n.order-6 {\r\n\t-ms-flex-order: 6;\r\n\torder: 6\r\n}\r\n\r\n.order-7 {\r\n\t-ms-flex-order: 7;\r\n\torder: 7\r\n}\r\n\r\n.order-8 {\r\n\t-ms-flex-order: 8;\r\n\torder: 8\r\n}\r\n\r\n.order-9 {\r\n\t-ms-flex-order: 9;\r\n\torder: 9\r\n}\r\n\r\n.order-10 {\r\n\t-ms-flex-order: 10;\r\n\torder: 10\r\n}\r\n\r\n.order-11 {\r\n\t-ms-flex-order: 11;\r\n\torder: 11\r\n}\r\n\r\n.order-12 {\r\n\t-ms-flex-order: 12;\r\n\torder: 12\r\n}\r\n\r\n.offset-1 {\r\n\tmargin-left: 8.333333%\r\n}\r\n\r\n.offset-2 {\r\n\tmargin-left: 16.666667%\r\n}\r\n\r\n.offset-3 {\r\n\tmargin-left: 25%\r\n}\r\n\r\n.offset-4 {\r\n\tmargin-left: 33.333333%\r\n}\r\n\r\n.offset-5 {\r\n\tmargin-left: 41.666667%\r\n}\r\n\r\n.offset-6 {\r\n\tmargin-left: 50%\r\n}\r\n\r\n.offset-7 {\r\n\tmargin-left: 58.333333%\r\n}\r\n\r\n.offset-8 {\r\n\tmargin-left: 66.666667%\r\n}\r\n\r\n.offset-9 {\r\n\tmargin-left: 75%\r\n}\r\n\r\n.offset-10 {\r\n\tmargin-left: 83.333333%\r\n}\r\n\r\n.offset-11 {\r\n\tmargin-left: 91.666667%\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.col-sm {\r\n\t\t-ms-flex-preferred-size: 0;\r\n\t\tflex-basis: 0;\r\n\t\t-ms-flex-positive: 1;\r\n\t\tflex-grow: 1;\r\n\t\tmax-width: 100%\r\n\t}\r\n\r\n\t.col-sm-auto {\r\n\t\t-ms-flex: 0 0 auto;\r\n\t\tflex: 0 0 auto;\r\n\t\twidth: auto;\r\n\t\tmax-width: none\r\n\t}\r\n\r\n\t.col-sm-1 {\r\n\t\t-ms-flex: 0 0 8.333333%;\r\n\t\tflex: 0 0 8.333333%;\r\n\t\tmax-width: 8.333333%\r\n\t}\r\n\r\n\t.col-sm-2 {\r\n\t\t-ms-flex: 0 0 16.666667%;\r\n\t\tflex: 0 0 16.666667%;\r\n\t\tmax-width: 16.666667%\r\n\t}\r\n\r\n\t.col-sm-3 {\r\n\t\t-ms-flex: 0 0 25%;\r\n\t\tflex: 0 0 25%;\r\n\t\tmax-width: 25%\r\n\t}\r\n\r\n\t.col-sm-4 {\r\n\t\t-ms-flex: 0 0 33.333333%;\r\n\t\tflex: 0 0 33.333333%;\r\n\t\tmax-width: 33.333333%\r\n\t}\r\n\r\n\t.col-sm-5 {\r\n\t\t-ms-flex: 0 0 41.666667%;\r\n\t\tflex: 0 0 41.666667%;\r\n\t\tmax-width: 41.666667%\r\n\t}\r\n\r\n\t.col-sm-6 {\r\n\t\t-ms-flex: 0 0 50%;\r\n\t\tflex: 0 0 50%;\r\n\t\tmax-width: 50%\r\n\t}\r\n\r\n\t.col-sm-7 {\r\n\t\t-ms-flex: 0 0 58.333333%;\r\n\t\tflex: 0 0 58.333333%;\r\n\t\tmax-width: 58.333333%\r\n\t}\r\n\r\n\t.col-sm-8 {\r\n\t\t-ms-flex: 0 0 66.666667%;\r\n\t\tflex: 0 0 66.666667%;\r\n\t\tmax-width: 66.666667%\r\n\t}\r\n\r\n\t.col-sm-9 {\r\n\t\t-ms-flex: 0 0 75%;\r\n\t\tflex: 0 0 75%;\r\n\t\tmax-width: 75%\r\n\t}\r\n\r\n\t.col-sm-10 {\r\n\t\t-ms-flex: 0 0 83.333333%;\r\n\t\tflex: 0 0 83.333333%;\r\n\t\tmax-width: 83.333333%\r\n\t}\r\n\r\n\t.col-sm-11 {\r\n\t\t-ms-flex: 0 0 91.666667%;\r\n\t\tflex: 0 0 91.666667%;\r\n\t\tmax-width: 91.666667%\r\n\t}\r\n\r\n\t.col-sm-12 {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%\r\n\t}\r\n\r\n\t.order-sm-first {\r\n\t\t-ms-flex-order: -1;\r\n\t\torder: -1\r\n\t}\r\n\r\n\t.order-sm-last {\r\n\t\t-ms-flex-order: 13;\r\n\t\torder: 13\r\n\t}\r\n\r\n\t.order-sm-0 {\r\n\t\t-ms-flex-order: 0;\r\n\t\torder: 0\r\n\t}\r\n\r\n\t.order-sm-1 {\r\n\t\t-ms-flex-order: 1;\r\n\t\torder: 1\r\n\t}\r\n\r\n\t.order-sm-2 {\r\n\t\t-ms-flex-order: 2;\r\n\t\torder: 2\r\n\t}\r\n\r\n\t.order-sm-3 {\r\n\t\t-ms-flex-order: 3;\r\n\t\torder: 3\r\n\t}\r\n\r\n\t.order-sm-4 {\r\n\t\t-ms-flex-order: 4;\r\n\t\torder: 4\r\n\t}\r\n\r\n\t.order-sm-5 {\r\n\t\t-ms-flex-order: 5;\r\n\t\torder: 5\r\n\t}\r\n\r\n\t.order-sm-6 {\r\n\t\t-ms-flex-order: 6;\r\n\t\torder: 6\r\n\t}\r\n\r\n\t.order-sm-7 {\r\n\t\t-ms-flex-order: 7;\r\n\t\torder: 7\r\n\t}\r\n\r\n\t.order-sm-8 {\r\n\t\t-ms-flex-order: 8;\r\n\t\torder: 8\r\n\t}\r\n\r\n\t.order-sm-9 {\r\n\t\t-ms-flex-order: 9;\r\n\t\torder: 9\r\n\t}\r\n\r\n\t.order-sm-10 {\r\n\t\t-ms-flex-order: 10;\r\n\t\torder: 10\r\n\t}\r\n\r\n\t.order-sm-11 {\r\n\t\t-ms-flex-order: 11;\r\n\t\torder: 11\r\n\t}\r\n\r\n\t.order-sm-12 {\r\n\t\t-ms-flex-order: 12;\r\n\t\torder: 12\r\n\t}\r\n\r\n\t.offset-sm-0 {\r\n\t\tmargin-left: 0\r\n\t}\r\n\r\n\t.offset-sm-1 {\r\n\t\tmargin-left: 8.333333%\r\n\t}\r\n\r\n\t.offset-sm-2 {\r\n\t\tmargin-left: 16.666667%\r\n\t}\r\n\r\n\t.offset-sm-3 {\r\n\t\tmargin-left: 25%\r\n\t}\r\n\r\n\t.offset-sm-4 {\r\n\t\tmargin-left: 33.333333%\r\n\t}\r\n\r\n\t.offset-sm-5 {\r\n\t\tmargin-left: 41.666667%\r\n\t}\r\n\r\n\t.offset-sm-6 {\r\n\t\tmargin-left: 50%\r\n\t}\r\n\r\n\t.offset-sm-7 {\r\n\t\tmargin-left: 58.333333%\r\n\t}\r\n\r\n\t.offset-sm-8 {\r\n\t\tmargin-left: 66.666667%\r\n\t}\r\n\r\n\t.offset-sm-9 {\r\n\t\tmargin-left: 75%\r\n\t}\r\n\r\n\t.offset-sm-10 {\r\n\t\tmargin-left: 83.333333%\r\n\t}\r\n\r\n\t.offset-sm-11 {\r\n\t\tmargin-left: 91.666667%\r\n\t}\r\n}\r\n\r\n@media (min-width:768px) {\r\n\t.col-md {\r\n\t\t-ms-flex-preferred-size: 0;\r\n\t\tflex-basis: 0;\r\n\t\t-ms-flex-positive: 1;\r\n\t\tflex-grow: 1;\r\n\t\tmax-width: 100%\r\n\t}\r\n\r\n\t.col-md-auto {\r\n\t\t-ms-flex: 0 0 auto;\r\n\t\tflex: 0 0 auto;\r\n\t\twidth: auto;\r\n\t\tmax-width: none\r\n\t}\r\n\r\n\t.col-md-1 {\r\n\t\t-ms-flex: 0 0 8.333333%;\r\n\t\tflex: 0 0 8.333333%;\r\n\t\tmax-width: 8.333333%\r\n\t}\r\n\r\n\t.col-md-2 {\r\n\t\t-ms-flex: 0 0 16.666667%;\r\n\t\tflex: 0 0 16.666667%;\r\n\t\tmax-width: 16.666667%\r\n\t}\r\n\r\n\t.col-md-3 {\r\n\t\t-ms-flex: 0 0 25%;\r\n\t\tflex: 0 0 25%;\r\n\t\tmax-width: 25%\r\n\t}\r\n\r\n\t.col-md-4 {\r\n\t\t-ms-flex: 0 0 33.333333%;\r\n\t\tflex: 0 0 33.333333%;\r\n\t\tmax-width: 33.333333%\r\n\t}\r\n\r\n\t.col-md-5 {\r\n\t\t-ms-flex: 0 0 41.666667%;\r\n\t\tflex: 0 0 41.666667%;\r\n\t\tmax-width: 41.666667%\r\n\t}\r\n\r\n\t.col-md-6 {\r\n\t\t-ms-flex: 0 0 50%;\r\n\t\tflex: 0 0 50%;\r\n\t\tmax-width: 50%\r\n\t}\r\n\r\n\t.col-md-7 {\r\n\t\t-ms-flex: 0 0 58.333333%;\r\n\t\tflex: 0 0 58.333333%;\r\n\t\tmax-width: 58.333333%\r\n\t}\r\n\r\n\t.col-md-8 {\r\n\t\t-ms-flex: 0 0 66.666667%;\r\n\t\tflex: 0 0 66.666667%;\r\n\t\tmax-width: 66.666667%\r\n\t}\r\n\r\n\t.col-md-9 {\r\n\t\t-ms-flex: 0 0 75%;\r\n\t\tflex: 0 0 75%;\r\n\t\tmax-width: 75%\r\n\t}\r\n\r\n\t.col-md-10 {\r\n\t\t-ms-flex: 0 0 83.333333%;\r\n\t\tflex: 0 0 83.333333%;\r\n\t\tmax-width: 83.333333%\r\n\t}\r\n\r\n\t.col-md-11 {\r\n\t\t-ms-flex: 0 0 91.666667%;\r\n\t\tflex: 0 0 91.666667%;\r\n\t\tmax-width: 91.666667%\r\n\t}\r\n\r\n\t.col-md-12 {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%\r\n\t}\r\n\r\n\t.order-md-first {\r\n\t\t-ms-flex-order: -1;\r\n\t\torder: -1\r\n\t}\r\n\r\n\t.order-md-last {\r\n\t\t-ms-flex-order: 13;\r\n\t\torder: 13\r\n\t}\r\n\r\n\t.order-md-0 {\r\n\t\t-ms-flex-order: 0;\r\n\t\torder: 0\r\n\t}\r\n\r\n\t.order-md-1 {\r\n\t\t-ms-flex-order: 1;\r\n\t\torder: 1\r\n\t}\r\n\r\n\t.order-md-2 {\r\n\t\t-ms-flex-order: 2;\r\n\t\torder: 2\r\n\t}\r\n\r\n\t.order-md-3 {\r\n\t\t-ms-flex-order: 3;\r\n\t\torder: 3\r\n\t}\r\n\r\n\t.order-md-4 {\r\n\t\t-ms-flex-order: 4;\r\n\t\torder: 4\r\n\t}\r\n\r\n\t.order-md-5 {\r\n\t\t-ms-flex-order: 5;\r\n\t\torder: 5\r\n\t}\r\n\r\n\t.order-md-6 {\r\n\t\t-ms-flex-order: 6;\r\n\t\torder: 6\r\n\t}\r\n\r\n\t.order-md-7 {\r\n\t\t-ms-flex-order: 7;\r\n\t\torder: 7\r\n\t}\r\n\r\n\t.order-md-8 {\r\n\t\t-ms-flex-order: 8;\r\n\t\torder: 8\r\n\t}\r\n\r\n\t.order-md-9 {\r\n\t\t-ms-flex-order: 9;\r\n\t\torder: 9\r\n\t}\r\n\r\n\t.order-md-10 {\r\n\t\t-ms-flex-order: 10;\r\n\t\torder: 10\r\n\t}\r\n\r\n\t.order-md-11 {\r\n\t\t-ms-flex-order: 11;\r\n\t\torder: 11\r\n\t}\r\n\r\n\t.order-md-12 {\r\n\t\t-ms-flex-order: 12;\r\n\t\torder: 12\r\n\t}\r\n\r\n\t.offset-md-0 {\r\n\t\tmargin-left: 0\r\n\t}\r\n\r\n\t.offset-md-1 {\r\n\t\tmargin-left: 8.333333%\r\n\t}\r\n\r\n\t.offset-md-2 {\r\n\t\tmargin-left: 16.666667%\r\n\t}\r\n\r\n\t.offset-md-3 {\r\n\t\tmargin-left: 25%\r\n\t}\r\n\r\n\t.offset-md-4 {\r\n\t\tmargin-left: 33.333333%\r\n\t}\r\n\r\n\t.offset-md-5 {\r\n\t\tmargin-left: 41.666667%\r\n\t}\r\n\r\n\t.offset-md-6 {\r\n\t\tmargin-left: 50%\r\n\t}\r\n\r\n\t.offset-md-7 {\r\n\t\tmargin-left: 58.333333%\r\n\t}\r\n\r\n\t.offset-md-8 {\r\n\t\tmargin-left: 66.666667%\r\n\t}\r\n\r\n\t.offset-md-9 {\r\n\t\tmargin-left: 75%\r\n\t}\r\n\r\n\t.offset-md-10 {\r\n\t\tmargin-left: 83.333333%\r\n\t}\r\n\r\n\t.offset-md-11 {\r\n\t\tmargin-left: 91.666667%\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.col-lg {\r\n\t\t-ms-flex-preferred-size: 0;\r\n\t\tflex-basis: 0;\r\n\t\t-ms-flex-positive: 1;\r\n\t\tflex-grow: 1;\r\n\t\tmax-width: 100%\r\n\t}\r\n\r\n\t.col-lg-auto {\r\n\t\t-ms-flex: 0 0 auto;\r\n\t\tflex: 0 0 auto;\r\n\t\twidth: auto;\r\n\t\tmax-width: none\r\n\t}\r\n\r\n\t.col-lg-1 {\r\n\t\t-ms-flex: 0 0 8.333333%;\r\n\t\tflex: 0 0 8.333333%;\r\n\t\tmax-width: 8.333333%\r\n\t}\r\n\r\n\t.col-lg-2 {\r\n\t\t-ms-flex: 0 0 16.666667%;\r\n\t\tflex: 0 0 16.666667%;\r\n\t\tmax-width: 16.666667%\r\n\t}\r\n\r\n\t.col-lg-3 {\r\n\t\t-ms-flex: 0 0 25%;\r\n\t\tflex: 0 0 25%;\r\n\t\tmax-width: 25%\r\n\t}\r\n\r\n\t.col-lg-4 {\r\n\t\t-ms-flex: 0 0 33.333333%;\r\n\t\tflex: 0 0 33.333333%;\r\n\t\tmax-width: 33.333333%\r\n\t}\r\n\r\n\t.col-lg-5 {\r\n\t\t-ms-flex: 0 0 41.666667%;\r\n\t\tflex: 0 0 41.666667%;\r\n\t\tmax-width: 41.666667%\r\n\t}\r\n\r\n\t.col-lg-6 {\r\n\t\t-ms-flex: 0 0 50%;\r\n\t\tflex: 0 0 50%;\r\n\t\tmax-width: 50%\r\n\t}\r\n\r\n\t.col-lg-7 {\r\n\t\t-ms-flex: 0 0 58.333333%;\r\n\t\tflex: 0 0 58.333333%;\r\n\t\tmax-width: 58.333333%\r\n\t}\r\n\r\n\t.col-lg-8 {\r\n\t\t-ms-flex: 0 0 66.666667%;\r\n\t\tflex: 0 0 66.666667%;\r\n\t\tmax-width: 66.666667%\r\n\t}\r\n\r\n\t.col-lg-9 {\r\n\t\t-ms-flex: 0 0 75%;\r\n\t\tflex: 0 0 75%;\r\n\t\tmax-width: 75%\r\n\t}\r\n\r\n\t.col-lg-10 {\r\n\t\t-ms-flex: 0 0 83.333333%;\r\n\t\tflex: 0 0 83.333333%;\r\n\t\tmax-width: 83.333333%\r\n\t}\r\n\r\n\t.col-lg-11 {\r\n\t\t-ms-flex: 0 0 91.666667%;\r\n\t\tflex: 0 0 91.666667%;\r\n\t\tmax-width: 91.666667%\r\n\t}\r\n\r\n\t.col-lg-12 {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%\r\n\t}\r\n\r\n\t.order-lg-first {\r\n\t\t-ms-flex-order: -1;\r\n\t\torder: -1\r\n\t}\r\n\r\n\t.order-lg-last {\r\n\t\t-ms-flex-order: 13;\r\n\t\torder: 13\r\n\t}\r\n\r\n\t.order-lg-0 {\r\n\t\t-ms-flex-order: 0;\r\n\t\torder: 0\r\n\t}\r\n\r\n\t.order-lg-1 {\r\n\t\t-ms-flex-order: 1;\r\n\t\torder: 1\r\n\t}\r\n\r\n\t.order-lg-2 {\r\n\t\t-ms-flex-order: 2;\r\n\t\torder: 2\r\n\t}\r\n\r\n\t.order-lg-3 {\r\n\t\t-ms-flex-order: 3;\r\n\t\torder: 3\r\n\t}\r\n\r\n\t.order-lg-4 {\r\n\t\t-ms-flex-order: 4;\r\n\t\torder: 4\r\n\t}\r\n\r\n\t.order-lg-5 {\r\n\t\t-ms-flex-order: 5;\r\n\t\torder: 5\r\n\t}\r\n\r\n\t.order-lg-6 {\r\n\t\t-ms-flex-order: 6;\r\n\t\torder: 6\r\n\t}\r\n\r\n\t.order-lg-7 {\r\n\t\t-ms-flex-order: 7;\r\n\t\torder: 7\r\n\t}\r\n\r\n\t.order-lg-8 {\r\n\t\t-ms-flex-order: 8;\r\n\t\torder: 8\r\n\t}\r\n\r\n\t.order-lg-9 {\r\n\t\t-ms-flex-order: 9;\r\n\t\torder: 9\r\n\t}\r\n\r\n\t.order-lg-10 {\r\n\t\t-ms-flex-order: 10;\r\n\t\torder: 10\r\n\t}\r\n\r\n\t.order-lg-11 {\r\n\t\t-ms-flex-order: 11;\r\n\t\torder: 11\r\n\t}\r\n\r\n\t.order-lg-12 {\r\n\t\t-ms-flex-order: 12;\r\n\t\torder: 12\r\n\t}\r\n\r\n\t.offset-lg-0 {\r\n\t\tmargin-left: 0\r\n\t}\r\n\r\n\t.offset-lg-1 {\r\n\t\tmargin-left: 8.333333%\r\n\t}\r\n\r\n\t.offset-lg-2 {\r\n\t\tmargin-left: 16.666667%\r\n\t}\r\n\r\n\t.offset-lg-3 {\r\n\t\tmargin-left: 25%\r\n\t}\r\n\r\n\t.offset-lg-4 {\r\n\t\tmargin-left: 33.333333%\r\n\t}\r\n\r\n\t.offset-lg-5 {\r\n\t\tmargin-left: 41.666667%\r\n\t}\r\n\r\n\t.offset-lg-6 {\r\n\t\tmargin-left: 50%\r\n\t}\r\n\r\n\t.offset-lg-7 {\r\n\t\tmargin-left: 58.333333%\r\n\t}\r\n\r\n\t.offset-lg-8 {\r\n\t\tmargin-left: 66.666667%\r\n\t}\r\n\r\n\t.offset-lg-9 {\r\n\t\tmargin-left: 75%\r\n\t}\r\n\r\n\t.offset-lg-10 {\r\n\t\tmargin-left: 83.333333%\r\n\t}\r\n\r\n\t.offset-lg-11 {\r\n\t\tmargin-left: 91.666667%\r\n\t}\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\t.col-xl {\r\n\t\t-ms-flex-preferred-size: 0;\r\n\t\tflex-basis: 0;\r\n\t\t-ms-flex-positive: 1;\r\n\t\tflex-grow: 1;\r\n\t\tmax-width: 100%\r\n\t}\r\n\r\n\t.col-xl-auto {\r\n\t\t-ms-flex: 0 0 auto;\r\n\t\tflex: 0 0 auto;\r\n\t\twidth: auto;\r\n\t\tmax-width: none\r\n\t}\r\n\r\n\t.col-xl-1 {\r\n\t\t-ms-flex: 0 0 8.333333%;\r\n\t\tflex: 0 0 8.333333%;\r\n\t\tmax-width: 8.333333%\r\n\t}\r\n\r\n\t.col-xl-2 {\r\n\t\t-ms-flex: 0 0 16.666667%;\r\n\t\tflex: 0 0 16.666667%;\r\n\t\tmax-width: 16.666667%\r\n\t}\r\n\r\n\t.col-xl-3 {\r\n\t\t-ms-flex: 0 0 25%;\r\n\t\tflex: 0 0 25%;\r\n\t\tmax-width: 25%\r\n\t}\r\n\r\n\t.col-xl-4 {\r\n\t\t-ms-flex: 0 0 33.333333%;\r\n\t\tflex: 0 0 33.333333%;\r\n\t\tmax-width: 33.333333%\r\n\t}\r\n\r\n\t.col-xl-5 {\r\n\t\t-ms-flex: 0 0 41.666667%;\r\n\t\tflex: 0 0 41.666667%;\r\n\t\tmax-width: 41.666667%\r\n\t}\r\n\r\n\t.col-xl-6 {\r\n\t\t-ms-flex: 0 0 50%;\r\n\t\tflex: 0 0 50%;\r\n\t\tmax-width: 50%\r\n\t}\r\n\r\n\t.col-xl-7 {\r\n\t\t-ms-flex: 0 0 58.333333%;\r\n\t\tflex: 0 0 58.333333%;\r\n\t\tmax-width: 58.333333%\r\n\t}\r\n\r\n\t.col-xl-8 {\r\n\t\t-ms-flex: 0 0 66.666667%;\r\n\t\tflex: 0 0 66.666667%;\r\n\t\tmax-width: 66.666667%\r\n\t}\r\n\r\n\t.col-xl-9 {\r\n\t\t-ms-flex: 0 0 75%;\r\n\t\tflex: 0 0 75%;\r\n\t\tmax-width: 75%\r\n\t}\r\n\r\n\t.col-xl-10 {\r\n\t\t-ms-flex: 0 0 83.333333%;\r\n\t\tflex: 0 0 83.333333%;\r\n\t\tmax-width: 83.333333%\r\n\t}\r\n\r\n\t.col-xl-11 {\r\n\t\t-ms-flex: 0 0 91.666667%;\r\n\t\tflex: 0 0 91.666667%;\r\n\t\tmax-width: 91.666667%\r\n\t}\r\n\r\n\t.col-xl-12 {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%\r\n\t}\r\n\r\n\t.order-xl-first {\r\n\t\t-ms-flex-order: -1;\r\n\t\torder: -1\r\n\t}\r\n\r\n\t.order-xl-last {\r\n\t\t-ms-flex-order: 13;\r\n\t\torder: 13\r\n\t}\r\n\r\n\t.order-xl-0 {\r\n\t\t-ms-flex-order: 0;\r\n\t\torder: 0\r\n\t}\r\n\r\n\t.order-xl-1 {\r\n\t\t-ms-flex-order: 1;\r\n\t\torder: 1\r\n\t}\r\n\r\n\t.order-xl-2 {\r\n\t\t-ms-flex-order: 2;\r\n\t\torder: 2\r\n\t}\r\n\r\n\t.order-xl-3 {\r\n\t\t-ms-flex-order: 3;\r\n\t\torder: 3\r\n\t}\r\n\r\n\t.order-xl-4 {\r\n\t\t-ms-flex-order: 4;\r\n\t\torder: 4\r\n\t}\r\n\r\n\t.order-xl-5 {\r\n\t\t-ms-flex-order: 5;\r\n\t\torder: 5\r\n\t}\r\n\r\n\t.order-xl-6 {\r\n\t\t-ms-flex-order: 6;\r\n\t\torder: 6\r\n\t}\r\n\r\n\t.order-xl-7 {\r\n\t\t-ms-flex-order: 7;\r\n\t\torder: 7\r\n\t}\r\n\r\n\t.order-xl-8 {\r\n\t\t-ms-flex-order: 8;\r\n\t\torder: 8\r\n\t}\r\n\r\n\t.order-xl-9 {\r\n\t\t-ms-flex-order: 9;\r\n\t\torder: 9\r\n\t}\r\n\r\n\t.order-xl-10 {\r\n\t\t-ms-flex-order: 10;\r\n\t\torder: 10\r\n\t}\r\n\r\n\t.order-xl-11 {\r\n\t\t-ms-flex-order: 11;\r\n\t\torder: 11\r\n\t}\r\n\r\n\t.order-xl-12 {\r\n\t\t-ms-flex-order: 12;\r\n\t\torder: 12\r\n\t}\r\n\r\n\t.offset-xl-0 {\r\n\t\tmargin-left: 0\r\n\t}\r\n\r\n\t.offset-xl-1 {\r\n\t\tmargin-left: 8.333333%\r\n\t}\r\n\r\n\t.offset-xl-2 {\r\n\t\tmargin-left: 16.666667%\r\n\t}\r\n\r\n\t.offset-xl-3 {\r\n\t\tmargin-left: 25%\r\n\t}\r\n\r\n\t.offset-xl-4 {\r\n\t\tmargin-left: 33.333333%\r\n\t}\r\n\r\n\t.offset-xl-5 {\r\n\t\tmargin-left: 41.666667%\r\n\t}\r\n\r\n\t.offset-xl-6 {\r\n\t\tmargin-left: 50%\r\n\t}\r\n\r\n\t.offset-xl-7 {\r\n\t\tmargin-left: 58.333333%\r\n\t}\r\n\r\n\t.offset-xl-8 {\r\n\t\tmargin-left: 66.666667%\r\n\t}\r\n\r\n\t.offset-xl-9 {\r\n\t\tmargin-left: 75%\r\n\t}\r\n\r\n\t.offset-xl-10 {\r\n\t\tmargin-left: 83.333333%\r\n\t}\r\n\r\n\t.offset-xl-11 {\r\n\t\tmargin-left: 91.666667%\r\n\t}\r\n}\r\n\r\n.table {\r\n\twidth: 100%;\r\n\tmax-width: 100%;\r\n\tmargin-bottom: 1rem;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.table td,\r\n.table th {\r\n\tpadding: .75rem;\r\n\tvertical-align: top;\r\n\tborder-top: 1px solid #dee2e6\r\n}\r\n\r\n.table thead th {\r\n\tvertical-align: bottom;\r\n\tborder-bottom: 2px solid #dee2e6\r\n}\r\n\r\n.table tbody+tbody {\r\n\tborder-top: 2px solid #dee2e6\r\n}\r\n\r\n.table .table {\r\n\tbackground-color: #fff\r\n}\r\n\r\n.table-sm td,\r\n.table-sm th {\r\n\tpadding: .3rem\r\n}\r\n\r\n.table-bordered {\r\n\tborder: 1px solid #dee2e6\r\n}\r\n\r\n.table-bordered td,\r\n.table-bordered th {\r\n\tborder: 1px solid #dee2e6\r\n}\r\n\r\n.table-bordered thead td,\r\n.table-bordered thead th {\r\n\tborder-bottom-width: 2px\r\n}\r\n\r\n.table-borderless tbody+tbody,\r\n.table-borderless td,\r\n.table-borderless th,\r\n.table-borderless thead th {\r\n\tborder: 0\r\n}\r\n\r\n.table-striped tbody tr:nth-of-type(odd) {\r\n\tbackground-color: rgba(0, 0, 0, .05)\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n\tbackground-color: rgba(0, 0, 0, .075)\r\n}\r\n\r\n.table-primary,\r\n.table-primary>td,\r\n.table-primary>th {\r\n\tbackground-color: #b8daff\r\n}\r\n\r\n.table-hover .table-primary:hover {\r\n\tbackground-color: #9fcdff\r\n}\r\n\r\n.table-hover .table-primary:hover>td,\r\n.table-hover .table-primary:hover>th {\r\n\tbackground-color: #9fcdff\r\n}\r\n\r\n.table-secondary,\r\n.table-secondary>td,\r\n.table-secondary>th {\r\n\tbackground-color: #d6d8db\r\n}\r\n\r\n.table-hover .table-secondary:hover {\r\n\tbackground-color: #c8cbcf\r\n}\r\n\r\n.table-hover .table-secondary:hover>td,\r\n.table-hover .table-secondary:hover>th {\r\n\tbackground-color: #c8cbcf\r\n}\r\n\r\n.table-success,\r\n.table-success>td,\r\n.table-success>th {\r\n\tbackground-color: #c3e6cb\r\n}\r\n\r\n.table-hover .table-success:hover {\r\n\tbackground-color: #b1dfbb\r\n}\r\n\r\n.table-hover .table-success:hover>td,\r\n.table-hover .table-success:hover>th {\r\n\tbackground-color: #b1dfbb\r\n}\r\n\r\n.table-info,\r\n.table-info>td,\r\n.table-info>th {\r\n\tbackground-color: #bee5eb\r\n}\r\n\r\n.table-hover .table-info:hover {\r\n\tbackground-color: #abdde5\r\n}\r\n\r\n.table-hover .table-info:hover>td,\r\n.table-hover .table-info:hover>th {\r\n\tbackground-color: #abdde5\r\n}\r\n\r\n.table-warning,\r\n.table-warning>td,\r\n.table-warning>th {\r\n\tbackground-color: #ffeeba\r\n}\r\n\r\n.table-hover .table-warning:hover {\r\n\tbackground-color: #ffe8a1\r\n}\r\n\r\n.table-hover .table-warning:hover>td,\r\n.table-hover .table-warning:hover>th {\r\n\tbackground-color: #ffe8a1\r\n}\r\n\r\n.table-danger,\r\n.table-danger>td,\r\n.table-danger>th {\r\n\tbackground-color: #f5c6cb\r\n}\r\n\r\n.table-hover .table-danger:hover {\r\n\tbackground-color: #f1b0b7\r\n}\r\n\r\n.table-hover .table-danger:hover>td,\r\n.table-hover .table-danger:hover>th {\r\n\tbackground-color: #f1b0b7\r\n}\r\n\r\n.table-light,\r\n.table-light>td,\r\n.table-light>th {\r\n\tbackground-color: #fdfdfe\r\n}\r\n\r\n.table-hover .table-light:hover {\r\n\tbackground-color: #ececf6\r\n}\r\n\r\n.table-hover .table-light:hover>td,\r\n.table-hover .table-light:hover>th {\r\n\tbackground-color: #ececf6\r\n}\r\n\r\n.table-dark,\r\n.table-dark>td,\r\n.table-dark>th {\r\n\tbackground-color: #c6c8ca\r\n}\r\n\r\n.table-hover .table-dark:hover {\r\n\tbackground-color: #b9bbbe\r\n}\r\n\r\n.table-hover .table-dark:hover>td,\r\n.table-hover .table-dark:hover>th {\r\n\tbackground-color: #b9bbbe\r\n}\r\n\r\n.table-active,\r\n.table-active>td,\r\n.table-active>th {\r\n\tbackground-color: rgba(0, 0, 0, .075)\r\n}\r\n\r\n.table-hover .table-active:hover {\r\n\tbackground-color: rgba(0, 0, 0, .075)\r\n}\r\n\r\n.table-hover .table-active:hover>td,\r\n.table-hover .table-active:hover>th {\r\n\tbackground-color: rgba(0, 0, 0, .075)\r\n}\r\n\r\n.table .thead-dark th {\r\n\tcolor: #fff;\r\n\tbackground-color: #212529;\r\n\tborder-color: #32383e\r\n}\r\n\r\n.table .thead-light th {\r\n\tcolor: #495057;\r\n\tbackground-color: #e9ecef;\r\n\tborder-color: #dee2e6\r\n}\r\n\r\n.table-dark {\r\n\tcolor: #fff;\r\n\tbackground-color: #212529\r\n}\r\n\r\n.table-dark td,\r\n.table-dark th,\r\n.table-dark thead th {\r\n\tborder-color: #32383e\r\n}\r\n\r\n.table-dark.table-bordered {\r\n\tborder: 0\r\n}\r\n\r\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\r\n\tbackground-color: rgba(255, 255, 255, .05)\r\n}\r\n\r\n.table-dark.table-hover tbody tr:hover {\r\n\tbackground-color: rgba(255, 255, 255, .075)\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n\t.table-responsive-sm {\r\n\t\tdisplay: block;\r\n\t\twidth: 100%;\r\n\t\toverflow-x: auto;\r\n\t\t-webkit-overflow-scrolling: touch;\r\n\t\t-ms-overflow-style: -ms-autohiding-scrollbar\r\n\t}\r\n\r\n\t.table-responsive-sm>.table-bordered {\r\n\t\tborder: 0\r\n\t}\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n\t.table-responsive-md {\r\n\t\tdisplay: block;\r\n\t\twidth: 100%;\r\n\t\toverflow-x: auto;\r\n\t\t-webkit-overflow-scrolling: touch;\r\n\t\t-ms-overflow-style: -ms-autohiding-scrollbar\r\n\t}\r\n\r\n\t.table-responsive-md>.table-bordered {\r\n\t\tborder: 0\r\n\t}\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n\t.table-responsive-lg {\r\n\t\tdisplay: block;\r\n\t\twidth: 100%;\r\n\t\toverflow-x: auto;\r\n\t\t-webkit-overflow-scrolling: touch;\r\n\t\t-ms-overflow-style: -ms-autohiding-scrollbar\r\n\t}\r\n\r\n\t.table-responsive-lg>.table-bordered {\r\n\t\tborder: 0\r\n\t}\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n\t.table-responsive-xl {\r\n\t\tdisplay: block;\r\n\t\twidth: 100%;\r\n\t\toverflow-x: auto;\r\n\t\t-webkit-overflow-scrolling: touch;\r\n\t\t-ms-overflow-style: -ms-autohiding-scrollbar\r\n\t}\r\n\r\n\t.table-responsive-xl>.table-bordered {\r\n\t\tborder: 0\r\n\t}\r\n}\r\n\r\n.table-responsive {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\toverflow-x: auto;\r\n\t-webkit-overflow-scrolling: touch;\r\n\t-ms-overflow-style: -ms-autohiding-scrollbar\r\n}\r\n\r\n.table-responsive>.table-bordered {\r\n\tborder: 0\r\n}\r\n\r\n.form-control {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tpadding: .375rem .75rem;\r\n\tfont-size: 1rem;\r\n\tline-height: 1.5;\r\n\tcolor: #495057;\r\n\tbackground-color: #fff;\r\n\tbackground-clip: padding-box;\r\n\tborder: 1px solid #ced4da;\r\n\tborder-radius: .25rem;\r\n\ttransition: border-color .15s ease-in-out, box-shadow .15s ease-in-out\r\n}\r\n\r\n@media screen and (prefers-reduced-motion:reduce) {\r\n\t.form-control {\r\n\t\ttransition: none\r\n\t}\r\n}\r\n\r\n.form-control::-ms-expand {\r\n\tbackground-color: transparent;\r\n\tborder: 0\r\n}\r\n\r\n.form-control:focus {\r\n\tcolor: #495057;\r\n\tbackground-color: #fff;\r\n\tborder-color: #80bdff;\r\n\toutline: 0;\r\n\tbox-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)\r\n}\r\n\r\n.form-control::-webkit-input-placeholder {\r\n\tcolor: #6c757d;\r\n\topacity: 1\r\n}\r\n\r\n.form-control::-moz-placeholder {\r\n\tcolor: #6c757d;\r\n\topacity: 1\r\n}\r\n\r\n.form-control:-ms-input-placeholder {\r\n\tcolor: #6c757d;\r\n\topacity: 1\r\n}\r\n\r\n.form-control::-ms-input-placeholder {\r\n\tcolor: #6c757d;\r\n\topacity: 1\r\n}\r\n\r\n.form-control::placeholder {\r\n\tcolor: #6c757d;\r\n\topacity: 1\r\n}\r\n\r\n.form-control:disabled,\r\n.form-control[readonly] {\r\n\tbackground-color: #e9ecef;\r\n\topacity: 1\r\n}\r\n\r\nselect.form-control:not([size]):not([multiple]) {\r\n\theight: calc(2.25rem + 2px)\r\n}\r\n\r\nselect.form-control:focus::-ms-value {\r\n\tcolor: #495057;\r\n\tbackground-color: #fff\r\n}\r\n\r\n.form-control-file,\r\n.form-control-range {\r\n\tdisplay: block;\r\n\twidth: 100%\r\n}\r\n\r\n.col-form-label {\r\n\tpadding-top: calc(.375rem + 1px);\r\n\tpadding-bottom: calc(.375rem + 1px);\r\n\tmargin-bottom: 0;\r\n\tfont-size: inherit;\r\n\tline-height: 1.5\r\n}\r\n\r\n.col-form-label-lg {\r\n\tpadding-top: calc(.5rem + 1px);\r\n\tpadding-bottom: calc(.5rem + 1px);\r\n\tfont-size: 1.25rem;\r\n\tline-height: 1.5\r\n}\r\n\r\n.col-form-label-sm {\r\n\tpadding-top: calc(.25rem + 1px);\r\n\tpadding-bottom: calc(.25rem + 1px);\r\n\tfont-size: .875rem;\r\n\tline-height: 1.5\r\n}\r\n\r\n.form-control-plaintext {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tpadding-top: .375rem;\r\n\tpadding-bottom: .375rem;\r\n\tmargin-bottom: 0;\r\n\tline-height: 1.5;\r\n\tcolor: #212529;\r\n\tbackground-color: transparent;\r\n\tborder: solid transparent;\r\n\tborder-width: 1px 0\r\n}\r\n\r\n.form-control-plaintext.form-control-lg,\r\n.form-control-plaintext.form-control-sm,\r\n.input-group-lg>.form-control-plaintext.form-control,\r\n.input-group-lg>.input-group-append>.form-control-plaintext.btn,\r\n.input-group-lg>.input-group-append>.form-control-plaintext.input-group-text,\r\n.input-group-lg>.input-group-prepend>.form-control-plaintext.btn,\r\n.input-group-lg>.input-group-prepend>.form-control-plaintext.input-group-text,\r\n.input-group-sm>.form-control-plaintext.form-control,\r\n.input-group-sm>.input-group-append>.form-control-plaintext.btn,\r\n.input-group-sm>.input-group-append>.form-control-plaintext.input-group-text,\r\n.input-group-sm>.input-group-prepend>.form-control-plaintext.btn,\r\n.input-group-sm>.input-group-prepend>.form-control-plaintext.input-group-text {\r\n\tpadding-right: 0;\r\n\tpadding-left: 0\r\n}\r\n\r\n.form-control-sm,\r\n.input-group-sm>.form-control,\r\n.input-group-sm>.input-group-append>.btn,\r\n.input-group-sm>.input-group-append>.input-group-text,\r\n.input-group-sm>.input-group-prepend>.btn,\r\n.input-group-sm>.input-group-prepend>.input-group-text {\r\n\tpadding: .25rem .5rem;\r\n\tfont-size: .875rem;\r\n\tline-height: 1.5;\r\n\tborder-radius: .2rem\r\n}\r\n\r\n.input-group-sm>.input-group-append>select.btn:not([size]):not([multiple]),\r\n.input-group-sm>.input-group-append>select.input-group-text:not([size]):not([multiple]),\r\n.input-group-sm>.input-group-prepend>select.btn:not([size]):not([multiple]),\r\n.input-group-sm>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),\r\n.input-group-sm>select.form-control:not([size]):not([multiple]),\r\nselect.form-control-sm:not([size]):not([multiple]) {\r\n\theight: calc(1.8125rem + 2px)\r\n}\r\n\r\n.form-control-lg,\r\n.input-group-lg>.form-control,\r\n.input-group-lg>.input-group-append>.btn,\r\n.input-group-lg>.input-group-append>.input-group-text,\r\n.input-group-lg>.input-group-prepend>.btn,\r\n.input-group-lg>.input-group-prepend>.input-group-text {\r\n\tpadding: .5rem 1rem;\r\n\tfont-size: 1.25rem;\r\n\tline-height: 1.5;\r\n\tborder-radius: .3rem\r\n}\r\n\r\n.input-group-lg>.input-group-append>select.btn:not([size]):not([multiple]),\r\n.input-group-lg>.input-group-append>select.input-group-text:not([size]):not([multiple]),\r\n.input-group-lg>.input-group-prepend>select.btn:not([size]):not([multiple]),\r\n.input-group-lg>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),\r\n.input-group-lg>select.form-control:not([size]):not([multiple]),\r\nselect.form-control-lg:not([size]):not([multiple]) {\r\n\theight: calc(2.875rem + 2px)\r\n}\r\n\r\n.form-group {\r\n\tmargin-bottom: 1rem\r\n}\r\n\r\n.form-text {\r\n\tdisplay: block;\r\n\tmargin-top: .25rem\r\n}\r\n\r\n.form-row {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tmargin-right: -5px;\r\n\tmargin-left: -5px\r\n}\r\n\r\n.form-row>.col,\r\n.form-row>[class*=col-] {\r\n\tpadding-right: 5px;\r\n\tpadding-left: 5px\r\n}\r\n\r\n.form-check {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tpadding-left: 1.25rem\r\n}\r\n\r\n.form-check-input {\r\n\tposition: absolute;\r\n\tmargin-top: .3rem;\r\n\tmargin-left: -1.25rem\r\n}\r\n\r\n.form-check-input:disabled~.form-check-label {\r\n\tcolor: #6c757d\r\n}\r\n\r\n.form-check-label {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.form-check-inline {\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tpadding-left: 0;\r\n\tmargin-right: .75rem\r\n}\r\n\r\n.form-check-inline .form-check-input {\r\n\tposition: static;\r\n\tmargin-top: 0;\r\n\tmargin-right: .3125rem;\r\n\tmargin-left: 0\r\n}\r\n\r\n.valid-feedback {\r\n\tdisplay: none;\r\n\twidth: 100%;\r\n\tmargin-top: .25rem;\r\n\tfont-size: 80%;\r\n\tcolor: #28a745\r\n}\r\n\r\n.valid-tooltip {\r\n\tposition: absolute;\r\n\ttop: 100%;\r\n\tz-index: 5;\r\n\tdisplay: none;\r\n\tmax-width: 100%;\r\n\tpadding: .5rem;\r\n\tmargin-top: .1rem;\r\n\tfont-size: .875rem;\r\n\tline-height: 1;\r\n\tcolor: #fff;\r\n\tbackground-color: rgba(40, 167, 69, .8);\r\n\tborder-radius: .2rem\r\n}\r\n\r\n.custom-select.is-valid,\r\n.form-control.is-valid,\r\n.was-validated .custom-select:valid,\r\n.was-validated .form-control:valid {\r\n\tborder-color: #28a745\r\n}\r\n\r\n.custom-select.is-valid:focus,\r\n.form-control.is-valid:focus,\r\n.was-validated .custom-select:valid:focus,\r\n.was-validated .form-control:valid:focus {\r\n\tborder-color: #28a745;\r\n\tbox-shadow: 0 0 0 .2rem rgba(40, 167, 69, .25)\r\n}\r\n\r\n.custom-select.is-valid~.valid-feedback,\r\n.custom-select.is-valid~.valid-tooltip,\r\n.form-control.is-valid~.valid-feedback,\r\n.form-control.is-valid~.valid-tooltip,\r\n.was-validated .custom-select:valid~.valid-feedback,\r\n.was-validated .custom-select:valid~.valid-tooltip,\r\n.was-validated .form-control:valid~.valid-feedback,\r\n.was-validated .form-control:valid~.valid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.form-control-file.is-valid~.valid-feedback,\r\n.form-control-file.is-valid~.valid-tooltip,\r\n.was-validated .form-control-file:valid~.valid-feedback,\r\n.was-validated .form-control-file:valid~.valid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.form-check-input.is-valid~.form-check-label,\r\n.was-validated .form-check-input:valid~.form-check-label {\r\n\tcolor: #28a745\r\n}\r\n\r\n.form-check-input.is-valid~.valid-feedback,\r\n.form-check-input.is-valid~.valid-tooltip,\r\n.was-validated .form-check-input:valid~.valid-feedback,\r\n.was-validated .form-check-input:valid~.valid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.custom-control-input.is-valid~.custom-control-label,\r\n.was-validated .custom-control-input:valid~.custom-control-label {\r\n\tcolor: #28a745\r\n}\r\n\r\n.custom-control-input.is-valid~.custom-control-label::before,\r\n.was-validated .custom-control-input:valid~.custom-control-label::before {\r\n\tbackground-color: #71dd8a\r\n}\r\n\r\n.custom-control-input.is-valid~.valid-feedback,\r\n.custom-control-input.is-valid~.valid-tooltip,\r\n.was-validated .custom-control-input:valid~.valid-feedback,\r\n.was-validated .custom-control-input:valid~.valid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.custom-control-input.is-valid:checked~.custom-control-label::before,\r\n.was-validated .custom-control-input:valid:checked~.custom-control-label::before {\r\n\tbackground-color: #34ce57\r\n}\r\n\r\n.custom-control-input.is-valid:focus~.custom-control-label::before,\r\n.was-validated .custom-control-input:valid:focus~.custom-control-label::before {\r\n\tbox-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(40, 167, 69, .25)\r\n}\r\n\r\n.custom-file-input.is-valid~.custom-file-label,\r\n.was-validated .custom-file-input:valid~.custom-file-label {\r\n\tborder-color: #28a745\r\n}\r\n\r\n.custom-file-input.is-valid~.custom-file-label::before,\r\n.was-validated .custom-file-input:valid~.custom-file-label::before {\r\n\tborder-color: inherit\r\n}\r\n\r\n.custom-file-input.is-valid~.valid-feedback,\r\n.custom-file-input.is-valid~.valid-tooltip,\r\n.was-validated .custom-file-input:valid~.valid-feedback,\r\n.was-validated .custom-file-input:valid~.valid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.custom-file-input.is-valid:focus~.custom-file-label,\r\n.was-validated .custom-file-input:valid:focus~.custom-file-label {\r\n\tbox-shadow: 0 0 0 .2rem rgba(40, 167, 69, .25)\r\n}\r\n\r\n.invalid-feedback {\r\n\tdisplay: none;\r\n\twidth: 100%;\r\n\tmargin-top: .25rem;\r\n\tfont-size: 80%;\r\n\tcolor: #dc3545\r\n}\r\n\r\n.invalid-tooltip {\r\n\tposition: absolute;\r\n\ttop: 100%;\r\n\tz-index: 5;\r\n\tdisplay: none;\r\n\tmax-width: 100%;\r\n\tpadding: .5rem;\r\n\tmargin-top: .1rem;\r\n\tfont-size: .875rem;\r\n\tline-height: 1;\r\n\tcolor: #fff;\r\n\tbackground-color: rgba(220, 53, 69, .8);\r\n\tborder-radius: .2rem\r\n}\r\n\r\n.custom-select.is-invalid,\r\n.form-control.is-invalid,\r\n.was-validated .custom-select:invalid,\r\n.was-validated .form-control:invalid {\r\n\tborder-color: #dc3545\r\n}\r\n\r\n.custom-select.is-invalid:focus,\r\n.form-control.is-invalid:focus,\r\n.was-validated .custom-select:invalid:focus,\r\n.was-validated .form-control:invalid:focus {\r\n\tborder-color: #dc3545;\r\n\tbox-shadow: 0 0 0 .2rem rgba(220, 53, 69, .25)\r\n}\r\n\r\n.custom-select.is-invalid~.invalid-feedback,\r\n.custom-select.is-invalid~.invalid-tooltip,\r\n.form-control.is-invalid~.invalid-feedback,\r\n.form-control.is-invalid~.invalid-tooltip,\r\n.was-validated .custom-select:invalid~.invalid-feedback,\r\n.was-validated .custom-select:invalid~.invalid-tooltip,\r\n.was-validated .form-control:invalid~.invalid-feedback,\r\n.was-validated .form-control:invalid~.invalid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.form-control-file.is-invalid~.invalid-feedback,\r\n.form-control-file.is-invalid~.invalid-tooltip,\r\n.was-validated .form-control-file:invalid~.invalid-feedback,\r\n.was-validated .form-control-file:invalid~.invalid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.form-check-input.is-invalid~.form-check-label,\r\n.was-validated .form-check-input:invalid~.form-check-label {\r\n\tcolor: #dc3545\r\n}\r\n\r\n.form-check-input.is-invalid~.invalid-feedback,\r\n.form-check-input.is-invalid~.invalid-tooltip,\r\n.was-validated .form-check-input:invalid~.invalid-feedback,\r\n.was-validated .form-check-input:invalid~.invalid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.custom-control-input.is-invalid~.custom-control-label,\r\n.was-validated .custom-control-input:invalid~.custom-control-label {\r\n\tcolor: #dc3545\r\n}\r\n\r\n.custom-control-input.is-invalid~.custom-control-label::before,\r\n.was-validated .custom-control-input:invalid~.custom-control-label::before {\r\n\tbackground-color: #efa2a9\r\n}\r\n\r\n.custom-control-input.is-invalid~.invalid-feedback,\r\n.custom-control-input.is-invalid~.invalid-tooltip,\r\n.was-validated .custom-control-input:invalid~.invalid-feedback,\r\n.was-validated .custom-control-input:invalid~.invalid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.custom-control-input.is-invalid:checked~.custom-control-label::before,\r\n.was-validated .custom-control-input:invalid:checked~.custom-control-label::before {\r\n\tbackground-color: #e4606d\r\n}\r\n\r\n.custom-control-input.is-invalid:focus~.custom-control-label::before,\r\n.was-validated .custom-control-input:invalid:focus~.custom-control-label::before {\r\n\tbox-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(220, 53, 69, .25)\r\n}\r\n\r\n.custom-file-input.is-invalid~.custom-file-label,\r\n.was-validated .custom-file-input:invalid~.custom-file-label {\r\n\tborder-color: #dc3545\r\n}\r\n\r\n.custom-file-input.is-invalid~.custom-file-label::before,\r\n.was-validated .custom-file-input:invalid~.custom-file-label::before {\r\n\tborder-color: inherit\r\n}\r\n\r\n.custom-file-input.is-invalid~.invalid-feedback,\r\n.custom-file-input.is-invalid~.invalid-tooltip,\r\n.was-validated .custom-file-input:invalid~.invalid-feedback,\r\n.was-validated .custom-file-input:invalid~.invalid-tooltip {\r\n\tdisplay: block\r\n}\r\n\r\n.custom-file-input.is-invalid:focus~.custom-file-label,\r\n.was-validated .custom-file-input:invalid:focus~.custom-file-label {\r\n\tbox-shadow: 0 0 0 .2rem rgba(220, 53, 69, .25)\r\n}\r\n\r\n.form-inline {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-flow: row wrap;\r\n\tflex-flow: row wrap;\r\n\t-ms-flex-align: center;\r\n\talign-items: center\r\n}\r\n\r\n.form-inline .form-check {\r\n\twidth: 100%\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.form-inline label {\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\t-ms-flex-pack: center;\r\n\t\tjustify-content: center;\r\n\t\tmargin-bottom: 0\r\n\t}\r\n\r\n\t.form-inline .form-group {\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-ms-flex: 0 0 auto;\r\n\t\tflex: 0 0 auto;\r\n\t\t-ms-flex-flow: row wrap;\r\n\t\tflex-flow: row wrap;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tmargin-bottom: 0\r\n\t}\r\n\r\n\t.form-inline .form-control {\r\n\t\tdisplay: inline-block;\r\n\t\twidth: auto;\r\n\t\tvertical-align: middle\r\n\t}\r\n\r\n\t.form-inline .form-control-plaintext {\r\n\t\tdisplay: inline-block\r\n\t}\r\n\r\n\t.form-inline .custom-select,\r\n\t.form-inline .input-group {\r\n\t\twidth: auto\r\n\t}\r\n\r\n\t.form-inline .form-check {\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\t-ms-flex-pack: center;\r\n\t\tjustify-content: center;\r\n\t\twidth: auto;\r\n\t\tpadding-left: 0\r\n\t}\r\n\r\n\t.form-inline .form-check-input {\r\n\t\tposition: relative;\r\n\t\tmargin-top: 0;\r\n\t\tmargin-right: .25rem;\r\n\t\tmargin-left: 0\r\n\t}\r\n\r\n\t.form-inline .custom-control {\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\t-ms-flex-pack: center;\r\n\t\tjustify-content: center\r\n\t}\r\n\r\n\t.form-inline .custom-control-label {\r\n\t\tmargin-bottom: 0\r\n\t}\r\n}\r\n\r\n.btn {\r\n\tdisplay: inline-block;\r\n\tfont-weight: 400;\r\n\ttext-align: center;\r\n\twhite-space: nowrap;\r\n\tvertical-align: middle;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\tborder: 1px solid transparent;\r\n\tpadding: .375rem .75rem;\r\n\tfont-size: 1rem;\r\n\tline-height: 1.5;\r\n\tborder-radius: .25rem;\r\n\ttransition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\r\n}\r\n\r\n@media screen and (prefers-reduced-motion:reduce) {\r\n\t.btn {\r\n\t\ttransition: none\r\n\t}\r\n}\r\n\r\n.btn:focus,\r\n.btn:hover {\r\n\ttext-decoration: none\r\n}\r\n\r\n.btn.focus,\r\n.btn:focus {\r\n\toutline: 0;\r\n\tbox-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)\r\n}\r\n\r\n.btn.disabled,\r\n.btn:disabled {\r\n\topacity: .65\r\n}\r\n\r\n.btn:not(:disabled):not(.disabled) {\r\n\tcursor: pointer\r\n}\r\n\r\n.btn:not(:disabled):not(.disabled).active,\r\n.btn:not(:disabled):not(.disabled):active {\r\n\tbackground-image: none\r\n}\r\n\r\na.btn.disabled,\r\nfieldset:disabled a.btn {\r\n\tpointer-events: none\r\n}\r\n\r\n.btn-primary {\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff;\r\n\tborder-color: #007bff\r\n}\r\n\r\n.btn-primary:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #0069d9;\r\n\tborder-color: #0062cc\r\n}\r\n\r\n.btn-primary.focus,\r\n.btn-primary:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5)\r\n}\r\n\r\n.btn-primary.disabled,\r\n.btn-primary:disabled {\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff;\r\n\tborder-color: #007bff\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled).active,\r\n.btn-primary:not(:disabled):not(.disabled):active,\r\n.show>.btn-primary.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #0062cc;\r\n\tborder-color: #005cbf\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled).active:focus,\r\n.btn-primary:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-primary.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5)\r\n}\r\n\r\n.btn-secondary {\r\n\tcolor: #fff;\r\n\tbackground-color: #6c757d;\r\n\tborder-color: #6c757d\r\n}\r\n\r\n.btn-secondary:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #5a6268;\r\n\tborder-color: #545b62\r\n}\r\n\r\n.btn-secondary.focus,\r\n.btn-secondary:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(108, 117, 125, .5)\r\n}\r\n\r\n.btn-secondary.disabled,\r\n.btn-secondary:disabled {\r\n\tcolor: #fff;\r\n\tbackground-color: #6c757d;\r\n\tborder-color: #6c757d\r\n}\r\n\r\n.btn-secondary:not(:disabled):not(.disabled).active,\r\n.btn-secondary:not(:disabled):not(.disabled):active,\r\n.show>.btn-secondary.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #545b62;\r\n\tborder-color: #4e555b\r\n}\r\n\r\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\r\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-secondary.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(108, 117, 125, .5)\r\n}\r\n\r\n.btn-success {\r\n\tcolor: #fff;\r\n\tbackground-color: #28a745;\r\n\tborder-color: #28a745\r\n}\r\n\r\n.btn-success:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #218838;\r\n\tborder-color: #1e7e34\r\n}\r\n\r\n.btn-success.focus,\r\n.btn-success:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(40, 167, 69, .5)\r\n}\r\n\r\n.btn-success.disabled,\r\n.btn-success:disabled {\r\n\tcolor: #fff;\r\n\tbackground-color: #28a745;\r\n\tborder-color: #28a745\r\n}\r\n\r\n.btn-success:not(:disabled):not(.disabled).active,\r\n.btn-success:not(:disabled):not(.disabled):active,\r\n.show>.btn-success.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #1e7e34;\r\n\tborder-color: #1c7430\r\n}\r\n\r\n.btn-success:not(:disabled):not(.disabled).active:focus,\r\n.btn-success:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-success.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(40, 167, 69, .5)\r\n}\r\n\r\n.btn-info {\r\n\tcolor: #fff;\r\n\tbackground-color: #17a2b8;\r\n\tborder-color: #17a2b8\r\n}\r\n\r\n.btn-info:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #138496;\r\n\tborder-color: #117a8b\r\n}\r\n\r\n.btn-info.focus,\r\n.btn-info:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)\r\n}\r\n\r\n.btn-info.disabled,\r\n.btn-info:disabled {\r\n\tcolor: #fff;\r\n\tbackground-color: #17a2b8;\r\n\tborder-color: #17a2b8\r\n}\r\n\r\n.btn-info:not(:disabled):not(.disabled).active,\r\n.btn-info:not(:disabled):not(.disabled):active,\r\n.show>.btn-info.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #117a8b;\r\n\tborder-color: #10707f\r\n}\r\n\r\n.btn-info:not(:disabled):not(.disabled).active:focus,\r\n.btn-info:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-info.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)\r\n}\r\n\r\n.btn-warning {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffc107;\r\n\tborder-color: #ffc107\r\n}\r\n\r\n.btn-warning:hover {\r\n\tcolor: #212529;\r\n\tbackground-color: #e0a800;\r\n\tborder-color: #d39e00\r\n}\r\n\r\n.btn-warning.focus,\r\n.btn-warning:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(255, 193, 7, .5)\r\n}\r\n\r\n.btn-warning.disabled,\r\n.btn-warning:disabled {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffc107;\r\n\tborder-color: #ffc107\r\n}\r\n\r\n.btn-warning:not(:disabled):not(.disabled).active,\r\n.btn-warning:not(:disabled):not(.disabled):active,\r\n.show>.btn-warning.dropdown-toggle {\r\n\tcolor: #212529;\r\n\tbackground-color: #d39e00;\r\n\tborder-color: #c69500\r\n}\r\n\r\n.btn-warning:not(:disabled):not(.disabled).active:focus,\r\n.btn-warning:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-warning.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(255, 193, 7, .5)\r\n}\r\n\r\n.btn-danger {\r\n\tcolor: #fff;\r\n\tbackground-color: #dc3545;\r\n\tborder-color: #dc3545\r\n}\r\n\r\n.btn-danger:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #c82333;\r\n\tborder-color: #bd2130\r\n}\r\n\r\n.btn-danger.focus,\r\n.btn-danger:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)\r\n}\r\n\r\n.btn-danger.disabled,\r\n.btn-danger:disabled {\r\n\tcolor: #fff;\r\n\tbackground-color: #dc3545;\r\n\tborder-color: #dc3545;\r\n}\r\n\r\n.btn-danger:not(:disabled):not(.disabled).active,\r\n.btn-danger:not(:disabled):not(.disabled):active,\r\n.show>.btn-danger.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #bd2130;\r\n\tborder-color: #b21f2d;\r\n}\r\n\r\n.btn-danger:not(:disabled):not(.disabled).active:focus,\r\n.btn-danger:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-danger.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)\r\n}\r\n\r\n.btn-light {\r\n\tcolor: #212529;\r\n\tbackground-color: #f8f9fa;\r\n\tborder-color: #facedd;\r\n}\r\n\r\n.btn-light:hover {\r\n\tcolor: #212529;\r\n\tbackground-color: #e2e6ea;\r\n\tborder-color: #dae0e5;\r\n}\r\n\r\n.btn-light.focus,\r\n.btn-light:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(248, 249, 250, .5)\r\n}\r\n\r\n.btn-light.disabled,\r\n.btn-light:disabled {\r\n\tcolor: #212529;\r\n\tbackground-color: #f8f9fa;\r\n\tborder-color: #f8f9fa\r\n}\r\n\r\n.btn-light:not(:disabled):not(.disabled).active,\r\n.btn-light:not(:disabled):not(.disabled):active,\r\n.show>.btn-light.dropdown-toggle {\r\n\tcolor: #212529;\r\n\tbackground-color: #dae0e5;\r\n\tborder-color: #d3d9df;\r\n}\r\n\r\n.btn-light:not(:disabled):not(.disabled).active:focus,\r\n.btn-light:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-light.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(248, 249, 250, .5)\r\n}\r\n\r\n.btn-dark {\r\n\tcolor: #fff;\r\n\tbackground-color: #343a40;\r\n\tborder-color: #343a40;\r\n}\r\n\r\n.btn-dark:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #23272b;\r\n\tborder-color: #1d2124\r\n}\r\n\r\n.btn-dark.focus,\r\n.btn-dark:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(52, 58, 64, .5)\r\n}\r\n\r\n.btn-dark.disabled,\r\n.btn-dark:disabled {\r\n\tcolor: #fff;\r\n\tbackground-color: #343a40;\r\n\tborder-color: #343a40\r\n}\r\n\r\n.btn-dark:not(:disabled):not(.disabled).active,\r\n.btn-dark:not(:disabled):not(.disabled):active,\r\n.show>.btn-dark.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #1d2124;\r\n\tborder-color: #171a1d\r\n}\r\n\r\n.btn-dark:not(:disabled):not(.disabled).active:focus,\r\n.btn-dark:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-dark.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(52, 58, 64, .5)\r\n}\r\n\r\n.btn-outline-primary {\r\n\tcolor: #007bff;\r\n\tbackground-color: transparent;\r\n\tbackground-image: none;\r\n\tborder-color: #007bff\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff;\r\n\tborder-color: #007bff\r\n}\r\n\r\n.btn-outline-primary.focus,\r\n.btn-outline-primary:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5)\r\n}\r\n\r\n.btn-outline-primary.disabled,\r\n.btn-outline-primary:disabled {\r\n\tcolor: #007bff;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-primary:not(:disabled):not(.disabled).active,\r\n.btn-outline-primary:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-primary.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff;\r\n\tborder-color: #007bff\r\n}\r\n\r\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\r\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-outline-primary.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5)\r\n}\r\n\r\n.btn-outline-secondary {\r\n\tcolor: #6c757d;\r\n\tbackground-color: transparent;\r\n\tbackground-image: none;\r\n\tborder-color: #6c757d\r\n}\r\n\r\n.btn-outline-secondary:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #6c757d;\r\n\tborder-color: #6c757d\r\n}\r\n\r\n.btn-outline-secondary.focus,\r\n.btn-outline-secondary:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(108, 117, 125, .5)\r\n}\r\n\r\n.btn-outline-secondary.disabled,\r\n.btn-outline-secondary:disabled {\r\n\tcolor: #6c757d;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-secondary.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #6c757d;\r\n\tborder-color: #6c757d\r\n}\r\n\r\n.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-outline-secondary.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(108, 117, 125, .5)\r\n}\r\n\r\n.btn-outline-success {\r\n\tcolor: #28a745;\r\n\tbackground-color: transparent;\r\n\tbackground-image: none;\r\n\tborder-color: #28a745\r\n}\r\n\r\n.btn-outline-success:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #28a745;\r\n\tborder-color: #28a745\r\n}\r\n\r\n.btn-outline-success.focus,\r\n.btn-outline-success:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(40, 167, 69, .5)\r\n}\r\n\r\n.btn-outline-success.disabled,\r\n.btn-outline-success:disabled {\r\n\tcolor: #28a745;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-success:not(:disabled):not(.disabled).active,\r\n.btn-outline-success:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-success.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #28a745;\r\n\tborder-color: #28a745\r\n}\r\n\r\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\r\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-outline-success.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(40, 167, 69, .5)\r\n}\r\n\r\n.btn-outline-info {\r\n\tcolor: #17a2b8;\r\n\tbackground-color: transparent;\r\n\tbackground-image: none;\r\n\tborder-color: #17a2b8\r\n}\r\n\r\n.btn-outline-info:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #17a2b8;\r\n\tborder-color: #17a2b8\r\n}\r\n\r\n.btn-outline-info.focus,\r\n.btn-outline-info:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)\r\n}\r\n\r\n.btn-outline-info.disabled,\r\n.btn-outline-info:disabled {\r\n\tcolor: #17a2b8;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-info:not(:disabled):not(.disabled).active,\r\n.btn-outline-info:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-info.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #17a2b8;\r\n\tborder-color: #17a2b8\r\n}\r\n\r\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\r\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-outline-info.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)\r\n}\r\n\r\n.btn-outline-warning {\r\n\tcolor: #ffc107;\r\n\tbackground-color: transparent;\r\n\tbackground-image: none;\r\n\tborder-color: #ffc107\r\n}\r\n\r\n.btn-outline-warning:hover {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffc107;\r\n\tborder-color: #ffc107\r\n}\r\n\r\n.btn-outline-warning.focus,\r\n.btn-outline-warning:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(255, 193, 7, .5)\r\n}\r\n\r\n.btn-outline-warning.disabled,\r\n.btn-outline-warning:disabled {\r\n\tcolor: #ffc107;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-warning:not(:disabled):not(.disabled).active,\r\n.btn-outline-warning:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-warning.dropdown-toggle {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffc107;\r\n\tborder-color: #ffc107\r\n}\r\n\r\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\r\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-outline-warning.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(255, 193, 7, .5)\r\n}\r\n\r\n.btn-outline-danger {\r\n\tcolor: #dc3545;\r\n\tbackground-color: transparent;\r\n\tbackground-image: none;\r\n\tborder-color: #dc3545\r\n}\r\n\r\n.btn-outline-danger:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #dc3545;\r\n\tborder-color: #dc3545\r\n}\r\n\r\n.btn-outline-danger.focus,\r\n.btn-outline-danger:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)\r\n}\r\n\r\n.btn-outline-danger.disabled,\r\n.btn-outline-danger:disabled {\r\n\tcolor: #dc3545;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-danger:not(:disabled):not(.disabled).active,\r\n.btn-outline-danger:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-danger.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #dc3545;\r\n\tborder-color: #dc3545\r\n}\r\n\r\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\r\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-outline-danger.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(220, 53, 69, .5)\r\n}\r\n\r\n.btn-outline-light {\r\n\tcolor: #f8f9fa;\r\n\tbackground-color: transparent;\r\n\tbackground-image: none;\r\n\tborder-color: #f8f9fa\r\n}\r\n\r\n.btn-outline-light:hover {\r\n\tcolor: #212529;\r\n\tbackground-color: #f8f9fa;\r\n\tborder-color: #f8f9fa\r\n}\r\n\r\n.btn-outline-light.focus,\r\n.btn-outline-light:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(248, 249, 250, .5)\r\n}\r\n\r\n.btn-outline-light.disabled,\r\n.btn-outline-light:disabled {\r\n\tcolor: #f8f9fa;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-light:not(:disabled):not(.disabled).active,\r\n.btn-outline-light:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-light.dropdown-toggle {\r\n\tcolor: #212529;\r\n\tbackground-color: #f8f9fa;\r\n\tborder-color: #f8f9fa\r\n}\r\n\r\n.btn-outline-light:not(:disabled):not(.disabled).active:focus,\r\n.btn-outline-light:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-outline-light.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(248, 249, 250, .5)\r\n}\r\n\r\n.btn-outline-dark {\r\n\tcolor: #343a40;\r\n\tbackground-color: transparent;\r\n\tbackground-image: none;\r\n\tborder-color: #343a40\r\n}\r\n\r\n.btn-outline-dark:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #343a40;\r\n\tborder-color: #343a40\r\n}\r\n\r\n.btn-outline-dark.focus,\r\n.btn-outline-dark:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(52, 58, 64, .5)\r\n}\r\n\r\n.btn-outline-dark.disabled,\r\n.btn-outline-dark:disabled {\r\n\tcolor: #343a40;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-outline-dark:not(:disabled):not(.disabled).active,\r\n.btn-outline-dark:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-dark.dropdown-toggle {\r\n\tcolor: #fff;\r\n\tbackground-color: #343a40;\r\n\tborder-color: #343a40\r\n}\r\n\r\n.btn-outline-dark:not(:disabled):not(.disabled).active:focus,\r\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-outline-dark.dropdown-toggle:focus {\r\n\tbox-shadow: 0 0 0 .2rem rgba(52, 58, 64, .5)\r\n}\r\n\r\n.btn-link {\r\n\tfont-weight: 400;\r\n\tcolor: #007bff;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.btn-link:hover {\r\n\tcolor: #0056b3;\r\n\ttext-decoration: underline;\r\n\tbackground-color: transparent;\r\n\tborder-color: transparent\r\n}\r\n\r\n.btn-link.focus,\r\n.btn-link:focus {\r\n\ttext-decoration: underline;\r\n\tborder-color: transparent;\r\n\tbox-shadow: none\r\n}\r\n\r\n.btn-link.disabled,\r\n.btn-link:disabled {\r\n\tcolor: #6c757d;\r\n\tpointer-events: none\r\n}\r\n\r\n.btn-group-lg>.btn,\r\n.btn-lg {\r\n\tpadding: .5rem 1rem;\r\n\tfont-size: 1.25rem;\r\n\tline-height: 1.5;\r\n\tborder-radius: .3rem\r\n}\r\n\r\n.btn-group-sm>.btn,\r\n.btn-sm {\r\n\tpadding: .25rem .5rem;\r\n\tfont-size: .875rem;\r\n\tline-height: 1.5;\r\n\tborder-radius: .2rem\r\n}\r\n\r\n.btn-block {\r\n\tdisplay: block;\r\n\twidth: 100%\r\n}\r\n\r\n.btn-block+.btn-block {\r\n\tmargin-top: .5rem\r\n}\r\n\r\ninput[type=button].btn-block,\r\ninput[type=reset].btn-block,\r\ninput[type=submit].btn-block {\r\n\twidth: 100%\r\n}\r\n\r\n.fade {\r\n\ttransition: opacity .15s linear\r\n}\r\n\r\n@media screen and (prefers-reduced-motion:reduce) {\r\n\t.fade {\r\n\t\ttransition: none\r\n\t}\r\n}\r\n\r\n.fade:not(.show) {\r\n\topacity: 0\r\n}\r\n\r\n.collapse:not(.show) {\r\n\tdisplay: none\r\n}\r\n\r\n.collapsing {\r\n\tposition: relative;\r\n\theight: 0;\r\n\toverflow: hidden;\r\n\ttransition: height .35s ease\r\n}\r\n\r\n@media screen and (prefers-reduced-motion:reduce) {\r\n\t.collapsing {\r\n\t\ttransition: none\r\n\t}\r\n}\r\n\r\n.dropdown,\r\n.dropleft,\r\n.dropright,\r\n.dropup {\r\n\tposition: relative\r\n}\r\n\r\n.dropdown-toggle::after {\r\n\tdisplay: inline-block;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tmargin-left: .255em;\r\n\tvertical-align: .255em;\r\n\tcontent: \"\";\r\n\tborder-top: .3em solid;\r\n\tborder-right: .3em solid transparent;\r\n\tborder-bottom: 0;\r\n\tborder-left: .3em solid transparent\r\n}\r\n\r\n.dropdown-toggle:empty::after {\r\n\tmargin-left: 0\r\n}\r\n\r\n.dropdown-menu {\r\n\tposition: absolute;\r\n\ttop: 100%;\r\n\tleft: 0;\r\n\tz-index: 1000;\r\n\tdisplay: none;\r\n\tfloat: left;\r\n\tmin-width: 10rem;\r\n\tpadding: .5rem 0;\r\n\tmargin: .125rem 0 0;\r\n\tfont-size: 1rem;\r\n\tcolor: #212529;\r\n\ttext-align: left;\r\n\tlist-style: none;\r\n\tbackground-color: #fff;\r\n\tbackground-clip: padding-box;\r\n\tborder: 1px solid rgba(0, 0, 0, .15);\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.dropdown-menu-right {\r\n\tright: 0;\r\n\tleft: auto\r\n}\r\n\r\n.dropup .dropdown-menu {\r\n\ttop: auto;\r\n\tbottom: 100%;\r\n\tmargin-top: 0;\r\n\tmargin-bottom: .125rem\r\n}\r\n\r\n.dropup .dropdown-toggle::after {\r\n\tdisplay: inline-block;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tmargin-left: .255em;\r\n\tvertical-align: .255em;\r\n\tcontent: \"\";\r\n\tborder-top: 0;\r\n\tborder-right: .3em solid transparent;\r\n\tborder-bottom: .3em solid;\r\n\tborder-left: .3em solid transparent\r\n}\r\n\r\n.dropup .dropdown-toggle:empty::after {\r\n\tmargin-left: 0\r\n}\r\n\r\n.dropright .dropdown-menu {\r\n\ttop: 0;\r\n\tright: auto;\r\n\tleft: 100%;\r\n\tmargin-top: 0;\r\n\tmargin-left: .125rem\r\n}\r\n\r\n.dropright .dropdown-toggle::after {\r\n\tdisplay: inline-block;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tmargin-left: .255em;\r\n\tvertical-align: .255em;\r\n\tcontent: \"\";\r\n\tborder-top: .3em solid transparent;\r\n\tborder-right: 0;\r\n\tborder-bottom: .3em solid transparent;\r\n\tborder-left: .3em solid\r\n}\r\n\r\n.dropright .dropdown-toggle:empty::after {\r\n\tmargin-left: 0\r\n}\r\n\r\n.dropright .dropdown-toggle::after {\r\n\tvertical-align: 0\r\n}\r\n\r\n.dropleft .dropdown-menu {\r\n\ttop: 0;\r\n\tright: 100%;\r\n\tleft: auto;\r\n\tmargin-top: 0;\r\n\tmargin-right: .125rem\r\n}\r\n\r\n.dropleft .dropdown-toggle::after {\r\n\tdisplay: inline-block;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tmargin-left: .255em;\r\n\tvertical-align: .255em;\r\n\tcontent: \"\"\r\n}\r\n\r\n.dropleft .dropdown-toggle::after {\r\n\tdisplay: none\r\n}\r\n\r\n.dropleft .dropdown-toggle::before {\r\n\tdisplay: inline-block;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tmargin-right: .255em;\r\n\tvertical-align: .255em;\r\n\tcontent: \"\";\r\n\tborder-top: .3em solid transparent;\r\n\tborder-right: .3em solid;\r\n\tborder-bottom: .3em solid transparent\r\n}\r\n\r\n.dropleft .dropdown-toggle:empty::after {\r\n\tmargin-left: 0\r\n}\r\n\r\n.dropleft .dropdown-toggle::before {\r\n\tvertical-align: 0\r\n}\r\n\r\n.dropdown-menu[x-placement^=bottom],\r\n.dropdown-menu[x-placement^=left],\r\n.dropdown-menu[x-placement^=right],\r\n.dropdown-menu[x-placement^=top] {\r\n\tright: auto;\r\n\tbottom: auto\r\n}\r\n\r\n.dropdown-divider {\r\n\theight: 0;\r\n\tmargin: .5rem 0;\r\n\toverflow: hidden;\r\n\tborder-top: 1px solid #e9ecef\r\n}\r\n\r\n.dropdown-item {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tpadding: .25rem 1.5rem;\r\n\tclear: both;\r\n\tfont-weight: 400;\r\n\tcolor: #212529;\r\n\ttext-align: inherit;\r\n\twhite-space: nowrap;\r\n\tbackground-color: transparent;\r\n\tborder: 0\r\n}\r\n\r\n.dropdown-item:focus,\r\n.dropdown-item:hover {\r\n\tcolor: #16181b;\r\n\ttext-decoration: none;\r\n\tbackground-color: #f8f9fa\r\n}\r\n\r\n.dropdown-item.active,\r\n.dropdown-item:active {\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\tbackground-color: #ec167f;\r\n}\r\n\r\n.dropdown-item.disabled,\r\n.dropdown-item:disabled {\r\n\tcolor: #6c757d;\r\n\tbackground-color: transparent\r\n}\r\n\r\n.dropdown-menu.show {\r\n\tdisplay: block\r\n}\r\n\r\n.dropdown-header {\r\n\tdisplay: block;\r\n\tpadding: .5rem 1.5rem;\r\n\tmargin-bottom: 0;\r\n\tfont-size: .875rem;\r\n\tcolor: #6c757d;\r\n\twhite-space: nowrap\r\n}\r\n\r\n.dropdown-item-text {\r\n\tdisplay: block;\r\n\tpadding: .25rem 1.5rem;\r\n\tcolor: #212529\r\n}\r\n\r\n.btn-group,\r\n.btn-group-vertical {\r\n\tposition: relative;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tvertical-align: middle\r\n}\r\n\r\n.btn-group-vertical>.btn,\r\n.btn-group>.btn {\r\n\tposition: relative;\r\n\t-ms-flex: 0 1 auto;\r\n\tflex: 0 1 auto\r\n}\r\n\r\n.btn-group-vertical>.btn:hover,\r\n.btn-group>.btn:hover {\r\n\tz-index: 1\r\n}\r\n\r\n.btn-group-vertical>.btn.active,\r\n.btn-group-vertical>.btn:active,\r\n.btn-group-vertical>.btn:focus,\r\n.btn-group>.btn.active,\r\n.btn-group>.btn:active,\r\n.btn-group>.btn:focus {\r\n\tz-index: 1\r\n}\r\n\r\n.btn-group .btn+.btn,\r\n.btn-group .btn+.btn-group,\r\n.btn-group .btn-group+.btn,\r\n.btn-group .btn-group+.btn-group,\r\n.btn-group-vertical .btn+.btn,\r\n.btn-group-vertical .btn+.btn-group,\r\n.btn-group-vertical .btn-group+.btn,\r\n.btn-group-vertical .btn-group+.btn-group {\r\n\tmargin-left: -1px\r\n}\r\n\r\n.btn-toolbar {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\t-ms-flex-pack: start;\r\n\tjustify-content: flex-start\r\n}\r\n\r\n.btn-toolbar .input-group {\r\n\twidth: auto\r\n}\r\n\r\n.btn-group>.btn:first-child {\r\n\tmargin-left: 0\r\n}\r\n\r\n.btn-group>.btn-group:not(:last-child)>.btn,\r\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle) {\r\n\tborder-top-right-radius: 0;\r\n\tborder-bottom-right-radius: 0\r\n}\r\n\r\n.btn-group>.btn-group:not(:first-child)>.btn,\r\n.btn-group>.btn:not(:first-child) {\r\n\tborder-top-left-radius: 0;\r\n\tborder-bottom-left-radius: 0\r\n}\r\n\r\n.dropdown-toggle-split {\r\n\tpadding-right: .5625rem;\r\n\tpadding-left: .5625rem\r\n}\r\n\r\n.dropdown-toggle-split::after,\r\n.dropright .dropdown-toggle-split::after,\r\n.dropup .dropdown-toggle-split::after {\r\n\tmargin-left: 0\r\n}\r\n\r\n.dropleft .dropdown-toggle-split::before {\r\n\tmargin-right: 0\r\n}\r\n\r\n.btn-group-sm>.btn+.dropdown-toggle-split,\r\n.btn-sm+.dropdown-toggle-split {\r\n\tpadding-right: .375rem;\r\n\tpadding-left: .375rem\r\n}\r\n\r\n.btn-group-lg>.btn+.dropdown-toggle-split,\r\n.btn-lg+.dropdown-toggle-split {\r\n\tpadding-right: .75rem;\r\n\tpadding-left: .75rem\r\n}\r\n\r\n.btn-group-vertical {\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\t-ms-flex-align: start;\r\n\talign-items: flex-start;\r\n\t-ms-flex-pack: center;\r\n\tjustify-content: center\r\n}\r\n\r\n.btn-group-vertical .btn,\r\n.btn-group-vertical .btn-group {\r\n\twidth: 100%\r\n}\r\n\r\n.btn-group-vertical>.btn+.btn,\r\n.btn-group-vertical>.btn+.btn-group,\r\n.btn-group-vertical>.btn-group+.btn,\r\n.btn-group-vertical>.btn-group+.btn-group {\r\n\tmargin-top: -1px;\r\n\tmargin-left: 0\r\n}\r\n\r\n.btn-group-vertical>.btn-group:not(:last-child)>.btn,\r\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle) {\r\n\tborder-bottom-right-radius: 0;\r\n\tborder-bottom-left-radius: 0\r\n}\r\n\r\n.btn-group-vertical>.btn-group:not(:first-child)>.btn,\r\n.btn-group-vertical>.btn:not(:first-child) {\r\n\tborder-top-left-radius: 0;\r\n\tborder-top-right-radius: 0\r\n}\r\n\r\n.btn-group-toggle>.btn,\r\n.btn-group-toggle>.btn-group>.btn {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.btn-group-toggle>.btn input[type=checkbox],\r\n.btn-group-toggle>.btn input[type=radio],\r\n.btn-group-toggle>.btn-group>.btn input[type=checkbox],\r\n.btn-group-toggle>.btn-group>.btn input[type=radio] {\r\n\tposition: absolute;\r\n\tclip: rect(0, 0, 0, 0);\r\n\tpointer-events: none\r\n}\r\n\r\n.input-group {\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\t-ms-flex-align: stretch;\r\n\talign-items: stretch;\r\n\twidth: 100%\r\n}\r\n\r\n.input-group>.custom-file,\r\n.input-group>.custom-select,\r\n.input-group>.form-control {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 auto;\r\n\tflex: 1 1 auto;\r\n\twidth: 1%;\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.input-group>.custom-file:focus,\r\n.input-group>.custom-select:focus,\r\n.input-group>.form-control:focus {\r\n\tz-index: 3\r\n}\r\n\r\n.input-group>.custom-file+.custom-file,\r\n.input-group>.custom-file+.custom-select,\r\n.input-group>.custom-file+.form-control,\r\n.input-group>.custom-select+.custom-file,\r\n.input-group>.custom-select+.custom-select,\r\n.input-group>.custom-select+.form-control,\r\n.input-group>.form-control+.custom-file,\r\n.input-group>.form-control+.custom-select,\r\n.input-group>.form-control+.form-control {\r\n\tmargin-left: -1px\r\n}\r\n\r\n.input-group>.custom-select:not(:last-child),\r\n.input-group>.form-control:not(:last-child) {\r\n\tborder-top-right-radius: 0;\r\n\tborder-bottom-right-radius: 0\r\n}\r\n\r\n.input-group>.custom-select:not(:first-child),\r\n.input-group>.form-control:not(:first-child) {\r\n\tborder-top-left-radius: 0;\r\n\tborder-bottom-left-radius: 0\r\n}\r\n\r\n.input-group>.custom-file {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\talign-items: center\r\n}\r\n\r\n.input-group>.custom-file:not(:last-child) .custom-file-label,\r\n.input-group>.custom-file:not(:last-child) .custom-file-label::after {\r\n\tborder-top-right-radius: 0;\r\n\tborder-bottom-right-radius: 0\r\n}\r\n\r\n.input-group>.custom-file:not(:first-child) .custom-file-label {\r\n\tborder-top-left-radius: 0;\r\n\tborder-bottom-left-radius: 0\r\n}\r\n\r\n.input-group-append,\r\n.input-group-prepend {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex\r\n}\r\n\r\n.input-group-append .btn,\r\n.input-group-prepend .btn {\r\n\tposition: relative;\r\n\tz-index: 2\r\n}\r\n\r\n.input-group-append .btn+.btn,\r\n.input-group-append .btn+.input-group-text,\r\n.input-group-append .input-group-text+.btn,\r\n.input-group-append .input-group-text+.input-group-text,\r\n.input-group-prepend .btn+.btn,\r\n.input-group-prepend .btn+.input-group-text,\r\n.input-group-prepend .input-group-text+.btn,\r\n.input-group-prepend .input-group-text+.input-group-text {\r\n\tmargin-left: -1px\r\n}\r\n\r\n.input-group-prepend {\r\n\tmargin-right: -1px\r\n}\r\n\r\n.input-group-append {\r\n\tmargin-left: -1px\r\n}\r\n\r\n.input-group-text {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tpadding: .375rem .75rem;\r\n\tmargin-bottom: 0;\r\n\tfont-size: 1rem;\r\n\tfont-weight: 400;\r\n\tline-height: 1.5;\r\n\tcolor: #495057;\r\n\ttext-align: center;\r\n\twhite-space: nowrap;\r\n\tbackground-color: #e9ecef;\r\n\tborder: 1px solid #ced4da;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.input-group-text input[type=checkbox],\r\n.input-group-text input[type=radio] {\r\n\tmargin-top: 0\r\n}\r\n\r\n.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),\r\n.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),\r\n.input-group>.input-group-append:not(:last-child)>.btn,\r\n.input-group>.input-group-append:not(:last-child)>.input-group-text,\r\n.input-group>.input-group-prepend>.btn,\r\n.input-group>.input-group-prepend>.input-group-text {\r\n\tborder-top-right-radius: 0;\r\n\tborder-bottom-right-radius: 0\r\n}\r\n\r\n.input-group>.input-group-append>.btn,\r\n.input-group>.input-group-append>.input-group-text,\r\n.input-group>.input-group-prepend:first-child>.btn:not(:first-child),\r\n.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),\r\n.input-group>.input-group-prepend:not(:first-child)>.btn,\r\n.input-group>.input-group-prepend:not(:first-child)>.input-group-text {\r\n\tborder-top-left-radius: 0;\r\n\tborder-bottom-left-radius: 0\r\n}\r\n\r\n.custom-control {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tmin-height: 1.5rem;\r\n\tpadding-left: 1.5rem\r\n}\r\n\r\n.custom-control-inline {\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tmargin-right: 1rem\r\n}\r\n\r\n.custom-control-input {\r\n\tposition: absolute;\r\n\tz-index: -1;\r\n\topacity: 0\r\n}\r\n\r\n.custom-control-input:checked~.custom-control-label::before {\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff\r\n}\r\n\r\n.custom-control-input:focus~.custom-control-label::before {\r\n\tbox-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)\r\n}\r\n\r\n.custom-control-input:active~.custom-control-label::before {\r\n\tcolor: #fff;\r\n\tbackground-color: #b3d7ff\r\n}\r\n\r\n.custom-control-input:disabled~.custom-control-label {\r\n\tcolor: #6c757d\r\n}\r\n\r\n.custom-control-input:disabled~.custom-control-label::before {\r\n\tbackground-color: #e9ecef\r\n}\r\n\r\n.custom-control-label {\r\n\tposition: relative;\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.custom-control-label::before {\r\n\tposition: absolute;\r\n\ttop: .25rem;\r\n\tleft: -1.5rem;\r\n\tdisplay: block;\r\n\twidth: 1rem;\r\n\theight: 1rem;\r\n\tpointer-events: none;\r\n\tcontent: \"\";\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\tbackground-color: #dee2e6\r\n}\r\n\r\n.custom-control-label::after {\r\n\tposition: absolute;\r\n\ttop: .25rem;\r\n\tleft: -1.5rem;\r\n\tdisplay: block;\r\n\twidth: 1rem;\r\n\theight: 1rem;\r\n\tcontent: \"\";\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: center center;\r\n\tbackground-size: 50% 50%\r\n}\r\n\r\n.custom-checkbox .custom-control-label::before {\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::before {\r\n\tbackground-color: #007bff\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::after {\r\n\tbackground-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")\r\n}\r\n\r\n.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {\r\n\tbackground-color: #007bff\r\n}\r\n\r\n.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {\r\n\tbackground-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {\r\n\tbackground-color: rgba(0, 123, 255, .5)\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {\r\n\tbackground-color: rgba(0, 123, 255, .5)\r\n}\r\n\r\n.custom-radio .custom-control-label::before {\r\n\tborder-radius: 50%\r\n}\r\n\r\n.custom-radio .custom-control-input:checked~.custom-control-label::before {\r\n\tbackground-color: #007bff\r\n}\r\n\r\n.custom-radio .custom-control-input:checked~.custom-control-label::after {\r\n\tbackground-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")\r\n}\r\n\r\n.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {\r\n\tbackground-color: rgba(0, 123, 255, .5)\r\n}\r\n\r\n.custom-select {\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n\theight: calc(2.25rem + 2px);\r\n\tpadding: .375rem 1.75rem .375rem .75rem;\r\n\tline-height: 1.5;\r\n\tcolor: #495057;\r\n\tvertical-align: middle;\r\n\tbackground: #fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;\r\n\tbackground-size: 8px 10px;\r\n\tborder: 1px solid #ced4da;\r\n\tborder-radius: .25rem;\r\n\t-webkit-appearance: none;\r\n\t-moz-appearance: none;\r\n\tappearance: none\r\n}\r\n\r\n.custom-select:focus {\r\n\tborder-color: #80bdff;\r\n\toutline: 0;\r\n\tbox-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(128, 189, 255, .5)\r\n}\r\n\r\n.custom-select:focus::-ms-value {\r\n\tcolor: #495057;\r\n\tbackground-color: #fff\r\n}\r\n\r\n.custom-select[multiple],\r\n.custom-select[size]:not([size=\"1\"]) {\r\n\theight: auto;\r\n\tpadding-right: .75rem;\r\n\tbackground-image: none\r\n}\r\n\r\n.custom-select:disabled {\r\n\tcolor: #6c757d;\r\n\tbackground-color: #e9ecef\r\n}\r\n\r\n.custom-select::-ms-expand {\r\n\topacity: 0\r\n}\r\n\r\n.custom-select-sm {\r\n\theight: calc(1.8125rem + 2px);\r\n\tpadding-top: .375rem;\r\n\tpadding-bottom: .375rem;\r\n\tfont-size: 75%\r\n}\r\n\r\n.custom-select-lg {\r\n\theight: calc(2.875rem + 2px);\r\n\tpadding-top: .375rem;\r\n\tpadding-bottom: .375rem;\r\n\tfont-size: 125%\r\n}\r\n\r\n.custom-file {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n\theight: calc(2.25rem + 2px);\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.custom-file-input {\r\n\tposition: relative;\r\n\tz-index: 2;\r\n\twidth: 100%;\r\n\theight: calc(2.25rem + 2px);\r\n\tmargin: 0;\r\n\topacity: 0\r\n}\r\n\r\n.custom-file-input:focus~.custom-file-label {\r\n\tborder-color: #80bdff;\r\n\tbox-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)\r\n}\r\n\r\n.custom-file-input:focus~.custom-file-label::after {\r\n\tborder-color: #80bdff\r\n}\r\n\r\n.custom-file-input:lang(en)~.custom-file-label::after {\r\n\tcontent: \"Browse\"\r\n}\r\n\r\n.custom-file-label {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tleft: 0;\r\n\tz-index: 1;\r\n\theight: calc(2.25rem + 2px);\r\n\tpadding: .375rem .75rem;\r\n\tline-height: 1.5;\r\n\tcolor: #495057;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #ced4da;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.custom-file-label::after {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tz-index: 3;\r\n\tdisplay: block;\r\n\theight: 2.25rem;\r\n\tpadding: .375rem .75rem;\r\n\tline-height: 1.5;\r\n\tcolor: #495057;\r\n\tcontent: \"Browse\";\r\n\tbackground-color: #e9ecef;\r\n\tborder-left: 1px solid #ced4da;\r\n\tborder-radius: 0 .25rem .25rem 0\r\n}\r\n\r\n.custom-range {\r\n\twidth: 100%;\r\n\tpadding-left: 0;\r\n\tbackground-color: transparent;\r\n\t-webkit-appearance: none;\r\n\t-moz-appearance: none;\r\n\tappearance: none\r\n}\r\n\r\n.custom-range:focus {\r\n\toutline: 0\r\n}\r\n\r\n.custom-range::-moz-focus-outer {\r\n\tborder: 0\r\n}\r\n\r\n.custom-range::-webkit-slider-thumb {\r\n\twidth: 1rem;\r\n\theight: 1rem;\r\n\tmargin-top: -.25rem;\r\n\tbackground-color: #007bff;\r\n\tborder: 0;\r\n\tborder-radius: 1rem;\r\n\t-webkit-appearance: none;\r\n\tappearance: none\r\n}\r\n\r\n.custom-range::-webkit-slider-thumb:focus {\r\n\toutline: 0;\r\n\tbox-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)\r\n}\r\n\r\n.custom-range::-webkit-slider-thumb:active {\r\n\tbackground-color: #b3d7ff\r\n}\r\n\r\n.custom-range::-webkit-slider-runnable-track {\r\n\twidth: 100%;\r\n\theight: .5rem;\r\n\tcolor: transparent;\r\n\tcursor: pointer;\r\n\tbackground-color: #dee2e6;\r\n\tborder-color: transparent;\r\n\tborder-radius: 1rem\r\n}\r\n\r\n.custom-range::-moz-range-thumb {\r\n\twidth: 1rem;\r\n\theight: 1rem;\r\n\tbackground-color: #007bff;\r\n\tborder: 0;\r\n\tborder-radius: 1rem;\r\n\t-moz-appearance: none;\r\n\tappearance: none\r\n}\r\n\r\n.custom-range::-moz-range-thumb:focus {\r\n\toutline: 0;\r\n\tbox-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)\r\n}\r\n\r\n.custom-range::-moz-range-thumb:active {\r\n\tbackground-color: #b3d7ff\r\n}\r\n\r\n.custom-range::-moz-range-track {\r\n\twidth: 100%;\r\n\theight: .5rem;\r\n\tcolor: transparent;\r\n\tcursor: pointer;\r\n\tbackground-color: #dee2e6;\r\n\tborder-color: transparent;\r\n\tborder-radius: 1rem\r\n}\r\n\r\n.custom-range::-ms-thumb {\r\n\twidth: 1rem;\r\n\theight: 1rem;\r\n\tbackground-color: #007bff;\r\n\tborder: 0;\r\n\tborder-radius: 1rem;\r\n\tappearance: none\r\n}\r\n\r\n.custom-range::-ms-thumb:focus {\r\n\toutline: 0;\r\n\tbox-shadow: 0 0 0 1px #fff, 0 0 0 .2rem rgba(0, 123, 255, .25)\r\n}\r\n\r\n.custom-range::-ms-thumb:active {\r\n\tbackground-color: #b3d7ff\r\n}\r\n\r\n.custom-range::-ms-track {\r\n\twidth: 100%;\r\n\theight: .5rem;\r\n\tcolor: transparent;\r\n\tcursor: pointer;\r\n\tbackground-color: transparent;\r\n\tborder-color: transparent;\r\n\tborder-width: .5rem\r\n}\r\n\r\n.custom-range::-ms-fill-lower {\r\n\tbackground-color: #dee2e6;\r\n\tborder-radius: 1rem\r\n}\r\n\r\n.custom-range::-ms-fill-upper {\r\n\tmargin-right: 15px;\r\n\tbackground-color: #dee2e6;\r\n\tborder-radius: 1rem\r\n}\r\n\r\n.nav {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tpadding-left: 0;\r\n\tmargin-bottom: 0;\r\n\tlist-style: none\r\n}\r\n\r\n.nav-link {\r\n\tdisplay: block;\r\n\tpadding: .5rem 1rem\r\n}\r\n\r\n.nav-link:focus,\r\n.nav-link:hover {\r\n\ttext-decoration: none\r\n}\r\n\r\n.nav-link.disabled {\r\n\tcolor: #6c757d\r\n}\r\n\r\n.nav-tabs {\r\n\tborder-bottom: 1px solid #dee2e6\r\n}\r\n\r\n.nav-tabs .nav-item {\r\n\tmargin-bottom: -1px\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n\tborder: 1px solid transparent;\r\n\tborder-top-left-radius: .25rem;\r\n\tborder-top-right-radius: .25rem\r\n}\r\n\r\n.nav-tabs .nav-link:focus,\r\n.nav-tabs .nav-link:hover {\r\n\tborder-color: #e9ecef #e9ecef #dee2e6\r\n}\r\n\r\n.nav-tabs .nav-link.disabled {\r\n\tcolor: #6c757d;\r\n\tbackground-color: transparent;\r\n\tborder-color: transparent\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link,\r\n.nav-tabs .nav-link.active {\r\n\tcolor: #495057;\r\n\tbackground-color: #fff;\r\n\tborder-color: #dee2e6 #dee2e6 #fff\r\n}\r\n\r\n.nav-tabs .dropdown-menu {\r\n\tmargin-top: -1px;\r\n\tborder-top-left-radius: 0;\r\n\tborder-top-right-radius: 0\r\n}\r\n\r\n.nav-pills .nav-link {\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.nav-pills .nav-link.active,\r\n.nav-pills .show>.nav-link {\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff\r\n}\r\n\r\n.nav-fill .nav-item {\r\n\t-ms-flex: 1 1 auto;\r\n\tflex: 1 1 auto;\r\n\ttext-align: center\r\n}\r\n\r\n.nav-justified .nav-item {\r\n\t-ms-flex-preferred-size: 0;\r\n\tflex-basis: 0;\r\n\t-ms-flex-positive: 1;\r\n\tflex-grow: 1;\r\n\ttext-align: center\r\n}\r\n\r\n.tab-content>.tab-pane {\r\n\tdisplay: none\r\n}\r\n\r\n.tab-content>.active {\r\n\tdisplay: block\r\n}\r\n\r\n.navbar {\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\t-ms-flex-pack: justify;\r\n\tjustify-content: space-between;\r\n\tpadding: .5rem 1rem\r\n}\r\n\r\n.navbar>.container,\r\n.navbar>.container-fluid {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\t-ms-flex-pack: justify;\r\n\tjustify-content: space-between\r\n}\r\n\r\n.navbar-brand {\r\n\tdisplay: inline-block;\r\n\tpadding-top: .3125rem;\r\n\tpadding-bottom: .3125rem;\r\n\tmargin-right: 1rem;\r\n\tfont-size: 1.25rem;\r\n\tline-height: inherit;\r\n\twhite-space: nowrap\r\n}\r\n\r\n.navbar-brand:focus,\r\n.navbar-brand:hover {\r\n\ttext-decoration: none\r\n}\r\n\r\n.navbar-nav {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\tpadding-left: 0;\r\n\tmargin-bottom: 0;\r\n\tlist-style: none\r\n}\r\n\r\n.navbar-nav .nav-link {\r\n\tpadding-right: 0;\r\n\tpadding-left: 0\r\n}\r\n\r\n.navbar-nav .dropdown-menu {\r\n\tposition: static;\r\n\tfloat: none\r\n}\r\n\r\n.navbar-text {\r\n\tdisplay: inline-block;\r\n\tpadding-top: .5rem;\r\n\tpadding-bottom: .5rem\r\n}\r\n\r\n.navbar-collapse {\r\n\t-ms-flex-preferred-size: 100%;\r\n\tflex-basis: 100%;\r\n\t-ms-flex-positive: 1;\r\n\tflex-grow: 1;\r\n\t-ms-flex-align: center;\r\n\talign-items: center\r\n}\r\n\r\n.navbar-toggler {\r\n\tpadding: .25rem .75rem;\r\n\tfont-size: 1.25rem;\r\n\tline-height: 1;\r\n\tbackground-color: transparent;\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.navbar-toggler:focus,\r\n.navbar-toggler:hover {\r\n\ttext-decoration: none\r\n}\r\n\r\n.navbar-toggler:not(:disabled):not(.disabled) {\r\n\tcursor: pointer\r\n}\r\n\r\n.navbar-toggler-icon {\r\n\tdisplay: inline-block;\r\n\twidth: 1.5em;\r\n\theight: 1.5em;\r\n\tvertical-align: middle;\r\n\tcontent: \"\";\r\n\tbackground: no-repeat center center;\r\n\tbackground-size: 100% 100%\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n\r\n\t.navbar-expand-sm>.container,\r\n\t.navbar-expand-sm>.container-fluid {\r\n\t\tpadding-right: 0;\r\n\t\tpadding-left: 0\r\n\t}\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.navbar-expand-sm {\r\n\t\t-ms-flex-flow: row nowrap;\r\n\t\tflex-flow: row nowrap;\r\n\t\t-ms-flex-pack: start;\r\n\t\tjustify-content: flex-start\r\n\t}\r\n\r\n\t.navbar-expand-sm .navbar-nav {\r\n\t\t-ms-flex-direction: row;\r\n\t\tflex-direction: row\r\n\t}\r\n\r\n\t.navbar-expand-sm .navbar-nav .dropdown-menu {\r\n\t\tposition: absolute\r\n\t}\r\n\r\n\t.navbar-expand-sm .navbar-nav .nav-link {\r\n\t\tpadding-right: .5rem;\r\n\t\tpadding-left: .5rem\r\n\t}\r\n\r\n\t.navbar-expand-sm>.container,\r\n\t.navbar-expand-sm>.container-fluid {\r\n\t\t-ms-flex-wrap: nowrap;\r\n\t\tflex-wrap: nowrap\r\n\t}\r\n\r\n\t.navbar-expand-sm .navbar-collapse {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important;\r\n\t\t-ms-flex-preferred-size: auto;\r\n\t\tflex-basis: auto\r\n\t}\r\n\r\n\t.navbar-expand-sm .navbar-toggler {\r\n\t\tdisplay: none\r\n\t}\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n\r\n\t.navbar-expand-md>.container,\r\n\t.navbar-expand-md>.container-fluid {\r\n\t\tpadding-right: 0;\r\n\t\tpadding-left: 0\r\n\t}\r\n}\r\n\r\n@media (min-width:768px) {\r\n\t.navbar-expand-md {\r\n\t\t-ms-flex-flow: row nowrap;\r\n\t\tflex-flow: row nowrap;\r\n\t\t-ms-flex-pack: start;\r\n\t\tjustify-content: flex-start\r\n\t}\r\n\r\n\t.navbar-expand-md .navbar-nav {\r\n\t\t-ms-flex-direction: row;\r\n\t\tflex-direction: row\r\n\t}\r\n\r\n\t.navbar-expand-md .navbar-nav .dropdown-menu {\r\n\t\tposition: absolute\r\n\t}\r\n\r\n\t.navbar-expand-md .navbar-nav .nav-link {\r\n\t\tpadding-right: .5rem;\r\n\t\tpadding-left: .5rem\r\n\t}\r\n\r\n\t.navbar-expand-md>.container,\r\n\t.navbar-expand-md>.container-fluid {\r\n\t\t-ms-flex-wrap: nowrap;\r\n\t\tflex-wrap: nowrap\r\n\t}\r\n\r\n\t.navbar-expand-md .navbar-collapse {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important;\r\n\t\t-ms-flex-preferred-size: auto;\r\n\t\tflex-basis: auto\r\n\t}\r\n\r\n\t.navbar-expand-md .navbar-toggler {\r\n\t\tdisplay: none\r\n\t}\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n\r\n\t.navbar-expand-lg>.container,\r\n\t.navbar-expand-lg>.container-fluid {\r\n\t\tpadding-right: 0;\r\n\t\tpadding-left: 0\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.navbar-expand-lg {\r\n\t\t-ms-flex-flow: row nowrap;\r\n\t\tflex-flow: row nowrap;\r\n\t\t-ms-flex-pack: start;\r\n\t\tjustify-content: flex-start\r\n\t}\r\n\r\n\t.navbar-expand-lg .navbar-nav {\r\n\t\t-ms-flex-direction: row;\r\n\t\tflex-direction: row\r\n\t}\r\n\r\n\t.navbar-expand-lg .navbar-nav .dropdown-menu {\r\n\t\tposition: absolute\r\n\t}\r\n\r\n\t.navbar-expand-lg .navbar-nav .nav-link {\r\n\t\tpadding-right: .5rem;\r\n\t\tpadding-left: .5rem\r\n\t}\r\n\r\n\t.navbar-expand-lg>.container,\r\n\t.navbar-expand-lg>.container-fluid {\r\n\t\t-ms-flex-wrap: nowrap;\r\n\t\tflex-wrap: nowrap\r\n\t}\r\n\r\n\t.navbar-expand-lg .navbar-collapse {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important;\r\n\t\t-ms-flex-preferred-size: auto;\r\n\t\tflex-basis: auto\r\n\t}\r\n\r\n\t.navbar-expand-lg .navbar-toggler {\r\n\t\tdisplay: none\r\n\t}\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n\r\n\t.navbar-expand-xl>.container,\r\n\t.navbar-expand-xl>.container-fluid {\r\n\t\tpadding-right: 0;\r\n\t\tpadding-left: 0\r\n\t}\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\t.navbar-expand-xl {\r\n\t\t-ms-flex-flow: row nowrap;\r\n\t\tflex-flow: row nowrap;\r\n\t\t-ms-flex-pack: start;\r\n\t\tjustify-content: flex-start\r\n\t}\r\n\r\n\t.navbar-expand-xl .navbar-nav {\r\n\t\t-ms-flex-direction: row;\r\n\t\tflex-direction: row\r\n\t}\r\n\r\n\t.navbar-expand-xl .navbar-nav .dropdown-menu {\r\n\t\tposition: absolute\r\n\t}\r\n\r\n\t.navbar-expand-xl .navbar-nav .nav-link {\r\n\t\tpadding-right: .5rem;\r\n\t\tpadding-left: .5rem\r\n\t}\r\n\r\n\t.navbar-expand-xl>.container,\r\n\t.navbar-expand-xl>.container-fluid {\r\n\t\t-ms-flex-wrap: nowrap;\r\n\t\tflex-wrap: nowrap\r\n\t}\r\n\r\n\t.navbar-expand-xl .navbar-collapse {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important;\r\n\t\t-ms-flex-preferred-size: auto;\r\n\t\tflex-basis: auto\r\n\t}\r\n\r\n\t.navbar-expand-xl .navbar-toggler {\r\n\t\tdisplay: none\r\n\t}\r\n}\r\n\r\n.navbar-expand {\r\n\t-ms-flex-flow: row nowrap;\r\n\tflex-flow: row nowrap;\r\n\t-ms-flex-pack: start;\r\n\tjustify-content: flex-start\r\n}\r\n\r\n.navbar-expand>.container,\r\n.navbar-expand>.container-fluid {\r\n\tpadding-right: 0;\r\n\tpadding-left: 0\r\n}\r\n\r\n.navbar-expand .navbar-nav {\r\n\t-ms-flex-direction: row;\r\n\tflex-direction: row\r\n}\r\n\r\n.navbar-expand .navbar-nav .dropdown-menu {\r\n\tposition: absolute\r\n}\r\n\r\n.navbar-expand .navbar-nav .nav-link {\r\n\tpadding-right: .5rem;\r\n\tpadding-left: .5rem\r\n}\r\n\r\n.navbar-expand>.container,\r\n.navbar-expand>.container-fluid {\r\n\t-ms-flex-wrap: nowrap;\r\n\tflex-wrap: nowrap\r\n}\r\n\r\n.navbar-expand .navbar-collapse {\r\n\tdisplay: -ms-flexbox !important;\r\n\tdisplay: flex !important;\r\n\t-ms-flex-preferred-size: auto;\r\n\tflex-basis: auto\r\n}\r\n\r\n.navbar-expand .navbar-toggler {\r\n\tdisplay: none\r\n}\r\n\r\n.navbar-light .navbar-brand {\r\n\tcolor: rgba(0, 0, 0, .9)\r\n}\r\n\r\n.navbar-light .navbar-brand:focus,\r\n.navbar-light .navbar-brand:hover {\r\n\tcolor: rgba(0, 0, 0, .9)\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link {\r\n\tcolor: rgba(0, 0, 0, .5)\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link:focus,\r\n.navbar-light .navbar-nav .nav-link:hover {\r\n\tcolor: rgba(0, 0, 0, .7)\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link.disabled {\r\n\tcolor: rgba(0, 0, 0, .3)\r\n}\r\n\r\n.navbar-light .navbar-nav .active>.nav-link,\r\n.navbar-light .navbar-nav .nav-link.active,\r\n.navbar-light .navbar-nav .nav-link.show,\r\n.navbar-light .navbar-nav .show>.nav-link {\r\n\tcolor: rgba(0, 0, 0, .9)\r\n}\r\n\r\n.navbar-light .navbar-toggler {\r\n\tcolor: rgba(0, 0, 0, .5);\r\n\tborder-color: rgba(0, 0, 0, .1)\r\n}\r\n\r\n.navbar-light .navbar-toggler-icon {\r\n\tbackground-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")\r\n}\r\n\r\n.navbar-light .navbar-text {\r\n\tcolor: rgba(0, 0, 0, .5)\r\n}\r\n\r\n.navbar-light .navbar-text a {\r\n\tcolor: rgba(0, 0, 0, .9)\r\n}\r\n\r\n.navbar-light .navbar-text a:focus,\r\n.navbar-light .navbar-text a:hover {\r\n\tcolor: rgba(0, 0, 0, .9)\r\n}\r\n\r\n.navbar-dark .navbar-brand {\r\n\tcolor: #fff\r\n}\r\n\r\n.navbar-dark .navbar-brand:focus,\r\n.navbar-dark .navbar-brand:hover {\r\n\tcolor: #fff\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link {\r\n\tcolor: rgba(255, 255, 255, .5)\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link:focus,\r\n.navbar-dark .navbar-nav .nav-link:hover {\r\n\tcolor: rgba(255, 255, 255, .75)\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link.disabled {\r\n\tcolor: rgba(255, 255, 255, .25)\r\n}\r\n\r\n.navbar-dark .navbar-nav .active>.nav-link,\r\n.navbar-dark .navbar-nav .nav-link.active,\r\n.navbar-dark .navbar-nav .nav-link.show,\r\n.navbar-dark .navbar-nav .show>.nav-link {\r\n\tcolor: #fff\r\n}\r\n\r\n.navbar-dark .navbar-toggler {\r\n\tcolor: rgba(255, 255, 255, .5);\r\n\tborder-color: rgba(255, 255, 255, .1)\r\n}\r\n\r\n.navbar-dark .navbar-toggler-icon {\r\n\tbackground-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")\r\n}\r\n\r\n.navbar-dark .navbar-text {\r\n\tcolor: rgba(255, 255, 255, .5)\r\n}\r\n\r\n.navbar-dark .navbar-text a {\r\n\tcolor: #fff\r\n}\r\n\r\n.navbar-dark .navbar-text a:focus,\r\n.navbar-dark .navbar-text a:hover {\r\n\tcolor: #fff\r\n}\r\n\r\n.card {\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\tmin-width: 0;\r\n\tword-wrap: break-word;\r\n\tbackground-color: #fff;\r\n\tbackground-clip: border-box;\r\n\tborder: 1px solid rgba(0, 0, 0, .125);\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.card>hr {\r\n\tmargin-right: 0;\r\n\tmargin-left: 0\r\n}\r\n\r\n.card>.list-group:first-child .list-group-item:first-child {\r\n\tborder-top-left-radius: .25rem;\r\n\tborder-top-right-radius: .25rem\r\n}\r\n\r\n.card>.list-group:last-child .list-group-item:last-child {\r\n\tborder-bottom-right-radius: .25rem;\r\n\tborder-bottom-left-radius: .25rem\r\n}\r\n\r\n.card-body {\r\n\t-ms-flex: 1 1 auto;\r\n\tflex: 1 1 auto;\r\n\tpadding: 1.25rem\r\n}\r\n\r\n.card-title {\r\n\tmargin-bottom: .75rem\r\n}\r\n\r\n.card-subtitle {\r\n\tmargin-top: -.375rem;\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.card-text:last-child {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.card-link:hover {\r\n\ttext-decoration: none\r\n}\r\n\r\n.card-link+.card-link {\r\n\tmargin-left: 1.25rem\r\n}\r\n\r\n.card-header {\r\n\tpadding: .75rem 1.25rem;\r\n\tmargin-bottom: 0;\r\n\tbackground-color: rgba(0, 0, 0, .03);\r\n\tborder-bottom: 1px solid rgba(0, 0, 0, .125)\r\n}\r\n\r\n.card-header:first-child {\r\n\tborder-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0\r\n}\r\n\r\n.card-header+.list-group .list-group-item:first-child {\r\n\tborder-top: 0\r\n}\r\n\r\n.card-footer {\r\n\tpadding: .75rem 1.25rem;\r\n\tbackground-color: rgba(0, 0, 0, .03);\r\n\tborder-top: 1px solid rgba(0, 0, 0, .125)\r\n}\r\n\r\n.card-footer:last-child {\r\n\tborder-radius: 0 0 calc(.25rem - 1px) calc(.25rem - 1px)\r\n}\r\n\r\n.card-header-tabs {\r\n\tmargin-right: -.625rem;\r\n\tmargin-bottom: -.75rem;\r\n\tmargin-left: -.625rem;\r\n\tborder-bottom: 0\r\n}\r\n\r\n.card-header-pills {\r\n\tmargin-right: -.625rem;\r\n\tmargin-left: -.625rem\r\n}\r\n\r\n.card-img-overlay {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tpadding: 1.25rem\r\n}\r\n\r\n.card-img {\r\n\twidth: 100%;\r\n\tborder-radius: calc(.25rem - 1px)\r\n}\r\n\r\n.card-img-top {\r\n\twidth: 100%;\r\n\tborder-top-left-radius: calc(.25rem - 1px);\r\n\tborder-top-right-radius: calc(.25rem - 1px)\r\n}\r\n\r\n.card-img-bottom {\r\n\twidth: 100%;\r\n\tborder-bottom-right-radius: calc(.25rem - 1px);\r\n\tborder-bottom-left-radius: calc(.25rem - 1px)\r\n}\r\n\r\n.card-deck {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column\r\n}\r\n\r\n.card-deck .card {\r\n\tmargin-bottom: 15px\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.card-deck {\r\n\t\t-ms-flex-flow: row wrap;\r\n\t\tflex-flow: row wrap;\r\n\t\tmargin-right: -15px;\r\n\t\tmargin-left: -15px\r\n\t}\r\n\r\n\t.card-deck .card {\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-ms-flex: 1 0 0%;\r\n\t\tflex: 1 0 0%;\r\n\t\t-ms-flex-direction: column;\r\n\t\tflex-direction: column;\r\n\t\tmargin-right: 15px;\r\n\t\tmargin-bottom: 0;\r\n\t\tmargin-left: 15px\r\n\t}\r\n}\r\n\r\n.card-group {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column\r\n}\r\n\r\n.card-group>.card {\r\n\tmargin-bottom: 15px\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.card-group {\r\n\t\t-ms-flex-flow: row wrap;\r\n\t\tflex-flow: row wrap\r\n\t}\r\n\r\n\t.card-group>.card {\r\n\t\t-ms-flex: 1 0 0%;\r\n\t\tflex: 1 0 0%;\r\n\t\tmargin-bottom: 0\r\n\t}\r\n\r\n\t.card-group>.card+.card {\r\n\t\tmargin-left: 0;\r\n\t\tborder-left: 0\r\n\t}\r\n\r\n\t.card-group>.card:first-child {\r\n\t\tborder-top-right-radius: 0;\r\n\t\tborder-bottom-right-radius: 0\r\n\t}\r\n\r\n\t.card-group>.card:first-child .card-header,\r\n\t.card-group>.card:first-child .card-img-top {\r\n\t\tborder-top-right-radius: 0\r\n\t}\r\n\r\n\t.card-group>.card:first-child .card-footer,\r\n\t.card-group>.card:first-child .card-img-bottom {\r\n\t\tborder-bottom-right-radius: 0\r\n\t}\r\n\r\n\t.card-group>.card:last-child {\r\n\t\tborder-top-left-radius: 0;\r\n\t\tborder-bottom-left-radius: 0\r\n\t}\r\n\r\n\t.card-group>.card:last-child .card-header,\r\n\t.card-group>.card:last-child .card-img-top {\r\n\t\tborder-top-left-radius: 0\r\n\t}\r\n\r\n\t.card-group>.card:last-child .card-footer,\r\n\t.card-group>.card:last-child .card-img-bottom {\r\n\t\tborder-bottom-left-radius: 0\r\n\t}\r\n\r\n\t.card-group>.card:only-child {\r\n\t\tborder-radius: .25rem\r\n\t}\r\n\r\n\t.card-group>.card:only-child .card-header,\r\n\t.card-group>.card:only-child .card-img-top {\r\n\t\tborder-top-left-radius: .25rem;\r\n\t\tborder-top-right-radius: .25rem\r\n\t}\r\n\r\n\t.card-group>.card:only-child .card-footer,\r\n\t.card-group>.card:only-child .card-img-bottom {\r\n\t\tborder-bottom-right-radius: .25rem;\r\n\t\tborder-bottom-left-radius: .25rem\r\n\t}\r\n\r\n\t.card-group>.card:not(:first-child):not(:last-child):not(:only-child) {\r\n\t\tborder-radius: 0\r\n\t}\r\n\r\n\t.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer,\r\n\t.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,\r\n\t.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,\r\n\t.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top {\r\n\t\tborder-radius: 0\r\n\t}\r\n}\r\n\r\n.card-columns .card {\r\n\tmargin-bottom: .75rem\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.card-columns {\r\n\t\t-webkit-column-count: 3;\r\n\t\t-moz-column-count: 3;\r\n\t\tcolumn-count: 3;\r\n\t\t-webkit-column-gap: 1.25rem;\r\n\t\t-moz-column-gap: 1.25rem;\r\n\t\tcolumn-gap: 1.25rem;\r\n\t\torphans: 1;\r\n\t\twidows: 1\r\n\t}\r\n\r\n\t.card-columns .card {\r\n\t\tdisplay: inline-block;\r\n\t\twidth: 100%\r\n\t}\r\n}\r\n\r\n.accordion .card:not(:first-of-type):not(:last-of-type) {\r\n\tborder-bottom: 0;\r\n\tborder-radius: 0\r\n}\r\n\r\n.accordion .card:not(:first-of-type) .card-header:first-child {\r\n\tborder-radius: 0\r\n}\r\n\r\n.accordion .card:first-of-type {\r\n\tborder-bottom: 0;\r\n\tborder-bottom-right-radius: 0;\r\n\tborder-bottom-left-radius: 0\r\n}\r\n\r\n.accordion .card:last-of-type {\r\n\tborder-top-left-radius: 0;\r\n\tborder-top-right-radius: 0\r\n}\r\n\r\n.breadcrumb {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tpadding: .75rem 1rem;\r\n\tmargin-bottom: 1rem;\r\n\tlist-style: none;\r\n\tbackground-color: #e9ecef;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item {\r\n\tpadding-left: .5rem\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n\tdisplay: inline-block;\r\n\tpadding-right: .5rem;\r\n\tcolor: #6c757d;\r\n\tcontent: \"/\"\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item:hover::before {\r\n\ttext-decoration: underline\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item:hover::before {\r\n\ttext-decoration: none\r\n}\r\n\r\n.breadcrumb-item.active {\r\n\tcolor: #6c757d\r\n}\r\n\r\n.pagination {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 0;\r\n\tlist-style: none;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.page-link {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tpadding: .5rem .75rem;\r\n\tmargin-left: -1px;\r\n\tline-height: 1.25;\r\n\tcolor: #007bff;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #dee2e6\r\n}\r\n\r\n.page-link:hover {\r\n\tz-index: 2;\r\n\tcolor: #0056b3;\r\n\ttext-decoration: none;\r\n\tbackground-color: #e9ecef;\r\n\tborder-color: #dee2e6\r\n}\r\n\r\n.page-link:focus {\r\n\tz-index: 2;\r\n\toutline: 0;\r\n\tbox-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25)\r\n}\r\n\r\n.page-link:not(:disabled):not(.disabled) {\r\n\tcursor: pointer\r\n}\r\n\r\n.page-item:first-child .page-link {\r\n\tmargin-left: 0;\r\n\tborder-top-left-radius: .25rem;\r\n\tborder-bottom-left-radius: .25rem\r\n}\r\n\r\n.page-item:last-child .page-link {\r\n\tborder-top-right-radius: .25rem;\r\n\tborder-bottom-right-radius: .25rem\r\n}\r\n\r\n.page-item.active .page-link {\r\n\tz-index: 1;\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff;\r\n\tborder-color: #007bff\r\n}\r\n\r\n.page-item.disabled .page-link {\r\n\tcolor: #6c757d;\r\n\tpointer-events: none;\r\n\tcursor: auto;\r\n\tbackground-color: #fff;\r\n\tborder-color: #dee2e6\r\n}\r\n\r\n.pagination-lg .page-link {\r\n\tpadding: .75rem 1.5rem;\r\n\tfont-size: 1.25rem;\r\n\tline-height: 1.5\r\n}\r\n\r\n.pagination-lg .page-item:first-child .page-link {\r\n\tborder-top-left-radius: .3rem;\r\n\tborder-bottom-left-radius: .3rem\r\n}\r\n\r\n.pagination-lg .page-item:last-child .page-link {\r\n\tborder-top-right-radius: .3rem;\r\n\tborder-bottom-right-radius: .3rem\r\n}\r\n\r\n.pagination-sm .page-link {\r\n\tpadding: .25rem .5rem;\r\n\tfont-size: .875rem;\r\n\tline-height: 1.5\r\n}\r\n\r\n.pagination-sm .page-item:first-child .page-link {\r\n\tborder-top-left-radius: .2rem;\r\n\tborder-bottom-left-radius: .2rem\r\n}\r\n\r\n.pagination-sm .page-item:last-child .page-link {\r\n\tborder-top-right-radius: .2rem;\r\n\tborder-bottom-right-radius: .2rem\r\n}\r\n\r\n.badge {\r\n\tdisplay: inline-block;\r\n\tpadding: .25em .4em;\r\n\tfont-size: 75%;\r\n\tfont-weight: 700;\r\n\tline-height: 1;\r\n\ttext-align: center;\r\n\twhite-space: nowrap;\r\n\tvertical-align: baseline;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.badge:empty {\r\n\tdisplay: none\r\n}\r\n\r\n.btn .badge {\r\n\tposition: relative;\r\n\ttop: -1px\r\n}\r\n\r\n.badge-pill {\r\n\tpadding-right: .6em;\r\n\tpadding-left: .6em;\r\n\tborder-radius: 10rem\r\n}\r\n\r\n.badge-primary {\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff\r\n}\r\n\r\n.badge-primary[href]:focus,\r\n.badge-primary[href]:hover {\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\tbackground-color: #0062cc\r\n}\r\n\r\n.badge-secondary {\r\n\tcolor: #fff;\r\n\tbackground-color: #6c757d\r\n}\r\n\r\n.badge-secondary[href]:focus,\r\n.badge-secondary[href]:hover {\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\tbackground-color: #545b62\r\n}\r\n\r\n.badge-success {\r\n\tcolor: #fff;\r\n\tbackground-color: #28a745\r\n}\r\n\r\n.badge-success[href]:focus,\r\n.badge-success[href]:hover {\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\tbackground-color: #1e7e34\r\n}\r\n\r\n.badge-info {\r\n\tcolor: #fff;\r\n\tbackground-color: #17a2b8\r\n}\r\n\r\n.badge-info[href]:focus,\r\n.badge-info[href]:hover {\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\tbackground-color: #117a8b\r\n}\r\n\r\n.badge-warning {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffc107\r\n}\r\n\r\n.badge-warning[href]:focus,\r\n.badge-warning[href]:hover {\r\n\tcolor: #212529;\r\n\ttext-decoration: none;\r\n\tbackground-color: #d39e00\r\n}\r\n\r\n.badge-danger {\r\n\tcolor: #fff;\r\n\tbackground-color: #dc3545\r\n}\r\n\r\n.badge-danger[href]:focus,\r\n.badge-danger[href]:hover {\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\tbackground-color: #bd2130\r\n}\r\n\r\n.badge-light {\r\n\tcolor: #212529;\r\n\tbackground-color: #f8f9fa\r\n}\r\n\r\n.badge-light[href]:focus,\r\n.badge-light[href]:hover {\r\n\tcolor: #212529;\r\n\ttext-decoration: none;\r\n\tbackground-color: #dae0e5\r\n}\r\n\r\n.badge-dark {\r\n\tcolor: #fff;\r\n\tbackground-color: #343a40\r\n}\r\n\r\n.badge-dark[href]:focus,\r\n.badge-dark[href]:hover {\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\tbackground-color: #1d2124\r\n}\r\n\r\n.jumbotron {\r\n\tpadding: 2rem 1rem;\r\n\tmargin-bottom: 2rem;\r\n\tbackground-color: #e9ecef;\r\n\tborder-radius: .3rem\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.jumbotron {\r\n\t\tpadding: 4rem 2rem\r\n\t}\r\n}\r\n\r\n.jumbotron-fluid {\r\n\tpadding-right: 0;\r\n\tpadding-left: 0;\r\n\tborder-radius: 0\r\n}\r\n\r\n.alert {\r\n\tposition: relative;\r\n\tpadding: .75rem 1.25rem;\r\n\tmargin-bottom: 1rem;\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.alert-heading {\r\n\tcolor: inherit\r\n}\r\n\r\n.alert-link {\r\n\tfont-weight: 700\r\n}\r\n\r\n.alert-dismissible {\r\n\tpadding-right: 4rem\r\n}\r\n\r\n.alert-dismissible .close {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tpadding: .75rem 1.25rem;\r\n\tcolor: inherit\r\n}\r\n\r\n.alert-primary {\r\n\tcolor: #004085;\r\n\tbackground-color: #cce5ff;\r\n\tborder-color: #b8daff\r\n}\r\n\r\n.alert-primary hr {\r\n\tborder-top-color: #9fcdff\r\n}\r\n\r\n.alert-primary .alert-link {\r\n\tcolor: #002752\r\n}\r\n\r\n.alert-secondary {\r\n\tcolor: #383d41;\r\n\tbackground-color: #e2e3e5;\r\n\tborder-color: #d6d8db\r\n}\r\n\r\n.alert-secondary hr {\r\n\tborder-top-color: #c8cbcf\r\n}\r\n\r\n.alert-secondary .alert-link {\r\n\tcolor: #202326\r\n}\r\n\r\n.alert-success {\r\n\tcolor: #155724;\r\n\tbackground-color: #d4edda;\r\n\tborder-color: #c3e6cb\r\n}\r\n\r\n.alert-success hr {\r\n\tborder-top-color: #b1dfbb\r\n}\r\n\r\n.alert-success .alert-link {\r\n\tcolor: #0b2e13\r\n}\r\n\r\n.alert-info {\r\n\tcolor: #0c5460;\r\n\tbackground-color: #d1ecf1;\r\n\tborder-color: #bee5eb\r\n}\r\n\r\n.alert-info hr {\r\n\tborder-top-color: #abdde5\r\n}\r\n\r\n.alert-info .alert-link {\r\n\tcolor: #062c33\r\n}\r\n\r\n.alert-warning {\r\n\tcolor: #856404;\r\n\tbackground-color: #fff3cd;\r\n\tborder-color: #ffeeba\r\n}\r\n\r\n.close {\r\n\tcolor: #fff;\r\n\topacity: 20;\r\n}\r\n\r\n.alert-warning hr {\r\n\tborder-top-color: #ffe8a1\r\n}\r\n\r\n.alert-warning .alert-link {\r\n\tcolor: #533f03\r\n}\r\n\r\n.alert-danger {\r\n\tcolor: #721c24;\r\n\tbackground-color: #f8d7da;\r\n\tborder-color: #f5c6cb\r\n}\r\n\r\n.alert-danger hr {\r\n\tborder-top-color: #f1b0b7\r\n}\r\n\r\n.alert-danger .alert-link {\r\n\tcolor: #491217\r\n}\r\n\r\n.alert-light {\r\n\tcolor: #818182;\r\n\tbackground-color: #fefefe;\r\n\tborder-color: #fdfdfe\r\n}\r\n\r\n.alert-light hr {\r\n\tborder-top-color: #ececf6\r\n}\r\n\r\n.alert-light .alert-link {\r\n\tcolor: #686868\r\n}\r\n\r\n.alert-dark {\r\n\tcolor: #1b1e21;\r\n\tbackground-color: #d6d8d9;\r\n\tborder-color: #c6c8ca\r\n}\r\n\r\n.alert-dark hr {\r\n\tborder-top-color: #b9bbbe\r\n}\r\n\r\n.alert-dark .alert-link {\r\n\tcolor: #040505\r\n}\r\n\r\n@-webkit-keyframes progress-bar-stripes {\r\n\tfrom {\r\n\t\tbackground-position: 1rem 0\r\n\t}\r\n\r\n\tto {\r\n\t\tbackground-position: 0 0\r\n\t}\r\n}\r\n\r\n@keyframes progress-bar-stripes {\r\n\tfrom {\r\n\t\tbackground-position: 1rem 0\r\n\t}\r\n\r\n\tto {\r\n\t\tbackground-position: 0 0\r\n\t}\r\n}\r\n\r\n.progress {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\theight: 1rem;\r\n\toverflow: hidden;\r\n\tfont-size: .75rem;\r\n\tbackground-color: #e9ecef;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.progress-bar {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\t-ms-flex-pack: center;\r\n\tjustify-content: center;\r\n\tcolor: #fff;\r\n\ttext-align: center;\r\n\twhite-space: nowrap;\r\n\tbackground-color: #007bff;\r\n\ttransition: width .6s ease\r\n}\r\n\r\n@media screen and (prefers-reduced-motion:reduce) {\r\n\t.progress-bar {\r\n\t\ttransition: none\r\n\t}\r\n}\r\n\r\n.progress-bar-striped {\r\n\tbackground-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n\tbackground-size: 1rem 1rem\r\n}\r\n\r\n.progress-bar-animated {\r\n\t-webkit-animation: progress-bar-stripes 1s linear infinite;\r\n\tanimation: progress-bar-stripes 1s linear infinite\r\n}\r\n\r\n.media {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: start;\r\n\talign-items: flex-start\r\n}\r\n\r\n.media-body {\r\n\t-ms-flex: 1;\r\n\tflex: 1\r\n}\r\n\r\n.list-group {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\tpadding-left: 0;\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.list-group-item-action {\r\n\twidth: 100%;\r\n\tcolor: #495057;\r\n\ttext-align: inherit\r\n}\r\n\r\n.list-group-item-action:focus,\r\n.list-group-item-action:hover {\r\n\tcolor: #495057;\r\n\ttext-decoration: none;\r\n\tbackground-color: #f8f9fa\r\n}\r\n\r\n.list-group-item-action:active {\r\n\tcolor: #212529;\r\n\tbackground-color: #e9ecef\r\n}\r\n\r\n.list-group-item {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tpadding: .75rem 1.25rem;\r\n\tmargin-bottom: -1px;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid rgba(0, 0, 0, .125)\r\n}\r\n\r\n.list-group-item:first-child {\r\n\tborder-top-left-radius: .25rem;\r\n\tborder-top-right-radius: .25rem\r\n}\r\n\r\n.list-group-item:last-child {\r\n\tmargin-bottom: 0;\r\n\tborder-bottom-right-radius: .25rem;\r\n\tborder-bottom-left-radius: .25rem\r\n}\r\n\r\n.list-group-item:focus,\r\n.list-group-item:hover {\r\n\tz-index: 1;\r\n\ttext-decoration: none\r\n}\r\n\r\n.list-group-item.disabled,\r\n.list-group-item:disabled {\r\n\tcolor: #6c757d;\r\n\tbackground-color: #fff\r\n}\r\n\r\n.list-group-item.active {\r\n\tz-index: 2;\r\n\tcolor: #fff;\r\n\tbackground-color: #007bff;\r\n\tborder-color: #007bff\r\n}\r\n\r\n.list-group-flush .list-group-item {\r\n\tborder-right: 0;\r\n\tborder-left: 0;\r\n\tborder-radius: 0\r\n}\r\n\r\n.list-group-flush:first-child .list-group-item:first-child {\r\n\tborder-top: 0\r\n}\r\n\r\n.list-group-flush:last-child .list-group-item:last-child {\r\n\tborder-bottom: 0\r\n}\r\n\r\n.list-group-item-primary {\r\n\tcolor: #004085;\r\n\tbackground-color: #b8daff\r\n}\r\n\r\n.list-group-item-primary.list-group-item-action:focus,\r\n.list-group-item-primary.list-group-item-action:hover {\r\n\tcolor: #004085;\r\n\tbackground-color: #9fcdff\r\n}\r\n\r\n.list-group-item-primary.list-group-item-action.active {\r\n\tcolor: #fff;\r\n\tbackground-color: #004085;\r\n\tborder-color: #004085\r\n}\r\n\r\n.list-group-item-secondary {\r\n\tcolor: #383d41;\r\n\tbackground-color: #d6d8db\r\n}\r\n\r\n.list-group-item-secondary.list-group-item-action:focus,\r\n.list-group-item-secondary.list-group-item-action:hover {\r\n\tcolor: #383d41;\r\n\tbackground-color: #c8cbcf\r\n}\r\n\r\n.list-group-item-secondary.list-group-item-action.active {\r\n\tcolor: #fff;\r\n\tbackground-color: #383d41;\r\n\tborder-color: #383d41\r\n}\r\n\r\n.list-group-item-success {\r\n\tcolor: #155724;\r\n\tbackground-color: #c3e6cb\r\n}\r\n\r\n.list-group-item-success.list-group-item-action:focus,\r\n.list-group-item-success.list-group-item-action:hover {\r\n\tcolor: #155724;\r\n\tbackground-color: #b1dfbb\r\n}\r\n\r\n.list-group-item-success.list-group-item-action.active {\r\n\tcolor: #fff;\r\n\tbackground-color: #155724;\r\n\tborder-color: #155724\r\n}\r\n\r\n.list-group-item-info {\r\n\tcolor: #0c5460;\r\n\tbackground-color: #bee5eb\r\n}\r\n\r\n.list-group-item-info.list-group-item-action:focus,\r\n.list-group-item-info.list-group-item-action:hover {\r\n\tcolor: #0c5460;\r\n\tbackground-color: #abdde5\r\n}\r\n\r\n.list-group-item-info.list-group-item-action.active {\r\n\tcolor: #fff;\r\n\tbackground-color: #0c5460;\r\n\tborder-color: #0c5460\r\n}\r\n\r\n.list-group-item-warning {\r\n\tcolor: #856404;\r\n\tbackground-color: #ffeeba\r\n}\r\n\r\n.list-group-item-warning.list-group-item-action:focus,\r\n.list-group-item-warning.list-group-item-action:hover {\r\n\tcolor: #856404;\r\n\tbackground-color: #ffe8a1\r\n}\r\n\r\n.list-group-item-warning.list-group-item-action.active {\r\n\tcolor: #fff;\r\n\tbackground-color: #856404;\r\n\tborder-color: #856404\r\n}\r\n\r\n.list-group-item-danger {\r\n\tcolor: #721c24;\r\n\tbackground-color: #f5c6cb\r\n}\r\n\r\n.list-group-item-danger.list-group-item-action:focus,\r\n.list-group-item-danger.list-group-item-action:hover {\r\n\tcolor: #721c24;\r\n\tbackground-color: #f1b0b7\r\n}\r\n\r\n.list-group-item-danger.list-group-item-action.active {\r\n\tcolor: #fff;\r\n\tbackground-color: #721c24;\r\n\tborder-color: #721c24\r\n}\r\n\r\n.list-group-item-light {\r\n\tcolor: #818182;\r\n\tbackground-color: #fdfdfe\r\n}\r\n\r\n.list-group-item-light.list-group-item-action:focus,\r\n.list-group-item-light.list-group-item-action:hover {\r\n\tcolor: #818182;\r\n\tbackground-color: #ececf6\r\n}\r\n\r\n.list-group-item-light.list-group-item-action.active {\r\n\tcolor: #fff;\r\n\tbackground-color: #818182;\r\n\tborder-color: #818182\r\n}\r\n\r\n.list-group-item-dark {\r\n\tcolor: #1b1e21;\r\n\tbackground-color: #c6c8ca\r\n}\r\n\r\n.list-group-item-dark.list-group-item-action:focus,\r\n.list-group-item-dark.list-group-item-action:hover {\r\n\tcolor: #1b1e21;\r\n\tbackground-color: #b9bbbe\r\n}\r\n\r\n.list-group-item-dark.list-group-item-action.active {\r\n\tcolor: #fff;\r\n\tbackground-color: #1b1e21;\r\n\tborder-color: #1b1e21\r\n}\r\n\r\n.close {\r\n\tfloat: right;\r\n\tfont-size: 1.5rem;\r\n\tfont-weight: 700;\r\n\tline-height: 1;\r\n\tcolor: #000;\r\n\ttext-shadow: 0 1px 0 #fff;\r\n\topacity: .5\r\n}\r\n\r\n.close:focus,\r\n.close:hover {\r\n\tcolor: #000;\r\n\ttext-decoration: none;\r\n\topacity: .75\r\n}\r\n\r\n.close:not(:disabled):not(.disabled) {\r\n\tcursor: pointer\r\n}\r\n\r\nbutton.close {\r\n\tpadding: 0;\r\n\tbackground-color: transparent;\r\n\tborder: 0;\r\n\t-webkit-appearance: none\r\n}\r\n\r\n.modal-open {\r\n\toverflow: hidden\r\n}\r\n\r\n.modal {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tz-index: 1050;\r\n\tdisplay: none;\r\n\toverflow: hidden;\r\n\toutline: 0\r\n}\r\n\r\n.modal-open .modal {\r\n\toverflow-x: hidden;\r\n\toverflow-y: auto\r\n}\r\n\r\n.modal-dialog {\r\n\tposition: relative;\r\n\twidth: auto;\r\n\tmargin: .5rem;\r\n\tpointer-events: none\r\n}\r\n\r\n.modal.fade .modal-dialog {\r\n\ttransition: -webkit-transform .3s ease-out;\r\n\ttransition: transform .3s ease-out;\r\n\ttransition: transform .3s ease-out, -webkit-transform .3s ease-out;\r\n\t-webkit-transform: translate(0, -25%);\r\n\ttransform: translate(0, -25%)\r\n}\r\n\r\n@media screen and (prefers-reduced-motion:reduce) {\r\n\t.modal.fade .modal-dialog {\r\n\t\ttransition: none\r\n\t}\r\n}\r\n\r\n.modal.show .modal-dialog {\r\n\t-webkit-transform: translate(0, 0);\r\n\ttransform: translate(0, 0)\r\n}\r\n\r\n.modal-dialog-centered {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tmin-height: calc(100% - (.5rem * 2))\r\n}\r\n\r\n.modal-content {\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\twidth: 100%;\r\n\tpointer-events: auto;\r\n\tbackground-color: #fff;\r\n\tbackground-clip: padding-box;\r\n\tborder: 1px solid rgba(0, 0, 0, .2);\r\n\tborder-radius: .3rem;\r\n\toutline: 0\r\n}\r\n\r\n.modal-backdrop {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tz-index: 1040;\r\n\tbackground-color: #000\r\n}\r\n\r\n.modal-backdrop.fade {\r\n\topacity: 0\r\n}\r\n\r\n.modal-backdrop.show {\r\n\topacity: .5\r\n}\r\n\r\n.modal-header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: start;\r\n\talign-items: flex-start;\r\n\t-ms-flex-pack: justify;\r\n\tjustify-content: space-between;\r\n\tpadding: 1rem;\r\n\tborder-bottom: 1px solid #e9ecef;\r\n\tborder-top-left-radius: .3rem;\r\n\tborder-top-right-radius: .3rem\r\n}\r\n\r\n.modal-header .close {\r\n\tpadding: 1rem;\r\n\tmargin: -1rem -1rem -1rem auto\r\n}\r\n\r\n.modal-title {\r\n\tmargin-bottom: 0;\r\n\tline-height: 1.5\r\n}\r\n\r\n.modal-body {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 auto;\r\n\tflex: 1 1 auto;\r\n\tpadding: 1rem\r\n}\r\n\r\n.modal-footer {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\t-ms-flex-pack: end;\r\n\tjustify-content: flex-end;\r\n\tpadding: 1rem;\r\n\tborder-top: 1px solid #e9ecef\r\n}\r\n\r\n.modal-footer>:not(:first-child) {\r\n\tmargin-left: .25rem\r\n}\r\n\r\n.modal-footer>:not(:last-child) {\r\n\tmargin-right: .25rem\r\n}\r\n\r\n.modal-scrollbar-measure {\r\n\tposition: absolute;\r\n\ttop: -9999px;\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\toverflow: scroll\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.modal-dialog {\r\n\t\tmax-width: 500px;\r\n\t\tmargin: 1.75rem auto\r\n\t}\r\n\r\n\t.modal-dialog-centered {\r\n\t\tmin-height: calc(100% - (1.75rem * 2))\r\n\t}\r\n\r\n\t.modal-sm {\r\n\t\tmax-width: 300px\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.modal-lg {\r\n\t\tmax-width: 800px\r\n\t}\r\n}\r\n\r\n.tooltip {\r\n\tposition: absolute;\r\n\tz-index: 1070;\r\n\tdisplay: block;\r\n\tmargin: 0;\r\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\r\n\tfont-style: normal;\r\n\tfont-weight: 400;\r\n\tline-height: 1.5;\r\n\ttext-align: left;\r\n\ttext-align: start;\r\n\ttext-decoration: none;\r\n\ttext-shadow: none;\r\n\ttext-transform: none;\r\n\tletter-spacing: normal;\r\n\tword-break: normal;\r\n\tword-spacing: normal;\r\n\twhite-space: normal;\r\n\tline-break: auto;\r\n\tfont-size: .875rem;\r\n\tword-wrap: break-word;\r\n\topacity: 0\r\n}\r\n\r\n.tooltip.show {\r\n\topacity: .9\r\n}\r\n\r\n.tooltip .arrow {\r\n\tposition: absolute;\r\n\tdisplay: block;\r\n\twidth: .8rem;\r\n\theight: .4rem\r\n}\r\n\r\n.tooltip .arrow::before {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\tborder-color: transparent;\r\n\tborder-style: solid\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=top],\r\n.bs-tooltip-top {\r\n\tpadding: .4rem 0\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=top] .arrow,\r\n.bs-tooltip-top .arrow {\r\n\tbottom: 0\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=top] .arrow::before,\r\n.bs-tooltip-top .arrow::before {\r\n\ttop: 0;\r\n\tborder-width: .4rem .4rem 0;\r\n\tborder-top-color: #000\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=right],\r\n.bs-tooltip-right {\r\n\tpadding: 0 .4rem\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=right] .arrow,\r\n.bs-tooltip-right .arrow {\r\n\tleft: 0;\r\n\twidth: .4rem;\r\n\theight: .8rem\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=right] .arrow::before,\r\n.bs-tooltip-right .arrow::before {\r\n\tright: 0;\r\n\tborder-width: .4rem .4rem .4rem 0;\r\n\tborder-right-color: #000\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=bottom],\r\n.bs-tooltip-bottom {\r\n\tpadding: .4rem 0\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=bottom] .arrow,\r\n.bs-tooltip-bottom .arrow {\r\n\ttop: 0\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=bottom] .arrow::before,\r\n.bs-tooltip-bottom .arrow::before {\r\n\tbottom: 0;\r\n\tborder-width: 0 .4rem .4rem;\r\n\tborder-bottom-color: #000\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=left],\r\n.bs-tooltip-left {\r\n\tpadding: 0 .4rem\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=left] .arrow,\r\n.bs-tooltip-left .arrow {\r\n\tright: 0;\r\n\twidth: .4rem;\r\n\theight: .8rem\r\n}\r\n\r\n.bs-tooltip-auto[x-placement^=left] .arrow::before,\r\n.bs-tooltip-left .arrow::before {\r\n\tleft: 0;\r\n\tborder-width: .4rem 0 .4rem .4rem;\r\n\tborder-left-color: #000\r\n}\r\n\r\n.tooltip-inner {\r\n\tmax-width: 200px;\r\n\tpadding: .25rem .5rem;\r\n\tcolor: #fff;\r\n\ttext-align: center;\r\n\tbackground-color: #000;\r\n\tborder-radius: .25rem\r\n}\r\n\r\n.popover {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tz-index: 1060;\r\n\tdisplay: block;\r\n\tmax-width: 276px;\r\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\r\n\tfont-style: normal;\r\n\tfont-weight: 400;\r\n\tline-height: 1.5;\r\n\ttext-align: left;\r\n\ttext-align: start;\r\n\ttext-decoration: none;\r\n\ttext-shadow: none;\r\n\ttext-transform: none;\r\n\tletter-spacing: normal;\r\n\tword-break: normal;\r\n\tword-spacing: normal;\r\n\twhite-space: normal;\r\n\tline-break: auto;\r\n\tfont-size: .875rem;\r\n\tword-wrap: break-word;\r\n\tbackground-color: #fff;\r\n\tbackground-clip: padding-box;\r\n\tborder: 1px solid rgba(0, 0, 0, .2);\r\n\tborder-radius: .3rem\r\n}\r\n\r\n.popover .arrow {\r\n\tposition: absolute;\r\n\tdisplay: block;\r\n\twidth: 1rem;\r\n\theight: .5rem;\r\n\tmargin: 0 .3rem\r\n}\r\n\r\n.popover .arrow::after,\r\n.popover .arrow::before {\r\n\tposition: absolute;\r\n\tdisplay: block;\r\n\tcontent: \"\";\r\n\tborder-color: transparent;\r\n\tborder-style: solid\r\n}\r\n\r\n.bs-popover-auto[x-placement^=top],\r\n.bs-popover-top {\r\n\tmargin-bottom: .5rem\r\n}\r\n\r\n.bs-popover-auto[x-placement^=top] .arrow,\r\n.bs-popover-top .arrow {\r\n\tbottom: calc((.5rem + 1px) * -1)\r\n}\r\n\r\n.bs-popover-auto[x-placement^=top] .arrow::after,\r\n.bs-popover-auto[x-placement^=top] .arrow::before,\r\n.bs-popover-top .arrow::after,\r\n.bs-popover-top .arrow::before {\r\n\tborder-width: .5rem .5rem 0\r\n}\r\n\r\n.bs-popover-auto[x-placement^=top] .arrow::before,\r\n.bs-popover-top .arrow::before {\r\n\tbottom: 0;\r\n\tborder-top-color: rgba(0, 0, 0, .25)\r\n}\r\n\r\n.bs-popover-auto[x-placement^=top] .arrow::after,\r\n.bs-popover-top .arrow::after {\r\n\tbottom: 1px;\r\n\tborder-top-color: #fff\r\n}\r\n\r\n.bs-popover-auto[x-placement^=right],\r\n.bs-popover-right {\r\n\tmargin-left: .5rem\r\n}\r\n\r\n.bs-popover-auto[x-placement^=right] .arrow,\r\n.bs-popover-right .arrow {\r\n\tleft: calc((.5rem + 1px) * -1);\r\n\twidth: .5rem;\r\n\theight: 1rem;\r\n\tmargin: .3rem 0\r\n}\r\n\r\n.bs-popover-auto[x-placement^=right] .arrow::after,\r\n.bs-popover-auto[x-placement^=right] .arrow::before,\r\n.bs-popover-right .arrow::after,\r\n.bs-popover-right .arrow::before {\r\n\tborder-width: .5rem .5rem .5rem 0\r\n}\r\n\r\n.bs-popover-auto[x-placement^=right] .arrow::before,\r\n.bs-popover-right .arrow::before {\r\n\tleft: 0;\r\n\tborder-right-color: rgba(0, 0, 0, .25)\r\n}\r\n\r\n.bs-popover-auto[x-placement^=right] .arrow::after,\r\n.bs-popover-right .arrow::after {\r\n\tleft: 1px;\r\n\tborder-right-color: #fff\r\n}\r\n\r\n.bs-popover-auto[x-placement^=bottom],\r\n.bs-popover-bottom {\r\n\tmargin-top: .5rem\r\n}\r\n\r\n.bs-popover-auto[x-placement^=bottom] .arrow,\r\n.bs-popover-bottom .arrow {\r\n\ttop: calc((.5rem + 1px) * -1)\r\n}\r\n\r\n.bs-popover-auto[x-placement^=bottom] .arrow::after,\r\n.bs-popover-auto[x-placement^=bottom] .arrow::before,\r\n.bs-popover-bottom .arrow::after,\r\n.bs-popover-bottom .arrow::before {\r\n\tborder-width: 0 .5rem .5rem .5rem\r\n}\r\n\r\n.bs-popover-auto[x-placement^=bottom] .arrow::before,\r\n.bs-popover-bottom .arrow::before {\r\n\ttop: 0;\r\n\tborder-bottom-color: rgba(0, 0, 0, .25)\r\n}\r\n\r\n.bs-popover-auto[x-placement^=bottom] .arrow::after,\r\n.bs-popover-bottom .arrow::after {\r\n\ttop: 1px;\r\n\tborder-bottom-color: #fff\r\n}\r\n\r\n.bs-popover-auto[x-placement^=bottom] .popover-header::before,\r\n.bs-popover-bottom .popover-header::before {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 50%;\r\n\tdisplay: block;\r\n\twidth: 1rem;\r\n\tmargin-left: -.5rem;\r\n\tcontent: \"\";\r\n\tborder-bottom: 1px solid #f7f7f7\r\n}\r\n\r\n.bs-popover-auto[x-placement^=left],\r\n.bs-popover-left {\r\n\tmargin-right: .5rem\r\n}\r\n\r\n.bs-popover-auto[x-placement^=left] .arrow,\r\n.bs-popover-left .arrow {\r\n\tright: calc((.5rem + 1px) * -1);\r\n\twidth: .5rem;\r\n\theight: 1rem;\r\n\tmargin: .3rem 0\r\n}\r\n\r\n.bs-popover-auto[x-placement^=left] .arrow::after,\r\n.bs-popover-auto[x-placement^=left] .arrow::before,\r\n.bs-popover-left .arrow::after,\r\n.bs-popover-left .arrow::before {\r\n\tborder-width: .5rem 0 .5rem .5rem\r\n}\r\n\r\n.bs-popover-auto[x-placement^=left] .arrow::before,\r\n.bs-popover-left .arrow::before {\r\n\tright: 0;\r\n\tborder-left-color: rgba(0, 0, 0, .25)\r\n}\r\n\r\n.bs-popover-auto[x-placement^=left] .arrow::after,\r\n.bs-popover-left .arrow::after {\r\n\tright: 1px;\r\n\tborder-left-color: #fff\r\n}\r\n\r\n.popover-header {\r\n\tpadding: .5rem .75rem;\r\n\tmargin-bottom: 0;\r\n\tfont-size: 1rem;\r\n\tcolor: inherit;\r\n\tbackground-color: #f7f7f7;\r\n\tborder-bottom: 1px solid #ebebeb;\r\n\tborder-top-left-radius: calc(.3rem - 1px);\r\n\tborder-top-right-radius: calc(.3rem - 1px)\r\n}\r\n\r\n.popover-header:empty {\r\n\tdisplay: none\r\n}\r\n\r\n.popover-body {\r\n\tpadding: .5rem .75rem;\r\n\tcolor: #212529\r\n}\r\n\r\n.carousel {\r\n\tposition: relative\r\n}\r\n\r\n.carousel-inner {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\toverflow: hidden\r\n}\r\n\r\n.carousel-item {\r\n\tposition: relative;\r\n\tdisplay: none;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\twidth: 100%;\r\n\ttransition: -webkit-transform .6s ease;\r\n\ttransition: transform .6s ease;\r\n\ttransition: transform .6s ease, -webkit-transform .6s ease;\r\n\t-webkit-backface-visibility: hidden;\r\n\tbackface-visibility: hidden;\r\n\t-webkit-perspective: 1000px;\r\n\tperspective: 1000px\r\n}\r\n\r\n@media screen and (prefers-reduced-motion:reduce) {\r\n\t.carousel-item {\r\n\t\ttransition: none\r\n\t}\r\n}\r\n\r\n.carousel-item-next,\r\n.carousel-item-prev,\r\n.carousel-item.active {\r\n\tdisplay: block\r\n}\r\n\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n\tposition: absolute;\r\n\ttop: 0\r\n}\r\n\r\n.carousel-item-next.carousel-item-left,\r\n.carousel-item-prev.carousel-item-right {\r\n\t-webkit-transform: translateX(0);\r\n\ttransform: translateX(0)\r\n}\r\n\r\n@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)) {\r\n\r\n\t.carousel-item-next.carousel-item-left,\r\n\t.carousel-item-prev.carousel-item-right {\r\n\t\t-webkit-transform: translate3d(0, 0, 0);\r\n\t\ttransform: translate3d(0, 0, 0)\r\n\t}\r\n}\r\n\r\n.active.carousel-item-right,\r\n.carousel-item-next {\r\n\t-webkit-transform: translateX(100%);\r\n\ttransform: translateX(100%)\r\n}\r\n\r\n@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)) {\r\n\r\n\t.active.carousel-item-right,\r\n\t.carousel-item-next {\r\n\t\t-webkit-transform: translate3d(100%, 0, 0);\r\n\t\ttransform: translate3d(100%, 0, 0)\r\n\t}\r\n}\r\n\r\n.active.carousel-item-left,\r\n.carousel-item-prev {\r\n\t-webkit-transform: translateX(-100%);\r\n\ttransform: translateX(-100%)\r\n}\r\n\r\n@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)) {\r\n\r\n\t.active.carousel-item-left,\r\n\t.carousel-item-prev {\r\n\t\t-webkit-transform: translate3d(-100%, 0, 0);\r\n\t\ttransform: translate3d(-100%, 0, 0)\r\n\t}\r\n}\r\n\r\n.carousel-fade .carousel-item {\r\n\topacity: 0;\r\n\ttransition-duration: .6s;\r\n\ttransition-property: opacity\r\n}\r\n\r\n.carousel-fade .carousel-item-next.carousel-item-left,\r\n.carousel-fade .carousel-item-prev.carousel-item-right,\r\n.carousel-fade .carousel-item.active {\r\n\topacity: 1\r\n}\r\n\r\n.carousel-fade .active.carousel-item-left,\r\n.carousel-fade .active.carousel-item-right {\r\n\topacity: 0\r\n}\r\n\r\n.carousel-fade .active.carousel-item-left,\r\n.carousel-fade .active.carousel-item-prev,\r\n.carousel-fade .carousel-item-next,\r\n.carousel-fade .carousel-item-prev,\r\n.carousel-fade .carousel-item.active {\r\n\t-webkit-transform: translateX(0);\r\n\ttransform: translateX(0)\r\n}\r\n\r\n@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)) {\r\n\r\n\t.carousel-fade .active.carousel-item-left,\r\n\t.carousel-fade .active.carousel-item-prev,\r\n\t.carousel-fade .carousel-item-next,\r\n\t.carousel-fade .carousel-item-prev,\r\n\t.carousel-fade .carousel-item.active {\r\n\t\t-webkit-transform: translate3d(0, 0, 0);\r\n\t\ttransform: translate3d(0, 0, 0)\r\n\t}\r\n}\r\n\r\n.carousel-control-next,\r\n.carousel-control-prev {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\t-ms-flex-pack: center;\r\n\tjustify-content: center;\r\n\twidth: 15%;\r\n\tcolor: #fff;\r\n\ttext-align: center;\r\n\topacity: .5\r\n}\r\n\r\n.carousel-control-next:focus,\r\n.carousel-control-next:hover,\r\n.carousel-control-prev:focus,\r\n.carousel-control-prev:hover {\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\toutline: 0;\r\n\topacity: .9\r\n}\r\n\r\n.carousel-control-prev {\r\n\tleft: 0\r\n}\r\n\r\n.carousel-control-next {\r\n\tright: 0\r\n}\r\n\r\n.carousel-control-next-icon,\r\n.carousel-control-prev-icon {\r\n\tdisplay: inline-block;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tbackground: transparent no-repeat center center;\r\n\tbackground-size: 100% 100%\r\n}\r\n\r\n.carousel-control-prev-icon {\r\n\tbackground-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\")\r\n}\r\n\r\n.carousel-control-next-icon {\r\n\tbackground-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\")\r\n}\r\n\r\n.carousel-indicators {\r\n\tposition: absolute;\r\n\tright: 0;\r\n\tbottom: 10px;\r\n\tleft: 0;\r\n\tz-index: 15;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\tjustify-content: center;\r\n\tpadding-left: 0;\r\n\tmargin-right: 15%;\r\n\tmargin-left: 15%;\r\n\tlist-style: none\r\n}\r\n\r\n.carousel-indicators li {\r\n\tposition: relative;\r\n\t-ms-flex: 0 1 auto;\r\n\tflex: 0 1 auto;\r\n\twidth: 30px;\r\n\theight: 3px;\r\n\tmargin-right: 3px;\r\n\tmargin-left: 3px;\r\n\ttext-indent: -999px;\r\n\tcursor: pointer;\r\n\tbackground-color: rgba(255, 255, 255, .5)\r\n}\r\n\r\n.pointer {\r\n\tcursor: pointer;\r\n}\r\n\r\n.carousel-indicators li::before {\r\n\tposition: absolute;\r\n\ttop: -10px;\r\n\tleft: 0;\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n\theight: 10px;\r\n\tcontent: \"\"\r\n}\r\n\r\n.carousel-indicators li::after {\r\n\tposition: absolute;\r\n\tbottom: -10px;\r\n\tleft: 0;\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n\theight: 10px;\r\n\tcontent: \"\"\r\n}\r\n\r\n.carousel-indicators .active {\r\n\tbackground-color: #fff\r\n}\r\n\r\n.carousel-caption {\r\n\tposition: absolute;\r\n\tright: 15%;\r\n\tbottom: 20px;\r\n\tleft: 15%;\r\n\tz-index: 10;\r\n\tpadding-top: 20px;\r\n\tpadding-bottom: 20px;\r\n\tcolor: #fff;\r\n\ttext-align: center\r\n}\r\n\r\n.align-baseline {\r\n\tvertical-align: baseline !important\r\n}\r\n\r\n.align-top {\r\n\tvertical-align: top !important\r\n}\r\n\r\n.align-middle {\r\n\tvertical-align: middle !important\r\n}\r\n\r\n.align-bottom {\r\n\tvertical-align: bottom !important\r\n}\r\n\r\n.align-text-bottom {\r\n\tvertical-align: text-bottom !important\r\n}\r\n\r\n.align-text-top {\r\n\tvertical-align: text-top !important\r\n}\r\n\r\n.bg-primary {\r\n\tbackground-color: #007bff !important\r\n}\r\n\r\na.bg-primary:focus,\r\na.bg-primary:hover,\r\nbutton.bg-primary:focus,\r\nbutton.bg-primary:hover {\r\n\tbackground-color: #0062cc !important\r\n}\r\n\r\n.bg-secondary {\r\n\tbackground-color: #6c757d !important\r\n}\r\n\r\na.bg-secondary:focus,\r\na.bg-secondary:hover,\r\nbutton.bg-secondary:focus,\r\nbutton.bg-secondary:hover {\r\n\tbackground-color: #545b62 !important\r\n}\r\n\r\n.bg-success {\r\n\tbackground-color: #28a745 !important\r\n}\r\n\r\na.bg-success:focus,\r\na.bg-success:hover,\r\nbutton.bg-success:focus,\r\nbutton.bg-success:hover {\r\n\tbackground-color: #1e7e34 !important\r\n}\r\n\r\n.bg-info {\r\n\tbackground-color: #17a2b8 !important\r\n}\r\n\r\na.bg-info:focus,\r\na.bg-info:hover,\r\nbutton.bg-info:focus,\r\nbutton.bg-info:hover {\r\n\tbackground-color: #117a8b !important\r\n}\r\n\r\n.bg-warning {\r\n\tbackground-color: #ffc107 !important\r\n}\r\n\r\na.bg-warning:focus,\r\na.bg-warning:hover,\r\nbutton.bg-warning:focus,\r\nbutton.bg-warning:hover {\r\n\tbackground-color: #d39e00 !important\r\n}\r\n\r\n.bg-danger {\r\n\tbackground-color: #dc3545 !important\r\n}\r\n\r\na.bg-danger:focus,\r\na.bg-danger:hover,\r\nbutton.bg-danger:focus,\r\nbutton.bg-danger:hover {\r\n\tbackground-color: #bd2130 !important\r\n}\r\n\r\n.bg-light {\r\n\tbackground-color: #f8f9fa !important\r\n}\r\n\r\na.bg-light:focus,\r\na.bg-light:hover,\r\nbutton.bg-light:focus,\r\nbutton.bg-light:hover {\r\n\tbackground-color: #dae0e5 !important\r\n}\r\n\r\n.bg-dark {\r\n\tbackground-color: #343a40 !important\r\n}\r\n\r\na.bg-dark:focus,\r\na.bg-dark:hover,\r\nbutton.bg-dark:focus,\r\nbutton.bg-dark:hover {\r\n\tbackground-color: #1d2124 !important\r\n}\r\n\r\n.bg-white {\r\n\tbackground-color: #fff !important\r\n}\r\n\r\n.bg-transparent {\r\n\tbackground-color: transparent !important\r\n}\r\n\r\n.border {\r\n\tborder: 1px solid #dee2e6 !important\r\n}\r\n\r\n.border-top {\r\n\tborder-top: 1px solid #dee2e6 !important\r\n}\r\n\r\n.border-right {\r\n\tborder-right: 1px solid #dee2e6 !important\r\n}\r\n\r\n.border-bottom {\r\n\tborder-bottom: 1px solid #dee2e6 !important\r\n}\r\n\r\n.border-left {\r\n\tborder-left: 1px solid #dee2e6 !important\r\n}\r\n\r\n.border-0 {\r\n\tborder: 0 !important\r\n}\r\n\r\n.border-top-0 {\r\n\tborder-top: 0 !important\r\n}\r\n\r\n.border-right-0 {\r\n\tborder-right: 0 !important\r\n}\r\n\r\n.border-bottom-0 {\r\n\tborder-bottom: 0 !important\r\n}\r\n\r\n.border-left-0 {\r\n\tborder-left: 0 !important\r\n}\r\n\r\n.border-primary {\r\n\tborder-color: #007bff !important\r\n}\r\n\r\n.border-secondary {\r\n\tborder-color: #6c757d !important\r\n}\r\n\r\n.border-success {\r\n\tborder-color: #28a745 !important\r\n}\r\n\r\n.border-info {\r\n\tborder-color: #17a2b8 !important\r\n}\r\n\r\n.border-warning {\r\n\tborder-color: #ffc107 !important\r\n}\r\n\r\n.border-danger {\r\n\tborder-color: #dc3545 !important\r\n}\r\n\r\n.border-light {\r\n\tborder-color: #f8f9fa !important\r\n}\r\n\r\n.border-dark {\r\n\tborder-color: #343a40 !important\r\n}\r\n\r\n.border-white {\r\n\tborder-color: #fff !important\r\n}\r\n\r\n.rounded {\r\n\tborder-radius: .25rem !important\r\n}\r\n\r\n.rounded-top {\r\n\tborder-top-left-radius: .25rem !important;\r\n\tborder-top-right-radius: .25rem !important\r\n}\r\n\r\n.rounded-right {\r\n\tborder-top-right-radius: .25rem !important;\r\n\tborder-bottom-right-radius: .25rem !important\r\n}\r\n\r\n.rounded-bottom {\r\n\tborder-bottom-right-radius: .25rem !important;\r\n\tborder-bottom-left-radius: .25rem !important\r\n}\r\n\r\n.rounded-left {\r\n\tborder-top-left-radius: .25rem !important;\r\n\tborder-bottom-left-radius: .25rem !important\r\n}\r\n\r\n.rounded-circle {\r\n\tborder-radius: 50% !important\r\n}\r\n\r\n.rounded-0 {\r\n\tborder-radius: 0 !important\r\n}\r\n\r\n.clearfix::after {\r\n\tdisplay: block;\r\n\tclear: both;\r\n\tcontent: \"\"\r\n}\r\n\r\n.d-none {\r\n\tdisplay: none !important\r\n}\r\n\r\n.d-inline {\r\n\tdisplay: inline !important\r\n}\r\n\r\n.d-inline-block {\r\n\tdisplay: inline-block !important\r\n}\r\n\r\n.d-block {\r\n\tdisplay: block !important\r\n}\r\n\r\n.d-table {\r\n\tdisplay: table !important\r\n}\r\n\r\n.d-table-row {\r\n\tdisplay: table-row !important\r\n}\r\n\r\n.d-table-cell {\r\n\tdisplay: table-cell !important\r\n}\r\n\r\n.d-flex {\r\n\tdisplay: -ms-flexbox !important;\r\n\tdisplay: flex !important\r\n}\r\n\r\n.d-inline-flex {\r\n\tdisplay: -ms-inline-flexbox !important;\r\n\tdisplay: inline-flex !important\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.d-sm-none {\r\n\t\tdisplay: none !important\r\n\t}\r\n\r\n\t.d-sm-inline {\r\n\t\tdisplay: inline !important\r\n\t}\r\n\r\n\t.d-sm-inline-block {\r\n\t\tdisplay: inline-block !important\r\n\t}\r\n\r\n\t.d-sm-block {\r\n\t\tdisplay: block !important\r\n\t}\r\n\r\n\t.d-sm-table {\r\n\t\tdisplay: table !important\r\n\t}\r\n\r\n\t.d-sm-table-row {\r\n\t\tdisplay: table-row !important\r\n\t}\r\n\r\n\t.d-sm-table-cell {\r\n\t\tdisplay: table-cell !important\r\n\t}\r\n\r\n\t.d-sm-flex {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important\r\n\t}\r\n\r\n\t.d-sm-inline-flex {\r\n\t\tdisplay: -ms-inline-flexbox !important;\r\n\t\tdisplay: inline-flex !important\r\n\t}\r\n}\r\n\r\n@media (min-width:768px) {\r\n\t.d-md-none {\r\n\t\tdisplay: none !important\r\n\t}\r\n\r\n\t.d-md-inline {\r\n\t\tdisplay: inline !important\r\n\t}\r\n\r\n\t.d-md-inline-block {\r\n\t\tdisplay: inline-block !important\r\n\t}\r\n\r\n\t.d-md-block {\r\n\t\tdisplay: block !important\r\n\t}\r\n\r\n\t.d-md-table {\r\n\t\tdisplay: table !important\r\n\t}\r\n\r\n\t.d-md-table-row {\r\n\t\tdisplay: table-row !important\r\n\t}\r\n\r\n\t.d-md-table-cell {\r\n\t\tdisplay: table-cell !important\r\n\t}\r\n\r\n\t.d-md-flex {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important\r\n\t}\r\n\r\n\t.d-md-inline-flex {\r\n\t\tdisplay: -ms-inline-flexbox !important;\r\n\t\tdisplay: inline-flex !important\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.d-lg-none {\r\n\t\tdisplay: none !important\r\n\t}\r\n\r\n\t.d-lg-inline {\r\n\t\tdisplay: inline !important\r\n\t}\r\n\r\n\t.d-lg-inline-block {\r\n\t\tdisplay: inline-block !important\r\n\t}\r\n\r\n\t.d-lg-block {\r\n\t\tdisplay: block !important\r\n\t}\r\n\r\n\t.d-lg-table {\r\n\t\tdisplay: table !important\r\n\t}\r\n\r\n\t.d-lg-table-row {\r\n\t\tdisplay: table-row !important\r\n\t}\r\n\r\n\t.d-lg-table-cell {\r\n\t\tdisplay: table-cell !important\r\n\t}\r\n\r\n\t.d-lg-flex {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important\r\n\t}\r\n\r\n\t.d-lg-inline-flex {\r\n\t\tdisplay: -ms-inline-flexbox !important;\r\n\t\tdisplay: inline-flex !important\r\n\t}\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\t.d-xl-none {\r\n\t\tdisplay: none !important\r\n\t}\r\n\r\n\t.d-xl-inline {\r\n\t\tdisplay: inline !important\r\n\t}\r\n\r\n\t.d-xl-inline-block {\r\n\t\tdisplay: inline-block !important\r\n\t}\r\n\r\n\t.d-xl-block {\r\n\t\tdisplay: block !important\r\n\t}\r\n\r\n\t.d-xl-table {\r\n\t\tdisplay: table !important\r\n\t}\r\n\r\n\t.d-xl-table-row {\r\n\t\tdisplay: table-row !important\r\n\t}\r\n\r\n\t.d-xl-table-cell {\r\n\t\tdisplay: table-cell !important\r\n\t}\r\n\r\n\t.d-xl-flex {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important\r\n\t}\r\n\r\n\t.d-xl-inline-flex {\r\n\t\tdisplay: -ms-inline-flexbox !important;\r\n\t\tdisplay: inline-flex !important\r\n\t}\r\n}\r\n\r\n@media print {\r\n\t.d-print-none {\r\n\t\tdisplay: none !important\r\n\t}\r\n\r\n\t.d-print-inline {\r\n\t\tdisplay: inline !important\r\n\t}\r\n\r\n\t.d-print-inline-block {\r\n\t\tdisplay: inline-block !important\r\n\t}\r\n\r\n\t.d-print-block {\r\n\t\tdisplay: block !important\r\n\t}\r\n\r\n\t.d-print-table {\r\n\t\tdisplay: table !important\r\n\t}\r\n\r\n\t.d-print-table-row {\r\n\t\tdisplay: table-row !important\r\n\t}\r\n\r\n\t.d-print-table-cell {\r\n\t\tdisplay: table-cell !important\r\n\t}\r\n\r\n\t.d-print-flex {\r\n\t\tdisplay: -ms-flexbox !important;\r\n\t\tdisplay: flex !important\r\n\t}\r\n\r\n\t.d-print-inline-flex {\r\n\t\tdisplay: -ms-inline-flexbox !important;\r\n\t\tdisplay: inline-flex !important\r\n\t}\r\n}\r\n\r\n.embed-responsive {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tpadding: 0;\r\n\toverflow: hidden\r\n}\r\n\r\n.embed-responsive::before {\r\n\tdisplay: block;\r\n\tcontent: \"\"\r\n}\r\n\r\n.embed-responsive .embed-responsive-item,\r\n.embed-responsive embed,\r\n.embed-responsive iframe,\r\n.embed-responsive object,\r\n.embed-responsive video {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tborder: 0\r\n}\r\n\r\n.embed-responsive-21by9::before {\r\n\tpadding-top: 42.857143%\r\n}\r\n\r\n.embed-responsive-16by9::before {\r\n\tpadding-top: 56.25%\r\n}\r\n\r\n.embed-responsive-4by3::before {\r\n\tpadding-top: 75%\r\n}\r\n\r\n.embed-responsive-1by1::before {\r\n\tpadding-top: 100%\r\n}\r\n\r\n.flex-row {\r\n\t-ms-flex-direction: row !important;\r\n\tflex-direction: row !important\r\n}\r\n\r\n.flex-column {\r\n\t-ms-flex-direction: column !important;\r\n\tflex-direction: column !important\r\n}\r\n\r\n.flex-row-reverse {\r\n\t-ms-flex-direction: row-reverse !important;\r\n\tflex-direction: row-reverse !important\r\n}\r\n\r\n.flex-column-reverse {\r\n\t-ms-flex-direction: column-reverse !important;\r\n\tflex-direction: column-reverse !important\r\n}\r\n\r\n.flex-wrap {\r\n\t-ms-flex-wrap: wrap !important;\r\n\tflex-wrap: wrap !important\r\n}\r\n\r\n.flex-nowrap {\r\n\t-ms-flex-wrap: nowrap !important;\r\n\tflex-wrap: nowrap !important\r\n}\r\n\r\n.flex-wrap-reverse {\r\n\t-ms-flex-wrap: wrap-reverse !important;\r\n\tflex-wrap: wrap-reverse !important\r\n}\r\n\r\n.flex-fill {\r\n\t-ms-flex: 1 1 auto !important;\r\n\tflex: 1 1 auto !important\r\n}\r\n\r\n.flex-grow-0 {\r\n\t-ms-flex-positive: 0 !important;\r\n\tflex-grow: 0 !important\r\n}\r\n\r\n.flex-grow-1 {\r\n\t-ms-flex-positive: 1 !important;\r\n\tflex-grow: 1 !important\r\n}\r\n\r\n.flex-shrink-0 {\r\n\t-ms-flex-negative: 0 !important;\r\n\tflex-shrink: 0 !important\r\n}\r\n\r\n.flex-shrink-1 {\r\n\t-ms-flex-negative: 1 !important;\r\n\tflex-shrink: 1 !important\r\n}\r\n\r\n.justify-content-start {\r\n\t-ms-flex-pack: start !important;\r\n\tjustify-content: flex-start !important\r\n}\r\n\r\n.justify-content-end {\r\n\t-ms-flex-pack: end !important;\r\n\tjustify-content: flex-end !important\r\n}\r\n\r\n.justify-content-center {\r\n\t-ms-flex-pack: center !important;\r\n\tjustify-content: center !important\r\n}\r\n\r\n.justify-content-between {\r\n\t-ms-flex-pack: justify !important;\r\n\tjustify-content: space-between !important\r\n}\r\n\r\n.justify-content-around {\r\n\t-ms-flex-pack: distribute !important;\r\n\tjustify-content: space-around !important\r\n}\r\n\r\n.align-items-start {\r\n\t-ms-flex-align: start !important;\r\n\talign-items: flex-start !important\r\n}\r\n\r\n.align-items-end {\r\n\t-ms-flex-align: end !important;\r\n\talign-items: flex-end !important\r\n}\r\n\r\n.align-items-center {\r\n\t-ms-flex-align: center !important;\r\n\talign-items: center !important\r\n}\r\n\r\n.align-items-baseline {\r\n\t-ms-flex-align: baseline !important;\r\n\talign-items: baseline !important\r\n}\r\n\r\n.align-items-stretch {\r\n\t-ms-flex-align: stretch !important;\r\n\talign-items: stretch !important\r\n}\r\n\r\n.align-content-start {\r\n\t-ms-flex-line-pack: start !important;\r\n\talign-content: flex-start !important\r\n}\r\n\r\n.align-content-end {\r\n\t-ms-flex-line-pack: end !important;\r\n\talign-content: flex-end !important\r\n}\r\n\r\n.align-content-center {\r\n\t-ms-flex-line-pack: center !important;\r\n\talign-content: center !important\r\n}\r\n\r\n.align-content-between {\r\n\t-ms-flex-line-pack: justify !important;\r\n\talign-content: space-between !important\r\n}\r\n\r\n.align-content-around {\r\n\t-ms-flex-line-pack: distribute !important;\r\n\talign-content: space-around !important\r\n}\r\n\r\n.align-content-stretch {\r\n\t-ms-flex-line-pack: stretch !important;\r\n\talign-content: stretch !important\r\n}\r\n\r\n.align-self-auto {\r\n\t-ms-flex-item-align: auto !important;\r\n\talign-self: auto !important\r\n}\r\n\r\n.align-self-start {\r\n\t-ms-flex-item-align: start !important;\r\n\talign-self: flex-start !important\r\n}\r\n\r\n.align-self-end {\r\n\t-ms-flex-item-align: end !important;\r\n\talign-self: flex-end !important\r\n}\r\n\r\n.align-self-center {\r\n\t-ms-flex-item-align: center !important;\r\n\talign-self: center !important\r\n}\r\n\r\n.align-self-baseline {\r\n\t-ms-flex-item-align: baseline !important;\r\n\talign-self: baseline !important\r\n}\r\n\r\n.align-self-stretch {\r\n\t-ms-flex-item-align: stretch !important;\r\n\talign-self: stretch !important\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.flex-sm-row {\r\n\t\t-ms-flex-direction: row !important;\r\n\t\tflex-direction: row !important\r\n\t}\r\n\r\n\t.flex-sm-column {\r\n\t\t-ms-flex-direction: column !important;\r\n\t\tflex-direction: column !important\r\n\t}\r\n\r\n\t.flex-sm-row-reverse {\r\n\t\t-ms-flex-direction: row-reverse !important;\r\n\t\tflex-direction: row-reverse !important\r\n\t}\r\n\r\n\t.flex-sm-column-reverse {\r\n\t\t-ms-flex-direction: column-reverse !important;\r\n\t\tflex-direction: column-reverse !important\r\n\t}\r\n\r\n\t.flex-sm-wrap {\r\n\t\t-ms-flex-wrap: wrap !important;\r\n\t\tflex-wrap: wrap !important\r\n\t}\r\n\r\n\t.flex-sm-nowrap {\r\n\t\t-ms-flex-wrap: nowrap !important;\r\n\t\tflex-wrap: nowrap !important\r\n\t}\r\n\r\n\t.flex-sm-wrap-reverse {\r\n\t\t-ms-flex-wrap: wrap-reverse !important;\r\n\t\tflex-wrap: wrap-reverse !important\r\n\t}\r\n\r\n\t.flex-sm-fill {\r\n\t\t-ms-flex: 1 1 auto !important;\r\n\t\tflex: 1 1 auto !important\r\n\t}\r\n\r\n\t.flex-sm-grow-0 {\r\n\t\t-ms-flex-positive: 0 !important;\r\n\t\tflex-grow: 0 !important\r\n\t}\r\n\r\n\t.flex-sm-grow-1 {\r\n\t\t-ms-flex-positive: 1 !important;\r\n\t\tflex-grow: 1 !important\r\n\t}\r\n\r\n\t.flex-sm-shrink-0 {\r\n\t\t-ms-flex-negative: 0 !important;\r\n\t\tflex-shrink: 0 !important\r\n\t}\r\n\r\n\t.flex-sm-shrink-1 {\r\n\t\t-ms-flex-negative: 1 !important;\r\n\t\tflex-shrink: 1 !important\r\n\t}\r\n\r\n\t.justify-content-sm-start {\r\n\t\t-ms-flex-pack: start !important;\r\n\t\tjustify-content: flex-start !important\r\n\t}\r\n\r\n\t.justify-content-sm-end {\r\n\t\t-ms-flex-pack: end !important;\r\n\t\tjustify-content: flex-end !important\r\n\t}\r\n\r\n\t.justify-content-sm-center {\r\n\t\t-ms-flex-pack: center !important;\r\n\t\tjustify-content: center !important\r\n\t}\r\n\r\n\t.justify-content-sm-between {\r\n\t\t-ms-flex-pack: justify !important;\r\n\t\tjustify-content: space-between !important\r\n\t}\r\n\r\n\t.justify-content-sm-around {\r\n\t\t-ms-flex-pack: distribute !important;\r\n\t\tjustify-content: space-around !important\r\n\t}\r\n\r\n\t.align-items-sm-start {\r\n\t\t-ms-flex-align: start !important;\r\n\t\talign-items: flex-start !important\r\n\t}\r\n\r\n\t.align-items-sm-end {\r\n\t\t-ms-flex-align: end !important;\r\n\t\talign-items: flex-end !important\r\n\t}\r\n\r\n\t.align-items-sm-center {\r\n\t\t-ms-flex-align: center !important;\r\n\t\talign-items: center !important\r\n\t}\r\n\r\n\t.align-items-sm-baseline {\r\n\t\t-ms-flex-align: baseline !important;\r\n\t\talign-items: baseline !important\r\n\t}\r\n\r\n\t.align-items-sm-stretch {\r\n\t\t-ms-flex-align: stretch !important;\r\n\t\talign-items: stretch !important\r\n\t}\r\n\r\n\t.align-content-sm-start {\r\n\t\t-ms-flex-line-pack: start !important;\r\n\t\talign-content: flex-start !important\r\n\t}\r\n\r\n\t.align-content-sm-end {\r\n\t\t-ms-flex-line-pack: end !important;\r\n\t\talign-content: flex-end !important\r\n\t}\r\n\r\n\t.align-content-sm-center {\r\n\t\t-ms-flex-line-pack: center !important;\r\n\t\talign-content: center !important\r\n\t}\r\n\r\n\t.align-content-sm-between {\r\n\t\t-ms-flex-line-pack: justify !important;\r\n\t\talign-content: space-between !important\r\n\t}\r\n\r\n\t.align-content-sm-around {\r\n\t\t-ms-flex-line-pack: distribute !important;\r\n\t\talign-content: space-around !important\r\n\t}\r\n\r\n\t.align-content-sm-stretch {\r\n\t\t-ms-flex-line-pack: stretch !important;\r\n\t\talign-content: stretch !important\r\n\t}\r\n\r\n\t.align-self-sm-auto {\r\n\t\t-ms-flex-item-align: auto !important;\r\n\t\talign-self: auto !important\r\n\t}\r\n\r\n\t.align-self-sm-start {\r\n\t\t-ms-flex-item-align: start !important;\r\n\t\talign-self: flex-start !important\r\n\t}\r\n\r\n\t.align-self-sm-end {\r\n\t\t-ms-flex-item-align: end !important;\r\n\t\talign-self: flex-end !important\r\n\t}\r\n\r\n\t.align-self-sm-center {\r\n\t\t-ms-flex-item-align: center !important;\r\n\t\talign-self: center !important\r\n\t}\r\n\r\n\t.align-self-sm-baseline {\r\n\t\t-ms-flex-item-align: baseline !important;\r\n\t\talign-self: baseline !important\r\n\t}\r\n\r\n\t.align-self-sm-stretch {\r\n\t\t-ms-flex-item-align: stretch !important;\r\n\t\talign-self: stretch !important\r\n\t}\r\n}\r\n\r\n@media (min-width:768px) {\r\n\t.flex-md-row {\r\n\t\t-ms-flex-direction: row !important;\r\n\t\tflex-direction: row !important\r\n\t}\r\n\r\n\t.flex-md-column {\r\n\t\t-ms-flex-direction: column !important;\r\n\t\tflex-direction: column !important\r\n\t}\r\n\r\n\t.flex-md-row-reverse {\r\n\t\t-ms-flex-direction: row-reverse !important;\r\n\t\tflex-direction: row-reverse !important\r\n\t}\r\n\r\n\t.flex-md-column-reverse {\r\n\t\t-ms-flex-direction: column-reverse !important;\r\n\t\tflex-direction: column-reverse !important\r\n\t}\r\n\r\n\t.flex-md-wrap {\r\n\t\t-ms-flex-wrap: wrap !important;\r\n\t\tflex-wrap: wrap !important\r\n\t}\r\n\r\n\t.flex-md-nowrap {\r\n\t\t-ms-flex-wrap: nowrap !important;\r\n\t\tflex-wrap: nowrap !important\r\n\t}\r\n\r\n\t.flex-md-wrap-reverse {\r\n\t\t-ms-flex-wrap: wrap-reverse !important;\r\n\t\tflex-wrap: wrap-reverse !important\r\n\t}\r\n\r\n\t.flex-md-fill {\r\n\t\t-ms-flex: 1 1 auto !important;\r\n\t\tflex: 1 1 auto !important\r\n\t}\r\n\r\n\t.flex-md-grow-0 {\r\n\t\t-ms-flex-positive: 0 !important;\r\n\t\tflex-grow: 0 !important\r\n\t}\r\n\r\n\t.flex-md-grow-1 {\r\n\t\t-ms-flex-positive: 1 !important;\r\n\t\tflex-grow: 1 !important\r\n\t}\r\n\r\n\t.flex-md-shrink-0 {\r\n\t\t-ms-flex-negative: 0 !important;\r\n\t\tflex-shrink: 0 !important\r\n\t}\r\n\r\n\t.flex-md-shrink-1 {\r\n\t\t-ms-flex-negative: 1 !important;\r\n\t\tflex-shrink: 1 !important\r\n\t}\r\n\r\n\t.justify-content-md-start {\r\n\t\t-ms-flex-pack: start !important;\r\n\t\tjustify-content: flex-start !important\r\n\t}\r\n\r\n\t.justify-content-md-end {\r\n\t\t-ms-flex-pack: end !important;\r\n\t\tjustify-content: flex-end !important\r\n\t}\r\n\r\n\t.justify-content-md-center {\r\n\t\t-ms-flex-pack: center !important;\r\n\t\tjustify-content: center !important\r\n\t}\r\n\r\n\t.justify-content-md-between {\r\n\t\t-ms-flex-pack: justify !important;\r\n\t\tjustify-content: space-between !important\r\n\t}\r\n\r\n\t.justify-content-md-around {\r\n\t\t-ms-flex-pack: distribute !important;\r\n\t\tjustify-content: space-around !important\r\n\t}\r\n\r\n\t.align-items-md-start {\r\n\t\t-ms-flex-align: start !important;\r\n\t\talign-items: flex-start !important\r\n\t}\r\n\r\n\t.align-items-md-end {\r\n\t\t-ms-flex-align: end !important;\r\n\t\talign-items: flex-end !important\r\n\t}\r\n\r\n\t.align-items-md-center {\r\n\t\t-ms-flex-align: center !important;\r\n\t\talign-items: center !important\r\n\t}\r\n\r\n\t.align-items-md-baseline {\r\n\t\t-ms-flex-align: baseline !important;\r\n\t\talign-items: baseline !important\r\n\t}\r\n\r\n\t.align-items-md-stretch {\r\n\t\t-ms-flex-align: stretch !important;\r\n\t\talign-items: stretch !important\r\n\t}\r\n\r\n\t.align-content-md-start {\r\n\t\t-ms-flex-line-pack: start !important;\r\n\t\talign-content: flex-start !important\r\n\t}\r\n\r\n\t.align-content-md-end {\r\n\t\t-ms-flex-line-pack: end !important;\r\n\t\talign-content: flex-end !important\r\n\t}\r\n\r\n\t.align-content-md-center {\r\n\t\t-ms-flex-line-pack: center !important;\r\n\t\talign-content: center !important\r\n\t}\r\n\r\n\t.align-content-md-between {\r\n\t\t-ms-flex-line-pack: justify !important;\r\n\t\talign-content: space-between !important\r\n\t}\r\n\r\n\t.align-content-md-around {\r\n\t\t-ms-flex-line-pack: distribute !important;\r\n\t\talign-content: space-around !important\r\n\t}\r\n\r\n\t.align-content-md-stretch {\r\n\t\t-ms-flex-line-pack: stretch !important;\r\n\t\talign-content: stretch !important\r\n\t}\r\n\r\n\t.align-self-md-auto {\r\n\t\t-ms-flex-item-align: auto !important;\r\n\t\talign-self: auto !important\r\n\t}\r\n\r\n\t.align-self-md-start {\r\n\t\t-ms-flex-item-align: start !important;\r\n\t\talign-self: flex-start !important\r\n\t}\r\n\r\n\t.align-self-md-end {\r\n\t\t-ms-flex-item-align: end !important;\r\n\t\talign-self: flex-end !important\r\n\t}\r\n\r\n\t.align-self-md-center {\r\n\t\t-ms-flex-item-align: center !important;\r\n\t\talign-self: center !important\r\n\t}\r\n\r\n\t.align-self-md-baseline {\r\n\t\t-ms-flex-item-align: baseline !important;\r\n\t\talign-self: baseline !important\r\n\t}\r\n\r\n\t.align-self-md-stretch {\r\n\t\t-ms-flex-item-align: stretch !important;\r\n\t\talign-self: stretch !important\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.flex-lg-row {\r\n\t\t-ms-flex-direction: row !important;\r\n\t\tflex-direction: row !important\r\n\t}\r\n\r\n\t.flex-lg-column {\r\n\t\t-ms-flex-direction: column !important;\r\n\t\tflex-direction: column !important\r\n\t}\r\n\r\n\t.flex-lg-row-reverse {\r\n\t\t-ms-flex-direction: row-reverse !important;\r\n\t\tflex-direction: row-reverse !important\r\n\t}\r\n\r\n\t.flex-lg-column-reverse {\r\n\t\t-ms-flex-direction: column-reverse !important;\r\n\t\tflex-direction: column-reverse !important\r\n\t}\r\n\r\n\t.flex-lg-wrap {\r\n\t\t-ms-flex-wrap: wrap !important;\r\n\t\tflex-wrap: wrap !important\r\n\t}\r\n\r\n\t.flex-lg-nowrap {\r\n\t\t-ms-flex-wrap: nowrap !important;\r\n\t\tflex-wrap: nowrap !important\r\n\t}\r\n\r\n\t.flex-lg-wrap-reverse {\r\n\t\t-ms-flex-wrap: wrap-reverse !important;\r\n\t\tflex-wrap: wrap-reverse !important\r\n\t}\r\n\r\n\t.flex-lg-fill {\r\n\t\t-ms-flex: 1 1 auto !important;\r\n\t\tflex: 1 1 auto !important\r\n\t}\r\n\r\n\t.flex-lg-grow-0 {\r\n\t\t-ms-flex-positive: 0 !important;\r\n\t\tflex-grow: 0 !important\r\n\t}\r\n\r\n\t.flex-lg-grow-1 {\r\n\t\t-ms-flex-positive: 1 !important;\r\n\t\tflex-grow: 1 !important\r\n\t}\r\n\r\n\t.flex-lg-shrink-0 {\r\n\t\t-ms-flex-negative: 0 !important;\r\n\t\tflex-shrink: 0 !important\r\n\t}\r\n\r\n\t.flex-lg-shrink-1 {\r\n\t\t-ms-flex-negative: 1 !important;\r\n\t\tflex-shrink: 1 !important\r\n\t}\r\n\r\n\t.justify-content-lg-start {\r\n\t\t-ms-flex-pack: start !important;\r\n\t\tjustify-content: flex-start !important\r\n\t}\r\n\r\n\t.justify-content-lg-end {\r\n\t\t-ms-flex-pack: end !important;\r\n\t\tjustify-content: flex-end !important\r\n\t}\r\n\r\n\t.justify-content-lg-center {\r\n\t\t-ms-flex-pack: center !important;\r\n\t\tjustify-content: center !important\r\n\t}\r\n\r\n\t.justify-content-lg-between {\r\n\t\t-ms-flex-pack: justify !important;\r\n\t\tjustify-content: space-between !important\r\n\t}\r\n\r\n\t.justify-content-lg-around {\r\n\t\t-ms-flex-pack: distribute !important;\r\n\t\tjustify-content: space-around !important\r\n\t}\r\n\r\n\t.align-items-lg-start {\r\n\t\t-ms-flex-align: start !important;\r\n\t\talign-items: flex-start !important\r\n\t}\r\n\r\n\t.align-items-lg-end {\r\n\t\t-ms-flex-align: end !important;\r\n\t\talign-items: flex-end !important\r\n\t}\r\n\r\n\t.align-items-lg-center {\r\n\t\t-ms-flex-align: center !important;\r\n\t\talign-items: center !important\r\n\t}\r\n\r\n\t.align-items-lg-baseline {\r\n\t\t-ms-flex-align: baseline !important;\r\n\t\talign-items: baseline !important\r\n\t}\r\n\r\n\t.align-items-lg-stretch {\r\n\t\t-ms-flex-align: stretch !important;\r\n\t\talign-items: stretch !important\r\n\t}\r\n\r\n\t.align-content-lg-start {\r\n\t\t-ms-flex-line-pack: start !important;\r\n\t\talign-content: flex-start !important\r\n\t}\r\n\r\n\t.align-content-lg-end {\r\n\t\t-ms-flex-line-pack: end !important;\r\n\t\talign-content: flex-end !important\r\n\t}\r\n\r\n\t.align-content-lg-center {\r\n\t\t-ms-flex-line-pack: center !important;\r\n\t\talign-content: center !important\r\n\t}\r\n\r\n\t.align-content-lg-between {\r\n\t\t-ms-flex-line-pack: justify !important;\r\n\t\talign-content: space-between !important\r\n\t}\r\n\r\n\t.align-content-lg-around {\r\n\t\t-ms-flex-line-pack: distribute !important;\r\n\t\talign-content: space-around !important\r\n\t}\r\n\r\n\t.align-content-lg-stretch {\r\n\t\t-ms-flex-line-pack: stretch !important;\r\n\t\talign-content: stretch !important\r\n\t}\r\n\r\n\t.align-self-lg-auto {\r\n\t\t-ms-flex-item-align: auto !important;\r\n\t\talign-self: auto !important\r\n\t}\r\n\r\n\t.align-self-lg-start {\r\n\t\t-ms-flex-item-align: start !important;\r\n\t\talign-self: flex-start !important\r\n\t}\r\n\r\n\t.align-self-lg-end {\r\n\t\t-ms-flex-item-align: end !important;\r\n\t\talign-self: flex-end !important\r\n\t}\r\n\r\n\t.align-self-lg-center {\r\n\t\t-ms-flex-item-align: center !important;\r\n\t\talign-self: center !important\r\n\t}\r\n\r\n\t.align-self-lg-baseline {\r\n\t\t-ms-flex-item-align: baseline !important;\r\n\t\talign-self: baseline !important\r\n\t}\r\n\r\n\t.align-self-lg-stretch {\r\n\t\t-ms-flex-item-align: stretch !important;\r\n\t\talign-self: stretch !important\r\n\t}\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\t.flex-xl-row {\r\n\t\t-ms-flex-direction: row !important;\r\n\t\tflex-direction: row !important\r\n\t}\r\n\r\n\t.flex-xl-column {\r\n\t\t-ms-flex-direction: column !important;\r\n\t\tflex-direction: column !important\r\n\t}\r\n\r\n\t.flex-xl-row-reverse {\r\n\t\t-ms-flex-direction: row-reverse !important;\r\n\t\tflex-direction: row-reverse !important\r\n\t}\r\n\r\n\t.flex-xl-column-reverse {\r\n\t\t-ms-flex-direction: column-reverse !important;\r\n\t\tflex-direction: column-reverse !important\r\n\t}\r\n\r\n\t.flex-xl-wrap {\r\n\t\t-ms-flex-wrap: wrap !important;\r\n\t\tflex-wrap: wrap !important\r\n\t}\r\n\r\n\t.flex-xl-nowrap {\r\n\t\t-ms-flex-wrap: nowrap !important;\r\n\t\tflex-wrap: nowrap !important\r\n\t}\r\n\r\n\t.flex-xl-wrap-reverse {\r\n\t\t-ms-flex-wrap: wrap-reverse !important;\r\n\t\tflex-wrap: wrap-reverse !important\r\n\t}\r\n\r\n\t.flex-xl-fill {\r\n\t\t-ms-flex: 1 1 auto !important;\r\n\t\tflex: 1 1 auto !important\r\n\t}\r\n\r\n\t.flex-xl-grow-0 {\r\n\t\t-ms-flex-positive: 0 !important;\r\n\t\tflex-grow: 0 !important\r\n\t}\r\n\r\n\t.flex-xl-grow-1 {\r\n\t\t-ms-flex-positive: 1 !important;\r\n\t\tflex-grow: 1 !important\r\n\t}\r\n\r\n\t.flex-xl-shrink-0 {\r\n\t\t-ms-flex-negative: 0 !important;\r\n\t\tflex-shrink: 0 !important\r\n\t}\r\n\r\n\t.flex-xl-shrink-1 {\r\n\t\t-ms-flex-negative: 1 !important;\r\n\t\tflex-shrink: 1 !important\r\n\t}\r\n\r\n\t.justify-content-xl-start {\r\n\t\t-ms-flex-pack: start !important;\r\n\t\tjustify-content: flex-start !important\r\n\t}\r\n\r\n\t.justify-content-xl-end {\r\n\t\t-ms-flex-pack: end !important;\r\n\t\tjustify-content: flex-end !important\r\n\t}\r\n\r\n\t.justify-content-xl-center {\r\n\t\t-ms-flex-pack: center !important;\r\n\t\tjustify-content: center !important\r\n\t}\r\n\r\n\t.justify-content-xl-between {\r\n\t\t-ms-flex-pack: justify !important;\r\n\t\tjustify-content: space-between !important\r\n\t}\r\n\r\n\t.justify-content-xl-around {\r\n\t\t-ms-flex-pack: distribute !important;\r\n\t\tjustify-content: space-around !important\r\n\t}\r\n\r\n\t.align-items-xl-start {\r\n\t\t-ms-flex-align: start !important;\r\n\t\talign-items: flex-start !important\r\n\t}\r\n\r\n\t.align-items-xl-end {\r\n\t\t-ms-flex-align: end !important;\r\n\t\talign-items: flex-end !important\r\n\t}\r\n\r\n\t.align-items-xl-center {\r\n\t\t-ms-flex-align: center !important;\r\n\t\talign-items: center !important\r\n\t}\r\n\r\n\t.align-items-xl-baseline {\r\n\t\t-ms-flex-align: baseline !important;\r\n\t\talign-items: baseline !important\r\n\t}\r\n\r\n\t.align-items-xl-stretch {\r\n\t\t-ms-flex-align: stretch !important;\r\n\t\talign-items: stretch !important\r\n\t}\r\n\r\n\t.align-content-xl-start {\r\n\t\t-ms-flex-line-pack: start !important;\r\n\t\talign-content: flex-start !important\r\n\t}\r\n\r\n\t.align-content-xl-end {\r\n\t\t-ms-flex-line-pack: end !important;\r\n\t\talign-content: flex-end !important\r\n\t}\r\n\r\n\t.align-content-xl-center {\r\n\t\t-ms-flex-line-pack: center !important;\r\n\t\talign-content: center !important\r\n\t}\r\n\r\n\t.align-content-xl-between {\r\n\t\t-ms-flex-line-pack: justify !important;\r\n\t\talign-content: space-between !important\r\n\t}\r\n\r\n\t.align-content-xl-around {\r\n\t\t-ms-flex-line-pack: distribute !important;\r\n\t\talign-content: space-around !important\r\n\t}\r\n\r\n\t.align-content-xl-stretch {\r\n\t\t-ms-flex-line-pack: stretch !important;\r\n\t\talign-content: stretch !important\r\n\t}\r\n\r\n\t.align-self-xl-auto {\r\n\t\t-ms-flex-item-align: auto !important;\r\n\t\talign-self: auto !important\r\n\t}\r\n\r\n\t.align-self-xl-start {\r\n\t\t-ms-flex-item-align: start !important;\r\n\t\talign-self: flex-start !important\r\n\t}\r\n\r\n\t.align-self-xl-end {\r\n\t\t-ms-flex-item-align: end !important;\r\n\t\talign-self: flex-end !important\r\n\t}\r\n\r\n\t.align-self-xl-center {\r\n\t\t-ms-flex-item-align: center !important;\r\n\t\talign-self: center !important\r\n\t}\r\n\r\n\t.align-self-xl-baseline {\r\n\t\t-ms-flex-item-align: baseline !important;\r\n\t\talign-self: baseline !important\r\n\t}\r\n\r\n\t.align-self-xl-stretch {\r\n\t\t-ms-flex-item-align: stretch !important;\r\n\t\talign-self: stretch !important\r\n\t}\r\n}\r\n\r\n.float-left {\r\n\tfloat: left !important\r\n}\r\n\r\n.float-right {\r\n\tfloat: right !important\r\n}\r\n\r\n.float-none {\r\n\tfloat: none !important\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.float-sm-left {\r\n\t\tfloat: left !important\r\n\t}\r\n\r\n\t.float-sm-right {\r\n\t\tfloat: right !important\r\n\t}\r\n\r\n\t.float-sm-none {\r\n\t\tfloat: none !important\r\n\t}\r\n}\r\n\r\n@media (min-width:768px) {\r\n\t.float-md-left {\r\n\t\tfloat: left !important\r\n\t}\r\n\r\n\t.float-md-right {\r\n\t\tfloat: right !important\r\n\t}\r\n\r\n\t.float-md-none {\r\n\t\tfloat: none !important\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.float-lg-left {\r\n\t\tfloat: left !important\r\n\t}\r\n\r\n\t.float-lg-right {\r\n\t\tfloat: right !important\r\n\t}\r\n\r\n\t.float-lg-none {\r\n\t\tfloat: none !important\r\n\t}\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\t.float-xl-left {\r\n\t\tfloat: left !important\r\n\t}\r\n\r\n\t.float-xl-right {\r\n\t\tfloat: right !important\r\n\t}\r\n\r\n\t.float-xl-none {\r\n\t\tfloat: none !important\r\n\t}\r\n}\r\n\r\n.position-static {\r\n\tposition: static !important\r\n}\r\n\r\n.position-relative {\r\n\tposition: relative !important\r\n}\r\n\r\n.position-absolute {\r\n\tposition: absolute !important\r\n}\r\n\r\n.position-fixed {\r\n\tposition: fixed !important\r\n}\r\n\r\n.position-sticky {\r\n\tposition: -webkit-sticky !important;\r\n\tposition: sticky !important\r\n}\r\n\r\n.fixed-top {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tleft: 0;\r\n\tz-index: 1030\r\n}\r\n\r\n.fixed-bottom {\r\n\tposition: fixed;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tz-index: 1030\r\n}\r\n\r\n@supports ((position:-webkit-sticky) or (position:sticky)) {\r\n\t.sticky-top {\r\n\t\tposition: -webkit-sticky;\r\n\t\tposition: sticky;\r\n\t\ttop: 0;\r\n\t\tz-index: 1020\r\n\t}\r\n}\r\n\r\n.sr-only {\r\n\tposition: absolute;\r\n\twidth: 1px;\r\n\theight: 1px;\r\n\tpadding: 0;\r\n\toverflow: hidden;\r\n\tclip: rect(0, 0, 0, 0);\r\n\twhite-space: nowrap;\r\n\tborder: 0\r\n}\r\n\r\n.sr-only-focusable:active,\r\n.sr-only-focusable:focus {\r\n\tposition: static;\r\n\twidth: auto;\r\n\theight: auto;\r\n\toverflow: visible;\r\n\tclip: auto;\r\n\twhite-space: normal\r\n}\r\n\r\n.shadow-sm {\r\n\tbox-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important\r\n}\r\n\r\n.shadow {\r\n\tbox-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important\r\n}\r\n\r\n.shadow-lg {\r\n\tbox-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important\r\n}\r\n\r\n.shadow-none {\r\n\tbox-shadow: none !important\r\n}\r\n\r\n.w-25 {\r\n\twidth: 25% !important\r\n}\r\n\r\n.w-50 {\r\n\twidth: 50% !important\r\n}\r\n\r\n.w-75 {\r\n\twidth: 75% !important\r\n}\r\n\r\n.w-100 {\r\n\twidth: 100% !important\r\n}\r\n\r\n.w-auto {\r\n\twidth: auto !important\r\n}\r\n\r\n.h-25 {\r\n\theight: 25% !important\r\n}\r\n\r\n.h-50 {\r\n\theight: 50% !important\r\n}\r\n\r\n.h-75 {\r\n\theight: 75% !important\r\n}\r\n\r\n.h-100 {\r\n\theight: 100% !important\r\n}\r\n\r\n.h-auto {\r\n\theight: auto !important\r\n}\r\n\r\n.mw-100 {\r\n\tmax-width: 100% !important\r\n}\r\n\r\n.mh-100 {\r\n\tmax-height: 100% !important\r\n}\r\n\r\n.m-0 {\r\n\tmargin: 0 !important\r\n}\r\n\r\n.mt-0,\r\n.my-0 {\r\n\tmargin-top: 0 !important\r\n}\r\n\r\n.mr-0,\r\n.mx-0 {\r\n\tmargin-right: 0 !important\r\n}\r\n\r\n.mb-0,\r\n.my-0 {\r\n\tmargin-bottom: 0 !important\r\n}\r\n\r\n.ml-0,\r\n.mx-0 {\r\n\tmargin-left: 0 !important\r\n}\r\n\r\n.m-1 {\r\n\tmargin: .25rem !important\r\n}\r\n\r\n.mt-1,\r\n.my-1 {\r\n\tmargin-top: .25rem !important\r\n}\r\n\r\n.mr-1,\r\n.mx-1 {\r\n\tmargin-right: .25rem !important\r\n}\r\n\r\n.mb-1,\r\n.my-1 {\r\n\tmargin-bottom: .25rem !important\r\n}\r\n\r\n.ml-1,\r\n.mx-1 {\r\n\tmargin-left: .25rem !important\r\n}\r\n\r\n.m-2 {\r\n\tmargin: .5rem !important\r\n}\r\n\r\n.mt-2,\r\n.my-2 {\r\n\tmargin-top: .5rem !important\r\n}\r\n\r\n.mr-2,\r\n.mx-2 {\r\n\tmargin-right: .5rem !important\r\n}\r\n\r\n.mb-2,\r\n.my-2 {\r\n\tmargin-bottom: .5rem !important\r\n}\r\n\r\n.ml-2,\r\n.mx-2 {\r\n\tmargin-left: .5rem !important\r\n}\r\n\r\n.m-3 {\r\n\tmargin: 1rem !important\r\n}\r\n\r\n.mt-3,\r\n.my-3 {\r\n\tmargin-top: 1rem !important\r\n}\r\n\r\n.mr-3,\r\n.mx-3 {\r\n\tmargin-right: 1rem !important\r\n}\r\n\r\n.mb-3,\r\n.my-3 {\r\n\tmargin-bottom: 1rem !important\r\n}\r\n\r\n.ml-3,\r\n.mx-3 {\r\n\tmargin-left: 1rem !important\r\n}\r\n\r\n.m-4 {\r\n\tmargin: 1.5rem !important\r\n}\r\n\r\n.mt-4,\r\n.my-4 {\r\n\tmargin-top: 1.5rem !important\r\n}\r\n\r\n.mr-4,\r\n.mx-4 {\r\n\tmargin-right: 1.5rem !important\r\n}\r\n\r\n.mb-4,\r\n.my-4 {\r\n\tmargin-bottom: 1.5rem !important\r\n}\r\n\r\n.ml-4,\r\n.mx-4 {\r\n\tmargin-left: 1.5rem !important\r\n}\r\n\r\n.m-5 {\r\n\tmargin: 3rem !important\r\n}\r\n\r\n.mt-5,\r\n.my-5 {\r\n\tmargin-top: 3rem !important\r\n}\r\n\r\n.mr-5,\r\n.mx-5 {\r\n\tmargin-right: 3rem !important\r\n}\r\n\r\n.mb-5,\r\n.my-5 {\r\n\tmargin-bottom: 3rem !important\r\n}\r\n\r\n.ml-5,\r\n.mx-5 {\r\n\tmargin-left: 3rem !important\r\n}\r\n\r\n.p-0 {\r\n\tpadding: 0 !important\r\n}\r\n\r\n.pt-0,\r\n.py-0 {\r\n\tpadding-top: 0 !important\r\n}\r\n\r\n.pr-0,\r\n.px-0 {\r\n\tpadding-right: 0 !important\r\n}\r\n\r\n.pb-0,\r\n.py-0 {\r\n\tpadding-bottom: 0 !important\r\n}\r\n\r\n.pl-0,\r\n.px-0 {\r\n\tpadding-left: 0 !important\r\n}\r\n\r\n.p-1 {\r\n\tpadding: .25rem !important\r\n}\r\n\r\n.pt-1,\r\n.py-1 {\r\n\tpadding-top: .25rem !important\r\n}\r\n\r\n.pr-1,\r\n.px-1 {\r\n\tpadding-right: .25rem !important\r\n}\r\n\r\n.pb-1,\r\n.py-1 {\r\n\tpadding-bottom: .25rem !important\r\n}\r\n\r\n.pl-1,\r\n.px-1 {\r\n\tpadding-left: .25rem !important\r\n}\r\n\r\n.p-2 {\r\n\tpadding: .5rem !important\r\n}\r\n\r\n.pt-2,\r\n.py-2 {\r\n\tpadding-top: .5rem !important\r\n}\r\n\r\n.pr-2,\r\n.px-2 {\r\n\tpadding-right: .5rem !important\r\n}\r\n\r\n.pb-2,\r\n.py-2 {\r\n\tpadding-bottom: .5rem !important\r\n}\r\n\r\n.pl-2,\r\n.px-2 {\r\n\tpadding-left: .5rem !important\r\n}\r\n\r\n.p-3 {\r\n\tpadding: 1rem !important\r\n}\r\n\r\n.pt-3,\r\n.py-3 {\r\n\tpadding-top: 1rem !important\r\n}\r\n\r\n.pr-3,\r\n.px-3 {\r\n\tpadding-right: 1rem !important\r\n}\r\n\r\n.pb-3,\r\n.py-3 {\r\n\tpadding-bottom: 1rem !important\r\n}\r\n\r\n.pl-3,\r\n.px-3 {\r\n\tpadding-left: 1rem !important\r\n}\r\n\r\n.p-4 {\r\n\tpadding: 1.5rem !important\r\n}\r\n\r\n.pt-4,\r\n.py-4 {\r\n\tpadding-top: 1.5rem !important\r\n}\r\n\r\n.pr-4,\r\n.px-4 {\r\n\tpadding-right: 1.5rem !important\r\n}\r\n\r\n.pb-4,\r\n.py-4 {\r\n\tpadding-bottom: 1.5rem !important\r\n}\r\n\r\n.pl-4,\r\n.px-4 {\r\n\tpadding-left: 1.5rem !important\r\n}\r\n\r\n.p-5 {\r\n\tpadding: 3rem !important\r\n}\r\n\r\n.pt-5,\r\n.py-5 {\r\n\tpadding-top: 3rem !important\r\n}\r\n\r\n.pr-5,\r\n.px-5 {\r\n\tpadding-right: 3rem !important\r\n}\r\n\r\n.pb-5,\r\n.py-5 {\r\n\tpadding-bottom: 3rem !important\r\n}\r\n\r\n.pl-5,\r\n.px-5 {\r\n\tpadding-left: 3rem !important\r\n}\r\n\r\n.m-auto {\r\n\tmargin: auto !important\r\n}\r\n\r\n.mt-auto,\r\n.my-auto {\r\n\tmargin-top: auto !important\r\n}\r\n\r\n.mr-auto,\r\n.mx-auto {\r\n\tmargin-right: auto !important\r\n}\r\n\r\n.mb-auto,\r\n.my-auto {\r\n\tmargin-bottom: auto !important\r\n}\r\n\r\n.ml-auto,\r\n.mx-auto {\r\n\tmargin-left: auto !important\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.m-sm-0 {\r\n\t\tmargin: 0 !important\r\n\t}\r\n\r\n\t.mt-sm-0,\r\n\t.my-sm-0 {\r\n\t\tmargin-top: 0 !important\r\n\t}\r\n\r\n\t.mr-sm-0,\r\n\t.mx-sm-0 {\r\n\t\tmargin-right: 0 !important\r\n\t}\r\n\r\n\t.mb-sm-0,\r\n\t.my-sm-0 {\r\n\t\tmargin-bottom: 0 !important\r\n\t}\r\n\r\n\t.ml-sm-0,\r\n\t.mx-sm-0 {\r\n\t\tmargin-left: 0 !important\r\n\t}\r\n\r\n\t.m-sm-1 {\r\n\t\tmargin: .25rem !important\r\n\t}\r\n\r\n\t.mt-sm-1,\r\n\t.my-sm-1 {\r\n\t\tmargin-top: .25rem !important\r\n\t}\r\n\r\n\t.mr-sm-1,\r\n\t.mx-sm-1 {\r\n\t\tmargin-right: .25rem !important\r\n\t}\r\n\r\n\t.mb-sm-1,\r\n\t.my-sm-1 {\r\n\t\tmargin-bottom: .25rem !important\r\n\t}\r\n\r\n\t.ml-sm-1,\r\n\t.mx-sm-1 {\r\n\t\tmargin-left: .25rem !important\r\n\t}\r\n\r\n\t.m-sm-2 {\r\n\t\tmargin: .5rem !important\r\n\t}\r\n\r\n\t.mt-sm-2,\r\n\t.my-sm-2 {\r\n\t\tmargin-top: .5rem !important\r\n\t}\r\n\r\n\t.mr-sm-2,\r\n\t.mx-sm-2 {\r\n\t\tmargin-right: .5rem !important\r\n\t}\r\n\r\n\t.mb-sm-2,\r\n\t.my-sm-2 {\r\n\t\tmargin-bottom: .5rem !important\r\n\t}\r\n\r\n\t.ml-sm-2,\r\n\t.mx-sm-2 {\r\n\t\tmargin-left: .5rem !important\r\n\t}\r\n\r\n\t.m-sm-3 {\r\n\t\tmargin: 1rem !important\r\n\t}\r\n\r\n\t.mt-sm-3,\r\n\t.my-sm-3 {\r\n\t\tmargin-top: 1rem !important\r\n\t}\r\n\r\n\t.mr-sm-3,\r\n\t.mx-sm-3 {\r\n\t\tmargin-right: 1rem !important\r\n\t}\r\n\r\n\t.mb-sm-3,\r\n\t.my-sm-3 {\r\n\t\tmargin-bottom: 1rem !important\r\n\t}\r\n\r\n\t.ml-sm-3,\r\n\t.mx-sm-3 {\r\n\t\tmargin-left: 1rem !important\r\n\t}\r\n\r\n\t.m-sm-4 {\r\n\t\tmargin: 1.5rem !important\r\n\t}\r\n\r\n\t.mt-sm-4,\r\n\t.my-sm-4 {\r\n\t\tmargin-top: 1.5rem !important\r\n\t}\r\n\r\n\t.mr-sm-4,\r\n\t.mx-sm-4 {\r\n\t\tmargin-right: 1.5rem !important\r\n\t}\r\n\r\n\t.mb-sm-4,\r\n\t.my-sm-4 {\r\n\t\tmargin-bottom: 1.5rem !important\r\n\t}\r\n\r\n\t.ml-sm-4,\r\n\t.mx-sm-4 {\r\n\t\tmargin-left: 1.5rem !important\r\n\t}\r\n\r\n\t.m-sm-5 {\r\n\t\tmargin: 3rem !important\r\n\t}\r\n\r\n\t.mt-sm-5,\r\n\t.my-sm-5 {\r\n\t\tmargin-top: 3rem !important\r\n\t}\r\n\r\n\t.mr-sm-5,\r\n\t.mx-sm-5 {\r\n\t\tmargin-right: 3rem !important\r\n\t}\r\n\r\n\t.mb-sm-5,\r\n\t.my-sm-5 {\r\n\t\tmargin-bottom: 3rem !important\r\n\t}\r\n\r\n\t.ml-sm-5,\r\n\t.mx-sm-5 {\r\n\t\tmargin-left: 3rem !important\r\n\t}\r\n\r\n\t.p-sm-0 {\r\n\t\tpadding: 0 !important\r\n\t}\r\n\r\n\t.pt-sm-0,\r\n\t.py-sm-0 {\r\n\t\tpadding-top: 0 !important\r\n\t}\r\n\r\n\t.pr-sm-0,\r\n\t.px-sm-0 {\r\n\t\tpadding-right: 0 !important\r\n\t}\r\n\r\n\t.pb-sm-0,\r\n\t.py-sm-0 {\r\n\t\tpadding-bottom: 0 !important\r\n\t}\r\n\r\n\t.pl-sm-0,\r\n\t.px-sm-0 {\r\n\t\tpadding-left: 0 !important\r\n\t}\r\n\r\n\t.p-sm-1 {\r\n\t\tpadding: .25rem !important\r\n\t}\r\n\r\n\t.pt-sm-1,\r\n\t.py-sm-1 {\r\n\t\tpadding-top: .25rem !important\r\n\t}\r\n\r\n\t.pr-sm-1,\r\n\t.px-sm-1 {\r\n\t\tpadding-right: .25rem !important\r\n\t}\r\n\r\n\t.pb-sm-1,\r\n\t.py-sm-1 {\r\n\t\tpadding-bottom: .25rem !important\r\n\t}\r\n\r\n\t.pl-sm-1,\r\n\t.px-sm-1 {\r\n\t\tpadding-left: .25rem !important\r\n\t}\r\n\r\n\t.p-sm-2 {\r\n\t\tpadding: .5rem !important\r\n\t}\r\n\r\n\t.pt-sm-2,\r\n\t.py-sm-2 {\r\n\t\tpadding-top: .5rem !important\r\n\t}\r\n\r\n\t.pr-sm-2,\r\n\t.px-sm-2 {\r\n\t\tpadding-right: .5rem !important\r\n\t}\r\n\r\n\t.pb-sm-2,\r\n\t.py-sm-2 {\r\n\t\tpadding-bottom: .5rem !important\r\n\t}\r\n\r\n\t.pl-sm-2,\r\n\t.px-sm-2 {\r\n\t\tpadding-left: .5rem !important\r\n\t}\r\n\r\n\t.p-sm-3 {\r\n\t\tpadding: 1rem !important\r\n\t}\r\n\r\n\t.pt-sm-3,\r\n\t.py-sm-3 {\r\n\t\tpadding-top: 1rem !important\r\n\t}\r\n\r\n\t.pr-sm-3,\r\n\t.px-sm-3 {\r\n\t\tpadding-right: 1rem !important\r\n\t}\r\n\r\n\t.pb-sm-3,\r\n\t.py-sm-3 {\r\n\t\tpadding-bottom: 1rem !important\r\n\t}\r\n\r\n\t.pl-sm-3,\r\n\t.px-sm-3 {\r\n\t\tpadding-left: 1rem !important\r\n\t}\r\n\r\n\t.p-sm-4 {\r\n\t\tpadding: 1.5rem !important\r\n\t}\r\n\r\n\t.pt-sm-4,\r\n\t.py-sm-4 {\r\n\t\tpadding-top: 1.5rem !important\r\n\t}\r\n\r\n\t.pr-sm-4,\r\n\t.px-sm-4 {\r\n\t\tpadding-right: 1.5rem !important\r\n\t}\r\n\r\n\t.pb-sm-4,\r\n\t.py-sm-4 {\r\n\t\tpadding-bottom: 1.5rem !important\r\n\t}\r\n\r\n\t.pl-sm-4,\r\n\t.px-sm-4 {\r\n\t\tpadding-left: 1.5rem !important\r\n\t}\r\n\r\n\t.p-sm-5 {\r\n\t\tpadding: 3rem !important\r\n\t}\r\n\r\n\t.pt-sm-5,\r\n\t.py-sm-5 {\r\n\t\tpadding-top: 3rem !important\r\n\t}\r\n\r\n\t.pr-sm-5,\r\n\t.px-sm-5 {\r\n\t\tpadding-right: 3rem !important\r\n\t}\r\n\r\n\t.pb-sm-5,\r\n\t.py-sm-5 {\r\n\t\tpadding-bottom: 3rem !important\r\n\t}\r\n\r\n\t.pl-sm-5,\r\n\t.px-sm-5 {\r\n\t\tpadding-left: 3rem !important\r\n\t}\r\n\r\n\t.m-sm-auto {\r\n\t\tmargin: auto !important\r\n\t}\r\n\r\n\t.mt-sm-auto,\r\n\t.my-sm-auto {\r\n\t\tmargin-top: auto !important\r\n\t}\r\n\r\n\t.mr-sm-auto,\r\n\t.mx-sm-auto {\r\n\t\tmargin-right: auto !important\r\n\t}\r\n\r\n\t.mb-sm-auto,\r\n\t.my-sm-auto {\r\n\t\tmargin-bottom: auto !important\r\n\t}\r\n\r\n\t.ml-sm-auto,\r\n\t.mx-sm-auto {\r\n\t\tmargin-left: auto !important\r\n\t}\r\n}\r\n\r\n@media (min-width:768px) {\r\n\t.m-md-0 {\r\n\t\tmargin: 0 !important\r\n\t}\r\n\r\n\t.mt-md-0,\r\n\t.my-md-0 {\r\n\t\tmargin-top: 0 !important\r\n\t}\r\n\r\n\t.mr-md-0,\r\n\t.mx-md-0 {\r\n\t\tmargin-right: 0 !important\r\n\t}\r\n\r\n\t.mb-md-0,\r\n\t.my-md-0 {\r\n\t\tmargin-bottom: 0 !important\r\n\t}\r\n\r\n\t.ml-md-0,\r\n\t.mx-md-0 {\r\n\t\tmargin-left: 0 !important\r\n\t}\r\n\r\n\t.m-md-1 {\r\n\t\tmargin: .25rem !important\r\n\t}\r\n\r\n\t.mt-md-1,\r\n\t.my-md-1 {\r\n\t\tmargin-top: .25rem !important\r\n\t}\r\n\r\n\t.mr-md-1,\r\n\t.mx-md-1 {\r\n\t\tmargin-right: .25rem !important\r\n\t}\r\n\r\n\t.mb-md-1,\r\n\t.my-md-1 {\r\n\t\tmargin-bottom: .25rem !important\r\n\t}\r\n\r\n\t.ml-md-1,\r\n\t.mx-md-1 {\r\n\t\tmargin-left: .25rem !important\r\n\t}\r\n\r\n\t.m-md-2 {\r\n\t\tmargin: .5rem !important\r\n\t}\r\n\r\n\t.mt-md-2,\r\n\t.my-md-2 {\r\n\t\tmargin-top: .5rem !important\r\n\t}\r\n\r\n\t.mr-md-2,\r\n\t.mx-md-2 {\r\n\t\tmargin-right: .5rem !important\r\n\t}\r\n\r\n\t.mb-md-2,\r\n\t.my-md-2 {\r\n\t\tmargin-bottom: .5rem !important\r\n\t}\r\n\r\n\t.ml-md-2,\r\n\t.mx-md-2 {\r\n\t\tmargin-left: .5rem !important\r\n\t}\r\n\r\n\t.m-md-3 {\r\n\t\tmargin: 1rem !important\r\n\t}\r\n\r\n\t.mt-md-3,\r\n\t.my-md-3 {\r\n\t\tmargin-top: 1rem !important\r\n\t}\r\n\r\n\t.mr-md-3,\r\n\t.mx-md-3 {\r\n\t\tmargin-right: 1rem !important\r\n\t}\r\n\r\n\t.mb-md-3,\r\n\t.my-md-3 {\r\n\t\tmargin-bottom: 1rem !important\r\n\t}\r\n\r\n\t.ml-md-3,\r\n\t.mx-md-3 {\r\n\t\tmargin-left: 1rem !important\r\n\t}\r\n\r\n\t.m-md-4 {\r\n\t\tmargin: 1.5rem !important\r\n\t}\r\n\r\n\t.mt-md-4,\r\n\t.my-md-4 {\r\n\t\tmargin-top: 1.5rem !important\r\n\t}\r\n\r\n\t.mr-md-4,\r\n\t.mx-md-4 {\r\n\t\tmargin-right: 1.5rem !important\r\n\t}\r\n\r\n\t.mb-md-4,\r\n\t.my-md-4 {\r\n\t\tmargin-bottom: 1.5rem !important\r\n\t}\r\n\r\n\t.ml-md-4,\r\n\t.mx-md-4 {\r\n\t\tmargin-left: 1.5rem !important\r\n\t}\r\n\r\n\t.m-md-5 {\r\n\t\tmargin: 3rem !important\r\n\t}\r\n\r\n\t.mt-md-5,\r\n\t.my-md-5 {\r\n\t\tmargin-top: 3rem !important\r\n\t}\r\n\r\n\t.mr-md-5,\r\n\t.mx-md-5 {\r\n\t\tmargin-right: 3rem !important\r\n\t}\r\n\r\n\t.mb-md-5,\r\n\t.my-md-5 {\r\n\t\tmargin-bottom: 3rem !important\r\n\t}\r\n\r\n\t.ml-md-5,\r\n\t.mx-md-5 {\r\n\t\tmargin-left: 3rem !important\r\n\t}\r\n\r\n\t.p-md-0 {\r\n\t\tpadding: 0 !important\r\n\t}\r\n\r\n\t.pt-md-0,\r\n\t.py-md-0 {\r\n\t\tpadding-top: 0 !important\r\n\t}\r\n\r\n\t.pr-md-0,\r\n\t.px-md-0 {\r\n\t\tpadding-right: 0 !important\r\n\t}\r\n\r\n\t.pb-md-0,\r\n\t.py-md-0 {\r\n\t\tpadding-bottom: 0 !important\r\n\t}\r\n\r\n\t.pl-md-0,\r\n\t.px-md-0 {\r\n\t\tpadding-left: 0 !important\r\n\t}\r\n\r\n\t.p-md-1 {\r\n\t\tpadding: .25rem !important\r\n\t}\r\n\r\n\t.pt-md-1,\r\n\t.py-md-1 {\r\n\t\tpadding-top: .25rem !important\r\n\t}\r\n\r\n\t.pr-md-1,\r\n\t.px-md-1 {\r\n\t\tpadding-right: .25rem !important\r\n\t}\r\n\r\n\t.pb-md-1,\r\n\t.py-md-1 {\r\n\t\tpadding-bottom: .25rem !important\r\n\t}\r\n\r\n\t.pl-md-1,\r\n\t.px-md-1 {\r\n\t\tpadding-left: .25rem !important\r\n\t}\r\n\r\n\t.p-md-2 {\r\n\t\tpadding: .5rem !important\r\n\t}\r\n\r\n\t.pt-md-2,\r\n\t.py-md-2 {\r\n\t\tpadding-top: .5rem !important\r\n\t}\r\n\r\n\t.pr-md-2,\r\n\t.px-md-2 {\r\n\t\tpadding-right: .5rem !important\r\n\t}\r\n\r\n\t.pb-md-2,\r\n\t.py-md-2 {\r\n\t\tpadding-bottom: .5rem !important\r\n\t}\r\n\r\n\t.pl-md-2,\r\n\t.px-md-2 {\r\n\t\tpadding-left: .5rem !important\r\n\t}\r\n\r\n\t.p-md-3 {\r\n\t\tpadding: 1rem !important\r\n\t}\r\n\r\n\t.pt-md-3,\r\n\t.py-md-3 {\r\n\t\tpadding-top: 1rem !important\r\n\t}\r\n\r\n\t.pr-md-3,\r\n\t.px-md-3 {\r\n\t\tpadding-right: 1rem !important\r\n\t}\r\n\r\n\t.pb-md-3,\r\n\t.py-md-3 {\r\n\t\tpadding-bottom: 1rem !important\r\n\t}\r\n\r\n\t.pl-md-3,\r\n\t.px-md-3 {\r\n\t\tpadding-left: 1rem !important\r\n\t}\r\n\r\n\t.p-md-4 {\r\n\t\tpadding: 1.5rem !important\r\n\t}\r\n\r\n\t.pt-md-4,\r\n\t.py-md-4 {\r\n\t\tpadding-top: 1.5rem !important\r\n\t}\r\n\r\n\t.pr-md-4,\r\n\t.px-md-4 {\r\n\t\tpadding-right: 1.5rem !important\r\n\t}\r\n\r\n\t.pb-md-4,\r\n\t.py-md-4 {\r\n\t\tpadding-bottom: 1.5rem !important\r\n\t}\r\n\r\n\t.pl-md-4,\r\n\t.px-md-4 {\r\n\t\tpadding-left: 1.5rem !important\r\n\t}\r\n\r\n\t.p-md-5 {\r\n\t\tpadding: 3rem !important\r\n\t}\r\n\r\n\t.pt-md-5,\r\n\t.py-md-5 {\r\n\t\tpadding-top: 3rem !important\r\n\t}\r\n\r\n\t.pr-md-5,\r\n\t.px-md-5 {\r\n\t\tpadding-right: 3rem !important\r\n\t}\r\n\r\n\t.pb-md-5,\r\n\t.py-md-5 {\r\n\t\tpadding-bottom: 3rem !important\r\n\t}\r\n\r\n\t.pl-md-5,\r\n\t.px-md-5 {\r\n\t\tpadding-left: 3rem !important\r\n\t}\r\n\r\n\t.m-md-auto {\r\n\t\tmargin: auto !important\r\n\t}\r\n\r\n\t.mt-md-auto,\r\n\t.my-md-auto {\r\n\t\tmargin-top: auto !important\r\n\t}\r\n\r\n\t.mr-md-auto,\r\n\t.mx-md-auto {\r\n\t\tmargin-right: auto !important\r\n\t}\r\n\r\n\t.mb-md-auto,\r\n\t.my-md-auto {\r\n\t\tmargin-bottom: auto !important\r\n\t}\r\n\r\n\t.ml-md-auto,\r\n\t.mx-md-auto {\r\n\t\tmargin-left: auto !important\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.m-lg-0 {\r\n\t\tmargin: 0 !important\r\n\t}\r\n\r\n\t.mt-lg-0,\r\n\t.my-lg-0 {\r\n\t\tmargin-top: 0 !important\r\n\t}\r\n\r\n\t.mr-lg-0,\r\n\t.mx-lg-0 {\r\n\t\tmargin-right: 0 !important\r\n\t}\r\n\r\n\t.mb-lg-0,\r\n\t.my-lg-0 {\r\n\t\tmargin-bottom: 0 !important\r\n\t}\r\n\r\n\t.ml-lg-0,\r\n\t.mx-lg-0 {\r\n\t\tmargin-left: 0 !important\r\n\t}\r\n\r\n\t.m-lg-1 {\r\n\t\tmargin: .25rem !important\r\n\t}\r\n\r\n\t.mt-lg-1,\r\n\t.my-lg-1 {\r\n\t\tmargin-top: .25rem !important\r\n\t}\r\n\r\n\t.mr-lg-1,\r\n\t.mx-lg-1 {\r\n\t\tmargin-right: .25rem !important\r\n\t}\r\n\r\n\t.mb-lg-1,\r\n\t.my-lg-1 {\r\n\t\tmargin-bottom: .25rem !important\r\n\t}\r\n\r\n\t.ml-lg-1,\r\n\t.mx-lg-1 {\r\n\t\tmargin-left: .25rem !important\r\n\t}\r\n\r\n\t.m-lg-2 {\r\n\t\tmargin: .5rem !important\r\n\t}\r\n\r\n\t.mt-lg-2,\r\n\t.my-lg-2 {\r\n\t\tmargin-top: .5rem !important\r\n\t}\r\n\r\n\t.mr-lg-2,\r\n\t.mx-lg-2 {\r\n\t\tmargin-right: .5rem !important\r\n\t}\r\n\r\n\t.mb-lg-2,\r\n\t.my-lg-2 {\r\n\t\tmargin-bottom: .5rem !important\r\n\t}\r\n\r\n\t.ml-lg-2,\r\n\t.mx-lg-2 {\r\n\t\tmargin-left: .5rem !important\r\n\t}\r\n\r\n\t.m-lg-3 {\r\n\t\tmargin: 1rem !important\r\n\t}\r\n\r\n\t.mt-lg-3,\r\n\t.my-lg-3 {\r\n\t\tmargin-top: 1rem !important\r\n\t}\r\n\r\n\t.mr-lg-3,\r\n\t.mx-lg-3 {\r\n\t\tmargin-right: 1rem !important\r\n\t}\r\n\r\n\t.mb-lg-3,\r\n\t.my-lg-3 {\r\n\t\tmargin-bottom: 1rem !important\r\n\t}\r\n\r\n\t.ml-lg-3,\r\n\t.mx-lg-3 {\r\n\t\tmargin-left: 1rem !important\r\n\t}\r\n\r\n\t.m-lg-4 {\r\n\t\tmargin: 1.5rem !important\r\n\t}\r\n\r\n\t.mt-lg-4,\r\n\t.my-lg-4 {\r\n\t\tmargin-top: 1.5rem !important\r\n\t}\r\n\r\n\t.mr-lg-4,\r\n\t.mx-lg-4 {\r\n\t\tmargin-right: 1.5rem !important\r\n\t}\r\n\r\n\t.mb-lg-4,\r\n\t.my-lg-4 {\r\n\t\tmargin-bottom: 1.5rem !important\r\n\t}\r\n\r\n\t.ml-lg-4,\r\n\t.mx-lg-4 {\r\n\t\tmargin-left: 1.5rem !important\r\n\t}\r\n\r\n\t.m-lg-5 {\r\n\t\tmargin: 3rem !important\r\n\t}\r\n\r\n\t.mt-lg-5,\r\n\t.my-lg-5 {\r\n\t\tmargin-top: 3rem !important\r\n\t}\r\n\r\n\t.mr-lg-5,\r\n\t.mx-lg-5 {\r\n\t\tmargin-right: 3rem !important\r\n\t}\r\n\r\n\t.mb-lg-5,\r\n\t.my-lg-5 {\r\n\t\tmargin-bottom: 3rem !important\r\n\t}\r\n\r\n\t.ml-lg-5,\r\n\t.mx-lg-5 {\r\n\t\tmargin-left: 3rem !important\r\n\t}\r\n\r\n\t.p-lg-0 {\r\n\t\tpadding: 0 !important\r\n\t}\r\n\r\n\t.pt-lg-0,\r\n\t.py-lg-0 {\r\n\t\tpadding-top: 0 !important\r\n\t}\r\n\r\n\t.pr-lg-0,\r\n\t.px-lg-0 {\r\n\t\tpadding-right: 0 !important\r\n\t}\r\n\r\n\t.pb-lg-0,\r\n\t.py-lg-0 {\r\n\t\tpadding-bottom: 0 !important\r\n\t}\r\n\r\n\t.pl-lg-0,\r\n\t.px-lg-0 {\r\n\t\tpadding-left: 0 !important\r\n\t}\r\n\r\n\t.p-lg-1 {\r\n\t\tpadding: .25rem !important\r\n\t}\r\n\r\n\t.pt-lg-1,\r\n\t.py-lg-1 {\r\n\t\tpadding-top: .25rem !important\r\n\t}\r\n\r\n\t.pr-lg-1,\r\n\t.px-lg-1 {\r\n\t\tpadding-right: .25rem !important\r\n\t}\r\n\r\n\t.pb-lg-1,\r\n\t.py-lg-1 {\r\n\t\tpadding-bottom: .25rem !important\r\n\t}\r\n\r\n\t.pl-lg-1,\r\n\t.px-lg-1 {\r\n\t\tpadding-left: .25rem !important\r\n\t}\r\n\r\n\t.p-lg-2 {\r\n\t\tpadding: .5rem !important\r\n\t}\r\n\r\n\t.pt-lg-2,\r\n\t.py-lg-2 {\r\n\t\tpadding-top: .5rem !important\r\n\t}\r\n\r\n\t.pr-lg-2,\r\n\t.px-lg-2 {\r\n\t\tpadding-right: .5rem !important\r\n\t}\r\n\r\n\t.pb-lg-2,\r\n\t.py-lg-2 {\r\n\t\tpadding-bottom: .5rem !important\r\n\t}\r\n\r\n\t.pl-lg-2,\r\n\t.px-lg-2 {\r\n\t\tpadding-left: .5rem !important\r\n\t}\r\n\r\n\t.p-lg-3 {\r\n\t\tpadding: 1rem !important\r\n\t}\r\n\r\n\t.pt-lg-3,\r\n\t.py-lg-3 {\r\n\t\tpadding-top: 1rem !important\r\n\t}\r\n\r\n\t.pr-lg-3,\r\n\t.px-lg-3 {\r\n\t\tpadding-right: 1rem !important\r\n\t}\r\n\r\n\t.pb-lg-3,\r\n\t.py-lg-3 {\r\n\t\tpadding-bottom: 1rem !important\r\n\t}\r\n\r\n\t.pl-lg-3,\r\n\t.px-lg-3 {\r\n\t\tpadding-left: 1rem !important\r\n\t}\r\n\r\n\t.p-lg-4 {\r\n\t\tpadding: 1.5rem !important\r\n\t}\r\n\r\n\t.pt-lg-4,\r\n\t.py-lg-4 {\r\n\t\tpadding-top: 1.5rem !important\r\n\t}\r\n\r\n\t.pr-lg-4,\r\n\t.px-lg-4 {\r\n\t\tpadding-right: 1.5rem !important\r\n\t}\r\n\r\n\t.pb-lg-4,\r\n\t.py-lg-4 {\r\n\t\tpadding-bottom: 1.5rem !important\r\n\t}\r\n\r\n\t.pl-lg-4,\r\n\t.px-lg-4 {\r\n\t\tpadding-left: 1.5rem !important\r\n\t}\r\n\r\n\t.p-lg-5 {\r\n\t\tpadding: 3rem !important\r\n\t}\r\n\r\n\t.pt-lg-5,\r\n\t.py-lg-5 {\r\n\t\tpadding-top: 3rem !important\r\n\t}\r\n\r\n\t.pr-lg-5,\r\n\t.px-lg-5 {\r\n\t\tpadding-right: 3rem !important\r\n\t}\r\n\r\n\t.pb-lg-5,\r\n\t.py-lg-5 {\r\n\t\tpadding-bottom: 3rem !important\r\n\t}\r\n\r\n\t.pl-lg-5,\r\n\t.px-lg-5 {\r\n\t\tpadding-left: 3rem !important\r\n\t}\r\n\r\n\t.m-lg-auto {\r\n\t\tmargin: auto !important\r\n\t}\r\n\r\n\t.mt-lg-auto,\r\n\t.my-lg-auto {\r\n\t\tmargin-top: auto !important\r\n\t}\r\n\r\n\t.mr-lg-auto,\r\n\t.mx-lg-auto {\r\n\t\tmargin-right: auto !important\r\n\t}\r\n\r\n\t.mb-lg-auto,\r\n\t.my-lg-auto {\r\n\t\tmargin-bottom: auto !important\r\n\t}\r\n\r\n\t.ml-lg-auto,\r\n\t.mx-lg-auto {\r\n\t\tmargin-left: auto !important\r\n\t}\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\t.m-xl-0 {\r\n\t\tmargin: 0 !important\r\n\t}\r\n\r\n\t.mt-xl-0,\r\n\t.my-xl-0 {\r\n\t\tmargin-top: 0 !important\r\n\t}\r\n\r\n\t.mr-xl-0,\r\n\t.mx-xl-0 {\r\n\t\tmargin-right: 0 !important\r\n\t}\r\n\r\n\t.mb-xl-0,\r\n\t.my-xl-0 {\r\n\t\tmargin-bottom: 0 !important\r\n\t}\r\n\r\n\t.ml-xl-0,\r\n\t.mx-xl-0 {\r\n\t\tmargin-left: 0 !important\r\n\t}\r\n\r\n\t.m-xl-1 {\r\n\t\tmargin: .25rem !important\r\n\t}\r\n\r\n\t.mt-xl-1,\r\n\t.my-xl-1 {\r\n\t\tmargin-top: .25rem !important\r\n\t}\r\n\r\n\t.mr-xl-1,\r\n\t.mx-xl-1 {\r\n\t\tmargin-right: .25rem !important\r\n\t}\r\n\r\n\t.mb-xl-1,\r\n\t.my-xl-1 {\r\n\t\tmargin-bottom: .25rem !important\r\n\t}\r\n\r\n\t.ml-xl-1,\r\n\t.mx-xl-1 {\r\n\t\tmargin-left: .25rem !important\r\n\t}\r\n\r\n\t.m-xl-2 {\r\n\t\tmargin: .5rem !important\r\n\t}\r\n\r\n\t.mt-xl-2,\r\n\t.my-xl-2 {\r\n\t\tmargin-top: .5rem !important\r\n\t}\r\n\r\n\t.mr-xl-2,\r\n\t.mx-xl-2 {\r\n\t\tmargin-right: .5rem !important\r\n\t}\r\n\r\n\t.mb-xl-2,\r\n\t.my-xl-2 {\r\n\t\tmargin-bottom: .5rem !important\r\n\t}\r\n\r\n\t.ml-xl-2,\r\n\t.mx-xl-2 {\r\n\t\tmargin-left: .5rem !important\r\n\t}\r\n\r\n\t.m-xl-3 {\r\n\t\tmargin: 1rem !important\r\n\t}\r\n\r\n\t.mt-xl-3,\r\n\t.my-xl-3 {\r\n\t\tmargin-top: 1rem !important\r\n\t}\r\n\r\n\t.mr-xl-3,\r\n\t.mx-xl-3 {\r\n\t\tmargin-right: 1rem !important\r\n\t}\r\n\r\n\t.mb-xl-3,\r\n\t.my-xl-3 {\r\n\t\tmargin-bottom: 1rem !important\r\n\t}\r\n\r\n\t.ml-xl-3,\r\n\t.mx-xl-3 {\r\n\t\tmargin-left: 1rem !important\r\n\t}\r\n\r\n\t.m-xl-4 {\r\n\t\tmargin: 1.5rem !important\r\n\t}\r\n\r\n\t.mt-xl-4,\r\n\t.my-xl-4 {\r\n\t\tmargin-top: 1.5rem !important\r\n\t}\r\n\r\n\t.mr-xl-4,\r\n\t.mx-xl-4 {\r\n\t\tmargin-right: 1.5rem !important\r\n\t}\r\n\r\n\t.mb-xl-4,\r\n\t.my-xl-4 {\r\n\t\tmargin-bottom: 1.5rem !important\r\n\t}\r\n\r\n\t.ml-xl-4,\r\n\t.mx-xl-4 {\r\n\t\tmargin-left: 1.5rem !important\r\n\t}\r\n\r\n\t.m-xl-5 {\r\n\t\tmargin: 3rem !important\r\n\t}\r\n\r\n\t.mt-xl-5,\r\n\t.my-xl-5 {\r\n\t\tmargin-top: 3rem !important\r\n\t}\r\n\r\n\t.mr-xl-5,\r\n\t.mx-xl-5 {\r\n\t\tmargin-right: 3rem !important\r\n\t}\r\n\r\n\t.mb-xl-5,\r\n\t.my-xl-5 {\r\n\t\tmargin-bottom: 3rem !important\r\n\t}\r\n\r\n\t.ml-xl-5,\r\n\t.mx-xl-5 {\r\n\t\tmargin-left: 3rem !important\r\n\t}\r\n\r\n\t.p-xl-0 {\r\n\t\tpadding: 0 !important\r\n\t}\r\n\r\n\t.pt-xl-0,\r\n\t.py-xl-0 {\r\n\t\tpadding-top: 0 !important\r\n\t}\r\n\r\n\t.pr-xl-0,\r\n\t.px-xl-0 {\r\n\t\tpadding-right: 0 !important\r\n\t}\r\n\r\n\t.pb-xl-0,\r\n\t.py-xl-0 {\r\n\t\tpadding-bottom: 0 !important\r\n\t}\r\n\r\n\t.pl-xl-0,\r\n\t.px-xl-0 {\r\n\t\tpadding-left: 0 !important\r\n\t}\r\n\r\n\t.p-xl-1 {\r\n\t\tpadding: .25rem !important\r\n\t}\r\n\r\n\t.pt-xl-1,\r\n\t.py-xl-1 {\r\n\t\tpadding-top: .25rem !important\r\n\t}\r\n\r\n\t.pr-xl-1,\r\n\t.px-xl-1 {\r\n\t\tpadding-right: .25rem !important\r\n\t}\r\n\r\n\t.pb-xl-1,\r\n\t.py-xl-1 {\r\n\t\tpadding-bottom: .25rem !important\r\n\t}\r\n\r\n\t.pl-xl-1,\r\n\t.px-xl-1 {\r\n\t\tpadding-left: .25rem !important\r\n\t}\r\n\r\n\t.p-xl-2 {\r\n\t\tpadding: .5rem !important\r\n\t}\r\n\r\n\t.pt-xl-2,\r\n\t.py-xl-2 {\r\n\t\tpadding-top: .5rem !important\r\n\t}\r\n\r\n\t.pr-xl-2,\r\n\t.px-xl-2 {\r\n\t\tpadding-right: .5rem !important\r\n\t}\r\n\r\n\t.pb-xl-2,\r\n\t.py-xl-2 {\r\n\t\tpadding-bottom: .5rem !important\r\n\t}\r\n\r\n\t.pl-xl-2,\r\n\t.px-xl-2 {\r\n\t\tpadding-left: .5rem !important\r\n\t}\r\n\r\n\t.p-xl-3 {\r\n\t\tpadding: 1rem !important\r\n\t}\r\n\r\n\t.pt-xl-3,\r\n\t.py-xl-3 {\r\n\t\tpadding-top: 1rem !important\r\n\t}\r\n\r\n\t.pr-xl-3,\r\n\t.px-xl-3 {\r\n\t\tpadding-right: 1rem !important\r\n\t}\r\n\r\n\t.pb-xl-3,\r\n\t.py-xl-3 {\r\n\t\tpadding-bottom: 1rem !important\r\n\t}\r\n\r\n\t.pl-xl-3,\r\n\t.px-xl-3 {\r\n\t\tpadding-left: 1rem !important\r\n\t}\r\n\r\n\t.p-xl-4 {\r\n\t\tpadding: 1.5rem !important\r\n\t}\r\n\r\n\t.pt-xl-4,\r\n\t.py-xl-4 {\r\n\t\tpadding-top: 1.5rem !important\r\n\t}\r\n\r\n\t.pr-xl-4,\r\n\t.px-xl-4 {\r\n\t\tpadding-right: 1.5rem !important\r\n\t}\r\n\r\n\t.pb-xl-4,\r\n\t.py-xl-4 {\r\n\t\tpadding-bottom: 1.5rem !important\r\n\t}\r\n\r\n\t.pl-xl-4,\r\n\t.px-xl-4 {\r\n\t\tpadding-left: 1.5rem !important\r\n\t}\r\n\r\n\t.p-xl-5 {\r\n\t\tpadding: 3rem !important\r\n\t}\r\n\r\n\t.pt-xl-5,\r\n\t.py-xl-5 {\r\n\t\tpadding-top: 3rem !important\r\n\t}\r\n\r\n\t.pr-xl-5,\r\n\t.px-xl-5 {\r\n\t\tpadding-right: 3rem !important\r\n\t}\r\n\r\n\t.pb-xl-5,\r\n\t.py-xl-5 {\r\n\t\tpadding-bottom: 3rem !important\r\n\t}\r\n\r\n\t.pl-xl-5,\r\n\t.px-xl-5 {\r\n\t\tpadding-left: 3rem !important\r\n\t}\r\n\r\n\t.m-xl-auto {\r\n\t\tmargin: auto !important\r\n\t}\r\n\r\n\t.mt-xl-auto,\r\n\t.my-xl-auto {\r\n\t\tmargin-top: auto !important\r\n\t}\r\n\r\n\t.mr-xl-auto,\r\n\t.mx-xl-auto {\r\n\t\tmargin-right: auto !important\r\n\t}\r\n\r\n\t.mb-xl-auto,\r\n\t.my-xl-auto {\r\n\t\tmargin-bottom: auto !important\r\n\t}\r\n\r\n\t.ml-xl-auto,\r\n\t.mx-xl-auto {\r\n\t\tmargin-left: auto !important\r\n\t}\r\n}\r\n\r\n.text-monospace {\r\n\tfont-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace\r\n}\r\n\r\n.text-justify {\r\n\ttext-align: justify !important\r\n}\r\n\r\n.text-nowrap {\r\n\twhite-space: nowrap !important\r\n}\r\n\r\n.text-truncate {\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\twhite-space: nowrap\r\n}\r\n\r\n.text-left {\r\n\ttext-align: left !important\r\n}\r\n\r\n.text-right {\r\n\ttext-align: right !important\r\n}\r\n\r\n.text-center {\r\n\ttext-align: center !important\r\n}\r\n\r\n@media (min-width:576px) {\r\n\t.text-sm-left {\r\n\t\ttext-align: left !important\r\n\t}\r\n\r\n\t.text-sm-right {\r\n\t\ttext-align: right !important\r\n\t}\r\n\r\n\t.text-sm-center {\r\n\t\ttext-align: center !important\r\n\t}\r\n}\r\n\r\n@media (min-width:768px) {\r\n\t.text-md-left {\r\n\t\ttext-align: left !important\r\n\t}\r\n\r\n\t.text-md-right {\r\n\t\ttext-align: right !important\r\n\t}\r\n\r\n\t.text-md-center {\r\n\t\ttext-align: center !important\r\n\t}\r\n}\r\n\r\n@media (min-width:992px) {\r\n\t.text-lg-left {\r\n\t\ttext-align: left !important\r\n\t}\r\n\r\n\t.text-lg-right {\r\n\t\ttext-align: right !important\r\n\t}\r\n\r\n\t.text-lg-center {\r\n\t\ttext-align: center !important\r\n\t}\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\t.text-xl-left {\r\n\t\ttext-align: left !important\r\n\t}\r\n\r\n\t.text-xl-right {\r\n\t\ttext-align: right !important\r\n\t}\r\n\r\n\t.text-xl-center {\r\n\t\ttext-align: center !important\r\n\t}\r\n}\r\n\r\n.text-lowercase {\r\n\ttext-transform: lowercase !important\r\n}\r\n\r\n.text-uppercase {\r\n\ttext-transform: uppercase !important\r\n}\r\n\r\n.text-capitalize {\r\n\ttext-transform: capitalize !important\r\n}\r\n\r\n.font-weight-light {\r\n\tfont-weight: 300 !important\r\n}\r\n\r\n.font-weight-normal {\r\n\tfont-weight: 400 !important\r\n}\r\n\r\n.font-weight-bold {\r\n\tfont-weight: 700 !important\r\n}\r\n\r\n.font-italic {\r\n\tfont-style: italic !important\r\n}\r\n\r\n.text-white {\r\n\tcolor: #fff !important\r\n}\r\n\r\n.text-primary {\r\n\tcolor: #007bff !important\r\n}\r\n\r\na.text-primary:focus,\r\na.text-primary:hover {\r\n\tcolor: #0062cc !important\r\n}\r\n\r\n.text-secondary {\r\n\tcolor: #6c757d !important\r\n}\r\n\r\na.text-secondary:focus,\r\na.text-secondary:hover {\r\n\tcolor: #545b62 !important\r\n}\r\n\r\n.text-success {\r\n\tcolor: #28a745 !important\r\n}\r\n\r\na.text-success:focus,\r\na.text-success:hover {\r\n\tcolor: #1e7e34 !important\r\n}\r\n\r\n.text-info {\r\n\tcolor: #17a2b8 !important\r\n}\r\n\r\na.text-info:focus,\r\na.text-info:hover {\r\n\tcolor: #117a8b !important\r\n}\r\n\r\n.text-warning {\r\n\tcolor: #ffc107 !important\r\n}\r\n\r\na.text-warning:focus,\r\na.text-warning:hover {\r\n\tcolor: #d39e00 !important\r\n}\r\n\r\n.text-danger {\r\n\tcolor: #dc3545 !important\r\n}\r\n\r\na.text-danger:focus,\r\na.text-danger:hover {\r\n\tcolor: #bd2130 !important\r\n}\r\n\r\n.text-light {\r\n\tcolor: #f8f9fa !important\r\n}\r\n\r\na.text-light:focus,\r\na.text-light:hover {\r\n\tcolor: #dae0e5 !important\r\n}\r\n\r\n.text-dark {\r\n\tcolor: #343a40 !important\r\n}\r\n\r\na.text-dark:focus,\r\na.text-dark:hover {\r\n\tcolor: #1d2124 !important\r\n}\r\n\r\n.text-body {\r\n\tcolor: #212529 !important\r\n}\r\n\r\n.text-muted {\r\n\tcolor: #6c757d !important\r\n}\r\n\r\n.text-black-50 {\r\n\tcolor: rgba(0, 0, 0, .5) !important\r\n}\r\n\r\n.text-white-50 {\r\n\tcolor: rgba(255, 255, 255, .5) !important\r\n}\r\n\r\n.text-hide {\r\n\tfont: 0/0 a;\r\n\tcolor: transparent;\r\n\ttext-shadow: none;\r\n\tbackground-color: transparent;\r\n\tborder: 0\r\n}\r\n\r\n.visible {\r\n\tvisibility: visible !important\r\n}\r\n\r\n.invisible {\r\n\tvisibility: hidden !important\r\n}\r\n\r\n@media print {\r\n\r\n\t*,\r\n\t::after,\r\n\t::before {\r\n\t\ttext-shadow: none !important;\r\n\t\tbox-shadow: none !important\r\n\t}\r\n\r\n\ta:not(.btn) {\r\n\t\ttext-decoration: underline\r\n\t}\r\n\r\n\tabbr[title]::after {\r\n\t\tcontent: \" (\" attr(title) \")\"\r\n\t}\r\n\r\n\tpre {\r\n\t\twhite-space: pre-wrap !important\r\n\t}\r\n\r\n\tblockquote,\r\n\tpre {\r\n\t\tborder: 1px solid #adb5bd;\r\n\t\tpage-break-inside: avoid\r\n\t}\r\n\r\n\tthead {\r\n\t\tdisplay: table-header-group\r\n\t}\r\n\r\n\timg,\r\n\ttr {\r\n\t\tpage-break-inside: avoid\r\n\t}\r\n\r\n\th2,\r\n\th3,\r\n\tp {\r\n\t\torphans: 3;\r\n\t\twidows: 3\r\n\t}\r\n\r\n\th2,\r\n\th3 {\r\n\t\tpage-break-after: avoid\r\n\t}\r\n\r\n\t@page {\r\n\t\tsize: a3\r\n\t}\r\n\r\n\tbody {\r\n\t\tmin-width: 992px !important\r\n\t}\r\n\r\n\t.container {\r\n\t\tmin-width: 992px !important\r\n\t}\r\n\r\n\t.navbar {\r\n\t\tdisplay: none\r\n\t}\r\n\r\n\t.badge {\r\n\t\tborder: 1px solid #000\r\n\t}\r\n\r\n\t.table {\r\n\t\tborder-collapse: collapse !important\r\n\t}\r\n\r\n\t.table td,\r\n\t.table th {\r\n\t\tbackground-color: #fff !important\r\n\t}\r\n\r\n\t.table-bordered td,\r\n\t.table-bordered th {\r\n\t\tborder: 1px solid #dee2e6 !important\r\n\t}\r\n\r\n\t.table-dark {\r\n\t\tcolor: inherit\r\n\t}\r\n\r\n\t.table-dark tbody+tbody,\r\n\t.table-dark td,\r\n\t.table-dark th,\r\n\t.table-dark thead th {\r\n\t\tborder-color: #dee2e6\r\n\t}\r\n\r\n\t.table .thead-dark th {\r\n\t\tcolor: inherit;\r\n\t\tborder-color: #dee2e6\r\n\t}\r\n}\r\n\r\n.form-control:focus {\r\n\tcolor: #495057;\r\n\tbackground-color: #f1f1f1;\r\n\tborder-color: #ef7b06;\r\n\toutline: 0;\r\n\tbox-shadow: 0 0 0 0.2rem rgba(255, 193, 71);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
